(() => {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref92d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref92d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("izU6i", function(module, exports) {
/**
 * cuid.js
 * Collision-resistant UID generator for browsers and node.
 * Sequential for fast db lookups and recency sorting.
 * Safe for element IDs and server-side lookups.
 *
 * Extracted from CLCTR
 *
 * Copyright (c) Eric Elliott 2012
 * MIT License
 */ 
var $kLWrQ = parcelRequire("kLWrQ");

var $2aPcl = parcelRequire("2aPcl");

var $eEaNR = parcelRequire("eEaNR");
var $d867034cbcced206$var$c = 0, $d867034cbcced206$var$blockSize = 4, $d867034cbcced206$var$base = 36, $d867034cbcced206$var$discreteValues = Math.pow($d867034cbcced206$var$base, $d867034cbcced206$var$blockSize);
function $d867034cbcced206$var$randomBlock() {
    return $2aPcl(($eEaNR() * $d867034cbcced206$var$discreteValues << 0).toString($d867034cbcced206$var$base), $d867034cbcced206$var$blockSize);
}
function $d867034cbcced206$var$safeCounter() {
    $d867034cbcced206$var$c = $d867034cbcced206$var$c < $d867034cbcced206$var$discreteValues ? $d867034cbcced206$var$c : 0;
    $d867034cbcced206$var$c++; // this is not subliminal
    return $d867034cbcced206$var$c - 1;
}
function $d867034cbcced206$var$cuid() {
    // Starting with a lowercase letter makes
    // it HTML element ID friendly.
    var letter = "c", // timestamp
    // warning: this exposes the exact date and time
    // that the uid was created.
    timestamp = new Date().getTime().toString($d867034cbcced206$var$base), // Prevent same-machine collisions.
    counter = $2aPcl($d867034cbcced206$var$safeCounter().toString($d867034cbcced206$var$base), $d867034cbcced206$var$blockSize), // A few chars to generate distinct ids for different
    // clients (so different computers are far less
    // likely to generate the same id)
    print = $kLWrQ(), // Grab some more chars from Math.random()
    random = $d867034cbcced206$var$randomBlock() + $d867034cbcced206$var$randomBlock();
    return letter + timestamp + counter + print + random;
}
$d867034cbcced206$var$cuid.slug = function slug() {
    var date = new Date().getTime().toString(36), counter = $d867034cbcced206$var$safeCounter().toString(36).slice(-4), print = $kLWrQ().slice(0, 1) + $kLWrQ().slice(-1), random = $d867034cbcced206$var$randomBlock().slice(-2);
    return date.slice(-2) + counter + print + random;
};
$d867034cbcced206$var$cuid.isCuid = function isCuid(stringToCheck) {
    if (typeof stringToCheck !== "string") return false;
    if (stringToCheck.startsWith("c")) return true;
    return false;
};
$d867034cbcced206$var$cuid.isSlug = function isSlug(stringToCheck) {
    if (typeof stringToCheck !== "string") return false;
    var stringLength = stringToCheck.length;
    if (stringLength >= 7 && stringLength <= 10) return true;
    return false;
};
$d867034cbcced206$var$cuid.fingerprint = $kLWrQ;
module.exports = $d867034cbcced206$var$cuid;

});
parcelRegister("kLWrQ", function(module, exports) {

var $2aPcl = parcelRequire("2aPcl");
var $f1f589078e15501c$var$env = typeof window === "object" ? window : self;
var $f1f589078e15501c$var$globalCount = Object.keys($f1f589078e15501c$var$env).length;
var $f1f589078e15501c$var$mimeTypesLength = navigator.mimeTypes ? navigator.mimeTypes.length : 0;
var $f1f589078e15501c$var$clientId = $2aPcl(($f1f589078e15501c$var$mimeTypesLength + navigator.userAgent.length).toString(36) + $f1f589078e15501c$var$globalCount.toString(36), 4);
module.exports = function fingerprint() {
    return $f1f589078e15501c$var$clientId;
};

});
parcelRegister("2aPcl", function(module, exports) {
module.exports = function pad(num, size) {
    var s = "000000000" + num;
    return s.substr(s.length - size);
};

});


parcelRegister("eEaNR", function(module, exports) {
var $aa9d2e624da8a03c$var$getRandomValue;
var $aa9d2e624da8a03c$var$crypto = typeof window !== "undefined" && (window.crypto || window.msCrypto) || typeof self !== "undefined" && self.crypto;
if ($aa9d2e624da8a03c$var$crypto) {
    var $aa9d2e624da8a03c$var$lim = Math.pow(2, 32) - 1;
    $aa9d2e624da8a03c$var$getRandomValue = function() {
        return Math.abs($aa9d2e624da8a03c$var$crypto.getRandomValues(new Uint32Array(1))[0] / $aa9d2e624da8a03c$var$lim);
    };
} else $aa9d2e624da8a03c$var$getRandomValue = Math.random;
module.exports = $aa9d2e624da8a03c$var$getRandomValue;

});


parcelRegister("1zKtH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "Axios", () => $125d1ceb57662f9a$export$1c00760e9e5a4e95);
$parcel$export(module.exports, "AxiosError", () => $125d1ceb57662f9a$export$c1fbed17c2f6a328);
$parcel$export(module.exports, "CanceledError", () => $125d1ceb57662f9a$export$1ab0c6b20d94fa14);
$parcel$export(module.exports, "isCancel", () => $125d1ceb57662f9a$export$3b22524397b493c6);
$parcel$export(module.exports, "CancelToken", () => $125d1ceb57662f9a$export$fd08e3cb425f0d61);
$parcel$export(module.exports, "VERSION", () => $125d1ceb57662f9a$export$a4ad2735b021c132);
$parcel$export(module.exports, "all", () => $125d1ceb57662f9a$export$84bf76cd7afc7469);
$parcel$export(module.exports, "Cancel", () => $125d1ceb57662f9a$export$848c9b7ead0df967);
$parcel$export(module.exports, "isAxiosError", () => $125d1ceb57662f9a$export$fbafdbe06a5b5a9a);
$parcel$export(module.exports, "spread", () => $125d1ceb57662f9a$export$3ae0fd4797ed47c8);
$parcel$export(module.exports, "toFormData", () => $125d1ceb57662f9a$export$10ae0d317ea97f8b);
$parcel$export(module.exports, "AxiosHeaders", () => $125d1ceb57662f9a$export$4e7d6ff0f3e6520);
$parcel$export(module.exports, "HttpStatusCode", () => $125d1ceb57662f9a$export$a972f69c851492b3);
$parcel$export(module.exports, "formToJSON", () => $125d1ceb57662f9a$export$86d7c59254d6a2c9);
$parcel$export(module.exports, "getAdapter", () => $125d1ceb57662f9a$export$17ddc20a97d669e2);
$parcel$export(module.exports, "mergeConfig", () => $125d1ceb57662f9a$export$7ec1ebcfa9d8bd6a);
$parcel$export(module.exports, "default", () => (parcelRequire("81tj9")).default);

var $81tj9 = parcelRequire("81tj9");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $125d1ceb57662f9a$export$1c00760e9e5a4e95, AxiosError: $125d1ceb57662f9a$export$c1fbed17c2f6a328, CanceledError: $125d1ceb57662f9a$export$1ab0c6b20d94fa14, isCancel: $125d1ceb57662f9a$export$3b22524397b493c6, CancelToken: $125d1ceb57662f9a$export$fd08e3cb425f0d61, VERSION: $125d1ceb57662f9a$export$a4ad2735b021c132, all: $125d1ceb57662f9a$export$84bf76cd7afc7469, Cancel: $125d1ceb57662f9a$export$848c9b7ead0df967, isAxiosError: $125d1ceb57662f9a$export$fbafdbe06a5b5a9a, spread: $125d1ceb57662f9a$export$3ae0fd4797ed47c8, toFormData: $125d1ceb57662f9a$export$10ae0d317ea97f8b, AxiosHeaders: $125d1ceb57662f9a$export$4e7d6ff0f3e6520, HttpStatusCode: $125d1ceb57662f9a$export$a972f69c851492b3, formToJSON: $125d1ceb57662f9a$export$86d7c59254d6a2c9, getAdapter: $125d1ceb57662f9a$export$17ddc20a97d669e2, mergeConfig: $125d1ceb57662f9a$export$7ec1ebcfa9d8bd6a } = (0, $81tj9.default);

});
parcelRegister("81tj9", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d7526a7a1e5b3fb$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $cG9HX = parcelRequire("cG9HX");

var $hBrVA = parcelRequire("hBrVA");

var $2PhsF = parcelRequire("2PhsF");

var $juuss = parcelRequire("juuss");

var $htyv1 = parcelRequire("htyv1");

var $8yOyy = parcelRequire("8yOyy");

var $4iFhx = parcelRequire("4iFhx");

var $lCgfr = parcelRequire("lCgfr");

var $6yYtd = parcelRequire("6yYtd");

var $lISaw = parcelRequire("lISaw");

var $6wIUo = parcelRequire("6wIUo");

var $albzn = parcelRequire("albzn");

var $1YbHN = parcelRequire("1YbHN");

var $7hTsj = parcelRequire("7hTsj");

var $ik8Aj = parcelRequire("ik8Aj");

var $kq2bQ = parcelRequire("kq2bQ");
"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $5d7526a7a1e5b3fb$var$createInstance(defaultConfig) {
    const context = new (0, $hBrVA.default)(defaultConfig);
    const instance = (0, $cG9HX.default)((0, $hBrVA.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $eFc3n.default).extend(instance, (0, $hBrVA.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $eFc3n.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $5d7526a7a1e5b3fb$var$createInstance((0, $2PhsF.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $5d7526a7a1e5b3fb$var$axios = $5d7526a7a1e5b3fb$var$createInstance((0, $juuss.default));
// Expose Axios class to allow class inheritance
$5d7526a7a1e5b3fb$var$axios.Axios = (0, $hBrVA.default);
// Expose Cancel & CancelToken
$5d7526a7a1e5b3fb$var$axios.CanceledError = (0, $8yOyy.default);
$5d7526a7a1e5b3fb$var$axios.CancelToken = (0, $4iFhx.default);
$5d7526a7a1e5b3fb$var$axios.isCancel = (0, $lCgfr.default);
$5d7526a7a1e5b3fb$var$axios.VERSION = (0, $6yYtd.VERSION);
$5d7526a7a1e5b3fb$var$axios.toFormData = (0, $lISaw.default);
// Expose AxiosError class
$5d7526a7a1e5b3fb$var$axios.AxiosError = (0, $6wIUo.default);
// alias for CanceledError for backward compatibility
$5d7526a7a1e5b3fb$var$axios.Cancel = $5d7526a7a1e5b3fb$var$axios.CanceledError;
// Expose all/spread
$5d7526a7a1e5b3fb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$5d7526a7a1e5b3fb$var$axios.spread = (0, $albzn.default);
// Expose isAxiosError
$5d7526a7a1e5b3fb$var$axios.isAxiosError = (0, $1YbHN.default);
// Expose mergeConfig
$5d7526a7a1e5b3fb$var$axios.mergeConfig = (0, $2PhsF.default);
$5d7526a7a1e5b3fb$var$axios.AxiosHeaders = (0, $7hTsj.default);
$5d7526a7a1e5b3fb$var$axios.formToJSON = (thing)=>(0, $htyv1.default)((0, $eFc3n.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$5d7526a7a1e5b3fb$var$axios.getAdapter = (0, $ik8Aj.default).getAdapter;
$5d7526a7a1e5b3fb$var$axios.HttpStatusCode = (0, $kq2bQ.default);
$5d7526a7a1e5b3fb$var$axios.default = $5d7526a7a1e5b3fb$var$axios;
var // this module should only have a default export
$5d7526a7a1e5b3fb$export$2e2bcd8739ae039 = $5d7526a7a1e5b3fb$var$axios;

});
parcelRegister("eFc3n", function(module, exports) {

$parcel$export(module.exports, "default", () => $aace3e920a0f1e4d$export$2e2bcd8739ae039);

var $cG9HX = parcelRequire("cG9HX");
"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $aace3e920a0f1e4d$var$toString } = Object.prototype;
const { getPrototypeOf: $aace3e920a0f1e4d$var$getPrototypeOf } = Object;
const $aace3e920a0f1e4d$var$kindOf = ((cache)=>(thing)=>{
        const str = $aace3e920a0f1e4d$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $aace3e920a0f1e4d$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$aace3e920a0f1e4d$var$kindOf(thing) === type;
};
const $aace3e920a0f1e4d$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $aace3e920a0f1e4d$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $aace3e920a0f1e4d$var$isUndefined = $aace3e920a0f1e4d$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isBuffer(val) {
    return val !== null && !$aace3e920a0f1e4d$var$isUndefined(val) && val.constructor !== null && !$aace3e920a0f1e4d$var$isUndefined(val.constructor) && $aace3e920a0f1e4d$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $aace3e920a0f1e4d$var$isArrayBuffer = $aace3e920a0f1e4d$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $aace3e920a0f1e4d$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $aace3e920a0f1e4d$var$isString = $aace3e920a0f1e4d$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $aace3e920a0f1e4d$var$isFunction = $aace3e920a0f1e4d$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $aace3e920a0f1e4d$var$isNumber = $aace3e920a0f1e4d$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $aace3e920a0f1e4d$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $aace3e920a0f1e4d$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $aace3e920a0f1e4d$var$isPlainObject = (val)=>{
    if ($aace3e920a0f1e4d$var$kindOf(val) !== "object") return false;
    const prototype = $aace3e920a0f1e4d$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $aace3e920a0f1e4d$var$isDate = $aace3e920a0f1e4d$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $aace3e920a0f1e4d$var$isFile = $aace3e920a0f1e4d$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $aace3e920a0f1e4d$var$isBlob = $aace3e920a0f1e4d$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $aace3e920a0f1e4d$var$isFileList = $aace3e920a0f1e4d$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $aace3e920a0f1e4d$var$isStream = (val)=>$aace3e920a0f1e4d$var$isObject(val) && $aace3e920a0f1e4d$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $aace3e920a0f1e4d$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $aace3e920a0f1e4d$var$isFunction(thing.append) && ((kind = $aace3e920a0f1e4d$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $aace3e920a0f1e4d$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $aace3e920a0f1e4d$var$isURLSearchParams = $aace3e920a0f1e4d$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $aace3e920a0f1e4d$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $aace3e920a0f1e4d$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($aace3e920a0f1e4d$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $aace3e920a0f1e4d$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $aace3e920a0f1e4d$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $aace3e920a0f1e4d$var$isContextDefined = (context)=>!$aace3e920a0f1e4d$var$isUndefined(context) && context !== $aace3e920a0f1e4d$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $aace3e920a0f1e4d$var$merge() {
    const { caseless: caseless } = $aace3e920a0f1e4d$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $aace3e920a0f1e4d$var$findKey(result, key) || key;
        if ($aace3e920a0f1e4d$var$isPlainObject(result[targetKey]) && $aace3e920a0f1e4d$var$isPlainObject(val)) result[targetKey] = $aace3e920a0f1e4d$var$merge(result[targetKey], val);
        else if ($aace3e920a0f1e4d$var$isPlainObject(val)) result[targetKey] = $aace3e920a0f1e4d$var$merge({}, val);
        else if ($aace3e920a0f1e4d$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $aace3e920a0f1e4d$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $aace3e920a0f1e4d$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $aace3e920a0f1e4d$var$forEach(b, (val, key)=>{
        if (thisArg && $aace3e920a0f1e4d$var$isFunction(val)) a[key] = (0, $cG9HX.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $aace3e920a0f1e4d$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $aace3e920a0f1e4d$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $aace3e920a0f1e4d$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $aace3e920a0f1e4d$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $aace3e920a0f1e4d$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $aace3e920a0f1e4d$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($aace3e920a0f1e4d$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$aace3e920a0f1e4d$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $aace3e920a0f1e4d$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $aace3e920a0f1e4d$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $aace3e920a0f1e4d$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $aace3e920a0f1e4d$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $aace3e920a0f1e4d$var$isHTMLForm = $aace3e920a0f1e4d$var$kindOfTest("HTMLFormElement");
const $aace3e920a0f1e4d$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $aace3e920a0f1e4d$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $aace3e920a0f1e4d$var$isRegExp = $aace3e920a0f1e4d$var$kindOfTest("RegExp");
const $aace3e920a0f1e4d$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $aace3e920a0f1e4d$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $aace3e920a0f1e4d$var$freezeMethods = (obj)=>{
    $aace3e920a0f1e4d$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($aace3e920a0f1e4d$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$aace3e920a0f1e4d$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $aace3e920a0f1e4d$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $aace3e920a0f1e4d$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $aace3e920a0f1e4d$var$noop = ()=>{};
const $aace3e920a0f1e4d$var$toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const $aace3e920a0f1e4d$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $aace3e920a0f1e4d$var$DIGIT = "0123456789";
const $aace3e920a0f1e4d$var$ALPHABET = {
    DIGIT: $aace3e920a0f1e4d$var$DIGIT,
    ALPHA: $aace3e920a0f1e4d$var$ALPHA,
    ALPHA_DIGIT: $aace3e920a0f1e4d$var$ALPHA + $aace3e920a0f1e4d$var$ALPHA.toUpperCase() + $aace3e920a0f1e4d$var$DIGIT
};
const $aace3e920a0f1e4d$var$generateString = (size = 16, alphabet = $aace3e920a0f1e4d$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $aace3e920a0f1e4d$var$isSpecCompliantForm(thing) {
    return !!(thing && $aace3e920a0f1e4d$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $aace3e920a0f1e4d$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($aace3e920a0f1e4d$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $aace3e920a0f1e4d$var$isArray(source) ? [] : {};
                $aace3e920a0f1e4d$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$aace3e920a0f1e4d$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $aace3e920a0f1e4d$var$isAsyncFn = $aace3e920a0f1e4d$var$kindOfTest("AsyncFunction");
const $aace3e920a0f1e4d$var$isThenable = (thing)=>thing && ($aace3e920a0f1e4d$var$isObject(thing) || $aace3e920a0f1e4d$var$isFunction(thing)) && $aace3e920a0f1e4d$var$isFunction(thing.then) && $aace3e920a0f1e4d$var$isFunction(thing.catch);
var $aace3e920a0f1e4d$export$2e2bcd8739ae039 = {
    isArray: $aace3e920a0f1e4d$var$isArray,
    isArrayBuffer: $aace3e920a0f1e4d$var$isArrayBuffer,
    isBuffer: $aace3e920a0f1e4d$var$isBuffer,
    isFormData: $aace3e920a0f1e4d$var$isFormData,
    isArrayBufferView: $aace3e920a0f1e4d$var$isArrayBufferView,
    isString: $aace3e920a0f1e4d$var$isString,
    isNumber: $aace3e920a0f1e4d$var$isNumber,
    isBoolean: $aace3e920a0f1e4d$var$isBoolean,
    isObject: $aace3e920a0f1e4d$var$isObject,
    isPlainObject: $aace3e920a0f1e4d$var$isPlainObject,
    isUndefined: $aace3e920a0f1e4d$var$isUndefined,
    isDate: $aace3e920a0f1e4d$var$isDate,
    isFile: $aace3e920a0f1e4d$var$isFile,
    isBlob: $aace3e920a0f1e4d$var$isBlob,
    isRegExp: $aace3e920a0f1e4d$var$isRegExp,
    isFunction: $aace3e920a0f1e4d$var$isFunction,
    isStream: $aace3e920a0f1e4d$var$isStream,
    isURLSearchParams: $aace3e920a0f1e4d$var$isURLSearchParams,
    isTypedArray: $aace3e920a0f1e4d$var$isTypedArray,
    isFileList: $aace3e920a0f1e4d$var$isFileList,
    forEach: $aace3e920a0f1e4d$var$forEach,
    merge: $aace3e920a0f1e4d$var$merge,
    extend: $aace3e920a0f1e4d$var$extend,
    trim: $aace3e920a0f1e4d$var$trim,
    stripBOM: $aace3e920a0f1e4d$var$stripBOM,
    inherits: $aace3e920a0f1e4d$var$inherits,
    toFlatObject: $aace3e920a0f1e4d$var$toFlatObject,
    kindOf: $aace3e920a0f1e4d$var$kindOf,
    kindOfTest: $aace3e920a0f1e4d$var$kindOfTest,
    endsWith: $aace3e920a0f1e4d$var$endsWith,
    toArray: $aace3e920a0f1e4d$var$toArray,
    forEachEntry: $aace3e920a0f1e4d$var$forEachEntry,
    matchAll: $aace3e920a0f1e4d$var$matchAll,
    isHTMLForm: $aace3e920a0f1e4d$var$isHTMLForm,
    hasOwnProperty: $aace3e920a0f1e4d$var$hasOwnProperty,
    hasOwnProp: $aace3e920a0f1e4d$var$hasOwnProperty,
    reduceDescriptors: $aace3e920a0f1e4d$var$reduceDescriptors,
    freezeMethods: $aace3e920a0f1e4d$var$freezeMethods,
    toObjectSet: $aace3e920a0f1e4d$var$toObjectSet,
    toCamelCase: $aace3e920a0f1e4d$var$toCamelCase,
    noop: $aace3e920a0f1e4d$var$noop,
    toFiniteNumber: $aace3e920a0f1e4d$var$toFiniteNumber,
    findKey: $aace3e920a0f1e4d$var$findKey,
    global: $aace3e920a0f1e4d$var$_global,
    isContextDefined: $aace3e920a0f1e4d$var$isContextDefined,
    ALPHABET: $aace3e920a0f1e4d$var$ALPHABET,
    generateString: $aace3e920a0f1e4d$var$generateString,
    isSpecCompliantForm: $aace3e920a0f1e4d$var$isSpecCompliantForm,
    toJSONObject: $aace3e920a0f1e4d$var$toJSONObject,
    isAsyncFn: $aace3e920a0f1e4d$var$isAsyncFn,
    isThenable: $aace3e920a0f1e4d$var$isThenable
};

});
parcelRegister("cG9HX", function(module, exports) {

$parcel$export(module.exports, "default", () => $93b0f01b05e2607a$export$2e2bcd8739ae039);
"use strict";
function $93b0f01b05e2607a$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});


parcelRegister("hBrVA", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd0b8e3cbef64068$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $iOHZJ = parcelRequire("iOHZJ");

var $9ltoJ = parcelRequire("9ltoJ");

var $cUzFg = parcelRequire("cUzFg");

var $2PhsF = parcelRequire("2PhsF");

var $cgfHI = parcelRequire("cgfHI");

var $8zXsW = parcelRequire("8zXsW");

var $7hTsj = parcelRequire("7hTsj");
"use strict";
const $cd0b8e3cbef64068$var$validators = (0, $8zXsW.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $cd0b8e3cbef64068$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $9ltoJ.default)(),
            response: new (0, $9ltoJ.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                if (!err.stack) err.stack = stack;
                else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $2PhsF.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $8zXsW.default).assertOptions(transitional, {
            silentJSONParsing: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
            forcedJSONParsing: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
            clarifyTimeoutError: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $eFc3n.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $8zXsW.default).assertOptions(paramsSerializer, {
                encode: $cd0b8e3cbef64068$var$validators.function,
                serialize: $cd0b8e3cbef64068$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $eFc3n.default).merge(headers.common, headers[config.method]);
        headers && (0, $eFc3n.default).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $7hTsj.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $cUzFg.default).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $cUzFg.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $2PhsF.default)(this.defaults, config);
        const fullPath = (0, $cgfHI.default)(config.baseURL, config.url);
        return (0, $iOHZJ.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $eFc3n.default).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $cd0b8e3cbef64068$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $2PhsF.default)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $eFc3n.default).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $2PhsF.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $cd0b8e3cbef64068$var$Axios.prototype[method] = generateHTTPMethod();
    $cd0b8e3cbef64068$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $cd0b8e3cbef64068$export$2e2bcd8739ae039 = $cd0b8e3cbef64068$var$Axios;

});
parcelRegister("iOHZJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $db2f05ec923f2ee7$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $4uovm = parcelRequire("4uovm");
"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $db2f05ec923f2ee7$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $db2f05ec923f2ee7$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $db2f05ec923f2ee7$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $eFc3n.default).isURLSearchParams(params) ? params.toString() : new (0, $4uovm.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}

});
parcelRegister("4uovm", function(module, exports) {

$parcel$export(module.exports, "default", () => $344cf8e4292137b6$export$2e2bcd8739ae039);

var $lISaw = parcelRequire("lISaw");
"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $344cf8e4292137b6$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $344cf8e4292137b6$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $lISaw.default)(params, this, options);
}
const $344cf8e4292137b6$var$prototype = $344cf8e4292137b6$var$AxiosURLSearchParams.prototype;
$344cf8e4292137b6$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$344cf8e4292137b6$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $344cf8e4292137b6$var$encode);
    } : $344cf8e4292137b6$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $344cf8e4292137b6$export$2e2bcd8739ae039 = $344cf8e4292137b6$var$AxiosURLSearchParams;

});
parcelRegister("lISaw", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd07b9cb0132c1f6$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $6wIUo = parcelRequire("6wIUo");

var $bAbs8 = parcelRequire("bAbs8");

var $N0o3H = parcelRequire("N0o3H");
var $fd07b9cb0132c1f6$require$Buffer = $N0o3H.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $fd07b9cb0132c1f6$var$isVisitable(thing) {
    return (0, $eFc3n.default).isPlainObject(thing) || (0, $eFc3n.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $fd07b9cb0132c1f6$var$removeBrackets(key) {
    return (0, $eFc3n.default).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $fd07b9cb0132c1f6$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $fd07b9cb0132c1f6$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $fd07b9cb0132c1f6$var$isFlatArray(arr) {
    return (0, $eFc3n.default).isArray(arr) && !arr.some($fd07b9cb0132c1f6$var$isVisitable);
}
const $fd07b9cb0132c1f6$var$predicates = (0, $eFc3n.default).toFlatObject((0, $eFc3n.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $fd07b9cb0132c1f6$var$toFormData(obj, formData, options) {
    if (!(0, $eFc3n.default).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $bAbs8.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $eFc3n.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $eFc3n.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $eFc3n.default).isSpecCompliantForm(formData);
    if (!(0, $eFc3n.default).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $eFc3n.default).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $eFc3n.default).isBlob(value)) throw new (0, $6wIUo.default)("Blob is not supported. Use a Buffer instead.");
        if ((0, $eFc3n.default).isArrayBuffer(value) || (0, $eFc3n.default).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $fd07b9cb0132c1f6$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $eFc3n.default).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $eFc3n.default).isArray(value) && $fd07b9cb0132c1f6$var$isFlatArray(value) || ((0, $eFc3n.default).isFileList(value) || (0, $eFc3n.default).endsWith(key, "[]")) && (arr = (0, $eFc3n.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $fd07b9cb0132c1f6$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $eFc3n.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $fd07b9cb0132c1f6$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($fd07b9cb0132c1f6$var$isVisitable(value)) return true;
        formData.append($fd07b9cb0132c1f6$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($fd07b9cb0132c1f6$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $fd07b9cb0132c1f6$var$isVisitable
    });
    function build(value, path) {
        if ((0, $eFc3n.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $eFc3n.default).forEach(value, function each(el, key) {
            const result = !((0, $eFc3n.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $eFc3n.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $eFc3n.default).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $fd07b9cb0132c1f6$export$2e2bcd8739ae039 = $fd07b9cb0132c1f6$var$toFormData;

});
parcelRegister("6wIUo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0139f1d30f4d6bd5$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");
"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $0139f1d30f4d6bd5$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $eFc3n.default).inherits($0139f1d30f4d6bd5$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $eFc3n.default).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $0139f1d30f4d6bd5$var$prototype = $0139f1d30f4d6bd5$var$AxiosError.prototype;
const $0139f1d30f4d6bd5$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $0139f1d30f4d6bd5$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($0139f1d30f4d6bd5$var$AxiosError, $0139f1d30f4d6bd5$var$descriptors);
Object.defineProperty($0139f1d30f4d6bd5$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$0139f1d30f4d6bd5$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($0139f1d30f4d6bd5$var$prototype);
    (0, $eFc3n.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $0139f1d30f4d6bd5$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $0139f1d30f4d6bd5$export$2e2bcd8739ae039 = $0139f1d30f4d6bd5$var$AxiosError;

});

parcelRegister("bAbs8", function(module, exports) {

$parcel$export(module.exports, "default", () => $86ebf0c810395e29$export$2e2bcd8739ae039);
// eslint-disable-next-line strict
var $86ebf0c810395e29$export$2e2bcd8739ae039 = null;

});

parcelRegister("N0o3H", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $0934e0939605d48c$export$a143d493d941bafc, (v) => $0934e0939605d48c$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $0934e0939605d48c$export$f99ded8fe4b79145, (v) => $0934e0939605d48c$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $0934e0939605d48c$export$a143d493d941bafc;
var $0934e0939605d48c$export$e4cf37d7f6fb9e0a;
var $0934e0939605d48c$export$f99ded8fe4b79145;
var $0934e0939605d48c$export$599f31c3813fae4d;
"use strict";

var $bQMRt = parcelRequire("bQMRt");

var $dbnIE = parcelRequire("dbnIE");
const $0934e0939605d48c$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$0934e0939605d48c$export$a143d493d941bafc = $0934e0939605d48c$var$Buffer;
$0934e0939605d48c$export$e4cf37d7f6fb9e0a = $0934e0939605d48c$var$SlowBuffer;
$0934e0939605d48c$export$f99ded8fe4b79145 = 50;
const $0934e0939605d48c$var$K_MAX_LENGTH = 0x7fffffff;
$0934e0939605d48c$export$599f31c3813fae4d = $0934e0939605d48c$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT = $0934e0939605d48c$var$typedArraySupport();
if (!$0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $0934e0939605d48c$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $0934e0939605d48c$var$createBuffer(length) {
    if (length > $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $0934e0939605d48c$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $0934e0939605d48c$var$allocUnsafe(arg);
    }
    return $0934e0939605d48c$var$from(arg, encodingOrOffset, length);
}
$0934e0939605d48c$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $0934e0939605d48c$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $0934e0939605d48c$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $0934e0939605d48c$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($0934e0939605d48c$var$isInstance(value, ArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, ArrayBuffer)) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($0934e0939605d48c$var$isInstance(value, SharedArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, SharedArrayBuffer))) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $0934e0939605d48c$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $0934e0939605d48c$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $0934e0939605d48c$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $0934e0939605d48c$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $0934e0939605d48c$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($0934e0939605d48c$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($0934e0939605d48c$var$Buffer, Uint8Array);
function $0934e0939605d48c$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $0934e0939605d48c$var$alloc(size, fill, encoding) {
    $0934e0939605d48c$var$assertSize(size);
    if (size <= 0) return $0934e0939605d48c$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $0934e0939605d48c$var$createBuffer(size).fill(fill, encoding) : $0934e0939605d48c$var$createBuffer(size).fill(fill);
    return $0934e0939605d48c$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $0934e0939605d48c$var$Buffer.alloc = function(size, fill, encoding) {
    return $0934e0939605d48c$var$alloc(size, fill, encoding);
};
function $0934e0939605d48c$var$allocUnsafe(size) {
    $0934e0939605d48c$var$assertSize(size);
    return $0934e0939605d48c$var$createBuffer(size < 0 ? 0 : $0934e0939605d48c$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $0934e0939605d48c$var$Buffer.allocUnsafe = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $0934e0939605d48c$var$Buffer.allocUnsafeSlow = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
function $0934e0939605d48c$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $0934e0939605d48c$var$byteLength(string, encoding) | 0;
    let buf = $0934e0939605d48c$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $0934e0939605d48c$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $0934e0939605d48c$var$checked(array.length) | 0;
    const buf = $0934e0939605d48c$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $0934e0939605d48c$var$fromArrayView(arrayView) {
    if ($0934e0939605d48c$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $0934e0939605d48c$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $0934e0939605d48c$var$fromArrayLike(arrayView);
}
function $0934e0939605d48c$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
function $0934e0939605d48c$var$fromObject(obj) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(obj)) {
        const len = $0934e0939605d48c$var$checked(obj.length) | 0;
        const buf = $0934e0939605d48c$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $0934e0939605d48c$var$numberIsNaN(obj.length)) return $0934e0939605d48c$var$createBuffer(0);
        return $0934e0939605d48c$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $0934e0939605d48c$var$fromArrayLike(obj.data);
}
function $0934e0939605d48c$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $0934e0939605d48c$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $0934e0939605d48c$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $0934e0939605d48c$var$Buffer.alloc(+length);
}
$0934e0939605d48c$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $0934e0939605d48c$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$0934e0939605d48c$var$Buffer.compare = function compare(a, b) {
    if ($0934e0939605d48c$var$isInstance(a, Uint8Array)) a = $0934e0939605d48c$var$Buffer.from(a, a.offset, a.byteLength);
    if ($0934e0939605d48c$var$isInstance(b, Uint8Array)) b = $0934e0939605d48c$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(a) || !$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$0934e0939605d48c$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$0934e0939605d48c$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $0934e0939605d48c$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $0934e0939605d48c$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($0934e0939605d48c$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) buf = $0934e0939605d48c$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $0934e0939605d48c$var$byteLength(string, encoding) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $0934e0939605d48c$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $0934e0939605d48c$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $0934e0939605d48c$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $0934e0939605d48c$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$0934e0939605d48c$var$Buffer.byteLength = $0934e0939605d48c$var$byteLength;
function $0934e0939605d48c$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $0934e0939605d48c$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $0934e0939605d48c$var$utf8Slice(this, start, end);
        case "ascii":
            return $0934e0939605d48c$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $0934e0939605d48c$var$latin1Slice(this, start, end);
        case "base64":
            return $0934e0939605d48c$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $0934e0939605d48c$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$0934e0939605d48c$var$Buffer.prototype._isBuffer = true;
function $0934e0939605d48c$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$0934e0939605d48c$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$0934e0939605d48c$var$swap(this, i, i + 1);
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $0934e0939605d48c$var$swap(this, i, i + 3);
        $0934e0939605d48c$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $0934e0939605d48c$var$swap(this, i, i + 7);
        $0934e0939605d48c$var$swap(this, i + 1, i + 6);
        $0934e0939605d48c$var$swap(this, i + 2, i + 5);
        $0934e0939605d48c$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $0934e0939605d48c$var$utf8Slice(this, 0, length);
    return $0934e0939605d48c$var$slowToString.apply(this, arguments);
};
$0934e0939605d48c$var$Buffer.prototype.toLocaleString = $0934e0939605d48c$var$Buffer.prototype.toString;
$0934e0939605d48c$var$Buffer.prototype.equals = function equals(b) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $0934e0939605d48c$var$Buffer.compare(this, b) === 0;
};
$0934e0939605d48c$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $0934e0939605d48c$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($0934e0939605d48c$var$customInspectSymbol) $0934e0939605d48c$var$Buffer.prototype[$0934e0939605d48c$var$customInspectSymbol] = $0934e0939605d48c$var$Buffer.prototype.inspect;
$0934e0939605d48c$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($0934e0939605d48c$var$isInstance(target, Uint8Array)) target = $0934e0939605d48c$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $0934e0939605d48c$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($0934e0939605d48c$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $0934e0939605d48c$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($0934e0939605d48c$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $0934e0939605d48c$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $0934e0939605d48c$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $0934e0939605d48c$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$0934e0939605d48c$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$0934e0939605d48c$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$0934e0939605d48c$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $0934e0939605d48c$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($0934e0939605d48c$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $0934e0939605d48c$var$utf8Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $0934e0939605d48c$var$asciiWrite(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$asciiToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$base64Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$base64ToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$ucs2Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$0934e0939605d48c$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $0934e0939605d48c$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $0934e0939605d48c$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $0934e0939605d48c$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $0934e0939605d48c$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $0934e0939605d48c$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$0934e0939605d48c$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $0934e0939605d48c$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $bQMRt.fromByteArray(buf);
    else return $bQMRt.fromByteArray(buf.slice(start, end));
}
function $0934e0939605d48c$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $0934e0939605d48c$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $0934e0939605d48c$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $0934e0939605d48c$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $0934e0939605d48c$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $0934e0939605d48c$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $0934e0939605d48c$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $0934e0939605d48c$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$0934e0939605d48c$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $0934e0939605d48c$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $0934e0939605d48c$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$0934e0939605d48c$var$Buffer.prototype.readUintLE = $0934e0939605d48c$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUintBE = $0934e0939605d48c$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUint8 = $0934e0939605d48c$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$0934e0939605d48c$var$Buffer.prototype.readUint16LE = $0934e0939605d48c$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$0934e0939605d48c$var$Buffer.prototype.readUint16BE = $0934e0939605d48c$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$0934e0939605d48c$var$Buffer.prototype.readUint32LE = $0934e0939605d48c$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$0934e0939605d48c$var$Buffer.prototype.readUint32BE = $0934e0939605d48c$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$0934e0939605d48c$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$0934e0939605d48c$var$Buffer.prototype.readBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$0934e0939605d48c$var$Buffer.prototype.readBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$0934e0939605d48c$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, true, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, false, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, true, 52, 8);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, false, 52, 8);
};
function $0934e0939605d48c$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$0934e0939605d48c$var$Buffer.prototype.writeUintLE = $0934e0939605d48c$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUintBE = $0934e0939605d48c$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint8 = $0934e0939605d48c$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $0934e0939605d48c$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $0934e0939605d48c$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$0934e0939605d48c$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $0934e0939605d48c$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $0934e0939605d48c$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$0934e0939605d48c$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, false, noAssert);
};
function $0934e0939605d48c$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$0934e0939605d48c$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$0934e0939605d48c$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $0934e0939605d48c$var$Buffer.isBuffer(val) ? val : $0934e0939605d48c$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $0934e0939605d48c$var$errors = {};
function $0934e0939605d48c$var$E(sym, getMessage, Base) {
    $0934e0939605d48c$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$0934e0939605d48c$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$0934e0939605d48c$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$0934e0939605d48c$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $0934e0939605d48c$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $0934e0939605d48c$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $0934e0939605d48c$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $0934e0939605d48c$var$checkBounds(buf, offset, byteLength) {
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $0934e0939605d48c$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $0934e0939605d48c$var$checkBounds(buf, offset, byteLength);
}
function $0934e0939605d48c$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $0934e0939605d48c$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $0934e0939605d48c$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $0934e0939605d48c$var$validateNumber(value, type);
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $0934e0939605d48c$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $0934e0939605d48c$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $0934e0939605d48c$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($0934e0939605d48c$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $0934e0939605d48c$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $0934e0939605d48c$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $0934e0939605d48c$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $0934e0939605d48c$var$base64ToBytes(str) {
    return $bQMRt.toByteArray($0934e0939605d48c$var$base64clean(str));
}
function $0934e0939605d48c$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $0934e0939605d48c$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $0934e0939605d48c$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $0934e0939605d48c$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $0934e0939605d48c$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $0934e0939605d48c$var$BufferBigIntNotDefined : fn;
}
function $0934e0939605d48c$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("bQMRt", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $8a0a73e6b73fd0c4$export$d622b2ad8d90c771, (v) => $8a0a73e6b73fd0c4$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $8a0a73e6b73fd0c4$export$6100ba28696e12de, (v) => $8a0a73e6b73fd0c4$export$6100ba28696e12de = v);
var $8a0a73e6b73fd0c4$export$a48f0734ac7c2329;
var $8a0a73e6b73fd0c4$export$d622b2ad8d90c771;
var $8a0a73e6b73fd0c4$export$6100ba28696e12de;
"use strict";
$8a0a73e6b73fd0c4$export$a48f0734ac7c2329 = $8a0a73e6b73fd0c4$var$byteLength;
$8a0a73e6b73fd0c4$export$d622b2ad8d90c771 = $8a0a73e6b73fd0c4$var$toByteArray;
$8a0a73e6b73fd0c4$export$6100ba28696e12de = $8a0a73e6b73fd0c4$var$fromByteArray;
var $8a0a73e6b73fd0c4$var$lookup = [];
var $8a0a73e6b73fd0c4$var$revLookup = [];
var $8a0a73e6b73fd0c4$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $8a0a73e6b73fd0c4$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $8a0a73e6b73fd0c4$var$i = 0, $8a0a73e6b73fd0c4$var$len = $8a0a73e6b73fd0c4$var$code.length; $8a0a73e6b73fd0c4$var$i < $8a0a73e6b73fd0c4$var$len; ++$8a0a73e6b73fd0c4$var$i){
    $8a0a73e6b73fd0c4$var$lookup[$8a0a73e6b73fd0c4$var$i] = $8a0a73e6b73fd0c4$var$code[$8a0a73e6b73fd0c4$var$i];
    $8a0a73e6b73fd0c4$var$revLookup[$8a0a73e6b73fd0c4$var$code.charCodeAt($8a0a73e6b73fd0c4$var$i)] = $8a0a73e6b73fd0c4$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$8a0a73e6b73fd0c4$var$revLookup["-".charCodeAt(0)] = 62;
$8a0a73e6b73fd0c4$var$revLookup["_".charCodeAt(0)] = 63;
function $8a0a73e6b73fd0c4$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $8a0a73e6b73fd0c4$var$byteLength(b64) {
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$toByteArray(b64) {
    var tmp;
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $8a0a73e6b73fd0c4$var$Arr($8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 18 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 2 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 10 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $8a0a73e6b73fd0c4$var$tripletToBase64(num) {
    return $8a0a73e6b73fd0c4$var$lookup[num >> 18 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 12 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 6 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num & 0x3F];
}
function $8a0a73e6b73fd0c4$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($8a0a73e6b73fd0c4$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $8a0a73e6b73fd0c4$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($8a0a73e6b73fd0c4$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 2] + $8a0a73e6b73fd0c4$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 10] + $8a0a73e6b73fd0c4$var$lookup[tmp >> 4 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("dbnIE", function(module, exports) {

$parcel$export(module.exports, "read", () => $998eb38f4d082829$export$aafa59e2e03f2942, (v) => $998eb38f4d082829$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $998eb38f4d082829$export$68d8715fc104d294, (v) => $998eb38f4d082829$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $998eb38f4d082829$export$aafa59e2e03f2942;
var $998eb38f4d082829$export$68d8715fc104d294;
$998eb38f4d082829$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$998eb38f4d082829$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});





parcelRegister("9ltoJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $01c17f80085c95b1$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");
"use strict";
class $01c17f80085c95b1$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $eFc3n.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $01c17f80085c95b1$export$2e2bcd8739ae039 = $01c17f80085c95b1$var$InterceptorManager;

});

parcelRegister("cUzFg", function(module, exports) {

$parcel$export(module.exports, "default", () => $96666136aaccd2e5$export$2e2bcd8739ae039);

var $kgh03 = parcelRequire("kgh03");

var $lCgfr = parcelRequire("lCgfr");

var $juuss = parcelRequire("juuss");

var $8yOyy = parcelRequire("8yOyy");

var $7hTsj = parcelRequire("7hTsj");

var $ik8Aj = parcelRequire("ik8Aj");
"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $96666136aaccd2e5$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $8yOyy.default)(null, config);
}
function $96666136aaccd2e5$export$2e2bcd8739ae039(config) {
    $96666136aaccd2e5$var$throwIfCancellationRequested(config);
    config.headers = (0, $7hTsj.default).from(config.headers);
    // Transform request data
    config.data = (0, $kgh03.default).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $ik8Aj.default).getAdapter(config.adapter || (0, $juuss.default).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $96666136aaccd2e5$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $kgh03.default).call(config, config.transformResponse, response);
        response.headers = (0, $7hTsj.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $lCgfr.default)(reason)) {
            $96666136aaccd2e5$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $kgh03.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $7hTsj.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("kgh03", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec027d10dfede142$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $juuss = parcelRequire("juuss");

var $7hTsj = parcelRequire("7hTsj");
"use strict";
function $ec027d10dfede142$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $juuss.default);
    const context = response || config;
    const headers = (0, $7hTsj.default).from(context.headers);
    let data = context.data;
    (0, $eFc3n.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("juuss", function(module, exports) {

$parcel$export(module.exports, "default", () => $e30871f78dcd7f19$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $6wIUo = parcelRequire("6wIUo");

var $49WWV = parcelRequire("49WWV");

var $lISaw = parcelRequire("lISaw");

var $eAUco = parcelRequire("eAUco");

var $bqN51 = parcelRequire("bqN51");

var $htyv1 = parcelRequire("htyv1");
"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $e30871f78dcd7f19$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $eFc3n.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $eFc3n.default).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $e30871f78dcd7f19$var$defaults = {
    transitional: (0, $49WWV.default),
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $eFc3n.default).isObject(data);
            if (isObjectPayload && (0, $eFc3n.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $eFc3n.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $htyv1.default)(data)) : data;
            if ((0, $eFc3n.default).isArrayBuffer(data) || (0, $eFc3n.default).isBuffer(data) || (0, $eFc3n.default).isStream(data) || (0, $eFc3n.default).isFile(data) || (0, $eFc3n.default).isBlob(data)) return data;
            if ((0, $eFc3n.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $eFc3n.default).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $eAUco.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, $eFc3n.default).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $lISaw.default)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $e30871f78dcd7f19$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $e30871f78dcd7f19$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, $eFc3n.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $6wIUo.default).from(e, (0, $6wIUo.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $bqN51.default).classes.FormData,
        Blob: (0, $bqN51.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $eFc3n.default).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $e30871f78dcd7f19$var$defaults.headers[method] = {};
});
var $e30871f78dcd7f19$export$2e2bcd8739ae039 = $e30871f78dcd7f19$var$defaults;

});
parcelRegister("49WWV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3075bac9f30e7782$export$2e2bcd8739ae039);
"use strict";
var $3075bac9f30e7782$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("eAUco", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa000567d8bb5ae2$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $lISaw = parcelRequire("lISaw");

var $bqN51 = parcelRequire("bqN51");
"use strict";
function $aa000567d8bb5ae2$export$2e2bcd8739ae039(data, options) {
    return (0, $lISaw.default)(data, new (0, $bqN51.default).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $bqN51.default).isNode && (0, $eFc3n.default).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

});
parcelRegister("bqN51", function(module, exports) {

$parcel$export(module.exports, "default", () => $852831b4a152a7ad$export$2e2bcd8739ae039);

var $lyPzr = parcelRequire("lyPzr");

var $31g1y = parcelRequire("31g1y");
var $852831b4a152a7ad$export$2e2bcd8739ae039 = {
    ...$31g1y,
    ...(0, $lyPzr.default)
};

});
parcelRegister("lyPzr", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb24c6d0b2a74508$export$2e2bcd8739ae039);

var $esdLz = parcelRequire("esdLz");

var $64i7Q = parcelRequire("64i7Q");

var $3YeiC = parcelRequire("3YeiC");
var $fb24c6d0b2a74508$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $esdLz.default,
        FormData: $64i7Q.default,
        Blob: $3YeiC.default
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};

});
parcelRegister("esdLz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a85e5bed82430d61$export$2e2bcd8739ae039);

var $4uovm = parcelRequire("4uovm");
"use strict";
var $a85e5bed82430d61$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $4uovm.default);

});

parcelRegister("64i7Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $46b12d255f217052$export$2e2bcd8739ae039);
"use strict";
var $46b12d255f217052$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;

});

parcelRegister("3YeiC", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e4211376cea43e6$export$2e2bcd8739ae039);
"use strict";
var $2e4211376cea43e6$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;

});


parcelRegister("31g1y", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", () => $232de52881daaba8$export$c4996c4b7b93b0bf);
$parcel$export(module.exports, "hasStandardBrowserEnv", () => $232de52881daaba8$export$c0bcc9250309d66);
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", () => $232de52881daaba8$export$c81692cf5af97dac);
const $232de52881daaba8$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $232de52881daaba8$export$c0bcc9250309d66 = ((product)=>{
    return $232de52881daaba8$export$c4996c4b7b93b0bf && [
        "ReactNative",
        "NativeScript",
        "NS"
    ].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $232de52881daaba8$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();

});



parcelRegister("htyv1", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb8fe7f388dc4432$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");
"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $cb8fe7f388dc4432$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $eFc3n.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $cb8fe7f388dc4432$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $cb8fe7f388dc4432$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $eFc3n.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $eFc3n.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $eFc3n.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $eFc3n.default).isArray(target[name])) target[name] = $cb8fe7f388dc4432$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $eFc3n.default).isFormData(formData) && (0, $eFc3n.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $eFc3n.default).forEachEntry(formData, (name, value)=>{
            buildPath($cb8fe7f388dc4432$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $cb8fe7f388dc4432$export$2e2bcd8739ae039 = $cb8fe7f388dc4432$var$formDataToJSON;

});


parcelRegister("7hTsj", function(module, exports) {

$parcel$export(module.exports, "default", () => $54e5234108b8e954$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $4Ik1V = parcelRequire("4Ik1V");
"use strict";
const $54e5234108b8e954$var$$internals = Symbol("internals");
function $54e5234108b8e954$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $54e5234108b8e954$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $eFc3n.default).isArray(value) ? value.map($54e5234108b8e954$var$normalizeValue) : String(value);
}
function $54e5234108b8e954$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $54e5234108b8e954$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $54e5234108b8e954$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $eFc3n.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $eFc3n.default).isString(value)) return;
    if ((0, $eFc3n.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $eFc3n.default).isRegExp(filter)) return filter.test(value);
}
function $54e5234108b8e954$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $54e5234108b8e954$var$buildAccessors(obj, header) {
    const accessorName = (0, $eFc3n.default).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $54e5234108b8e954$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $54e5234108b8e954$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $eFc3n.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $54e5234108b8e954$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $eFc3n.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $eFc3n.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $eFc3n.default).isString(header) && (header = header.trim()) && !$54e5234108b8e954$var$isValidHeaderName(header)) setHeaders((0, $4Ik1V.default)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $54e5234108b8e954$var$normalizeHeader(header);
        if (header) {
            const key = (0, $eFc3n.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $54e5234108b8e954$var$parseTokens(value);
                if ((0, $eFc3n.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $eFc3n.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $54e5234108b8e954$var$normalizeHeader(header);
        if (header) {
            const key = (0, $eFc3n.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $54e5234108b8e954$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $54e5234108b8e954$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $eFc3n.default).findKey(self, _header);
                if (key && (!matcher || $54e5234108b8e954$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $eFc3n.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $54e5234108b8e954$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $eFc3n.default).forEach(this, (value, header)=>{
            const key = (0, $eFc3n.default).findKey(headers, header);
            if (key) {
                self[key] = $54e5234108b8e954$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $54e5234108b8e954$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $54e5234108b8e954$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $eFc3n.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $eFc3n.default).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$54e5234108b8e954$var$$internals] = this[$54e5234108b8e954$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $54e5234108b8e954$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $54e5234108b8e954$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $eFc3n.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$54e5234108b8e954$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $eFc3n.default).reduceDescriptors($54e5234108b8e954$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $eFc3n.default).freezeMethods($54e5234108b8e954$var$AxiosHeaders);
var $54e5234108b8e954$export$2e2bcd8739ae039 = $54e5234108b8e954$var$AxiosHeaders;

});
parcelRegister("4Ik1V", function(module, exports) {

$parcel$export(module.exports, "default", () => $36eacf0f5ae88424$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");
"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $36eacf0f5ae88424$var$ignoreDuplicateOf = (0, $eFc3n.default).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $36eacf0f5ae88424$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $36eacf0f5ae88424$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};

});



parcelRegister("lCgfr", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbc9c01c5c3dc518$export$2e2bcd8739ae039);
"use strict";
function $fbc9c01c5c3dc518$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("8yOyy", function(module, exports) {

$parcel$export(module.exports, "default", () => $63b8b72909769bf2$export$2e2bcd8739ae039);

var $6wIUo = parcelRequire("6wIUo");

var $eFc3n = parcelRequire("eFc3n");
"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $63b8b72909769bf2$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $6wIUo.default).call(this, message == null ? "canceled" : message, (0, $6wIUo.default).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $eFc3n.default).inherits($63b8b72909769bf2$var$CanceledError, (0, $6wIUo.default), {
    __CANCEL__: true
});
var $63b8b72909769bf2$export$2e2bcd8739ae039 = $63b8b72909769bf2$var$CanceledError;

});

parcelRegister("ik8Aj", function(module, exports) {

$parcel$export(module.exports, "default", () => $d570c100e0cb7a05$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $bAbs8 = parcelRequire("bAbs8");

var $8nTSD = parcelRequire("8nTSD");

var $6wIUo = parcelRequire("6wIUo");
const $d570c100e0cb7a05$var$knownAdapters = {
    http: (0, $bAbs8.default),
    xhr: (0, $8nTSD.default)
};
(0, $eFc3n.default).forEach($d570c100e0cb7a05$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $d570c100e0cb7a05$var$renderReason = (reason)=>`- ${reason}`;
const $d570c100e0cb7a05$var$isResolvedHandle = (adapter)=>(0, $eFc3n.default).isFunction(adapter) || adapter === null || adapter === false;
var $d570c100e0cb7a05$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $eFc3n.default).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$d570c100e0cb7a05$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $d570c100e0cb7a05$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $6wIUo.default)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($d570c100e0cb7a05$var$renderReason).join("\n") : " " + $d570c100e0cb7a05$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $6wIUo.default)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $d570c100e0cb7a05$var$knownAdapters
};

});
parcelRegister("8nTSD", function(module, exports) {

$parcel$export(module.exports, "default", () => $61abd1574bd1dd32$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $gyIfz = parcelRequire("gyIfz");

var $6D8uh = parcelRequire("6D8uh");

var $iOHZJ = parcelRequire("iOHZJ");

var $cgfHI = parcelRequire("cgfHI");

var $4YUSN = parcelRequire("4YUSN");

var $49WWV = parcelRequire("49WWV");

var $6wIUo = parcelRequire("6wIUo");

var $8yOyy = parcelRequire("8yOyy");

var $drWk7 = parcelRequire("drWk7");

var $bqN51 = parcelRequire("bqN51");

var $7hTsj = parcelRequire("7hTsj");

var $6eLe3 = parcelRequire("6eLe3");
"use strict";
function $61abd1574bd1dd32$var$progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, $6eLe3.default)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const $61abd1574bd1dd32$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $61abd1574bd1dd32$export$2e2bcd8739ae039 = $61abd1574bd1dd32$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, $7hTsj.default).from(config.headers).normalize();
        let { responseType: responseType, withXSRFToken: withXSRFToken } = config;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        let contentType;
        if ((0, $eFc3n.default).isFormData(requestData)) {
            if ((0, $bqN51.default).hasStandardBrowserEnv || (0, $bqN51.default).hasStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else if ((contentType = requestHeaders.getContentType()) !== false) {
                // fix semicolon duplication issue for ReactNative FormData implementation
                const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
                requestHeaders.setContentType([
                    type || "multipart/form-data",
                    ...tokens
                ].join("; "));
            }
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, $cgfHI.default)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, $iOHZJ.default)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $7hTsj.default).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $gyIfz.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $6wIUo.default)("Request aborted", (0, $6wIUo.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $6wIUo.default)("Network Error", (0, $6wIUo.default).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, $49WWV.default);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, $6wIUo.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $6wIUo.default).ETIMEDOUT : (0, $6wIUo.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, $bqN51.default).hasStandardBrowserEnv) {
            withXSRFToken && (0, $eFc3n.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));
            if (withXSRFToken || withXSRFToken !== false && (0, $4YUSN.default)(fullPath)) {
                // Add xsrf header
                const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && (0, $6D8uh.default).read(config.xsrfCookieName);
                if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
            }
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $eFc3n.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $eFc3n.default).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", $61abd1574bd1dd32$var$progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", $61abd1574bd1dd32$var$progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $8yOyy.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $drWk7.default)(fullPath);
        if (protocol && (0, $bqN51.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, $6wIUo.default)("Unsupported protocol " + protocol + ":", (0, $6wIUo.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("gyIfz", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0e22576f74b8071$export$2e2bcd8739ae039);

var $6wIUo = parcelRequire("6wIUo");
"use strict";
function $c0e22576f74b8071$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $6wIUo.default)("Request failed with status code " + response.status, [
        (0, $6wIUo.default).ERR_BAD_REQUEST,
        (0, $6wIUo.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

});

parcelRegister("6D8uh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d3cf801f7fd4dc6$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $bqN51 = parcelRequire("bqN51");
var $4d3cf801f7fd4dc6$export$2e2bcd8739ae039 = (0, $bqN51.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $eFc3n.default).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $eFc3n.default).isString(path) && cookie.push("path=" + path);
        (0, $eFc3n.default).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("cgfHI", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ed3292b1f9dccb5$export$2e2bcd8739ae039);

var $uAxSn = parcelRequire("uAxSn");

var $aFAjA = parcelRequire("aFAjA");
"use strict";
function $8ed3292b1f9dccb5$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $uAxSn.default)(requestedURL)) return (0, $aFAjA.default)(baseURL, requestedURL);
    return requestedURL;
}

});
parcelRegister("uAxSn", function(module, exports) {

$parcel$export(module.exports, "default", () => $05bf269bfca011f3$export$2e2bcd8739ae039);
"use strict";
function $05bf269bfca011f3$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("aFAjA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c49e720f6231ba2$export$2e2bcd8739ae039);
"use strict";
function $7c49e720f6231ba2$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}

});


parcelRegister("4YUSN", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a08e3bf7b3045fa$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $bqN51 = parcelRequire("bqN51");
"use strict";
var $3a08e3bf7b3045fa$export$2e2bcd8739ae039 = (0, $bqN51.default).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $eFc3n.default).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("drWk7", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cab09d0d089fc0e$export$2e2bcd8739ae039);
"use strict";
function $9cab09d0d089fc0e$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}

});

parcelRegister("6eLe3", function(module, exports) {

$parcel$export(module.exports, "default", () => $48a8aeed25ee768a$export$2e2bcd8739ae039);
"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $48a8aeed25ee768a$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $48a8aeed25ee768a$export$2e2bcd8739ae039 = $48a8aeed25ee768a$var$speedometer;

});




parcelRegister("2PhsF", function(module, exports) {

$parcel$export(module.exports, "default", () => $20ede3a7e8b675d4$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $7hTsj = parcelRequire("7hTsj");
"use strict";
const $20ede3a7e8b675d4$var$headersToObject = (thing)=>thing instanceof (0, $7hTsj.default) ? {
        ...thing
    } : thing;
function $20ede3a7e8b675d4$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $eFc3n.default).isPlainObject(target) && (0, $eFc3n.default).isPlainObject(source)) return (0, $eFc3n.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $eFc3n.default).isPlainObject(source)) return (0, $eFc3n.default).merge({}, source);
        else if ((0, $eFc3n.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $eFc3n.default).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $eFc3n.default).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $eFc3n.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $eFc3n.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $eFc3n.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($20ede3a7e8b675d4$var$headersToObject(a), $20ede3a7e8b675d4$var$headersToObject(b), true)
    };
    (0, $eFc3n.default).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $eFc3n.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

});

parcelRegister("8zXsW", function(module, exports) {

$parcel$export(module.exports, "default", () => $63efb8494987aa98$export$2e2bcd8739ae039);

var $6yYtd = parcelRequire("6yYtd");

var $6wIUo = parcelRequire("6wIUo");
"use strict";
const $63efb8494987aa98$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $63efb8494987aa98$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $63efb8494987aa98$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $63efb8494987aa98$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $6yYtd.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $6wIUo.default)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $6wIUo.default).ERR_DEPRECATED);
        if (version && !$63efb8494987aa98$var$deprecatedWarnings[opt]) {
            $63efb8494987aa98$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $63efb8494987aa98$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $6wIUo.default)("options must be an object", (0, $6wIUo.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $6wIUo.default)("option " + opt + " must be " + result, (0, $6wIUo.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $6wIUo.default)("Unknown option " + opt, (0, $6wIUo.default).ERR_BAD_OPTION);
    }
}
var $63efb8494987aa98$export$2e2bcd8739ae039 = {
    assertOptions: $63efb8494987aa98$var$assertOptions,
    validators: $63efb8494987aa98$var$validators
};

});
parcelRegister("6yYtd", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $4c74d331112ba968$export$a4ad2735b021c132);
const $4c74d331112ba968$export$a4ad2735b021c132 = "1.6.8";

});



parcelRegister("4iFhx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3218dd97b5460664$export$2e2bcd8739ae039);

var $8yOyy = parcelRequire("8yOyy");
"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $3218dd97b5460664$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $8yOyy.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $3218dd97b5460664$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $3218dd97b5460664$export$2e2bcd8739ae039 = $3218dd97b5460664$var$CancelToken;

});

parcelRegister("albzn", function(module, exports) {

$parcel$export(module.exports, "default", () => $7874d702b64e6994$export$2e2bcd8739ae039);
"use strict";
function $7874d702b64e6994$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("1YbHN", function(module, exports) {

$parcel$export(module.exports, "default", () => $16f479813f4fb9c8$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");
"use strict";
function $16f479813f4fb9c8$export$2e2bcd8739ae039(payload) {
    return (0, $eFc3n.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("kq2bQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $edd7ef3f6e3b67e5$export$2e2bcd8739ae039);
const $edd7ef3f6e3b67e5$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($edd7ef3f6e3b67e5$var$HttpStatusCode).forEach(([key, value])=>{
    $edd7ef3f6e3b67e5$var$HttpStatusCode[value] = key;
});
var $edd7ef3f6e3b67e5$export$2e2bcd8739ae039 = $edd7ef3f6e3b67e5$var$HttpStatusCode;

});



parcelRegister("9Jm1V", function(module, exports) {

$parcel$export(module.exports, "AbstractConnector", () => $4bf7ba9bbb4881ae$export$c3faceeb92aa39dd);
$parcel$export(module.exports, "iterateDeletedStructs", () => $4bf7ba9bbb4881ae$export$8afefebbaf4e4c78);
$parcel$export(module.exports, "isDeleted", () => $4bf7ba9bbb4881ae$export$dcb04af092e44fde);
$parcel$export(module.exports, "createDeleteSet", () => $4bf7ba9bbb4881ae$export$8cbac0d946238699);
$parcel$export(module.exports, "createDeleteSetFromStructStore", () => $4bf7ba9bbb4881ae$export$8450d668bec558e2);
$parcel$export(module.exports, "getState", () => $4bf7ba9bbb4881ae$export$50fdfeece43146fd);
$parcel$export(module.exports, "findIndexSS", () => $4bf7ba9bbb4881ae$export$5f8f02523cf47b58);
$parcel$export(module.exports, "UpdateEncoderV2", () => $4bf7ba9bbb4881ae$export$30c99e08943e1c2);
$parcel$export(module.exports, "equalDeleteSets", () => $4bf7ba9bbb4881ae$export$9697b72c46fd3a5d);
$parcel$export(module.exports, "Doc", () => $4bf7ba9bbb4881ae$export$bceacc74c2212615);
$parcel$export(module.exports, "transact", () => $4bf7ba9bbb4881ae$export$dac1bad6146b2469);
$parcel$export(module.exports, "AbstractType", () => $4bf7ba9bbb4881ae$export$c265dc8338484497);
$parcel$export(module.exports, "Array", () => $4bf7ba9bbb4881ae$export$c4be6576ca6fe4aa);
$parcel$export(module.exports, "Text", () => $4bf7ba9bbb4881ae$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "Map", () => $4bf7ba9bbb4881ae$export$a5c7b93649eaf8f8);
$parcel$export(module.exports, "XmlElement", () => $4bf7ba9bbb4881ae$export$4db87581d3ca170d);
$parcel$export(module.exports, "XmlFragment", () => $4bf7ba9bbb4881ae$export$d5ce8c3e1731f1a7);
$parcel$export(module.exports, "UpdateDecoderV1", () => $4bf7ba9bbb4881ae$export$1aa46d9818b5d1ec);
$parcel$export(module.exports, "createID", () => $4bf7ba9bbb4881ae$export$6c7d4e6171d008d0);
$parcel$export(module.exports, "UpdateDecoderV2", () => $4bf7ba9bbb4881ae$export$1c932452355c5571);
$parcel$export(module.exports, "ID", () => $4bf7ba9bbb4881ae$export$8be180ec26319f9f);
$parcel$export(module.exports, "UpdateEncoderV1", () => $4bf7ba9bbb4881ae$export$99171b804d9c5b54);
$parcel$export(module.exports, "GC", () => $4bf7ba9bbb4881ae$export$12d259ff017e6b58);
$parcel$export(module.exports, "Skip", () => $4bf7ba9bbb4881ae$export$38d24f5c1eb0e4c0);
$parcel$export(module.exports, "Item", () => $4bf7ba9bbb4881ae$export$6d08773d2e66f8f2);
$parcel$export(module.exports, "readUpdateV2", () => $4bf7ba9bbb4881ae$export$7abe492a0b891b4d);
$parcel$export(module.exports, "mergeUpdatesV2", () => $4bf7ba9bbb4881ae$export$ce273d78de0331d1);
$parcel$export(module.exports, "applyUpdateV2", () => $4bf7ba9bbb4881ae$export$acc3b0324aabf1b6);
$parcel$export(module.exports, "readUpdate", () => $4bf7ba9bbb4881ae$export$d67ac8d73b7d336c);
$parcel$export(module.exports, "applyUpdate", () => $4bf7ba9bbb4881ae$export$c271737a9c02e925);
$parcel$export(module.exports, "encodeStateAsUpdateV2", () => $4bf7ba9bbb4881ae$export$90338e0798f6f64f);
$parcel$export(module.exports, "decodeStateVector", () => $4bf7ba9bbb4881ae$export$324ac6fb20a844e3);
$parcel$export(module.exports, "diffUpdateV2", () => $4bf7ba9bbb4881ae$export$a8143edf39d2ad8e);
$parcel$export(module.exports, "mergeUpdates", () => $4bf7ba9bbb4881ae$export$6319871659fd2460);
$parcel$export(module.exports, "convertUpdateFormatV2ToV1", () => $4bf7ba9bbb4881ae$export$afffbdeed14adbd);
$parcel$export(module.exports, "encodeStateAsUpdate", () => $4bf7ba9bbb4881ae$export$e5848df80e65bd53);
$parcel$export(module.exports, "encodeStateVector", () => $4bf7ba9bbb4881ae$export$3e2f5393f32e71f);
$parcel$export(module.exports, "compareIDs", () => $4bf7ba9bbb4881ae$export$c0af976e7e459c02);
$parcel$export(module.exports, "findRootTypeKey", () => $4bf7ba9bbb4881ae$export$e726a40920d54663);
$parcel$export(module.exports, "isParentOf", () => $4bf7ba9bbb4881ae$export$3c81af374b054d6a);
$parcel$export(module.exports, "logType", () => $4bf7ba9bbb4881ae$export$e9068ad704ba2f79);
$parcel$export(module.exports, "PermanentUserData", () => $4bf7ba9bbb4881ae$export$b9e8b5fa1162ca4e);
$parcel$export(module.exports, "RelativePosition", () => $4bf7ba9bbb4881ae$export$da21a415c5907662);
$parcel$export(module.exports, "relativePositionToJSON", () => $4bf7ba9bbb4881ae$export$a783b081767a452e);
$parcel$export(module.exports, "createRelativePositionFromJSON", () => $4bf7ba9bbb4881ae$export$ddad8a1b8f7475d8);
$parcel$export(module.exports, "AbsolutePosition", () => $4bf7ba9bbb4881ae$export$64c95a3fb7344864);
$parcel$export(module.exports, "createRelativePositionFromTypeIndex", () => $4bf7ba9bbb4881ae$export$197e7d99e3857e88);
$parcel$export(module.exports, "encodeRelativePosition", () => $4bf7ba9bbb4881ae$export$c5c95ef724203575);
$parcel$export(module.exports, "decodeRelativePosition", () => $4bf7ba9bbb4881ae$export$58a46cebc90e7851);
$parcel$export(module.exports, "createAbsolutePositionFromRelativePosition", () => $4bf7ba9bbb4881ae$export$8fc3152f62fb7ed1);
$parcel$export(module.exports, "ContentType", () => $4bf7ba9bbb4881ae$export$e2e108cbe2e4f865);
$parcel$export(module.exports, "compareRelativePositions", () => $4bf7ba9bbb4881ae$export$fc8bd253c948b475);
$parcel$export(module.exports, "Snapshot", () => $4bf7ba9bbb4881ae$export$c963130a5525248f);
$parcel$export(module.exports, "equalSnapshots", () => $4bf7ba9bbb4881ae$export$742742a0f55b273d);
$parcel$export(module.exports, "encodeSnapshotV2", () => $4bf7ba9bbb4881ae$export$b946cadc55f8e512);
$parcel$export(module.exports, "encodeSnapshot", () => $4bf7ba9bbb4881ae$export$a6d29989648e995);
$parcel$export(module.exports, "decodeSnapshotV2", () => $4bf7ba9bbb4881ae$export$b0049fa299f4f58e);
$parcel$export(module.exports, "decodeSnapshot", () => $4bf7ba9bbb4881ae$export$5c696daccf32bd2e);
$parcel$export(module.exports, "createSnapshot", () => $4bf7ba9bbb4881ae$export$548fae0445f878fd);
$parcel$export(module.exports, "emptySnapshot", () => $4bf7ba9bbb4881ae$export$d4568a81dd107a34);
$parcel$export(module.exports, "snapshot", () => $4bf7ba9bbb4881ae$export$b8801ea43165ed7d);
$parcel$export(module.exports, "createDocFromSnapshot", () => $4bf7ba9bbb4881ae$export$5be4ae1e1e56a014);
$parcel$export(module.exports, "snapshotContainsUpdate", () => $4bf7ba9bbb4881ae$export$f938135bed5d8db7);
$parcel$export(module.exports, "getItem", () => $4bf7ba9bbb4881ae$export$f92dfeb71e9bb569);
$parcel$export(module.exports, "Transaction", () => $4bf7ba9bbb4881ae$export$febc5573c75cefb0);
$parcel$export(module.exports, "tryGc", () => $4bf7ba9bbb4881ae$export$c2e5de00fc43f658);
$parcel$export(module.exports, "UndoManager", () => $4bf7ba9bbb4881ae$export$932a3f9a7e88971c);
$parcel$export(module.exports, "logUpdate", () => $4bf7ba9bbb4881ae$export$d6235ced6e55ace9);
$parcel$export(module.exports, "logUpdateV2", () => $4bf7ba9bbb4881ae$export$624b3f0248c2dc40);
$parcel$export(module.exports, "decodeUpdate", () => $4bf7ba9bbb4881ae$export$aa45cba8121663dc);
$parcel$export(module.exports, "decodeUpdateV2", () => $4bf7ba9bbb4881ae$export$2fed33908eb23d71);
$parcel$export(module.exports, "encodeStateVectorFromUpdateV2", () => $4bf7ba9bbb4881ae$export$ed51750cf3ab2381);
$parcel$export(module.exports, "encodeStateVectorFromUpdate", () => $4bf7ba9bbb4881ae$export$5c451fd8502b011f);
$parcel$export(module.exports, "parseUpdateMetaV2", () => $4bf7ba9bbb4881ae$export$8212a58b2178fdcf);
$parcel$export(module.exports, "parseUpdateMeta", () => $4bf7ba9bbb4881ae$export$e212b06fd4bf78fd);
$parcel$export(module.exports, "diffUpdate", () => $4bf7ba9bbb4881ae$export$bf60b51d6c283426);
$parcel$export(module.exports, "ContentDeleted", () => $4bf7ba9bbb4881ae$export$3b06e0b3a2ece602);
$parcel$export(module.exports, "XmlHook", () => $4bf7ba9bbb4881ae$export$ec64c1dd5e7a264);
$parcel$export(module.exports, "ContentAny", () => $4bf7ba9bbb4881ae$export$1d788b93bbb631a0);
$parcel$export(module.exports, "ContentBinary", () => $4bf7ba9bbb4881ae$export$e8d530cdf62d1cbd);
$parcel$export(module.exports, "ContentDoc", () => $4bf7ba9bbb4881ae$export$b564c0e69572c0e);
$parcel$export(module.exports, "ContentEmbed", () => $4bf7ba9bbb4881ae$export$c3787ba7f6086664);
$parcel$export(module.exports, "ContentFormat", () => $4bf7ba9bbb4881ae$export$3194899188fb5a88);
$parcel$export(module.exports, "ContentJSON", () => $4bf7ba9bbb4881ae$export$6a907ea8f733ecf3);
$parcel$export(module.exports, "ContentString", () => $4bf7ba9bbb4881ae$export$ee670b2cf091bbb6);
$parcel$export(module.exports, "obfuscateUpdate", () => $4bf7ba9bbb4881ae$export$2dc24d59ec48a24e);
$parcel$export(module.exports, "obfuscateUpdateV2", () => $4bf7ba9bbb4881ae$export$90648fb14f8c31aa);
$parcel$export(module.exports, "convertUpdateFormatV1ToV2", () => $4bf7ba9bbb4881ae$export$162408325d5832c);
$parcel$export(module.exports, "YEvent", () => $4bf7ba9bbb4881ae$export$80fac438977fb51c);
$parcel$export(module.exports, "getTypeChildren", () => $4bf7ba9bbb4881ae$export$5418d693f13991b3);
$parcel$export(module.exports, "typeListToArraySnapshot", () => $4bf7ba9bbb4881ae$export$9de42b6dda4c7e48);
$parcel$export(module.exports, "typeMapGetSnapshot", () => $4bf7ba9bbb4881ae$export$a7c089bf6c22a1db);
$parcel$export(module.exports, "typeMapGetAllSnapshot", () => $4bf7ba9bbb4881ae$export$7769bdedaef2c91b);
$parcel$export(module.exports, "YArrayEvent", () => $4bf7ba9bbb4881ae$export$a095f7fee639264a);
$parcel$export(module.exports, "YMapEvent", () => $4bf7ba9bbb4881ae$export$33aab1b1a47c1cc3);
$parcel$export(module.exports, "cleanupYTextFormatting", () => $4bf7ba9bbb4881ae$export$5d9f53c13ebffb65);
$parcel$export(module.exports, "YTextEvent", () => $4bf7ba9bbb4881ae$export$51155b8ebb74188a);
$parcel$export(module.exports, "YXmlEvent", () => $4bf7ba9bbb4881ae$export$88c9145a0c3b556c);
$parcel$export(module.exports, "XmlText", () => $4bf7ba9bbb4881ae$export$b35b8f45887823df);
$parcel$export(module.exports, "AbstractStruct", () => $4bf7ba9bbb4881ae$export$3cf6f9765c5c3196);

var $3S8dv = parcelRequire("3S8dv");

var $iiUWJ = parcelRequire("iiUWJ");

var $5qKvF = parcelRequire("5qKvF");

var $dh5fq = parcelRequire("dh5fq");

var $6E0HV = parcelRequire("6E0HV");

var $dirF1 = parcelRequire("dirF1");

var $8HsF3 = parcelRequire("8HsF3");

var $d23gX = parcelRequire("d23gX");

var $fuxjU = parcelRequire("fuxjU");

var $iVMsw = parcelRequire("iVMsw");

var $51l7Q = parcelRequire("51l7Q");

var $4NUz5 = parcelRequire("4NUz5");

var $bUD5M = parcelRequire("bUD5M");
parcelRequire("98BSr");
var $b2PaR = parcelRequire("b2PaR");
var $98BSr = parcelRequire("98BSr");

var $c48Az = parcelRequire("c48Az");

var $dVtwn = parcelRequire("dVtwn");

var $2H3N4 = parcelRequire("2H3N4");

var $kLkle = parcelRequire("kLkle");
/**
 * This is an abstract interface that all Connectors should implement to keep them interchangeable.
 *
 * @note This interface is experimental and it is not advised to actually inherit this class.
 *       It just serves as typing information.
 *
 * @extends {ObservableV2<any>}
 */ class $4bf7ba9bbb4881ae$export$c3faceeb92aa39dd extends (0, $3S8dv.ObservableV2) {
    /**
   * @param {Doc} ydoc
   * @param {any} awareness
   */ constructor(ydoc, awareness){
        super();
        this.doc = ydoc;
        this.awareness = awareness;
    }
}
class $4bf7ba9bbb4881ae$var$DeleteItem {
    /**
   * @param {number} clock
   * @param {number} len
   */ constructor(clock, len){
        /**
     * @type {number}
     */ this.clock = clock;
        /**
     * @type {number}
     */ this.len = len;
    }
}
/**
 * We no longer maintain a DeleteStore. DeleteSet is a temporary object that is created when needed.
 * - When created in a transaction, it must only be accessed after sorting, and merging
 *   - This DeleteSet is send to other clients
 * - We do not create a DeleteSet when we send a sync message. The DeleteSet message is created directly from StructStore
 * - We read a DeleteSet as part of a sync/update message. In this case the DeleteSet is already sorted and merged.
 */ class $4bf7ba9bbb4881ae$var$DeleteSet {
    constructor(){
        /**
     * @type {Map<number,Array<DeleteItem>>}
     */ this.clients = new Map();
    }
}
/**
 * Iterate over all structs that the DeleteSet gc's.
 *
 * @param {Transaction} transaction
 * @param {DeleteSet} ds
 * @param {function(GC|Item):void} f
 *
 * @function
 */ const $4bf7ba9bbb4881ae$export$8afefebbaf4e4c78 = (transaction, ds, f)=>ds.clients.forEach((deletes, clientid)=>{
        const structs = /** @type {Array<GC|Item>} */ transaction.doc.store.clients.get(clientid);
        for(let i = 0; i < deletes.length; i++){
            const del = deletes[i];
            $4bf7ba9bbb4881ae$var$iterateStructs(transaction, structs, del.clock, del.len, f);
        }
    });
/**
 * @param {Array<DeleteItem>} dis
 * @param {number} clock
 * @return {number|null}
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$findIndexDS = (dis, clock)=>{
    let left = 0;
    let right = dis.length - 1;
    while(left <= right){
        const midindex = $5qKvF.floor((left + right) / 2);
        const mid = dis[midindex];
        const midclock = mid.clock;
        if (midclock <= clock) {
            if (clock < midclock + mid.len) return midindex;
            left = midindex + 1;
        } else right = midindex - 1;
    }
    return null;
};
/**
 * @param {DeleteSet} ds
 * @param {ID} id
 * @return {boolean}
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$export$dcb04af092e44fde = (ds, id)=>{
    const dis = ds.clients.get(id.client);
    return dis !== undefined && $4bf7ba9bbb4881ae$var$findIndexDS(dis, id.clock) !== null;
};
/**
 * @param {DeleteSet} ds
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$sortAndMergeDeleteSet = (ds)=>{
    ds.clients.forEach((dels)=>{
        dels.sort((a, b)=>a.clock - b.clock);
        // merge items without filtering or splicing the array
        // i is the current pointer
        // j refers to the current insert position for the pointed item
        // try to merge dels[i] into dels[j-1] or set dels[j]=dels[i]
        let i, j;
        for(i = 1, j = 1; i < dels.length; i++){
            const left = dels[j - 1];
            const right = dels[i];
            if (left.clock + left.len >= right.clock) left.len = $5qKvF.max(left.len, right.clock + right.len - left.clock);
            else {
                if (j < i) dels[j] = right;
                j++;
            }
        }
        dels.length = j;
    });
};
/**
 * @param {Array<DeleteSet>} dss
 * @return {DeleteSet} A fresh DeleteSet
 */ const $4bf7ba9bbb4881ae$var$mergeDeleteSets = (dss)=>{
    const merged = new $4bf7ba9bbb4881ae$var$DeleteSet();
    for(let dssI = 0; dssI < dss.length; dssI++)dss[dssI].clients.forEach((delsLeft, client)=>{
        if (!merged.clients.has(client)) {
            // Write all missing keys from current ds and all following.
            // If merged already contains `client` current ds has already been added.
            /**
         * @type {Array<DeleteItem>}
         */ const dels = delsLeft.slice();
            for(let i = dssI + 1; i < dss.length; i++)$iiUWJ.appendTo(dels, dss[i].clients.get(client) || []);
            merged.clients.set(client, dels);
        }
    });
    $4bf7ba9bbb4881ae$var$sortAndMergeDeleteSet(merged);
    return merged;
};
/**
 * @param {DeleteSet} ds
 * @param {number} client
 * @param {number} clock
 * @param {number} length
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$addToDeleteSet = (ds, client, clock, length)=>{
    $dh5fq.setIfUndefined(ds.clients, client, ()=>/** @type {Array<DeleteItem>} */ []).push(new $4bf7ba9bbb4881ae$var$DeleteItem(clock, length));
};
const $4bf7ba9bbb4881ae$export$8cbac0d946238699 = ()=>new $4bf7ba9bbb4881ae$var$DeleteSet();
/**
 * @param {StructStore} ss
 * @return {DeleteSet} Merged and sorted DeleteSet
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$export$8450d668bec558e2 = (ss)=>{
    const ds = $4bf7ba9bbb4881ae$export$8cbac0d946238699();
    ss.clients.forEach((structs, client)=>{
        /**
     * @type {Array<DeleteItem>}
     */ const dsitems = [];
        for(let i = 0; i < structs.length; i++){
            const struct = structs[i];
            if (struct.deleted) {
                const clock = struct.id.clock;
                let len = struct.length;
                if (i + 1 < structs.length) for(let next = structs[i + 1]; i + 1 < structs.length && next.deleted; next = structs[++i + 1])len += next.length;
                dsitems.push(new $4bf7ba9bbb4881ae$var$DeleteItem(clock, len));
            }
        }
        if (dsitems.length > 0) ds.clients.set(client, dsitems);
    });
    return ds;
};
/**
 * @param {DSEncoderV1 | DSEncoderV2} encoder
 * @param {DeleteSet} ds
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$writeDeleteSet = (encoder, ds)=>{
    $6E0HV.writeVarUint(encoder.restEncoder, ds.clients.size);
    // Ensure that the delete set is written in a deterministic order
    $iiUWJ.from(ds.clients.entries()).sort((a, b)=>b[0] - a[0]).forEach(([client, dsitems])=>{
        encoder.resetDsCurVal();
        $6E0HV.writeVarUint(encoder.restEncoder, client);
        const len = dsitems.length;
        $6E0HV.writeVarUint(encoder.restEncoder, len);
        for(let i = 0; i < len; i++){
            const item = dsitems[i];
            encoder.writeDsClock(item.clock);
            encoder.writeDsLen(item.len);
        }
    });
};
/**
 * @param {DSDecoderV1 | DSDecoderV2} decoder
 * @return {DeleteSet}
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$readDeleteSet = (decoder)=>{
    const ds = new $4bf7ba9bbb4881ae$var$DeleteSet();
    const numClients = $dirF1.readVarUint(decoder.restDecoder);
    for(let i = 0; i < numClients; i++){
        decoder.resetDsCurVal();
        const client = $dirF1.readVarUint(decoder.restDecoder);
        const numberOfDeletes = $dirF1.readVarUint(decoder.restDecoder);
        if (numberOfDeletes > 0) {
            const dsField = $dh5fq.setIfUndefined(ds.clients, client, ()=>/** @type {Array<DeleteItem>} */ []);
            for(let i = 0; i < numberOfDeletes; i++)dsField.push(new $4bf7ba9bbb4881ae$var$DeleteItem(decoder.readDsClock(), decoder.readDsLen()));
        }
    }
    return ds;
};
/**
 * @todo YDecoder also contains references to String and other Decoders. Would make sense to exchange YDecoder.toUint8Array for YDecoder.DsToUint8Array()..
 */ /**
 * @param {DSDecoderV1 | DSDecoderV2} decoder
 * @param {Transaction} transaction
 * @param {StructStore} store
 * @return {Uint8Array|null} Returns a v2 update containing all deletes that couldn't be applied yet; or null if all deletes were applied successfully.
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$readAndApplyDeleteSet = (decoder, transaction, store)=>{
    const unappliedDS = new $4bf7ba9bbb4881ae$var$DeleteSet();
    const numClients = $dirF1.readVarUint(decoder.restDecoder);
    for(let i = 0; i < numClients; i++){
        decoder.resetDsCurVal();
        const client = $dirF1.readVarUint(decoder.restDecoder);
        const numberOfDeletes = $dirF1.readVarUint(decoder.restDecoder);
        const structs = store.clients.get(client) || [];
        const state = $4bf7ba9bbb4881ae$export$50fdfeece43146fd(store, client);
        for(let i = 0; i < numberOfDeletes; i++){
            const clock = decoder.readDsClock();
            const clockEnd = clock + decoder.readDsLen();
            if (clock < state) {
                if (state < clockEnd) $4bf7ba9bbb4881ae$var$addToDeleteSet(unappliedDS, client, state, clockEnd - state);
                let index = $4bf7ba9bbb4881ae$export$5f8f02523cf47b58(structs, clock);
                /**
         * We can ignore the case of GC and Delete structs, because we are going to skip them
         * @type {Item}
         */ // @ts-ignore
                let struct = structs[index];
                // split the first item if necessary
                if (!struct.deleted && struct.id.clock < clock) {
                    structs.splice(index + 1, 0, $4bf7ba9bbb4881ae$var$splitItem(transaction, struct, clock - struct.id.clock));
                    index++; // increase we now want to use the next struct
                }
                while(index < structs.length){
                    // @ts-ignore
                    struct = structs[index++];
                    if (struct.id.clock < clockEnd) {
                        if (!struct.deleted) {
                            if (clockEnd < struct.id.clock + struct.length) structs.splice(index, 0, $4bf7ba9bbb4881ae$var$splitItem(transaction, struct, clockEnd - struct.id.clock));
                            struct.delete(transaction);
                        }
                    } else break;
                }
            } else $4bf7ba9bbb4881ae$var$addToDeleteSet(unappliedDS, client, clock, clockEnd - clock);
        }
    }
    if (unappliedDS.clients.size > 0) {
        const ds = new $4bf7ba9bbb4881ae$export$30c99e08943e1c2();
        $6E0HV.writeVarUint(ds.restEncoder, 0); // encode 0 structs
        $4bf7ba9bbb4881ae$var$writeDeleteSet(ds, unappliedDS);
        return ds.toUint8Array();
    }
    return null;
};
/**
 * @param {DeleteSet} ds1
 * @param {DeleteSet} ds2
 */ const $4bf7ba9bbb4881ae$export$9697b72c46fd3a5d = (ds1, ds2)=>{
    if (ds1.clients.size !== ds2.clients.size) return false;
    for (const [client, deleteItems1] of ds1.clients.entries()){
        const deleteItems2 = /** @type {Array<import('../internals.js').DeleteItem>} */ ds2.clients.get(client);
        if (deleteItems2 === undefined || deleteItems1.length !== deleteItems2.length) return false;
        for(let i = 0; i < deleteItems1.length; i++){
            const di1 = deleteItems1[i];
            const di2 = deleteItems2[i];
            if (di1.clock !== di2.clock || di1.len !== di2.len) return false;
        }
    }
    return true;
};
/**
 * @module Y
 */ const $4bf7ba9bbb4881ae$var$generateNewClientId = $8HsF3.uint32;
/**
 * @typedef {Object} DocOpts
 * @property {boolean} [DocOpts.gc=true] Disable garbage collection (default: gc=true)
 * @property {function(Item):boolean} [DocOpts.gcFilter] Will be called before an Item is garbage collected. Return false to keep the Item.
 * @property {string} [DocOpts.guid] Define a globally unique identifier for this document
 * @property {string | null} [DocOpts.collectionid] Associate this document with a collection. This only plays a role if your provider has a concept of collection.
 * @property {any} [DocOpts.meta] Any kind of meta information you want to associate with this document. If this is a subdocument, remote peers will store the meta information as well.
 * @property {boolean} [DocOpts.autoLoad] If a subdocument, automatically load document. If this is a subdocument, remote peers will load the document as well automatically.
 * @property {boolean} [DocOpts.shouldLoad] Whether the document should be synced by the provider now. This is toggled to true when you call ydoc.load()
 */ /**
 * @typedef {Object} DocEvents
 * @property {function(Doc):void} DocEvents.destroy
 * @property {function(Doc):void} DocEvents.load
 * @property {function(boolean, Doc):void} DocEvents.sync
 * @property {function(Uint8Array, any, Doc, Transaction):void} DocEvents.update
 * @property {function(Uint8Array, any, Doc, Transaction):void} DocEvents.updateV2
 * @property {function(Doc):void} DocEvents.beforeAllTransactions
 * @property {function(Transaction, Doc):void} DocEvents.beforeTransaction
 * @property {function(Transaction, Doc):void} DocEvents.beforeObserverCalls
 * @property {function(Transaction, Doc):void} DocEvents.afterTransaction
 * @property {function(Transaction, Doc):void} DocEvents.afterTransactionCleanup
 * @property {function(Doc, Array<Transaction>):void} DocEvents.afterAllTransactions
 * @property {function({ loaded: Set<Doc>, added: Set<Doc>, removed: Set<Doc> }, Doc, Transaction):void} DocEvents.subdocs
 */ /**
 * A Yjs instance handles the state of shared data.
 * @extends ObservableV2<DocEvents>
 */ class $4bf7ba9bbb4881ae$export$bceacc74c2212615 extends (0, $3S8dv.ObservableV2) {
    /**
   * @param {DocOpts} opts configuration
   */ constructor({ guid: guid = $8HsF3.uuidv4(), collectionid: collectionid = null, gc: gc = true, gcFilter: gcFilter = ()=>true, meta: meta = null, autoLoad: autoLoad = false, shouldLoad: shouldLoad = true } = {}){
        super();
        this.gc = gc;
        this.gcFilter = gcFilter;
        this.clientID = $4bf7ba9bbb4881ae$var$generateNewClientId();
        this.guid = guid;
        this.collectionid = collectionid;
        /**
     * @type {Map<string, AbstractType<YEvent<any>>>}
     */ this.share = new Map();
        this.store = new $4bf7ba9bbb4881ae$var$StructStore();
        /**
     * @type {Transaction | null}
     */ this._transaction = null;
        /**
     * @type {Array<Transaction>}
     */ this._transactionCleanups = [];
        /**
     * @type {Set<Doc>}
     */ this.subdocs = new Set();
        /**
     * If this document is a subdocument - a document integrated into another document - then _item is defined.
     * @type {Item?}
     */ this._item = null;
        this.shouldLoad = shouldLoad;
        this.autoLoad = autoLoad;
        this.meta = meta;
        /**
     * This is set to true when the persistence provider loaded the document from the database or when the `sync` event fires.
     * Note that not all providers implement this feature. Provider authors are encouraged to fire the `load` event when the doc content is loaded from the database.
     *
     * @type {boolean}
     */ this.isLoaded = false;
        /**
     * This is set to true when the connection provider has successfully synced with a backend.
     * Note that when using peer-to-peer providers this event may not provide very useful.
     * Also note that not all providers implement this feature. Provider authors are encouraged to fire
     * the `sync` event when the doc has been synced (with `true` as a parameter) or if connection is
     * lost (with false as a parameter).
     */ this.isSynced = false;
        /**
     * Promise that resolves once the document has been loaded from a presistence provider.
     */ this.whenLoaded = $d23gX.create((resolve)=>{
            this.on("load", ()=>{
                this.isLoaded = true;
                resolve(this);
            });
        });
        const provideSyncedPromise = ()=>$d23gX.create((resolve)=>{
                /**
       * @param {boolean} isSynced
       */ const eventHandler = (isSynced)=>{
                    if (isSynced === undefined || isSynced === true) {
                        this.off("sync", eventHandler);
                        resolve();
                    }
                };
                this.on("sync", eventHandler);
            });
        this.on("sync", (isSynced)=>{
            if (isSynced === false && this.isSynced) this.whenSynced = provideSyncedPromise();
            this.isSynced = isSynced === undefined || isSynced === true;
            if (this.isSynced && !this.isLoaded) this.emit("load", [
                this
            ]);
        });
        /**
     * Promise that resolves once the document has been synced with a backend.
     * This promise is recreated when the connection is lost.
     * Note the documentation about the `isSynced` property.
     */ this.whenSynced = provideSyncedPromise();
    }
    /**
   * Notify the parent document that you request to load data into this subdocument (if it is a subdocument).
   *
   * `load()` might be used in the future to request any provider to load the most current data.
   *
   * It is safe to call `load()` multiple times.
   */ load() {
        const item = this._item;
        if (item !== null && !this.shouldLoad) $4bf7ba9bbb4881ae$export$dac1bad6146b2469(/** @type {any} */ item.parent.doc, (transaction)=>{
            transaction.subdocsLoaded.add(this);
        }, null, true);
        this.shouldLoad = true;
    }
    getSubdocs() {
        return this.subdocs;
    }
    getSubdocGuids() {
        return new Set($iiUWJ.from(this.subdocs).map((doc)=>doc.guid));
    }
    /**
   * Changes that happen inside of a transaction are bundled. This means that
   * the observer fires _after_ the transaction is finished and that all changes
   * that happened inside of the transaction are sent as one message to the
   * other peers.
   *
   * @template T
   * @param {function(Transaction):T} f The function that should be executed as a transaction
   * @param {any} [origin] Origin of who started the transaction. Will be stored on transaction.origin
   * @return T
   *
   * @public
   */ transact(f, origin = null) {
        return $4bf7ba9bbb4881ae$export$dac1bad6146b2469(this, f, origin);
    }
    /**
   * Define a shared data type.
   *
   * Multiple calls of `y.get(name, TypeConstructor)` yield the same result
   * and do not overwrite each other. I.e.
   * `y.define(name, Y.Array) === y.define(name, Y.Array)`
   *
   * After this method is called, the type is also available on `y.share.get(name)`.
   *
   * *Best Practices:*
   * Define all types right after the Yjs instance is created and store them in a separate object.
   * Also use the typed methods `getText(name)`, `getArray(name)`, ..
   *
   * @template {typeof AbstractType<any>} Type
   * @example
   *   const y = new Y(..)
   *   const appState = {
   *     document: y.getText('document')
   *     comments: y.getArray('comments')
   *   }
   *
   * @param {string} name
   * @param {Type} TypeConstructor The constructor of the type definition. E.g. Y.Text, Y.Array, Y.Map, ...
   * @return {InstanceType<Type>} The created type. Constructed with TypeConstructor
   *
   * @public
   */ get(name, TypeConstructor = /** @type {any} */ $4bf7ba9bbb4881ae$export$c265dc8338484497) {
        const type = $dh5fq.setIfUndefined(this.share, name, ()=>{
            // @ts-ignore
            const t = new TypeConstructor();
            t._integrate(this, null);
            return t;
        });
        const Constr = type.constructor;
        if (TypeConstructor !== $4bf7ba9bbb4881ae$export$c265dc8338484497 && Constr !== TypeConstructor) {
            if (Constr === $4bf7ba9bbb4881ae$export$c265dc8338484497) {
                // @ts-ignore
                const t = new TypeConstructor();
                t._map = type._map;
                type._map.forEach(/** @param {Item?} n */ (n)=>{
                    for(; n !== null; n = n.left)// @ts-ignore
                    n.parent = t;
                });
                t._start = type._start;
                for(let n = t._start; n !== null; n = n.right)n.parent = t;
                t._length = type._length;
                this.share.set(name, t);
                t._integrate(this, null);
                return /** @type {InstanceType<Type>} */ t;
            } else throw new Error(`Type with the name ${name} has already been defined with a different constructor`);
        }
        return /** @type {InstanceType<Type>} */ type;
    }
    /**
   * @template T
   * @param {string} [name]
   * @return {YArray<T>}
   *
   * @public
   */ getArray(name = "") {
        return /** @type {YArray<T>} */ this.get(name, $4bf7ba9bbb4881ae$export$c4be6576ca6fe4aa);
    }
    /**
   * @param {string} [name]
   * @return {YText}
   *
   * @public
   */ getText(name = "") {
        return this.get(name, $4bf7ba9bbb4881ae$export$5f1af8db9871e1d6);
    }
    /**
   * @template T
   * @param {string} [name]
   * @return {YMap<T>}
   *
   * @public
   */ getMap(name = "") {
        return /** @type {YMap<T>} */ this.get(name, $4bf7ba9bbb4881ae$export$a5c7b93649eaf8f8);
    }
    /**
   * @param {string} [name]
   * @return {YXmlElement}
   *
   * @public
   */ getXmlElement(name = "") {
        return /** @type {YXmlElement<{[key:string]:string}>} */ this.get(name, $4bf7ba9bbb4881ae$export$4db87581d3ca170d);
    }
    /**
   * @param {string} [name]
   * @return {YXmlFragment}
   *
   * @public
   */ getXmlFragment(name = "") {
        return this.get(name, $4bf7ba9bbb4881ae$export$d5ce8c3e1731f1a7);
    }
    /**
   * Converts the entire document into a js object, recursively traversing each yjs type
   * Doesn't log types that have not been defined (using ydoc.getType(..)).
   *
   * @deprecated Do not use this method and rather call toJSON directly on the shared types.
   *
   * @return {Object<string, any>}
   */ toJSON() {
        /**
     * @type {Object<string, any>}
     */ const doc = {};
        this.share.forEach((value, key)=>{
            doc[key] = value.toJSON();
        });
        return doc;
    }
    /**
   * Emit `destroy` event and unregister all event handlers.
   */ destroy() {
        $iiUWJ.from(this.subdocs).forEach((subdoc)=>subdoc.destroy());
        const item = this._item;
        if (item !== null) {
            this._item = null;
            const content = /** @type {ContentDoc} */ item.content;
            content.doc = new $4bf7ba9bbb4881ae$export$bceacc74c2212615({
                guid: this.guid,
                ...content.opts,
                shouldLoad: false
            });
            content.doc._item = item;
            $4bf7ba9bbb4881ae$export$dac1bad6146b2469(/** @type {any} */ item.parent.doc, (transaction)=>{
                const doc = content.doc;
                if (!item.deleted) transaction.subdocsAdded.add(doc);
                transaction.subdocsRemoved.add(this);
            }, null, true);
        }
        // @ts-ignore
        this.emit("destroyed", [
            true
        ]); // DEPRECATED!
        this.emit("destroy", [
            this
        ]);
        super.destroy();
    }
}
class $4bf7ba9bbb4881ae$var$DSDecoderV1 {
    /**
   * @param {decoding.Decoder} decoder
   */ constructor(decoder){
        this.restDecoder = decoder;
    }
    resetDsCurVal() {
    // nop
    }
    /**
   * @return {number}
   */ readDsClock() {
        return $dirF1.readVarUint(this.restDecoder);
    }
    /**
   * @return {number}
   */ readDsLen() {
        return $dirF1.readVarUint(this.restDecoder);
    }
}
class $4bf7ba9bbb4881ae$export$1aa46d9818b5d1ec extends $4bf7ba9bbb4881ae$var$DSDecoderV1 {
    /**
   * @return {ID}
   */ readLeftID() {
        return $4bf7ba9bbb4881ae$export$6c7d4e6171d008d0($dirF1.readVarUint(this.restDecoder), $dirF1.readVarUint(this.restDecoder));
    }
    /**
   * @return {ID}
   */ readRightID() {
        return $4bf7ba9bbb4881ae$export$6c7d4e6171d008d0($dirF1.readVarUint(this.restDecoder), $dirF1.readVarUint(this.restDecoder));
    }
    /**
   * Read the next client id.
   * Use this in favor of readID whenever possible to reduce the number of objects created.
   */ readClient() {
        return $dirF1.readVarUint(this.restDecoder);
    }
    /**
   * @return {number} info An unsigned 8-bit integer
   */ readInfo() {
        return $dirF1.readUint8(this.restDecoder);
    }
    /**
   * @return {string}
   */ readString() {
        return $dirF1.readVarString(this.restDecoder);
    }
    /**
   * @return {boolean} isKey
   */ readParentInfo() {
        return $dirF1.readVarUint(this.restDecoder) === 1;
    }
    /**
   * @return {number} info An unsigned 8-bit integer
   */ readTypeRef() {
        return $dirF1.readVarUint(this.restDecoder);
    }
    /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @return {number} len
   */ readLen() {
        return $dirF1.readVarUint(this.restDecoder);
    }
    /**
   * @return {any}
   */ readAny() {
        return $dirF1.readAny(this.restDecoder);
    }
    /**
   * @return {Uint8Array}
   */ readBuf() {
        return $fuxjU.copyUint8Array($dirF1.readVarUint8Array(this.restDecoder));
    }
    /**
   * Legacy implementation uses JSON parse. We use any-decoding in v2.
   *
   * @return {any}
   */ readJSON() {
        return JSON.parse($dirF1.readVarString(this.restDecoder));
    }
    /**
   * @return {string}
   */ readKey() {
        return $dirF1.readVarString(this.restDecoder);
    }
}
class $4bf7ba9bbb4881ae$var$DSDecoderV2 {
    /**
   * @param {decoding.Decoder} decoder
   */ constructor(decoder){
        /**
     * @private
     */ this.dsCurrVal = 0;
        this.restDecoder = decoder;
    }
    resetDsCurVal() {
        this.dsCurrVal = 0;
    }
    /**
   * @return {number}
   */ readDsClock() {
        this.dsCurrVal += $dirF1.readVarUint(this.restDecoder);
        return this.dsCurrVal;
    }
    /**
   * @return {number}
   */ readDsLen() {
        const diff = $dirF1.readVarUint(this.restDecoder) + 1;
        this.dsCurrVal += diff;
        return diff;
    }
}
class $4bf7ba9bbb4881ae$export$1c932452355c5571 extends $4bf7ba9bbb4881ae$var$DSDecoderV2 {
    /**
   * @param {decoding.Decoder} decoder
   */ constructor(decoder){
        super(decoder);
        /**
     * List of cached keys. If the keys[id] does not exist, we read a new key
     * from stringEncoder and push it to keys.
     *
     * @type {Array<string>}
     */ this.keys = [];
        $dirF1.readVarUint(decoder); // read feature flag - currently unused
        this.keyClockDecoder = new $dirF1.IntDiffOptRleDecoder($dirF1.readVarUint8Array(decoder));
        this.clientDecoder = new $dirF1.UintOptRleDecoder($dirF1.readVarUint8Array(decoder));
        this.leftClockDecoder = new $dirF1.IntDiffOptRleDecoder($dirF1.readVarUint8Array(decoder));
        this.rightClockDecoder = new $dirF1.IntDiffOptRleDecoder($dirF1.readVarUint8Array(decoder));
        this.infoDecoder = new $dirF1.RleDecoder($dirF1.readVarUint8Array(decoder), $dirF1.readUint8);
        this.stringDecoder = new $dirF1.StringDecoder($dirF1.readVarUint8Array(decoder));
        this.parentInfoDecoder = new $dirF1.RleDecoder($dirF1.readVarUint8Array(decoder), $dirF1.readUint8);
        this.typeRefDecoder = new $dirF1.UintOptRleDecoder($dirF1.readVarUint8Array(decoder));
        this.lenDecoder = new $dirF1.UintOptRleDecoder($dirF1.readVarUint8Array(decoder));
    }
    /**
   * @return {ID}
   */ readLeftID() {
        return new $4bf7ba9bbb4881ae$export$8be180ec26319f9f(this.clientDecoder.read(), this.leftClockDecoder.read());
    }
    /**
   * @return {ID}
   */ readRightID() {
        return new $4bf7ba9bbb4881ae$export$8be180ec26319f9f(this.clientDecoder.read(), this.rightClockDecoder.read());
    }
    /**
   * Read the next client id.
   * Use this in favor of readID whenever possible to reduce the number of objects created.
   */ readClient() {
        return this.clientDecoder.read();
    }
    /**
   * @return {number} info An unsigned 8-bit integer
   */ readInfo() {
        return /** @type {number} */ this.infoDecoder.read();
    }
    /**
   * @return {string}
   */ readString() {
        return this.stringDecoder.read();
    }
    /**
   * @return {boolean}
   */ readParentInfo() {
        return this.parentInfoDecoder.read() === 1;
    }
    /**
   * @return {number} An unsigned 8-bit integer
   */ readTypeRef() {
        return this.typeRefDecoder.read();
    }
    /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @return {number}
   */ readLen() {
        return this.lenDecoder.read();
    }
    /**
   * @return {any}
   */ readAny() {
        return $dirF1.readAny(this.restDecoder);
    }
    /**
   * @return {Uint8Array}
   */ readBuf() {
        return $dirF1.readVarUint8Array(this.restDecoder);
    }
    /**
   * This is mainly here for legacy purposes.
   *
   * Initial we incoded objects using JSON. Now we use the much faster lib0/any-encoder. This method mainly exists for legacy purposes for the v1 encoder.
   *
   * @return {any}
   */ readJSON() {
        return $dirF1.readAny(this.restDecoder);
    }
    /**
   * @return {string}
   */ readKey() {
        const keyClock = this.keyClockDecoder.read();
        if (keyClock < this.keys.length) return this.keys[keyClock];
        else {
            const key = this.stringDecoder.read();
            this.keys.push(key);
            return key;
        }
    }
}
class $4bf7ba9bbb4881ae$var$DSEncoderV1 {
    constructor(){
        this.restEncoder = $6E0HV.createEncoder();
    }
    toUint8Array() {
        return $6E0HV.toUint8Array(this.restEncoder);
    }
    resetDsCurVal() {
    // nop
    }
    /**
   * @param {number} clock
   */ writeDsClock(clock) {
        $6E0HV.writeVarUint(this.restEncoder, clock);
    }
    /**
   * @param {number} len
   */ writeDsLen(len) {
        $6E0HV.writeVarUint(this.restEncoder, len);
    }
}
class $4bf7ba9bbb4881ae$export$99171b804d9c5b54 extends $4bf7ba9bbb4881ae$var$DSEncoderV1 {
    /**
   * @param {ID} id
   */ writeLeftID(id) {
        $6E0HV.writeVarUint(this.restEncoder, id.client);
        $6E0HV.writeVarUint(this.restEncoder, id.clock);
    }
    /**
   * @param {ID} id
   */ writeRightID(id) {
        $6E0HV.writeVarUint(this.restEncoder, id.client);
        $6E0HV.writeVarUint(this.restEncoder, id.clock);
    }
    /**
   * Use writeClient and writeClock instead of writeID if possible.
   * @param {number} client
   */ writeClient(client) {
        $6E0HV.writeVarUint(this.restEncoder, client);
    }
    /**
   * @param {number} info An unsigned 8-bit integer
   */ writeInfo(info) {
        $6E0HV.writeUint8(this.restEncoder, info);
    }
    /**
   * @param {string} s
   */ writeString(s) {
        $6E0HV.writeVarString(this.restEncoder, s);
    }
    /**
   * @param {boolean} isYKey
   */ writeParentInfo(isYKey) {
        $6E0HV.writeVarUint(this.restEncoder, isYKey ? 1 : 0);
    }
    /**
   * @param {number} info An unsigned 8-bit integer
   */ writeTypeRef(info) {
        $6E0HV.writeVarUint(this.restEncoder, info);
    }
    /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @param {number} len
   */ writeLen(len) {
        $6E0HV.writeVarUint(this.restEncoder, len);
    }
    /**
   * @param {any} any
   */ writeAny(any) {
        $6E0HV.writeAny(this.restEncoder, any);
    }
    /**
   * @param {Uint8Array} buf
   */ writeBuf(buf) {
        $6E0HV.writeVarUint8Array(this.restEncoder, buf);
    }
    /**
   * @param {any} embed
   */ writeJSON(embed) {
        $6E0HV.writeVarString(this.restEncoder, JSON.stringify(embed));
    }
    /**
   * @param {string} key
   */ writeKey(key) {
        $6E0HV.writeVarString(this.restEncoder, key);
    }
}
class $4bf7ba9bbb4881ae$var$DSEncoderV2 {
    constructor(){
        this.restEncoder = $6E0HV.createEncoder(); // encodes all the rest / non-optimized
        this.dsCurrVal = 0;
    }
    toUint8Array() {
        return $6E0HV.toUint8Array(this.restEncoder);
    }
    resetDsCurVal() {
        this.dsCurrVal = 0;
    }
    /**
   * @param {number} clock
   */ writeDsClock(clock) {
        const diff = clock - this.dsCurrVal;
        this.dsCurrVal = clock;
        $6E0HV.writeVarUint(this.restEncoder, diff);
    }
    /**
   * @param {number} len
   */ writeDsLen(len) {
        if (len === 0) $iVMsw.unexpectedCase();
        $6E0HV.writeVarUint(this.restEncoder, len - 1);
        this.dsCurrVal += len;
    }
}
class $4bf7ba9bbb4881ae$export$30c99e08943e1c2 extends $4bf7ba9bbb4881ae$var$DSEncoderV2 {
    constructor(){
        super();
        /**
     * @type {Map<string,number>}
     */ this.keyMap = new Map();
        /**
     * Refers to the next uniqe key-identifier to me used.
     * See writeKey method for more information.
     *
     * @type {number}
     */ this.keyClock = 0;
        this.keyClockEncoder = new $6E0HV.IntDiffOptRleEncoder();
        this.clientEncoder = new $6E0HV.UintOptRleEncoder();
        this.leftClockEncoder = new $6E0HV.IntDiffOptRleEncoder();
        this.rightClockEncoder = new $6E0HV.IntDiffOptRleEncoder();
        this.infoEncoder = new $6E0HV.RleEncoder($6E0HV.writeUint8);
        this.stringEncoder = new $6E0HV.StringEncoder();
        this.parentInfoEncoder = new $6E0HV.RleEncoder($6E0HV.writeUint8);
        this.typeRefEncoder = new $6E0HV.UintOptRleEncoder();
        this.lenEncoder = new $6E0HV.UintOptRleEncoder();
    }
    toUint8Array() {
        const encoder = $6E0HV.createEncoder();
        $6E0HV.writeVarUint(encoder, 0); // this is a feature flag that we might use in the future
        $6E0HV.writeVarUint8Array(encoder, this.keyClockEncoder.toUint8Array());
        $6E0HV.writeVarUint8Array(encoder, this.clientEncoder.toUint8Array());
        $6E0HV.writeVarUint8Array(encoder, this.leftClockEncoder.toUint8Array());
        $6E0HV.writeVarUint8Array(encoder, this.rightClockEncoder.toUint8Array());
        $6E0HV.writeVarUint8Array(encoder, $6E0HV.toUint8Array(this.infoEncoder));
        $6E0HV.writeVarUint8Array(encoder, this.stringEncoder.toUint8Array());
        $6E0HV.writeVarUint8Array(encoder, $6E0HV.toUint8Array(this.parentInfoEncoder));
        $6E0HV.writeVarUint8Array(encoder, this.typeRefEncoder.toUint8Array());
        $6E0HV.writeVarUint8Array(encoder, this.lenEncoder.toUint8Array());
        // @note The rest encoder is appended! (note the missing var)
        $6E0HV.writeUint8Array(encoder, $6E0HV.toUint8Array(this.restEncoder));
        return $6E0HV.toUint8Array(encoder);
    }
    /**
   * @param {ID} id
   */ writeLeftID(id) {
        this.clientEncoder.write(id.client);
        this.leftClockEncoder.write(id.clock);
    }
    /**
   * @param {ID} id
   */ writeRightID(id) {
        this.clientEncoder.write(id.client);
        this.rightClockEncoder.write(id.clock);
    }
    /**
   * @param {number} client
   */ writeClient(client) {
        this.clientEncoder.write(client);
    }
    /**
   * @param {number} info An unsigned 8-bit integer
   */ writeInfo(info) {
        this.infoEncoder.write(info);
    }
    /**
   * @param {string} s
   */ writeString(s) {
        this.stringEncoder.write(s);
    }
    /**
   * @param {boolean} isYKey
   */ writeParentInfo(isYKey) {
        this.parentInfoEncoder.write(isYKey ? 1 : 0);
    }
    /**
   * @param {number} info An unsigned 8-bit integer
   */ writeTypeRef(info) {
        this.typeRefEncoder.write(info);
    }
    /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @param {number} len
   */ writeLen(len) {
        this.lenEncoder.write(len);
    }
    /**
   * @param {any} any
   */ writeAny(any) {
        $6E0HV.writeAny(this.restEncoder, any);
    }
    /**
   * @param {Uint8Array} buf
   */ writeBuf(buf) {
        $6E0HV.writeVarUint8Array(this.restEncoder, buf);
    }
    /**
   * This is mainly here for legacy purposes.
   *
   * Initial we incoded objects using JSON. Now we use the much faster lib0/any-encoder. This method mainly exists for legacy purposes for the v1 encoder.
   *
   * @param {any} embed
   */ writeJSON(embed) {
        $6E0HV.writeAny(this.restEncoder, embed);
    }
    /**
   * Property keys are often reused. For example, in y-prosemirror the key `bold` might
   * occur very often. For a 3d application, the key `position` might occur very often.
   *
   * We cache these keys in a Map and refer to them via a unique number.
   *
   * @param {string} key
   */ writeKey(key) {
        const clock = this.keyMap.get(key);
        if (clock === undefined) {
            /**
       * @todo uncomment to introduce this feature finally
       *
       * Background. The ContentFormat object was always encoded using writeKey, but the decoder used to use readString.
       * Furthermore, I forgot to set the keyclock. So everything was working fine.
       *
       * However, this feature here is basically useless as it is not being used (it actually only consumes extra memory).
       *
       * I don't know yet how to reintroduce this feature..
       *
       * Older clients won't be able to read updates when we reintroduce this feature. So this should probably be done using a flag.
       *
       */ // this.keyMap.set(key, this.keyClock)
            this.keyClockEncoder.write(this.keyClock++);
            this.stringEncoder.write(key);
        } else this.keyClockEncoder.write(clock);
    }
}
/**
 * @module encoding
 */ /*
 * We use the first five bits in the info flag for determining the type of the struct.
 *
 * 0: GC
 * 1: Item with Deleted content
 * 2: Item with JSON content
 * 3: Item with Binary content
 * 4: Item with String content
 * 5: Item with Embed content (for richtext content)
 * 6: Item with Format content (a formatting marker for richtext content)
 * 7: Item with Type
 */ /**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Array<GC|Item>} structs All structs by `client`
 * @param {number} client
 * @param {number} clock write structs starting with `ID(client,clock)`
 *
 * @function
 */ const $4bf7ba9bbb4881ae$var$writeStructs = (encoder, structs, client, clock)=>{
    // write first id
    clock = $5qKvF.max(clock, structs[0].id.clock); // make sure the first id exists
    const startNewStructs = $4bf7ba9bbb4881ae$export$5f8f02523cf47b58(structs, clock);
    // write # encoded structs
    $6E0HV.writeVarUint(encoder.restEncoder, structs.length - startNewStructs);
    encoder.writeClient(client);
    $6E0HV.writeVarUint(encoder.restEncoder, clock);
    const firstStruct = structs[startNewStructs];
    // write first struct with an offset
    firstStruct.write(encoder, clock - firstStruct.id.clock);
    for(let i = startNewStructs + 1; i < structs.length; i++)structs[i].write(encoder, 0);
};
/**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {StructStore} store
 * @param {Map<number,number>} _sm
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$writeClientsStructs = (encoder, store, _sm)=>{
    // we filter all valid _sm entries into sm
    const sm = new Map();
    _sm.forEach((clock, client)=>{
        // only write if new structs are available
        if ($4bf7ba9bbb4881ae$export$50fdfeece43146fd(store, client) > clock) sm.set(client, clock);
    });
    $4bf7ba9bbb4881ae$var$getStateVector(store).forEach((_clock, client)=>{
        if (!_sm.has(client)) sm.set(client, 0);
    });
    // write # states that were updated
    $6E0HV.writeVarUint(encoder.restEncoder, sm.size);
    // Write items with higher client ids first
    // This heavily improves the conflict algorithm.
    $iiUWJ.from(sm.entries()).sort((a, b)=>b[0] - a[0]).forEach(([client, clock])=>{
        $4bf7ba9bbb4881ae$var$writeStructs(encoder, /** @type {Array<GC|Item>} */ store.clients.get(client), client, clock);
    });
};
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder The decoder object to read data from.
 * @param {Doc} doc
 * @return {Map<number, { i: number, refs: Array<Item | GC> }>}
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$readClientsStructRefs = (decoder, doc)=>{
    /**
   * @type {Map<number, { i: number, refs: Array<Item | GC> }>}
   */ const clientRefs = $dh5fq.create();
    const numOfStateUpdates = $dirF1.readVarUint(decoder.restDecoder);
    for(let i = 0; i < numOfStateUpdates; i++){
        const numberOfStructs = $dirF1.readVarUint(decoder.restDecoder);
        /**
     * @type {Array<GC|Item>}
     */ const refs = new Array(numberOfStructs);
        const client = decoder.readClient();
        let clock = $dirF1.readVarUint(decoder.restDecoder);
        // const start = performance.now()
        clientRefs.set(client, {
            i: 0,
            refs: refs
        });
        for(let i = 0; i < numberOfStructs; i++){
            const info = decoder.readInfo();
            switch($51l7Q.BITS5 & info){
                case 0:
                    {
                        const len = decoder.readLen();
                        refs[i] = new $4bf7ba9bbb4881ae$export$12d259ff017e6b58($4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(client, clock), len);
                        clock += len;
                        break;
                    }
                case 10:
                    {
                        // @todo we could reduce the amount of checks by adding Skip struct to clientRefs so we know that something is missing.
                        const len = $dirF1.readVarUint(decoder.restDecoder);
                        refs[i] = new $4bf7ba9bbb4881ae$export$38d24f5c1eb0e4c0($4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(client, clock), len);
                        clock += len;
                        break;
                    }
                default:
                    {
                        /**
           * The optimized implementation doesn't use any variables because inlining variables is faster.
           * Below a non-optimized version is shown that implements the basic algorithm with
           * a few comments
           */ const cantCopyParentInfo = (info & ($51l7Q.BIT7 | $51l7Q.BIT8)) === 0;
                        // If parent = null and neither left nor right are defined, then we know that `parent` is child of `y`
                        // and we read the next string as parentYKey.
                        // It indicates how we store/retrieve parent from `y.share`
                        // @type {string|null}
                        const struct = new $4bf7ba9bbb4881ae$export$6d08773d2e66f8f2($4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(client, clock), null, (info & $51l7Q.BIT8) === $51l7Q.BIT8 ? decoder.readLeftID() : null, null, (info & $51l7Q.BIT7) === $51l7Q.BIT7 ? decoder.readRightID() : null, cantCopyParentInfo ? decoder.readParentInfo() ? doc.get(decoder.readString()) : decoder.readLeftID() : null, cantCopyParentInfo && (info & $51l7Q.BIT6) === $51l7Q.BIT6 ? decoder.readString() : null, $4bf7ba9bbb4881ae$var$readItemContent(decoder, info) // item content
                        );
                        /* A non-optimized implementation of the above algorithm:

          // The item that was originally to the left of this item.
          const origin = (info & binary.BIT8) === binary.BIT8 ? decoder.readLeftID() : null
          // The item that was originally to the right of this item.
          const rightOrigin = (info & binary.BIT7) === binary.BIT7 ? decoder.readRightID() : null
          const cantCopyParentInfo = (info & (binary.BIT7 | binary.BIT8)) === 0
          const hasParentYKey = cantCopyParentInfo ? decoder.readParentInfo() : false
          // If parent = null and neither left nor right are defined, then we know that `parent` is child of `y`
          // and we read the next string as parentYKey.
          // It indicates how we store/retrieve parent from `y.share`
          // @type {string|null}
          const parentYKey = cantCopyParentInfo && hasParentYKey ? decoder.readString() : null

          const struct = new Item(
            createID(client, clock),
            null, // leftd
            origin, // origin
            null, // right
            rightOrigin, // right origin
            cantCopyParentInfo && !hasParentYKey ? decoder.readLeftID() : (parentYKey !== null ? doc.get(parentYKey) : null), // parent
            cantCopyParentInfo && (info & binary.BIT6) === binary.BIT6 ? decoder.readString() : null, // parentSub
            readItemContent(decoder, info) // item content
          )
          */ refs[i] = struct;
                        clock += struct.length;
                    }
            }
        }
    // console.log('time to read: ', performance.now() - start) // @todo remove
    }
    return clientRefs;
};
/**
 * Resume computing structs generated by struct readers.
 *
 * While there is something to do, we integrate structs in this order
 * 1. top element on stack, if stack is not empty
 * 2. next element from current struct reader (if empty, use next struct reader)
 *
 * If struct causally depends on another struct (ref.missing), we put next reader of
 * `ref.id.client` on top of stack.
 *
 * At some point we find a struct that has no causal dependencies,
 * then we start emptying the stack.
 *
 * It is not possible to have circles: i.e. struct1 (from client1) depends on struct2 (from client2)
 * depends on struct3 (from client1). Therefore the max stack size is eqaul to `structReaders.length`.
 *
 * This method is implemented in a way so that we can resume computation if this update
 * causally depends on another update.
 *
 * @param {Transaction} transaction
 * @param {StructStore} store
 * @param {Map<number, { i: number, refs: (GC | Item)[] }>} clientsStructRefs
 * @return { null | { update: Uint8Array, missing: Map<number,number> } }
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$integrateStructs = (transaction, store, clientsStructRefs)=>{
    /**
   * @type {Array<Item | GC>}
   */ const stack = [];
    // sort them so that we take the higher id first, in case of conflicts the lower id will probably not conflict with the id from the higher user.
    let clientsStructRefsIds = $iiUWJ.from(clientsStructRefs.keys()).sort((a, b)=>a - b);
    if (clientsStructRefsIds.length === 0) return null;
    const getNextStructTarget = ()=>{
        if (clientsStructRefsIds.length === 0) return null;
        let nextStructsTarget = /** @type {{i:number,refs:Array<GC|Item>}} */ clientsStructRefs.get(clientsStructRefsIds[clientsStructRefsIds.length - 1]);
        while(nextStructsTarget.refs.length === nextStructsTarget.i){
            clientsStructRefsIds.pop();
            if (clientsStructRefsIds.length > 0) nextStructsTarget = /** @type {{i:number,refs:Array<GC|Item>}} */ clientsStructRefs.get(clientsStructRefsIds[clientsStructRefsIds.length - 1]);
            else return null;
        }
        return nextStructsTarget;
    };
    let curStructsTarget = getNextStructTarget();
    if (curStructsTarget === null) return null;
    /**
   * @type {StructStore}
   */ const restStructs = new $4bf7ba9bbb4881ae$var$StructStore();
    const missingSV = new Map();
    /**
   * @param {number} client
   * @param {number} clock
   */ const updateMissingSv = (client, clock)=>{
        const mclock = missingSV.get(client);
        if (mclock == null || mclock > clock) missingSV.set(client, clock);
    };
    /**
   * @type {GC|Item}
   */ let stackHead = /** @type {any} */ curStructsTarget.refs[/** @type {any} */ curStructsTarget.i++];
    // caching the state because it is used very often
    const state = new Map();
    const addStackToRestSS = ()=>{
        for (const item of stack){
            const client = item.id.client;
            const unapplicableItems = clientsStructRefs.get(client);
            if (unapplicableItems) {
                // decrement because we weren't able to apply previous operation
                unapplicableItems.i--;
                restStructs.clients.set(client, unapplicableItems.refs.slice(unapplicableItems.i));
                clientsStructRefs.delete(client);
                unapplicableItems.i = 0;
                unapplicableItems.refs = [];
            } else // item was the last item on clientsStructRefs and the field was already cleared. Add item to restStructs and continue
            restStructs.clients.set(client, [
                item
            ]);
            // remove client from clientsStructRefsIds to prevent users from applying the same update again
            clientsStructRefsIds = clientsStructRefsIds.filter((c)=>c !== client);
        }
        stack.length = 0;
    };
    // iterate over all struct readers until we are done
    while(true){
        if (stackHead.constructor !== $4bf7ba9bbb4881ae$export$38d24f5c1eb0e4c0) {
            const localClock = $dh5fq.setIfUndefined(state, stackHead.id.client, ()=>$4bf7ba9bbb4881ae$export$50fdfeece43146fd(store, stackHead.id.client));
            const offset = localClock - stackHead.id.clock;
            if (offset < 0) {
                // update from the same client is missing
                stack.push(stackHead);
                updateMissingSv(stackHead.id.client, stackHead.id.clock - 1);
                // hid a dead wall, add all items from stack to restSS
                addStackToRestSS();
            } else {
                const missing = stackHead.getMissing(transaction, store);
                if (missing !== null) {
                    stack.push(stackHead);
                    // get the struct reader that has the missing struct
                    /**
           * @type {{ refs: Array<GC|Item>, i: number }}
           */ const structRefs = clientsStructRefs.get(/** @type {number} */ missing) || {
                        refs: [],
                        i: 0
                    };
                    if (structRefs.refs.length === structRefs.i) {
                        // This update message causally depends on another update message that doesn't exist yet
                        updateMissingSv(/** @type {number} */ missing, $4bf7ba9bbb4881ae$export$50fdfeece43146fd(store, missing));
                        addStackToRestSS();
                    } else {
                        stackHead = structRefs.refs[structRefs.i++];
                        continue;
                    }
                } else if (offset === 0 || offset < stackHead.length) {
                    // all fine, apply the stackhead
                    stackHead.integrate(transaction, offset);
                    state.set(stackHead.id.client, stackHead.id.clock + stackHead.length);
                }
            }
        }
        // iterate to next stackHead
        if (stack.length > 0) stackHead = /** @type {GC|Item} */ stack.pop();
        else if (curStructsTarget !== null && curStructsTarget.i < curStructsTarget.refs.length) stackHead = /** @type {GC|Item} */ curStructsTarget.refs[curStructsTarget.i++];
        else {
            curStructsTarget = getNextStructTarget();
            if (curStructsTarget === null) break;
            else stackHead = /** @type {GC|Item} */ curStructsTarget.refs[curStructsTarget.i++];
        }
    }
    if (restStructs.clients.size > 0) {
        const encoder = new $4bf7ba9bbb4881ae$export$30c99e08943e1c2();
        $4bf7ba9bbb4881ae$var$writeClientsStructs(encoder, restStructs, new Map());
        // write empty deleteset
        // writeDeleteSet(encoder, new DeleteSet())
        $6E0HV.writeVarUint(encoder.restEncoder, 0); // => no need for an extra function call, just write 0 deletes
        return {
            missing: missingSV,
            update: encoder.toUint8Array()
        };
    }
    return null;
};
/**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Transaction} transaction
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$writeStructsFromTransaction = (encoder, transaction)=>$4bf7ba9bbb4881ae$var$writeClientsStructs(encoder, transaction.doc.store, transaction.beforeState);
/**
 * Read and apply a document update.
 *
 * This function has the same effect as `applyUpdate` but accepts an decoder.
 *
 * @param {decoding.Decoder} decoder
 * @param {Doc} ydoc
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 * @param {UpdateDecoderV1 | UpdateDecoderV2} [structDecoder]
 *
 * @function
 */ const $4bf7ba9bbb4881ae$export$7abe492a0b891b4d = (decoder, ydoc, transactionOrigin, structDecoder = new $4bf7ba9bbb4881ae$export$1c932452355c5571(decoder))=>$4bf7ba9bbb4881ae$export$dac1bad6146b2469(ydoc, (transaction)=>{
        // force that transaction.local is set to non-local
        transaction.local = false;
        let retry = false;
        const doc = transaction.doc;
        const store = doc.store;
        // let start = performance.now()
        const ss = $4bf7ba9bbb4881ae$var$readClientsStructRefs(structDecoder, doc);
        // console.log('time to read structs: ', performance.now() - start) // @todo remove
        // start = performance.now()
        // console.log('time to merge: ', performance.now() - start) // @todo remove
        // start = performance.now()
        const restStructs = $4bf7ba9bbb4881ae$var$integrateStructs(transaction, store, ss);
        const pending = store.pendingStructs;
        if (pending) {
            // check if we can apply something
            for (const [client, clock] of pending.missing)if (clock < $4bf7ba9bbb4881ae$export$50fdfeece43146fd(store, client)) {
                retry = true;
                break;
            }
            if (restStructs) {
                // merge restStructs into store.pending
                for (const [client, clock] of restStructs.missing){
                    const mclock = pending.missing.get(client);
                    if (mclock == null || mclock > clock) pending.missing.set(client, clock);
                }
                pending.update = $4bf7ba9bbb4881ae$export$ce273d78de0331d1([
                    pending.update,
                    restStructs.update
                ]);
            }
        } else store.pendingStructs = restStructs;
        // console.log('time to integrate: ', performance.now() - start) // @todo remove
        // start = performance.now()
        const dsRest = $4bf7ba9bbb4881ae$var$readAndApplyDeleteSet(structDecoder, transaction, store);
        if (store.pendingDs) {
            // @todo we could make a lower-bound state-vector check as we do above
            const pendingDSUpdate = new $4bf7ba9bbb4881ae$export$1c932452355c5571($dirF1.createDecoder(store.pendingDs));
            $dirF1.readVarUint(pendingDSUpdate.restDecoder); // read 0 structs, because we only encode deletes in pendingdsupdate
            const dsRest2 = $4bf7ba9bbb4881ae$var$readAndApplyDeleteSet(pendingDSUpdate, transaction, store);
            if (dsRest && dsRest2) // case 1: ds1 != null && ds2 != null
            store.pendingDs = $4bf7ba9bbb4881ae$export$ce273d78de0331d1([
                dsRest,
                dsRest2
            ]);
            else // case 2: ds1 != null
            // case 3: ds2 != null
            // case 4: ds1 == null && ds2 == null
            store.pendingDs = dsRest || dsRest2;
        } else // Either dsRest == null && pendingDs == null OR dsRest != null
        store.pendingDs = dsRest;
        // console.log('time to cleanup: ', performance.now() - start) // @todo remove
        // start = performance.now()
        // console.log('time to resume delete readers: ', performance.now() - start) // @todo remove
        // start = performance.now()
        if (retry) {
            const update = /** @type {{update: Uint8Array}} */ store.pendingStructs.update;
            store.pendingStructs = null;
            $4bf7ba9bbb4881ae$export$acc3b0324aabf1b6(transaction.doc, update);
        }
    }, transactionOrigin, false);
/**
 * Read and apply a document update.
 *
 * This function has the same effect as `applyUpdate` but accepts an decoder.
 *
 * @param {decoding.Decoder} decoder
 * @param {Doc} ydoc
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 *
 * @function
 */ const $4bf7ba9bbb4881ae$export$d67ac8d73b7d336c = (decoder, ydoc, transactionOrigin)=>$4bf7ba9bbb4881ae$export$7abe492a0b891b4d(decoder, ydoc, transactionOrigin, new $4bf7ba9bbb4881ae$export$1aa46d9818b5d1ec(decoder));
/**
 * Apply a document update created by, for example, `y.on('update', update => ..)` or `update = encodeStateAsUpdate()`.
 *
 * This function has the same effect as `readUpdate` but accepts an Uint8Array instead of a Decoder.
 *
 * @param {Doc} ydoc
 * @param {Uint8Array} update
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} [YDecoder]
 *
 * @function
 */ const $4bf7ba9bbb4881ae$export$acc3b0324aabf1b6 = (ydoc, update, transactionOrigin, YDecoder = $4bf7ba9bbb4881ae$export$1c932452355c5571)=>{
    const decoder = $dirF1.createDecoder(update);
    $4bf7ba9bbb4881ae$export$7abe492a0b891b4d(decoder, ydoc, transactionOrigin, new YDecoder(decoder));
};
/**
 * Apply a document update created by, for example, `y.on('update', update => ..)` or `update = encodeStateAsUpdate()`.
 *
 * This function has the same effect as `readUpdate` but accepts an Uint8Array instead of a Decoder.
 *
 * @param {Doc} ydoc
 * @param {Uint8Array} update
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 *
 * @function
 */ const $4bf7ba9bbb4881ae$export$c271737a9c02e925 = (ydoc, update, transactionOrigin)=>$4bf7ba9bbb4881ae$export$acc3b0324aabf1b6(ydoc, update, transactionOrigin, $4bf7ba9bbb4881ae$export$1aa46d9818b5d1ec);
/**
 * Write all the document as a single update message. If you specify the state of the remote client (`targetStateVector`) it will
 * only write the operations that are missing.
 *
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Doc} doc
 * @param {Map<number,number>} [targetStateVector] The state of the target that receives the update. Leave empty to write all known structs
 *
 * @function
 */ const $4bf7ba9bbb4881ae$var$writeStateAsUpdate = (encoder, doc, targetStateVector = new Map())=>{
    $4bf7ba9bbb4881ae$var$writeClientsStructs(encoder, doc.store, targetStateVector);
    $4bf7ba9bbb4881ae$var$writeDeleteSet(encoder, $4bf7ba9bbb4881ae$export$8450d668bec558e2(doc.store));
};
/**
 * Write all the document as a single update message that can be applied on the remote document. If you specify the state of the remote client (`targetState`) it will
 * only write the operations that are missing.
 *
 * Use `writeStateAsUpdate` instead if you are working with lib0/encoding.js#Encoder
 *
 * @param {Doc} doc
 * @param {Uint8Array} [encodedTargetStateVector] The state of the target that receives the update. Leave empty to write all known structs
 * @param {UpdateEncoderV1 | UpdateEncoderV2} [encoder]
 * @return {Uint8Array}
 *
 * @function
 */ const $4bf7ba9bbb4881ae$export$90338e0798f6f64f = (doc, encodedTargetStateVector = new Uint8Array([
    0
]), encoder = new $4bf7ba9bbb4881ae$export$30c99e08943e1c2())=>{
    const targetStateVector = $4bf7ba9bbb4881ae$export$324ac6fb20a844e3(encodedTargetStateVector);
    $4bf7ba9bbb4881ae$var$writeStateAsUpdate(encoder, doc, targetStateVector);
    const updates = [
        encoder.toUint8Array()
    ];
    // also add the pending updates (if there are any)
    if (doc.store.pendingDs) updates.push(doc.store.pendingDs);
    if (doc.store.pendingStructs) updates.push($4bf7ba9bbb4881ae$export$a8143edf39d2ad8e(doc.store.pendingStructs.update, encodedTargetStateVector));
    if (updates.length > 1) {
        if (encoder.constructor === $4bf7ba9bbb4881ae$export$99171b804d9c5b54) return $4bf7ba9bbb4881ae$export$6319871659fd2460(updates.map((update, i)=>i === 0 ? update : $4bf7ba9bbb4881ae$export$afffbdeed14adbd(update)));
        else if (encoder.constructor === $4bf7ba9bbb4881ae$export$30c99e08943e1c2) return $4bf7ba9bbb4881ae$export$ce273d78de0331d1(updates);
    }
    return updates[0];
};
/**
 * Write all the document as a single update message that can be applied on the remote document. If you specify the state of the remote client (`targetState`) it will
 * only write the operations that are missing.
 *
 * Use `writeStateAsUpdate` instead if you are working with lib0/encoding.js#Encoder
 *
 * @param {Doc} doc
 * @param {Uint8Array} [encodedTargetStateVector] The state of the target that receives the update. Leave empty to write all known structs
 * @return {Uint8Array}
 *
 * @function
 */ const $4bf7ba9bbb4881ae$export$e5848df80e65bd53 = (doc, encodedTargetStateVector)=>$4bf7ba9bbb4881ae$export$90338e0798f6f64f(doc, encodedTargetStateVector, new $4bf7ba9bbb4881ae$export$99171b804d9c5b54());
/**
 * Read state vector from Decoder and return as Map
 *
 * @param {DSDecoderV1 | DSDecoderV2} decoder
 * @return {Map<number,number>} Maps `client` to the number next expected `clock` from that client.
 *
 * @function
 */ const $4bf7ba9bbb4881ae$var$readStateVector = (decoder)=>{
    const ss = new Map();
    const ssLength = $dirF1.readVarUint(decoder.restDecoder);
    for(let i = 0; i < ssLength; i++){
        const client = $dirF1.readVarUint(decoder.restDecoder);
        const clock = $dirF1.readVarUint(decoder.restDecoder);
        ss.set(client, clock);
    }
    return ss;
};
/**
 * Read decodedState and return State as Map.
 *
 * @param {Uint8Array} decodedState
 * @return {Map<number,number>} Maps `client` to the number next expected `clock` from that client.
 *
 * @function
 */ // export const decodeStateVectorV2 = decodedState => readStateVector(new DSDecoderV2(decoding.createDecoder(decodedState)))
/**
 * Read decodedState and return State as Map.
 *
 * @param {Uint8Array} decodedState
 * @return {Map<number,number>} Maps `client` to the number next expected `clock` from that client.
 *
 * @function
 */ const $4bf7ba9bbb4881ae$export$324ac6fb20a844e3 = (decodedState)=>$4bf7ba9bbb4881ae$var$readStateVector(new $4bf7ba9bbb4881ae$var$DSDecoderV1($dirF1.createDecoder(decodedState)));
/**
 * @param {DSEncoderV1 | DSEncoderV2} encoder
 * @param {Map<number,number>} sv
 * @function
 */ const $4bf7ba9bbb4881ae$var$writeStateVector = (encoder, sv)=>{
    $6E0HV.writeVarUint(encoder.restEncoder, sv.size);
    $iiUWJ.from(sv.entries()).sort((a, b)=>b[0] - a[0]).forEach(([client, clock])=>{
        $6E0HV.writeVarUint(encoder.restEncoder, client); // @todo use a special client decoder that is based on mapping
        $6E0HV.writeVarUint(encoder.restEncoder, clock);
    });
    return encoder;
};
/**
 * @param {DSEncoderV1 | DSEncoderV2} encoder
 * @param {Doc} doc
 *
 * @function
 */ const $4bf7ba9bbb4881ae$var$writeDocumentStateVector = (encoder, doc)=>$4bf7ba9bbb4881ae$var$writeStateVector(encoder, $4bf7ba9bbb4881ae$var$getStateVector(doc.store));
/**
 * Encode State as Uint8Array.
 *
 * @param {Doc|Map<number,number>} doc
 * @param {DSEncoderV1 | DSEncoderV2} [encoder]
 * @return {Uint8Array}
 *
 * @function
 */ const $4bf7ba9bbb4881ae$var$encodeStateVectorV2 = (doc, encoder = new $4bf7ba9bbb4881ae$var$DSEncoderV2())=>{
    if (doc instanceof Map) $4bf7ba9bbb4881ae$var$writeStateVector(encoder, doc);
    else $4bf7ba9bbb4881ae$var$writeDocumentStateVector(encoder, doc);
    return encoder.toUint8Array();
};
/**
 * Encode State as Uint8Array.
 *
 * @param {Doc|Map<number,number>} doc
 * @return {Uint8Array}
 *
 * @function
 */ const $4bf7ba9bbb4881ae$export$3e2f5393f32e71f = (doc)=>$4bf7ba9bbb4881ae$var$encodeStateVectorV2(doc, new $4bf7ba9bbb4881ae$var$DSEncoderV1());
/**
 * General event handler implementation.
 *
 * @template ARG0, ARG1
 *
 * @private
 */ class $4bf7ba9bbb4881ae$var$EventHandler {
    constructor(){
        /**
     * @type {Array<function(ARG0, ARG1):void>}
     */ this.l = [];
    }
}
/**
 * @template ARG0,ARG1
 * @returns {EventHandler<ARG0,ARG1>}
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$createEventHandler = ()=>new $4bf7ba9bbb4881ae$var$EventHandler();
/**
 * Adds an event listener that is called when
 * {@link EventHandler#callEventListeners} is called.
 *
 * @template ARG0,ARG1
 * @param {EventHandler<ARG0,ARG1>} eventHandler
 * @param {function(ARG0,ARG1):void} f The event handler.
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$addEventHandlerListener = (eventHandler, f)=>eventHandler.l.push(f);
/**
 * Removes an event listener.
 *
 * @template ARG0,ARG1
 * @param {EventHandler<ARG0,ARG1>} eventHandler
 * @param {function(ARG0,ARG1):void} f The event handler that was added with
 *                     {@link EventHandler#addEventListener}
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$removeEventHandlerListener = (eventHandler, f)=>{
    const l = eventHandler.l;
    const len = l.length;
    eventHandler.l = l.filter((g)=>f !== g);
    if (len === eventHandler.l.length) console.error("[yjs] Tried to remove event handler that doesn't exist.");
};
/**
 * Call all event listeners that were added via
 * {@link EventHandler#addEventListener}.
 *
 * @template ARG0,ARG1
 * @param {EventHandler<ARG0,ARG1>} eventHandler
 * @param {ARG0} arg0
 * @param {ARG1} arg1
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$callEventHandlerListeners = (eventHandler, arg0, arg1)=>$4NUz5.callAll(eventHandler.l, [
        arg0,
        arg1
    ]);
class $4bf7ba9bbb4881ae$export$8be180ec26319f9f {
    /**
   * @param {number} client client id
   * @param {number} clock unique per client id, continuous number
   */ constructor(client, clock){
        /**
     * Client id
     * @type {number}
     */ this.client = client;
        /**
     * unique per client id, continuous number
     * @type {number}
     */ this.clock = clock;
    }
}
/**
 * @param {ID | null} a
 * @param {ID | null} b
 * @return {boolean}
 *
 * @function
 */ const $4bf7ba9bbb4881ae$export$c0af976e7e459c02 = (a, b)=>a === b || a !== null && b !== null && a.client === b.client && a.clock === b.clock;
/**
 * @param {number} client
 * @param {number} clock
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$export$6c7d4e6171d008d0 = (client, clock)=>new $4bf7ba9bbb4881ae$export$8be180ec26319f9f(client, clock);
/**
 * @param {encoding.Encoder} encoder
 * @param {ID} id
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$writeID = (encoder, id)=>{
    $6E0HV.writeVarUint(encoder, id.client);
    $6E0HV.writeVarUint(encoder, id.clock);
};
/**
 * Read ID.
 * * If first varUint read is 0xFFFFFF a RootID is returned.
 * * Otherwise an ID is returned
 *
 * @param {decoding.Decoder} decoder
 * @return {ID}
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$readID = (decoder)=>$4bf7ba9bbb4881ae$export$6c7d4e6171d008d0($dirF1.readVarUint(decoder), $dirF1.readVarUint(decoder));
/**
 * The top types are mapped from y.share.get(keyname) => type.
 * `type` does not store any information about the `keyname`.
 * This function finds the correct `keyname` for `type` and throws otherwise.
 *
 * @param {AbstractType<any>} type
 * @return {string}
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$export$e726a40920d54663 = (type)=>{
    // @ts-ignore _y must be defined, otherwise unexpected case
    for (const [key, value] of type.doc.share.entries()){
        if (value === type) return key;
    }
    throw $iVMsw.unexpectedCase();
};
/**
 * Check if `parent` is a parent of `child`.
 *
 * @param {AbstractType<any>} parent
 * @param {Item|null} child
 * @return {Boolean} Whether `parent` is a parent of `child`.
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$export$3c81af374b054d6a = (parent, child)=>{
    while(child !== null){
        if (child.parent === parent) return true;
        child = /** @type {AbstractType<any>} */ child.parent._item;
    }
    return false;
};
/**
 * Convenient helper to log type information.
 *
 * Do not use in productive systems as the output can be immense!
 *
 * @param {AbstractType<any>} type
 */ const $4bf7ba9bbb4881ae$export$e9068ad704ba2f79 = (type)=>{
    const res = [];
    let n = type._start;
    while(n){
        res.push(n);
        n = n.right;
    }
    console.log("Children: ", res);
    console.log("Children content: ", res.filter((m)=>!m.deleted).map((m)=>m.content));
};
class $4bf7ba9bbb4881ae$export$b9e8b5fa1162ca4e {
    /**
   * @param {Doc} doc
   * @param {YMap<any>} [storeType]
   */ constructor(doc, storeType = doc.getMap("users")){
        /**
     * @type {Map<string,DeleteSet>}
     */ const dss = new Map();
        this.yusers = storeType;
        this.doc = doc;
        /**
     * Maps from clientid to userDescription
     *
     * @type {Map<number,string>}
     */ this.clients = new Map();
        this.dss = dss;
        /**
     * @param {YMap<any>} user
     * @param {string} userDescription
     */ const initUser = (user, userDescription)=>{
            /**
       * @type {YArray<Uint8Array>}
       */ const ds = user.get("ds");
            const ids = user.get("ids");
            const addClientId = /** @param {number} clientid */ (clientid)=>this.clients.set(clientid, userDescription);
            ds.observe(/** @param {YArrayEvent<any>} event */ (event)=>{
                event.changes.added.forEach((item)=>{
                    item.content.getContent().forEach((encodedDs)=>{
                        if (encodedDs instanceof Uint8Array) this.dss.set(userDescription, $4bf7ba9bbb4881ae$var$mergeDeleteSets([
                            this.dss.get(userDescription) || $4bf7ba9bbb4881ae$export$8cbac0d946238699(),
                            $4bf7ba9bbb4881ae$var$readDeleteSet(new $4bf7ba9bbb4881ae$var$DSDecoderV1($dirF1.createDecoder(encodedDs)))
                        ]));
                    });
                });
            });
            this.dss.set(userDescription, $4bf7ba9bbb4881ae$var$mergeDeleteSets(ds.map((encodedDs)=>$4bf7ba9bbb4881ae$var$readDeleteSet(new $4bf7ba9bbb4881ae$var$DSDecoderV1($dirF1.createDecoder(encodedDs))))));
            ids.observe(/** @param {YArrayEvent<any>} event */ (event)=>event.changes.added.forEach((item)=>item.content.getContent().forEach(addClientId)));
            ids.forEach(addClientId);
        };
        // observe users
        storeType.observe((event)=>{
            event.keysChanged.forEach((userDescription)=>initUser(storeType.get(userDescription), userDescription));
        });
        // add intial data
        storeType.forEach(initUser);
    }
    /**
   * @param {Doc} doc
   * @param {number} clientid
   * @param {string} userDescription
   * @param {Object} conf
   * @param {function(Transaction, DeleteSet):boolean} [conf.filter]
   */ setUserMapping(doc, clientid, userDescription, { filter: filter = ()=>true } = {}) {
        const users = this.yusers;
        let user = users.get(userDescription);
        if (!user) {
            user = new $4bf7ba9bbb4881ae$export$a5c7b93649eaf8f8();
            user.set("ids", new $4bf7ba9bbb4881ae$export$c4be6576ca6fe4aa());
            user.set("ds", new $4bf7ba9bbb4881ae$export$c4be6576ca6fe4aa());
            users.set(userDescription, user);
        }
        user.get("ids").push([
            clientid
        ]);
        users.observe((_event)=>{
            setTimeout(()=>{
                const userOverwrite = users.get(userDescription);
                if (userOverwrite !== user) {
                    // user was overwritten, port all data over to the next user object
                    // @todo Experiment with Y.Sets here
                    user = userOverwrite;
                    // @todo iterate over old type
                    this.clients.forEach((_userDescription, clientid)=>{
                        if (userDescription === _userDescription) user.get("ids").push([
                            clientid
                        ]);
                    });
                    const encoder = new $4bf7ba9bbb4881ae$var$DSEncoderV1();
                    const ds = this.dss.get(userDescription);
                    if (ds) {
                        $4bf7ba9bbb4881ae$var$writeDeleteSet(encoder, ds);
                        user.get("ds").push([
                            encoder.toUint8Array()
                        ]);
                    }
                }
            }, 0);
        });
        doc.on("afterTransaction", /** @param {Transaction} transaction */ (transaction)=>{
            setTimeout(()=>{
                const yds = user.get("ds");
                const ds = transaction.deleteSet;
                if (transaction.local && ds.clients.size > 0 && filter(transaction, ds)) {
                    const encoder = new $4bf7ba9bbb4881ae$var$DSEncoderV1();
                    $4bf7ba9bbb4881ae$var$writeDeleteSet(encoder, ds);
                    yds.push([
                        encoder.toUint8Array()
                    ]);
                }
            });
        });
    }
    /**
   * @param {number} clientid
   * @return {any}
   */ getUserByClientId(clientid) {
        return this.clients.get(clientid) || null;
    }
    /**
   * @param {ID} id
   * @return {string | null}
   */ getUserByDeletedId(id) {
        for (const [userDescription, ds] of this.dss.entries()){
            if ($4bf7ba9bbb4881ae$export$dcb04af092e44fde(ds, id)) return userDescription;
        }
        return null;
    }
}
/**
 * A relative position is based on the Yjs model and is not affected by document changes.
 * E.g. If you place a relative position before a certain character, it will always point to this character.
 * If you place a relative position at the end of a type, it will always point to the end of the type.
 *
 * A numeric position is often unsuited for user selections, because it does not change when content is inserted
 * before or after.
 *
 * ```Insert(0, 'x')('a|bc') = 'xa|bc'``` Where | is the relative position.
 *
 * One of the properties must be defined.
 *
 * @example
 *   // Current cursor position is at position 10
 *   const relativePosition = createRelativePositionFromIndex(yText, 10)
 *   // modify yText
 *   yText.insert(0, 'abc')
 *   yText.delete(3, 10)
 *   // Compute the cursor position
 *   const absolutePosition = createAbsolutePositionFromRelativePosition(y, relativePosition)
 *   absolutePosition.type === yText // => true
 *   console.log('cursor location is ' + absolutePosition.index) // => cursor location is 3
 *
 */ class $4bf7ba9bbb4881ae$export$da21a415c5907662 {
    /**
   * @param {ID|null} type
   * @param {string|null} tname
   * @param {ID|null} item
   * @param {number} assoc
   */ constructor(type, tname, item, assoc = 0){
        /**
     * @type {ID|null}
     */ this.type = type;
        /**
     * @type {string|null}
     */ this.tname = tname;
        /**
     * @type {ID | null}
     */ this.item = item;
        /**
     * A relative position is associated to a specific character. By default
     * assoc >= 0, the relative position is associated to the character
     * after the meant position.
     * I.e. position 1 in 'ab' is associated to character 'b'.
     *
     * If assoc < 0, then the relative position is associated to the caharacter
     * before the meant position.
     *
     * @type {number}
     */ this.assoc = assoc;
    }
}
/**
 * @param {RelativePosition} rpos
 * @return {any}
 */ const $4bf7ba9bbb4881ae$export$a783b081767a452e = (rpos)=>{
    const json = {};
    if (rpos.type) json.type = rpos.type;
    if (rpos.tname) json.tname = rpos.tname;
    if (rpos.item) json.item = rpos.item;
    if (rpos.assoc != null) json.assoc = rpos.assoc;
    return json;
};
/**
 * @param {any} json
 * @return {RelativePosition}
 *
 * @function
 */ const $4bf7ba9bbb4881ae$export$ddad8a1b8f7475d8 = (json)=>new $4bf7ba9bbb4881ae$export$da21a415c5907662(json.type == null ? null : $4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(json.type.client, json.type.clock), json.tname || null, json.item == null ? null : $4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(json.item.client, json.item.clock), json.assoc == null ? 0 : json.assoc);
class $4bf7ba9bbb4881ae$export$64c95a3fb7344864 {
    /**
   * @param {AbstractType<any>} type
   * @param {number} index
   * @param {number} [assoc]
   */ constructor(type, index, assoc = 0){
        /**
     * @type {AbstractType<any>}
     */ this.type = type;
        /**
     * @type {number}
     */ this.index = index;
        this.assoc = assoc;
    }
}
/**
 * @param {AbstractType<any>} type
 * @param {number} index
 * @param {number} [assoc]
 *
 * @function
 */ const $4bf7ba9bbb4881ae$var$createAbsolutePosition = (type, index, assoc = 0)=>new $4bf7ba9bbb4881ae$export$64c95a3fb7344864(type, index, assoc);
/**
 * @param {AbstractType<any>} type
 * @param {ID|null} item
 * @param {number} [assoc]
 *
 * @function
 */ const $4bf7ba9bbb4881ae$var$createRelativePosition = (type, item, assoc)=>{
    let typeid = null;
    let tname = null;
    if (type._item === null) tname = $4bf7ba9bbb4881ae$export$e726a40920d54663(type);
    else typeid = $4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(type._item.id.client, type._item.id.clock);
    return new $4bf7ba9bbb4881ae$export$da21a415c5907662(typeid, tname, item, assoc);
};
/**
 * Create a relativePosition based on a absolute position.
 *
 * @param {AbstractType<any>} type The base type (e.g. YText or YArray).
 * @param {number} index The absolute position.
 * @param {number} [assoc]
 * @return {RelativePosition}
 *
 * @function
 */ const $4bf7ba9bbb4881ae$export$197e7d99e3857e88 = (type, index, assoc = 0)=>{
    let t = type._start;
    if (assoc < 0) {
        // associated to the left character or the beginning of a type, increment index if possible.
        if (index === 0) return $4bf7ba9bbb4881ae$var$createRelativePosition(type, null, assoc);
        index--;
    }
    while(t !== null){
        if (!t.deleted && t.countable) {
            if (t.length > index) // case 1: found position somewhere in the linked list
            return $4bf7ba9bbb4881ae$var$createRelativePosition(type, $4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(t.id.client, t.id.clock + index), assoc);
            index -= t.length;
        }
        if (t.right === null && assoc < 0) // left-associated position, return last available id
        return $4bf7ba9bbb4881ae$var$createRelativePosition(type, t.lastId, assoc);
        t = t.right;
    }
    return $4bf7ba9bbb4881ae$var$createRelativePosition(type, null, assoc);
};
/**
 * @param {encoding.Encoder} encoder
 * @param {RelativePosition} rpos
 *
 * @function
 */ const $4bf7ba9bbb4881ae$var$writeRelativePosition = (encoder, rpos)=>{
    const { type: type, tname: tname, item: item, assoc: assoc } = rpos;
    if (item !== null) {
        $6E0HV.writeVarUint(encoder, 0);
        $4bf7ba9bbb4881ae$var$writeID(encoder, item);
    } else if (tname !== null) {
        // case 2: found position at the end of the list and type is stored in y.share
        $6E0HV.writeUint8(encoder, 1);
        $6E0HV.writeVarString(encoder, tname);
    } else if (type !== null) {
        // case 3: found position at the end of the list and type is attached to an item
        $6E0HV.writeUint8(encoder, 2);
        $4bf7ba9bbb4881ae$var$writeID(encoder, type);
    } else throw $iVMsw.unexpectedCase();
    $6E0HV.writeVarInt(encoder, assoc);
    return encoder;
};
/**
 * @param {RelativePosition} rpos
 * @return {Uint8Array}
 */ const $4bf7ba9bbb4881ae$export$c5c95ef724203575 = (rpos)=>{
    const encoder = $6E0HV.createEncoder();
    $4bf7ba9bbb4881ae$var$writeRelativePosition(encoder, rpos);
    return $6E0HV.toUint8Array(encoder);
};
/**
 * @param {decoding.Decoder} decoder
 * @return {RelativePosition}
 *
 * @function
 */ const $4bf7ba9bbb4881ae$var$readRelativePosition = (decoder)=>{
    let type = null;
    let tname = null;
    let itemID = null;
    switch($dirF1.readVarUint(decoder)){
        case 0:
            // case 1: found position somewhere in the linked list
            itemID = $4bf7ba9bbb4881ae$var$readID(decoder);
            break;
        case 1:
            // case 2: found position at the end of the list and type is stored in y.share
            tname = $dirF1.readVarString(decoder);
            break;
        case 2:
            // case 3: found position at the end of the list and type is attached to an item
            type = $4bf7ba9bbb4881ae$var$readID(decoder);
    }
    const assoc = $dirF1.hasContent(decoder) ? $dirF1.readVarInt(decoder) : 0;
    return new $4bf7ba9bbb4881ae$export$da21a415c5907662(type, tname, itemID, assoc);
};
/**
 * @param {Uint8Array} uint8Array
 * @return {RelativePosition}
 */ const $4bf7ba9bbb4881ae$export$58a46cebc90e7851 = (uint8Array)=>$4bf7ba9bbb4881ae$var$readRelativePosition($dirF1.createDecoder(uint8Array));
/**
 * @param {RelativePosition} rpos
 * @param {Doc} doc
 * @return {AbsolutePosition|null}
 *
 * @function
 */ const $4bf7ba9bbb4881ae$export$8fc3152f62fb7ed1 = (rpos, doc)=>{
    const store = doc.store;
    const rightID = rpos.item;
    const typeID = rpos.type;
    const tname = rpos.tname;
    const assoc = rpos.assoc;
    let type = null;
    let index = 0;
    if (rightID !== null) {
        if ($4bf7ba9bbb4881ae$export$50fdfeece43146fd(store, rightID.client) <= rightID.clock) return null;
        const res = $4bf7ba9bbb4881ae$var$followRedone(store, rightID);
        const right = res.item;
        if (!(right instanceof $4bf7ba9bbb4881ae$export$6d08773d2e66f8f2)) return null;
        type = /** @type {AbstractType<any>} */ right.parent;
        if (type._item === null || !type._item.deleted) {
            index = right.deleted || !right.countable ? 0 : res.diff + (assoc >= 0 ? 0 : 1); // adjust position based on left association if necessary
            let n = right.left;
            while(n !== null){
                if (!n.deleted && n.countable) index += n.length;
                n = n.left;
            }
        }
    } else {
        if (tname !== null) type = doc.get(tname);
        else if (typeID !== null) {
            if ($4bf7ba9bbb4881ae$export$50fdfeece43146fd(store, typeID.client) <= typeID.clock) // type does not exist yet
            return null;
            const { item: item } = $4bf7ba9bbb4881ae$var$followRedone(store, typeID);
            if (item instanceof $4bf7ba9bbb4881ae$export$6d08773d2e66f8f2 && item.content instanceof $4bf7ba9bbb4881ae$export$e2e108cbe2e4f865) type = item.content.type;
            else // struct is garbage collected
            return null;
        } else throw $iVMsw.unexpectedCase();
        if (assoc >= 0) index = type._length;
        else index = 0;
    }
    return $4bf7ba9bbb4881ae$var$createAbsolutePosition(type, index, rpos.assoc);
};
/**
 * @param {RelativePosition|null} a
 * @param {RelativePosition|null} b
 * @return {boolean}
 *
 * @function
 */ const $4bf7ba9bbb4881ae$export$fc8bd253c948b475 = (a, b)=>a === b || a !== null && b !== null && a.tname === b.tname && $4bf7ba9bbb4881ae$export$c0af976e7e459c02(a.item, b.item) && $4bf7ba9bbb4881ae$export$c0af976e7e459c02(a.type, b.type) && a.assoc === b.assoc;
class $4bf7ba9bbb4881ae$export$c963130a5525248f {
    /**
   * @param {DeleteSet} ds
   * @param {Map<number,number>} sv state map
   */ constructor(ds, sv){
        /**
     * @type {DeleteSet}
     */ this.ds = ds;
        /**
     * State Map
     * @type {Map<number,number>}
     */ this.sv = sv;
    }
}
/**
 * @param {Snapshot} snap1
 * @param {Snapshot} snap2
 * @return {boolean}
 */ const $4bf7ba9bbb4881ae$export$742742a0f55b273d = (snap1, snap2)=>{
    const ds1 = snap1.ds.clients;
    const ds2 = snap2.ds.clients;
    const sv1 = snap1.sv;
    const sv2 = snap2.sv;
    if (sv1.size !== sv2.size || ds1.size !== ds2.size) return false;
    for (const [key, value] of sv1.entries()){
        if (sv2.get(key) !== value) return false;
    }
    for (const [client, dsitems1] of ds1.entries()){
        const dsitems2 = ds2.get(client) || [];
        if (dsitems1.length !== dsitems2.length) return false;
        for(let i = 0; i < dsitems1.length; i++){
            const dsitem1 = dsitems1[i];
            const dsitem2 = dsitems2[i];
            if (dsitem1.clock !== dsitem2.clock || dsitem1.len !== dsitem2.len) return false;
        }
    }
    return true;
};
/**
 * @param {Snapshot} snapshot
 * @param {DSEncoderV1 | DSEncoderV2} [encoder]
 * @return {Uint8Array}
 */ const $4bf7ba9bbb4881ae$export$b946cadc55f8e512 = (snapshot, encoder = new $4bf7ba9bbb4881ae$var$DSEncoderV2())=>{
    $4bf7ba9bbb4881ae$var$writeDeleteSet(encoder, snapshot.ds);
    $4bf7ba9bbb4881ae$var$writeStateVector(encoder, snapshot.sv);
    return encoder.toUint8Array();
};
/**
 * @param {Snapshot} snapshot
 * @return {Uint8Array}
 */ const $4bf7ba9bbb4881ae$export$a6d29989648e995 = (snapshot)=>$4bf7ba9bbb4881ae$export$b946cadc55f8e512(snapshot, new $4bf7ba9bbb4881ae$var$DSEncoderV1());
/**
 * @param {Uint8Array} buf
 * @param {DSDecoderV1 | DSDecoderV2} [decoder]
 * @return {Snapshot}
 */ const $4bf7ba9bbb4881ae$export$b0049fa299f4f58e = (buf, decoder = new $4bf7ba9bbb4881ae$var$DSDecoderV2($dirF1.createDecoder(buf)))=>{
    return new $4bf7ba9bbb4881ae$export$c963130a5525248f($4bf7ba9bbb4881ae$var$readDeleteSet(decoder), $4bf7ba9bbb4881ae$var$readStateVector(decoder));
};
/**
 * @param {Uint8Array} buf
 * @return {Snapshot}
 */ const $4bf7ba9bbb4881ae$export$5c696daccf32bd2e = (buf)=>$4bf7ba9bbb4881ae$export$b0049fa299f4f58e(buf, new $4bf7ba9bbb4881ae$var$DSDecoderV1($dirF1.createDecoder(buf)));
/**
 * @param {DeleteSet} ds
 * @param {Map<number,number>} sm
 * @return {Snapshot}
 */ const $4bf7ba9bbb4881ae$export$548fae0445f878fd = (ds, sm)=>new $4bf7ba9bbb4881ae$export$c963130a5525248f(ds, sm);
const $4bf7ba9bbb4881ae$export$d4568a81dd107a34 = $4bf7ba9bbb4881ae$export$548fae0445f878fd($4bf7ba9bbb4881ae$export$8cbac0d946238699(), new Map());
/**
 * @param {Doc} doc
 * @return {Snapshot}
 */ const $4bf7ba9bbb4881ae$export$b8801ea43165ed7d = (doc)=>$4bf7ba9bbb4881ae$export$548fae0445f878fd($4bf7ba9bbb4881ae$export$8450d668bec558e2(doc.store), $4bf7ba9bbb4881ae$var$getStateVector(doc.store));
/**
 * @param {Item} item
 * @param {Snapshot|undefined} snapshot
 *
 * @protected
 * @function
 */ const $4bf7ba9bbb4881ae$var$isVisible = (item, snapshot)=>snapshot === undefined ? !item.deleted : snapshot.sv.has(item.id.client) && (snapshot.sv.get(item.id.client) || 0) > item.id.clock && !$4bf7ba9bbb4881ae$export$dcb04af092e44fde(snapshot.ds, item.id);
/**
 * @param {Transaction} transaction
 * @param {Snapshot} snapshot
 */ const $4bf7ba9bbb4881ae$var$splitSnapshotAffectedStructs = (transaction, snapshot)=>{
    const meta = $dh5fq.setIfUndefined(transaction.meta, $4bf7ba9bbb4881ae$var$splitSnapshotAffectedStructs, $bUD5M.create);
    const store = transaction.doc.store;
    // check if we already split for this snapshot
    if (!meta.has(snapshot)) {
        snapshot.sv.forEach((clock, client)=>{
            if (clock < $4bf7ba9bbb4881ae$export$50fdfeece43146fd(store, client)) $4bf7ba9bbb4881ae$var$getItemCleanStart(transaction, $4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(client, clock));
        });
        $4bf7ba9bbb4881ae$export$8afefebbaf4e4c78(transaction, snapshot.ds, (_item)=>{});
        meta.add(snapshot);
    }
};
/**
 * @example
 *  const ydoc = new Y.Doc({ gc: false })
 *  ydoc.getText().insert(0, 'world!')
 *  const snapshot = Y.snapshot(ydoc)
 *  ydoc.getText().insert(0, 'hello ')
 *  const restored = Y.createDocFromSnapshot(ydoc, snapshot)
 *  assert(restored.getText().toString() === 'world!')
 *
 * @param {Doc} originDoc
 * @param {Snapshot} snapshot
 * @param {Doc} [newDoc] Optionally, you may define the Yjs document that receives the data from originDoc
 * @return {Doc}
 */ const $4bf7ba9bbb4881ae$export$5be4ae1e1e56a014 = (originDoc, snapshot, newDoc = new $4bf7ba9bbb4881ae$export$bceacc74c2212615())=>{
    if (originDoc.gc) // we should not try to restore a GC-ed document, because some of the restored items might have their content deleted
    throw new Error("Garbage-collection must be disabled in `originDoc`!");
    const { sv: sv, ds: ds } = snapshot;
    const encoder = new $4bf7ba9bbb4881ae$export$30c99e08943e1c2();
    originDoc.transact((transaction)=>{
        let size = 0;
        sv.forEach((clock)=>{
            if (clock > 0) size++;
        });
        $6E0HV.writeVarUint(encoder.restEncoder, size);
        // splitting the structs before writing them to the encoder
        for (const [client, clock] of sv){
            if (clock === 0) continue;
            if (clock < $4bf7ba9bbb4881ae$export$50fdfeece43146fd(originDoc.store, client)) $4bf7ba9bbb4881ae$var$getItemCleanStart(transaction, $4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(client, clock));
            const structs = originDoc.store.clients.get(client) || [];
            const lastStructIndex = $4bf7ba9bbb4881ae$export$5f8f02523cf47b58(structs, clock - 1);
            // write # encoded structs
            $6E0HV.writeVarUint(encoder.restEncoder, lastStructIndex + 1);
            encoder.writeClient(client);
            // first clock written is 0
            $6E0HV.writeVarUint(encoder.restEncoder, 0);
            for(let i = 0; i <= lastStructIndex; i++)structs[i].write(encoder, 0);
        }
        $4bf7ba9bbb4881ae$var$writeDeleteSet(encoder, ds);
    });
    $4bf7ba9bbb4881ae$export$acc3b0324aabf1b6(newDoc, encoder.toUint8Array(), "snapshot");
    return newDoc;
};
/**
 * @param {Snapshot} snapshot
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV2 | typeof UpdateDecoderV1} [YDecoder]
 */ const $4bf7ba9bbb4881ae$var$snapshotContainsUpdateV2 = (snapshot, update, YDecoder = $4bf7ba9bbb4881ae$export$1c932452355c5571)=>{
    const updateDecoder = new YDecoder($dirF1.createDecoder(update));
    const lazyDecoder = new $4bf7ba9bbb4881ae$var$LazyStructReader(updateDecoder, false);
    for(let curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next()){
        if ((snapshot.sv.get(curr.id.client) || 0) < curr.id.clock + curr.length) return false;
    }
    const mergedDS = $4bf7ba9bbb4881ae$var$mergeDeleteSets([
        snapshot.ds,
        $4bf7ba9bbb4881ae$var$readDeleteSet(updateDecoder)
    ]);
    return $4bf7ba9bbb4881ae$export$9697b72c46fd3a5d(snapshot.ds, mergedDS);
};
/**
 * @param {Snapshot} snapshot
 * @param {Uint8Array} update
 */ const $4bf7ba9bbb4881ae$export$f938135bed5d8db7 = (snapshot, update)=>$4bf7ba9bbb4881ae$var$snapshotContainsUpdateV2(snapshot, update, $4bf7ba9bbb4881ae$export$1aa46d9818b5d1ec);
class $4bf7ba9bbb4881ae$var$StructStore {
    constructor(){
        /**
     * @type {Map<number,Array<GC|Item>>}
     */ this.clients = new Map();
        /**
     * @type {null | { missing: Map<number, number>, update: Uint8Array }}
     */ this.pendingStructs = null;
        /**
     * @type {null | Uint8Array}
     */ this.pendingDs = null;
    }
}
/**
 * Return the states as a Map<client,clock>.
 * Note that clock refers to the next expected clock id.
 *
 * @param {StructStore} store
 * @return {Map<number,number>}
 *
 * @public
 * @function
 */ const $4bf7ba9bbb4881ae$var$getStateVector = (store)=>{
    const sm = new Map();
    store.clients.forEach((structs, client)=>{
        const struct = structs[structs.length - 1];
        sm.set(client, struct.id.clock + struct.length);
    });
    return sm;
};
/**
 * @param {StructStore} store
 * @param {number} client
 * @return {number}
 *
 * @public
 * @function
 */ const $4bf7ba9bbb4881ae$export$50fdfeece43146fd = (store, client)=>{
    const structs = store.clients.get(client);
    if (structs === undefined) return 0;
    const lastStruct = structs[structs.length - 1];
    return lastStruct.id.clock + lastStruct.length;
};
/**
 * @param {StructStore} store
 * @param {GC|Item} struct
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$addStruct = (store, struct)=>{
    let structs = store.clients.get(struct.id.client);
    if (structs === undefined) {
        structs = [];
        store.clients.set(struct.id.client, structs);
    } else {
        const lastStruct = structs[structs.length - 1];
        if (lastStruct.id.clock + lastStruct.length !== struct.id.clock) throw $iVMsw.unexpectedCase();
    }
    structs.push(struct);
};
/**
 * Perform a binary search on a sorted array
 * @param {Array<Item|GC>} structs
 * @param {number} clock
 * @return {number}
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$export$5f8f02523cf47b58 = (structs, clock)=>{
    let left = 0;
    let right = structs.length - 1;
    let mid = structs[right];
    let midclock = mid.id.clock;
    if (midclock === clock) return right;
    // @todo does it even make sense to pivot the search?
    // If a good split misses, it might actually increase the time to find the correct item.
    // Currently, the only advantage is that search with pivoting might find the item on the first try.
    let midindex = $5qKvF.floor(clock / (midclock + mid.length - 1) * right); // pivoting the search
    while(left <= right){
        mid = structs[midindex];
        midclock = mid.id.clock;
        if (midclock <= clock) {
            if (clock < midclock + mid.length) return midindex;
            left = midindex + 1;
        } else right = midindex - 1;
        midindex = $5qKvF.floor((left + right) / 2);
    }
    // Always check state before looking for a struct in StructStore
    // Therefore the case of not finding a struct is unexpected
    throw $iVMsw.unexpectedCase();
};
/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 *
 * @param {StructStore} store
 * @param {ID} id
 * @return {GC|Item}
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$find = (store, id)=>{
    /**
   * @type {Array<GC|Item>}
   */ // @ts-ignore
    const structs = store.clients.get(id.client);
    return structs[$4bf7ba9bbb4881ae$export$5f8f02523cf47b58(structs, id.clock)];
};
/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$export$f92dfeb71e9bb569 = /** @type {function(StructStore,ID):Item} */ $4bf7ba9bbb4881ae$var$find;
/**
 * @param {Transaction} transaction
 * @param {Array<Item|GC>} structs
 * @param {number} clock
 */ const $4bf7ba9bbb4881ae$var$findIndexCleanStart = (transaction, structs, clock)=>{
    const index = $4bf7ba9bbb4881ae$export$5f8f02523cf47b58(structs, clock);
    const struct = structs[index];
    if (struct.id.clock < clock && struct instanceof $4bf7ba9bbb4881ae$export$6d08773d2e66f8f2) {
        structs.splice(index + 1, 0, $4bf7ba9bbb4881ae$var$splitItem(transaction, struct, clock - struct.id.clock));
        return index + 1;
    }
    return index;
};
/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 *
 * @param {Transaction} transaction
 * @param {ID} id
 * @return {Item}
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$getItemCleanStart = (transaction, id)=>{
    const structs = /** @type {Array<Item>} */ transaction.doc.store.clients.get(id.client);
    return structs[$4bf7ba9bbb4881ae$var$findIndexCleanStart(transaction, structs, id.clock)];
};
/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 *
 * @param {Transaction} transaction
 * @param {StructStore} store
 * @param {ID} id
 * @return {Item}
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$getItemCleanEnd = (transaction, store, id)=>{
    /**
   * @type {Array<Item>}
   */ // @ts-ignore
    const structs = store.clients.get(id.client);
    const index = $4bf7ba9bbb4881ae$export$5f8f02523cf47b58(structs, id.clock);
    const struct = structs[index];
    if (id.clock !== struct.id.clock + struct.length - 1 && struct.constructor !== $4bf7ba9bbb4881ae$export$12d259ff017e6b58) structs.splice(index + 1, 0, $4bf7ba9bbb4881ae$var$splitItem(transaction, struct, id.clock - struct.id.clock + 1));
    return struct;
};
/**
 * Replace `item` with `newitem` in store
 * @param {StructStore} store
 * @param {GC|Item} struct
 * @param {GC|Item} newStruct
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$replaceStruct = (store, struct, newStruct)=>{
    const structs = /** @type {Array<GC|Item>} */ store.clients.get(struct.id.client);
    structs[$4bf7ba9bbb4881ae$export$5f8f02523cf47b58(structs, struct.id.clock)] = newStruct;
};
/**
 * Iterate over a range of structs
 *
 * @param {Transaction} transaction
 * @param {Array<Item|GC>} structs
 * @param {number} clockStart Inclusive start
 * @param {number} len
 * @param {function(GC|Item):void} f
 *
 * @function
 */ const $4bf7ba9bbb4881ae$var$iterateStructs = (transaction, structs, clockStart, len, f)=>{
    if (len === 0) return;
    const clockEnd = clockStart + len;
    let index = $4bf7ba9bbb4881ae$var$findIndexCleanStart(transaction, structs, clockStart);
    let struct;
    do {
        struct = structs[index++];
        if (clockEnd < struct.id.clock + struct.length) $4bf7ba9bbb4881ae$var$findIndexCleanStart(transaction, structs, clockEnd);
        f(struct);
    }while (index < structs.length && structs[index].id.clock < clockEnd);
};
/**
 * A transaction is created for every change on the Yjs model. It is possible
 * to bundle changes on the Yjs model in a single transaction to
 * minimize the number on messages sent and the number of observer calls.
 * If possible the user of this library should bundle as many changes as
 * possible. Here is an example to illustrate the advantages of bundling:
 *
 * @example
 * const map = y.define('map', YMap)
 * // Log content when change is triggered
 * map.observe(() => {
 *   console.log('change triggered')
 * })
 * // Each change on the map type triggers a log message:
 * map.set('a', 0) // => "change triggered"
 * map.set('b', 0) // => "change triggered"
 * // When put in a transaction, it will trigger the log after the transaction:
 * y.transact(() => {
 *   map.set('a', 1)
 *   map.set('b', 1)
 * }) // => "change triggered"
 *
 * @public
 */ class $4bf7ba9bbb4881ae$export$febc5573c75cefb0 {
    /**
   * @param {Doc} doc
   * @param {any} origin
   * @param {boolean} local
   */ constructor(doc, origin, local){
        /**
     * The Yjs instance.
     * @type {Doc}
     */ this.doc = doc;
        /**
     * Describes the set of deleted items by ids
     * @type {DeleteSet}
     */ this.deleteSet = new $4bf7ba9bbb4881ae$var$DeleteSet();
        /**
     * Holds the state before the transaction started.
     * @type {Map<Number,Number>}
     */ this.beforeState = $4bf7ba9bbb4881ae$var$getStateVector(doc.store);
        /**
     * Holds the state after the transaction.
     * @type {Map<Number,Number>}
     */ this.afterState = new Map();
        /**
     * All types that were directly modified (property added or child
     * inserted/deleted). New types are not included in this Set.
     * Maps from type to parentSubs (`item.parentSub = null` for YArray)
     * @type {Map<AbstractType<YEvent<any>>,Set<String|null>>}
     */ this.changed = new Map();
        /**
     * Stores the events for the types that observe also child elements.
     * It is mainly used by `observeDeep`.
     * @type {Map<AbstractType<YEvent<any>>,Array<YEvent<any>>>}
     */ this.changedParentTypes = new Map();
        /**
     * @type {Array<AbstractStruct>}
     */ this._mergeStructs = [];
        /**
     * @type {any}
     */ this.origin = origin;
        /**
     * Stores meta information on the transaction
     * @type {Map<any,any>}
     */ this.meta = new Map();
        /**
     * Whether this change originates from this doc.
     * @type {boolean}
     */ this.local = local;
        /**
     * @type {Set<Doc>}
     */ this.subdocsAdded = new Set();
        /**
     * @type {Set<Doc>}
     */ this.subdocsRemoved = new Set();
        /**
     * @type {Set<Doc>}
     */ this.subdocsLoaded = new Set();
        /**
     * @type {boolean}
     */ this._needFormattingCleanup = false;
    }
}
/**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Transaction} transaction
 * @return {boolean} Whether data was written.
 */ const $4bf7ba9bbb4881ae$var$writeUpdateMessageFromTransaction = (encoder, transaction)=>{
    if (transaction.deleteSet.clients.size === 0 && !$dh5fq.any(transaction.afterState, (clock, client)=>transaction.beforeState.get(client) !== clock)) return false;
    $4bf7ba9bbb4881ae$var$sortAndMergeDeleteSet(transaction.deleteSet);
    $4bf7ba9bbb4881ae$var$writeStructsFromTransaction(encoder, transaction);
    $4bf7ba9bbb4881ae$var$writeDeleteSet(encoder, transaction.deleteSet);
    return true;
};
/**
 * If `type.parent` was added in current transaction, `type` technically
 * did not change, it was just added and we should not fire events for `type`.
 *
 * @param {Transaction} transaction
 * @param {AbstractType<YEvent<any>>} type
 * @param {string|null} parentSub
 */ const $4bf7ba9bbb4881ae$var$addChangedTypeToTransaction = (transaction, type, parentSub)=>{
    const item = type._item;
    if (item === null || item.id.clock < (transaction.beforeState.get(item.id.client) || 0) && !item.deleted) $dh5fq.setIfUndefined(transaction.changed, type, $bUD5M.create).add(parentSub);
};
/**
 * @param {Array<AbstractStruct>} structs
 * @param {number} pos
 * @return {number} # of merged structs
 */ const $4bf7ba9bbb4881ae$var$tryToMergeWithLefts = (structs, pos)=>{
    let right = structs[pos];
    let left = structs[pos - 1];
    let i = pos;
    for(; i > 0; right = left, left = structs[--i - 1]){
        if (left.deleted === right.deleted && left.constructor === right.constructor) {
            if (left.mergeWith(right)) {
                if (right instanceof $4bf7ba9bbb4881ae$export$6d08773d2e66f8f2 && right.parentSub !== null && /** @type {AbstractType<any>} */ right.parent._map.get(right.parentSub) === right) /** @type {AbstractType<any>} */ right.parent._map.set(right.parentSub, /** @type {Item} */ left);
                continue;
            }
        }
        break;
    }
    const merged = pos - i;
    if (merged) // remove all merged structs from the array
    structs.splice(pos + 1 - merged, merged);
    return merged;
};
/**
 * @param {DeleteSet} ds
 * @param {StructStore} store
 * @param {function(Item):boolean} gcFilter
 */ const $4bf7ba9bbb4881ae$var$tryGcDeleteSet = (ds, store, gcFilter)=>{
    for (const [client, deleteItems] of ds.clients.entries()){
        const structs = /** @type {Array<GC|Item>} */ store.clients.get(client);
        for(let di = deleteItems.length - 1; di >= 0; di--){
            const deleteItem = deleteItems[di];
            const endDeleteItemClock = deleteItem.clock + deleteItem.len;
            for(let si = $4bf7ba9bbb4881ae$export$5f8f02523cf47b58(structs, deleteItem.clock), struct = structs[si]; si < structs.length && struct.id.clock < endDeleteItemClock; struct = structs[++si]){
                const struct = structs[si];
                if (deleteItem.clock + deleteItem.len <= struct.id.clock) break;
                if (struct instanceof $4bf7ba9bbb4881ae$export$6d08773d2e66f8f2 && struct.deleted && !struct.keep && gcFilter(struct)) struct.gc(store, false);
            }
        }
    }
};
/**
 * @param {DeleteSet} ds
 * @param {StructStore} store
 */ const $4bf7ba9bbb4881ae$var$tryMergeDeleteSet = (ds, store)=>{
    // try to merge deleted / gc'd items
    // merge from right to left for better efficiecy and so we don't miss any merge targets
    ds.clients.forEach((deleteItems, client)=>{
        const structs = /** @type {Array<GC|Item>} */ store.clients.get(client);
        for(let di = deleteItems.length - 1; di >= 0; di--){
            const deleteItem = deleteItems[di];
            // start with merging the item next to the last deleted item
            const mostRightIndexToCheck = $5qKvF.min(structs.length - 1, 1 + $4bf7ba9bbb4881ae$export$5f8f02523cf47b58(structs, deleteItem.clock + deleteItem.len - 1));
            for(let si = mostRightIndexToCheck, struct = structs[si]; si > 0 && struct.id.clock >= deleteItem.clock; struct = structs[si])si -= 1 + $4bf7ba9bbb4881ae$var$tryToMergeWithLefts(structs, si);
        }
    });
};
/**
 * @param {DeleteSet} ds
 * @param {StructStore} store
 * @param {function(Item):boolean} gcFilter
 */ const $4bf7ba9bbb4881ae$export$c2e5de00fc43f658 = (ds, store, gcFilter)=>{
    $4bf7ba9bbb4881ae$var$tryGcDeleteSet(ds, store, gcFilter);
    $4bf7ba9bbb4881ae$var$tryMergeDeleteSet(ds, store);
};
/**
 * @param {Array<Transaction>} transactionCleanups
 * @param {number} i
 */ const $4bf7ba9bbb4881ae$var$cleanupTransactions = (transactionCleanups, i)=>{
    if (i < transactionCleanups.length) {
        const transaction = transactionCleanups[i];
        const doc = transaction.doc;
        const store = doc.store;
        const ds = transaction.deleteSet;
        const mergeStructs = transaction._mergeStructs;
        try {
            $4bf7ba9bbb4881ae$var$sortAndMergeDeleteSet(ds);
            transaction.afterState = $4bf7ba9bbb4881ae$var$getStateVector(transaction.doc.store);
            doc.emit("beforeObserverCalls", [
                transaction,
                doc
            ]);
            /**
       * An array of event callbacks.
       *
       * Each callback is called even if the other ones throw errors.
       *
       * @type {Array<function():void>}
       */ const fs = [];
            // observe events on changed types
            transaction.changed.forEach((subs, itemtype)=>fs.push(()=>{
                    if (itemtype._item === null || !itemtype._item.deleted) itemtype._callObserver(transaction, subs);
                }));
            fs.push(()=>{
                // deep observe events
                transaction.changedParentTypes.forEach((events, type)=>{
                    // We need to think about the possibility that the user transforms the
                    // Y.Doc in the event.
                    if (type._dEH.l.length > 0 && (type._item === null || !type._item.deleted)) {
                        events = events.filter((event)=>event.target._item === null || !event.target._item.deleted);
                        events.forEach((event)=>{
                            event.currentTarget = type;
                            // path is relative to the current target
                            event._path = null;
                        });
                        // sort events by path length so that top-level events are fired first.
                        events.sort((event1, event2)=>event1.path.length - event2.path.length);
                        // We don't need to check for events.length
                        // because we know it has at least one element
                        $4bf7ba9bbb4881ae$var$callEventHandlerListeners(type._dEH, events, transaction);
                    }
                });
            });
            fs.push(()=>doc.emit("afterTransaction", [
                    transaction,
                    doc
                ]));
            (0, $4NUz5.callAll)(fs, []);
            if (transaction._needFormattingCleanup) $4bf7ba9bbb4881ae$var$cleanupYTextAfterTransaction(transaction);
        } finally{
            // Replace deleted items with ItemDeleted / GC.
            // This is where content is actually remove from the Yjs Doc.
            if (doc.gc) $4bf7ba9bbb4881ae$var$tryGcDeleteSet(ds, store, doc.gcFilter);
            $4bf7ba9bbb4881ae$var$tryMergeDeleteSet(ds, store);
            // on all affected store.clients props, try to merge
            transaction.afterState.forEach((clock, client)=>{
                const beforeClock = transaction.beforeState.get(client) || 0;
                if (beforeClock !== clock) {
                    const structs = /** @type {Array<GC|Item>} */ store.clients.get(client);
                    // we iterate from right to left so we can safely remove entries
                    const firstChangePos = $5qKvF.max($4bf7ba9bbb4881ae$export$5f8f02523cf47b58(structs, beforeClock), 1);
                    for(let i = structs.length - 1; i >= firstChangePos;)i -= 1 + $4bf7ba9bbb4881ae$var$tryToMergeWithLefts(structs, i);
                }
            });
            // try to merge mergeStructs
            // @todo: it makes more sense to transform mergeStructs to a DS, sort it, and merge from right to left
            //        but at the moment DS does not handle duplicates
            for(let i = mergeStructs.length - 1; i >= 0; i--){
                const { client: client, clock: clock } = mergeStructs[i].id;
                const structs = /** @type {Array<GC|Item>} */ store.clients.get(client);
                const replacedStructPos = $4bf7ba9bbb4881ae$export$5f8f02523cf47b58(structs, clock);
                if (replacedStructPos + 1 < structs.length) {
                    if ($4bf7ba9bbb4881ae$var$tryToMergeWithLefts(structs, replacedStructPos + 1) > 1) continue; // no need to perform next check, both are already merged
                }
                if (replacedStructPos > 0) $4bf7ba9bbb4881ae$var$tryToMergeWithLefts(structs, replacedStructPos);
            }
            if (!transaction.local && transaction.afterState.get(doc.clientID) !== transaction.beforeState.get(doc.clientID)) {
                $98BSr.print($b2PaR.ORANGE, $b2PaR.BOLD, "[yjs] ", $b2PaR.UNBOLD, $b2PaR.RED, "Changed the client-id because another client seems to be using it.");
                doc.clientID = $4bf7ba9bbb4881ae$var$generateNewClientId();
            }
            // @todo Merge all the transactions into one and provide send the data as a single update message
            doc.emit("afterTransactionCleanup", [
                transaction,
                doc
            ]);
            if (doc._observers.has("update")) {
                const encoder = new $4bf7ba9bbb4881ae$export$99171b804d9c5b54();
                const hasContent = $4bf7ba9bbb4881ae$var$writeUpdateMessageFromTransaction(encoder, transaction);
                if (hasContent) doc.emit("update", [
                    encoder.toUint8Array(),
                    transaction.origin,
                    doc,
                    transaction
                ]);
            }
            if (doc._observers.has("updateV2")) {
                const encoder = new $4bf7ba9bbb4881ae$export$30c99e08943e1c2();
                const hasContent = $4bf7ba9bbb4881ae$var$writeUpdateMessageFromTransaction(encoder, transaction);
                if (hasContent) doc.emit("updateV2", [
                    encoder.toUint8Array(),
                    transaction.origin,
                    doc,
                    transaction
                ]);
            }
            const { subdocsAdded: subdocsAdded, subdocsLoaded: subdocsLoaded, subdocsRemoved: subdocsRemoved } = transaction;
            if (subdocsAdded.size > 0 || subdocsRemoved.size > 0 || subdocsLoaded.size > 0) {
                subdocsAdded.forEach((subdoc)=>{
                    subdoc.clientID = doc.clientID;
                    if (subdoc.collectionid == null) subdoc.collectionid = doc.collectionid;
                    doc.subdocs.add(subdoc);
                });
                subdocsRemoved.forEach((subdoc)=>doc.subdocs.delete(subdoc));
                doc.emit("subdocs", [
                    {
                        loaded: subdocsLoaded,
                        added: subdocsAdded,
                        removed: subdocsRemoved
                    },
                    doc,
                    transaction
                ]);
                subdocsRemoved.forEach((subdoc)=>subdoc.destroy());
            }
            if (transactionCleanups.length <= i + 1) {
                doc._transactionCleanups = [];
                doc.emit("afterAllTransactions", [
                    doc,
                    transactionCleanups
                ]);
            } else $4bf7ba9bbb4881ae$var$cleanupTransactions(transactionCleanups, i + 1);
        }
    }
};
/**
 * Implements the functionality of `y.transact(()=>{..})`
 *
 * @template T
 * @param {Doc} doc
 * @param {function(Transaction):T} f
 * @param {any} [origin=true]
 * @return {T}
 *
 * @function
 */ const $4bf7ba9bbb4881ae$export$dac1bad6146b2469 = (doc, f, origin = null, local = true)=>{
    const transactionCleanups = doc._transactionCleanups;
    let initialCall = false;
    /**
   * @type {any}
   */ let result = null;
    if (doc._transaction === null) {
        initialCall = true;
        doc._transaction = new $4bf7ba9bbb4881ae$export$febc5573c75cefb0(doc, origin, local);
        transactionCleanups.push(doc._transaction);
        if (transactionCleanups.length === 1) doc.emit("beforeAllTransactions", [
            doc
        ]);
        doc.emit("beforeTransaction", [
            doc._transaction,
            doc
        ]);
    }
    try {
        result = f(doc._transaction);
    } finally{
        if (initialCall) {
            const finishCleanup = doc._transaction === transactionCleanups[0];
            doc._transaction = null;
            if (finishCleanup) // The first transaction ended, now process observer calls.
            // Observer call may create new transactions for which we need to call the observers and do cleanup.
            // We don't want to nest these calls, so we execute these calls one after
            // another.
            // Also we need to ensure that all cleanups are called, even if the
            // observes throw errors.
            // This file is full of hacky try {} finally {} blocks to ensure that an
            // event can throw errors and also that the cleanup is called.
            $4bf7ba9bbb4881ae$var$cleanupTransactions(transactionCleanups, 0);
        }
    }
    return result;
};
class $4bf7ba9bbb4881ae$var$StackItem {
    /**
   * @param {DeleteSet} deletions
   * @param {DeleteSet} insertions
   */ constructor(deletions, insertions){
        this.insertions = insertions;
        this.deletions = deletions;
        /**
     * Use this to save and restore metadata like selection range
     */ this.meta = new Map();
    }
}
/**
 * @param {Transaction} tr
 * @param {UndoManager} um
 * @param {StackItem} stackItem
 */ const $4bf7ba9bbb4881ae$var$clearUndoManagerStackItem = (tr, um, stackItem)=>{
    $4bf7ba9bbb4881ae$export$8afefebbaf4e4c78(tr, stackItem.deletions, (item)=>{
        if (item instanceof $4bf7ba9bbb4881ae$export$6d08773d2e66f8f2 && um.scope.some((type)=>$4bf7ba9bbb4881ae$export$3c81af374b054d6a(type, item))) $4bf7ba9bbb4881ae$var$keepItem(item, false);
    });
};
/**
 * @param {UndoManager} undoManager
 * @param {Array<StackItem>} stack
 * @param {'undo'|'redo'} eventType
 * @return {StackItem?}
 */ const $4bf7ba9bbb4881ae$var$popStackItem = (undoManager, stack, eventType)=>{
    /**
   * Keep a reference to the transaction so we can fire the event with the changedParentTypes
   * @type {any}
   */ let _tr = null;
    const doc = undoManager.doc;
    const scope = undoManager.scope;
    $4bf7ba9bbb4881ae$export$dac1bad6146b2469(doc, (transaction)=>{
        while(stack.length > 0 && undoManager.currStackItem === null){
            const store = doc.store;
            const stackItem = /** @type {StackItem} */ stack.pop();
            /**
       * @type {Set<Item>}
       */ const itemsToRedo = new Set();
            /**
       * @type {Array<Item>}
       */ const itemsToDelete = [];
            let performedChange = false;
            $4bf7ba9bbb4881ae$export$8afefebbaf4e4c78(transaction, stackItem.insertions, (struct)=>{
                if (struct instanceof $4bf7ba9bbb4881ae$export$6d08773d2e66f8f2) {
                    if (struct.redone !== null) {
                        let { item: item, diff: diff } = $4bf7ba9bbb4881ae$var$followRedone(store, struct.id);
                        if (diff > 0) item = $4bf7ba9bbb4881ae$var$getItemCleanStart(transaction, $4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(item.id.client, item.id.clock + diff));
                        struct = item;
                    }
                    if (!struct.deleted && scope.some((type)=>$4bf7ba9bbb4881ae$export$3c81af374b054d6a(type, /** @type {Item} */ struct))) itemsToDelete.push(struct);
                }
            });
            $4bf7ba9bbb4881ae$export$8afefebbaf4e4c78(transaction, stackItem.deletions, (struct)=>{
                if (struct instanceof $4bf7ba9bbb4881ae$export$6d08773d2e66f8f2 && scope.some((type)=>$4bf7ba9bbb4881ae$export$3c81af374b054d6a(type, struct)) && // Never redo structs in stackItem.insertions because they were created and deleted in the same capture interval.
                !$4bf7ba9bbb4881ae$export$dcb04af092e44fde(stackItem.insertions, struct.id)) itemsToRedo.add(struct);
            });
            itemsToRedo.forEach((struct)=>{
                performedChange = $4bf7ba9bbb4881ae$var$redoItem(transaction, struct, itemsToRedo, stackItem.insertions, undoManager.ignoreRemoteMapChanges, undoManager) !== null || performedChange;
            });
            // We want to delete in reverse order so that children are deleted before
            // parents, so we have more information available when items are filtered.
            for(let i = itemsToDelete.length - 1; i >= 0; i--){
                const item = itemsToDelete[i];
                if (undoManager.deleteFilter(item)) {
                    item.delete(transaction);
                    performedChange = true;
                }
            }
            undoManager.currStackItem = performedChange ? stackItem : null;
        }
        transaction.changed.forEach((subProps, type)=>{
            // destroy search marker if necessary
            if (subProps.has(null) && type._searchMarker) type._searchMarker.length = 0;
        });
        _tr = transaction;
    }, undoManager);
    if (undoManager.currStackItem != null) {
        const changedParentTypes = _tr.changedParentTypes;
        undoManager.emit("stack-item-popped", [
            {
                stackItem: undoManager.currStackItem,
                type: eventType,
                changedParentTypes: changedParentTypes,
                origin: undoManager
            },
            undoManager
        ]);
        undoManager.currStackItem = null;
    }
    return undoManager.currStackItem;
};
/**
 * @typedef {Object} UndoManagerOptions
 * @property {number} [UndoManagerOptions.captureTimeout=500]
 * @property {function(Transaction):boolean} [UndoManagerOptions.captureTransaction] Do not capture changes of a Transaction if result false.
 * @property {function(Item):boolean} [UndoManagerOptions.deleteFilter=()=>true] Sometimes
 * it is necessary to filter what an Undo/Redo operation can delete. If this
 * filter returns false, the type/item won't be deleted even it is in the
 * undo/redo scope.
 * @property {Set<any>} [UndoManagerOptions.trackedOrigins=new Set([null])]
 * @property {boolean} [ignoreRemoteMapChanges] Experimental. By default, the UndoManager will never overwrite remote changes. Enable this property to enable overwriting remote changes on key-value changes (Y.Map, properties on Y.Xml, etc..).
 * @property {Doc} [doc] The document that this UndoManager operates on. Only needed if typeScope is empty.
 */ /**
 * @typedef {Object} StackItemEvent
 * @property {StackItem} StackItemEvent.stackItem
 * @property {any} StackItemEvent.origin
 * @property {'undo'|'redo'} StackItemEvent.type
 * @property {Map<AbstractType<YEvent<any>>,Array<YEvent<any>>>} StackItemEvent.changedParentTypes
 */ /**
 * Fires 'stack-item-added' event when a stack item was added to either the undo- or
 * the redo-stack. You may store additional stack information via the
 * metadata property on `event.stackItem.meta` (it is a `Map` of metadata properties).
 * Fires 'stack-item-popped' event when a stack item was popped from either the
 * undo- or the redo-stack. You may restore the saved stack information from `event.stackItem.meta`.
 *
 * @extends {ObservableV2<{'stack-item-added':function(StackItemEvent, UndoManager):void, 'stack-item-popped': function(StackItemEvent, UndoManager):void, 'stack-cleared': function({ undoStackCleared: boolean, redoStackCleared: boolean }):void, 'stack-item-updated': function(StackItemEvent, UndoManager):void }>}
 */ class $4bf7ba9bbb4881ae$export$932a3f9a7e88971c extends (0, $3S8dv.ObservableV2) {
    /**
   * @param {AbstractType<any>|Array<AbstractType<any>>} typeScope Accepts either a single type, or an array of types
   * @param {UndoManagerOptions} options
   */ constructor(typeScope, { captureTimeout: captureTimeout = 500, captureTransaction: captureTransaction = (_tr)=>true, deleteFilter: deleteFilter = ()=>true, trackedOrigins: trackedOrigins = new Set([
        null
    ]), ignoreRemoteMapChanges: ignoreRemoteMapChanges = false, doc: doc = /** @type {Doc} */ $iiUWJ.isArray(typeScope) ? typeScope[0].doc : typeScope.doc } = {}){
        super();
        /**
     * @type {Array<AbstractType<any>>}
     */ this.scope = [];
        this.doc = doc;
        this.addToScope(typeScope);
        this.deleteFilter = deleteFilter;
        trackedOrigins.add(this);
        this.trackedOrigins = trackedOrigins;
        this.captureTransaction = captureTransaction;
        /**
     * @type {Array<StackItem>}
     */ this.undoStack = [];
        /**
     * @type {Array<StackItem>}
     */ this.redoStack = [];
        /**
     * Whether the client is currently undoing (calling UndoManager.undo)
     *
     * @type {boolean}
     */ this.undoing = false;
        this.redoing = false;
        /**
     * The currently popped stack item if UndoManager.undoing or UndoManager.redoing
     *
     * @type {StackItem|null}
     */ this.currStackItem = null;
        this.lastChange = 0;
        this.ignoreRemoteMapChanges = ignoreRemoteMapChanges;
        this.captureTimeout = captureTimeout;
        /**
     * @param {Transaction} transaction
     */ this.afterTransactionHandler = (transaction)=>{
            // Only track certain transactions
            if (!this.captureTransaction(transaction) || !this.scope.some((type)=>transaction.changedParentTypes.has(type)) || !this.trackedOrigins.has(transaction.origin) && (!transaction.origin || !this.trackedOrigins.has(transaction.origin.constructor))) return;
            const undoing = this.undoing;
            const redoing = this.redoing;
            const stack = undoing ? this.redoStack : this.undoStack;
            if (undoing) this.stopCapturing(); // next undo should not be appended to last stack item
            else if (!redoing) // neither undoing nor redoing: delete redoStack
            this.clear(false, true);
            const insertions = new $4bf7ba9bbb4881ae$var$DeleteSet();
            transaction.afterState.forEach((endClock, client)=>{
                const startClock = transaction.beforeState.get(client) || 0;
                const len = endClock - startClock;
                if (len > 0) $4bf7ba9bbb4881ae$var$addToDeleteSet(insertions, client, startClock, len);
            });
            const now = $c48Az.getUnixTime();
            let didAdd = false;
            if (this.lastChange > 0 && now - this.lastChange < this.captureTimeout && stack.length > 0 && !undoing && !redoing) {
                // append change to last stack op
                const lastOp = stack[stack.length - 1];
                lastOp.deletions = $4bf7ba9bbb4881ae$var$mergeDeleteSets([
                    lastOp.deletions,
                    transaction.deleteSet
                ]);
                lastOp.insertions = $4bf7ba9bbb4881ae$var$mergeDeleteSets([
                    lastOp.insertions,
                    insertions
                ]);
            } else {
                // create a new stack op
                stack.push(new $4bf7ba9bbb4881ae$var$StackItem(transaction.deleteSet, insertions));
                didAdd = true;
            }
            if (!undoing && !redoing) this.lastChange = now;
            // make sure that deleted structs are not gc'd
            $4bf7ba9bbb4881ae$export$8afefebbaf4e4c78(transaction, transaction.deleteSet, /** @param {Item|GC} item */ (item)=>{
                if (item instanceof $4bf7ba9bbb4881ae$export$6d08773d2e66f8f2 && this.scope.some((type)=>$4bf7ba9bbb4881ae$export$3c81af374b054d6a(type, item))) $4bf7ba9bbb4881ae$var$keepItem(item, true);
            });
            /**
       * @type {[StackItemEvent, UndoManager]}
       */ const changeEvent = [
                {
                    stackItem: stack[stack.length - 1],
                    origin: transaction.origin,
                    type: undoing ? "redo" : "undo",
                    changedParentTypes: transaction.changedParentTypes
                },
                this
            ];
            if (didAdd) this.emit("stack-item-added", changeEvent);
            else this.emit("stack-item-updated", changeEvent);
        };
        this.doc.on("afterTransaction", this.afterTransactionHandler);
        this.doc.on("destroy", ()=>{
            this.destroy();
        });
    }
    /**
   * @param {Array<AbstractType<any>> | AbstractType<any>} ytypes
   */ addToScope(ytypes) {
        ytypes = $iiUWJ.isArray(ytypes) ? ytypes : [
            ytypes
        ];
        ytypes.forEach((ytype)=>{
            if (this.scope.every((yt)=>yt !== ytype)) {
                if (ytype.doc !== this.doc) $98BSr.warn("[yjs#509] Not same Y.Doc"); // use MultiDocUndoManager instead. also see https://github.com/yjs/yjs/issues/509
                this.scope.push(ytype);
            }
        });
    }
    /**
   * @param {any} origin
   */ addTrackedOrigin(origin) {
        this.trackedOrigins.add(origin);
    }
    /**
   * @param {any} origin
   */ removeTrackedOrigin(origin) {
        this.trackedOrigins.delete(origin);
    }
    clear(clearUndoStack = true, clearRedoStack = true) {
        if (clearUndoStack && this.canUndo() || clearRedoStack && this.canRedo()) this.doc.transact((tr)=>{
            if (clearUndoStack) {
                this.undoStack.forEach((item)=>$4bf7ba9bbb4881ae$var$clearUndoManagerStackItem(tr, this, item));
                this.undoStack = [];
            }
            if (clearRedoStack) {
                this.redoStack.forEach((item)=>$4bf7ba9bbb4881ae$var$clearUndoManagerStackItem(tr, this, item));
                this.redoStack = [];
            }
            this.emit("stack-cleared", [
                {
                    undoStackCleared: clearUndoStack,
                    redoStackCleared: clearRedoStack
                }
            ]);
        });
    }
    /**
   * UndoManager merges Undo-StackItem if they are created within time-gap
   * smaller than `options.captureTimeout`. Call `um.stopCapturing()` so that the next
   * StackItem won't be merged.
   *
   *
   * @example
   *     // without stopCapturing
   *     ytext.insert(0, 'a')
   *     ytext.insert(1, 'b')
   *     um.undo()
   *     ytext.toString() // => '' (note that 'ab' was removed)
   *     // with stopCapturing
   *     ytext.insert(0, 'a')
   *     um.stopCapturing()
   *     ytext.insert(0, 'b')
   *     um.undo()
   *     ytext.toString() // => 'a' (note that only 'b' was removed)
   *
   */ stopCapturing() {
        this.lastChange = 0;
    }
    /**
   * Undo last changes on type.
   *
   * @return {StackItem?} Returns StackItem if a change was applied
   */ undo() {
        this.undoing = true;
        let res;
        try {
            res = $4bf7ba9bbb4881ae$var$popStackItem(this, this.undoStack, "undo");
        } finally{
            this.undoing = false;
        }
        return res;
    }
    /**
   * Redo last undo operation.
   *
   * @return {StackItem?} Returns StackItem if a change was applied
   */ redo() {
        this.redoing = true;
        let res;
        try {
            res = $4bf7ba9bbb4881ae$var$popStackItem(this, this.redoStack, "redo");
        } finally{
            this.redoing = false;
        }
        return res;
    }
    /**
   * Are undo steps available?
   *
   * @return {boolean} `true` if undo is possible
   */ canUndo() {
        return this.undoStack.length > 0;
    }
    /**
   * Are redo steps available?
   *
   * @return {boolean} `true` if redo is possible
   */ canRedo() {
        return this.redoStack.length > 0;
    }
    destroy() {
        this.trackedOrigins.delete(this);
        this.doc.off("afterTransaction", this.afterTransactionHandler);
        super.destroy();
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 */ function* $4bf7ba9bbb4881ae$var$lazyStructReaderGenerator(decoder) {
    const numOfStateUpdates = $dirF1.readVarUint(decoder.restDecoder);
    for(let i = 0; i < numOfStateUpdates; i++){
        const numberOfStructs = $dirF1.readVarUint(decoder.restDecoder);
        const client = decoder.readClient();
        let clock = $dirF1.readVarUint(decoder.restDecoder);
        for(let i = 0; i < numberOfStructs; i++){
            const info = decoder.readInfo();
            // @todo use switch instead of ifs
            if (info === 10) {
                const len = $dirF1.readVarUint(decoder.restDecoder);
                yield new $4bf7ba9bbb4881ae$export$38d24f5c1eb0e4c0($4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(client, clock), len);
                clock += len;
            } else if (($51l7Q.BITS5 & info) !== 0) {
                const cantCopyParentInfo = (info & ($51l7Q.BIT7 | $51l7Q.BIT8)) === 0;
                // If parent = null and neither left nor right are defined, then we know that `parent` is child of `y`
                // and we read the next string as parentYKey.
                // It indicates how we store/retrieve parent from `y.share`
                // @type {string|null}
                const struct = new $4bf7ba9bbb4881ae$export$6d08773d2e66f8f2($4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(client, clock), null, (info & $51l7Q.BIT8) === $51l7Q.BIT8 ? decoder.readLeftID() : null, null, (info & $51l7Q.BIT7) === $51l7Q.BIT7 ? decoder.readRightID() : null, // @ts-ignore Force writing a string here.
                cantCopyParentInfo ? decoder.readParentInfo() ? decoder.readString() : decoder.readLeftID() : null, cantCopyParentInfo && (info & $51l7Q.BIT6) === $51l7Q.BIT6 ? decoder.readString() : null, $4bf7ba9bbb4881ae$var$readItemContent(decoder, info) // item content
                );
                yield struct;
                clock += struct.length;
            } else {
                const len = decoder.readLen();
                yield new $4bf7ba9bbb4881ae$export$12d259ff017e6b58($4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(client, clock), len);
                clock += len;
            }
        }
    }
}
class $4bf7ba9bbb4881ae$var$LazyStructReader {
    /**
   * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
   * @param {boolean} filterSkips
   */ constructor(decoder, filterSkips){
        this.gen = $4bf7ba9bbb4881ae$var$lazyStructReaderGenerator(decoder);
        /**
     * @type {null | Item | Skip | GC}
     */ this.curr = null;
        this.done = false;
        this.filterSkips = filterSkips;
        this.next();
    }
    /**
   * @return {Item | GC | Skip |null}
   */ next() {
        // ignore "Skip" structs
        do this.curr = this.gen.next().value || null;
        while (this.filterSkips && this.curr !== null && this.curr.constructor === $4bf7ba9bbb4881ae$export$38d24f5c1eb0e4c0);
        return this.curr;
    }
}
/**
 * @param {Uint8Array} update
 *
 */ const $4bf7ba9bbb4881ae$export$d6235ced6e55ace9 = (update)=>$4bf7ba9bbb4881ae$export$624b3f0248c2dc40(update, $4bf7ba9bbb4881ae$export$1aa46d9818b5d1ec);
/**
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV2 | typeof UpdateDecoderV1} [YDecoder]
 *
 */ const $4bf7ba9bbb4881ae$export$624b3f0248c2dc40 = (update, YDecoder = $4bf7ba9bbb4881ae$export$1c932452355c5571)=>{
    const structs = [];
    const updateDecoder = new YDecoder($dirF1.createDecoder(update));
    const lazyDecoder = new $4bf7ba9bbb4881ae$var$LazyStructReader(updateDecoder, false);
    for(let curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next())structs.push(curr);
    $98BSr.print("Structs: ", structs);
    const ds = $4bf7ba9bbb4881ae$var$readDeleteSet(updateDecoder);
    $98BSr.print("DeleteSet: ", ds);
};
/**
 * @param {Uint8Array} update
 *
 */ const $4bf7ba9bbb4881ae$export$aa45cba8121663dc = (update)=>$4bf7ba9bbb4881ae$export$2fed33908eb23d71(update, $4bf7ba9bbb4881ae$export$1aa46d9818b5d1ec);
/**
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV2 | typeof UpdateDecoderV1} [YDecoder]
 *
 */ const $4bf7ba9bbb4881ae$export$2fed33908eb23d71 = (update, YDecoder = $4bf7ba9bbb4881ae$export$1c932452355c5571)=>{
    const structs = [];
    const updateDecoder = new YDecoder($dirF1.createDecoder(update));
    const lazyDecoder = new $4bf7ba9bbb4881ae$var$LazyStructReader(updateDecoder, false);
    for(let curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next())structs.push(curr);
    return {
        structs: structs,
        ds: $4bf7ba9bbb4881ae$var$readDeleteSet(updateDecoder)
    };
};
class $4bf7ba9bbb4881ae$var$LazyStructWriter {
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ constructor(encoder){
        this.currClient = 0;
        this.startClock = 0;
        this.written = 0;
        this.encoder = encoder;
        /**
     * We want to write operations lazily, but also we need to know beforehand how many operations we want to write for each client.
     *
     * This kind of meta-information (#clients, #structs-per-client-written) is written to the restEncoder.
     *
     * We fragment the restEncoder and store a slice of it per-client until we know how many clients there are.
     * When we flush (toUint8Array) we write the restEncoder using the fragments and the meta-information.
     *
     * @type {Array<{ written: number, restEncoder: Uint8Array }>}
     */ this.clientStructs = [];
    }
}
/**
 * @param {Array<Uint8Array>} updates
 * @return {Uint8Array}
 */ const $4bf7ba9bbb4881ae$export$6319871659fd2460 = (updates)=>$4bf7ba9bbb4881ae$export$ce273d78de0331d1(updates, $4bf7ba9bbb4881ae$export$1aa46d9818b5d1ec, $4bf7ba9bbb4881ae$export$99171b804d9c5b54);
/**
 * @param {Uint8Array} update
 * @param {typeof DSEncoderV1 | typeof DSEncoderV2} YEncoder
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} YDecoder
 * @return {Uint8Array}
 */ const $4bf7ba9bbb4881ae$export$ed51750cf3ab2381 = (update, YEncoder = $4bf7ba9bbb4881ae$var$DSEncoderV2, YDecoder = $4bf7ba9bbb4881ae$export$1c932452355c5571)=>{
    const encoder = new YEncoder();
    const updateDecoder = new $4bf7ba9bbb4881ae$var$LazyStructReader(new YDecoder($dirF1.createDecoder(update)), false);
    let curr = updateDecoder.curr;
    if (curr !== null) {
        let size = 0;
        let currClient = curr.id.client;
        let stopCounting = curr.id.clock !== 0; // must start at 0
        let currClock = stopCounting ? 0 : curr.id.clock + curr.length;
        for(; curr !== null; curr = updateDecoder.next()){
            if (currClient !== curr.id.client) {
                if (currClock !== 0) {
                    size++;
                    // We found a new client
                    // write what we have to the encoder
                    $6E0HV.writeVarUint(encoder.restEncoder, currClient);
                    $6E0HV.writeVarUint(encoder.restEncoder, currClock);
                }
                currClient = curr.id.client;
                currClock = 0;
                stopCounting = curr.id.clock !== 0;
            }
            // we ignore skips
            if (curr.constructor === $4bf7ba9bbb4881ae$export$38d24f5c1eb0e4c0) stopCounting = true;
            if (!stopCounting) currClock = curr.id.clock + curr.length;
        }
        // write what we have
        if (currClock !== 0) {
            size++;
            $6E0HV.writeVarUint(encoder.restEncoder, currClient);
            $6E0HV.writeVarUint(encoder.restEncoder, currClock);
        }
        // prepend the size of the state vector
        const enc = $6E0HV.createEncoder();
        $6E0HV.writeVarUint(enc, size);
        $6E0HV.writeBinaryEncoder(enc, encoder.restEncoder);
        encoder.restEncoder = enc;
        return encoder.toUint8Array();
    } else {
        $6E0HV.writeVarUint(encoder.restEncoder, 0);
        return encoder.toUint8Array();
    }
};
/**
 * @param {Uint8Array} update
 * @return {Uint8Array}
 */ const $4bf7ba9bbb4881ae$export$5c451fd8502b011f = (update)=>$4bf7ba9bbb4881ae$export$ed51750cf3ab2381(update, $4bf7ba9bbb4881ae$var$DSEncoderV1, $4bf7ba9bbb4881ae$export$1aa46d9818b5d1ec);
/**
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} YDecoder
 * @return {{ from: Map<number,number>, to: Map<number,number> }}
 */ const $4bf7ba9bbb4881ae$export$8212a58b2178fdcf = (update, YDecoder = $4bf7ba9bbb4881ae$export$1c932452355c5571)=>{
    /**
   * @type {Map<number, number>}
   */ const from = new Map();
    /**
   * @type {Map<number, number>}
   */ const to = new Map();
    const updateDecoder = new $4bf7ba9bbb4881ae$var$LazyStructReader(new YDecoder($dirF1.createDecoder(update)), false);
    let curr = updateDecoder.curr;
    if (curr !== null) {
        let currClient = curr.id.client;
        let currClock = curr.id.clock;
        // write the beginning to `from`
        from.set(currClient, currClock);
        for(; curr !== null; curr = updateDecoder.next()){
            if (currClient !== curr.id.client) {
                // We found a new client
                // write the end to `to`
                to.set(currClient, currClock);
                // write the beginning to `from`
                from.set(curr.id.client, curr.id.clock);
                // update currClient
                currClient = curr.id.client;
            }
            currClock = curr.id.clock + curr.length;
        }
        // write the end to `to`
        to.set(currClient, currClock);
    }
    return {
        from: from,
        to: to
    };
};
/**
 * @param {Uint8Array} update
 * @return {{ from: Map<number,number>, to: Map<number,number> }}
 */ const $4bf7ba9bbb4881ae$export$e212b06fd4bf78fd = (update)=>$4bf7ba9bbb4881ae$export$8212a58b2178fdcf(update, $4bf7ba9bbb4881ae$export$1aa46d9818b5d1ec);
/**
 * This method is intended to slice any kind of struct and retrieve the right part.
 * It does not handle side-effects, so it should only be used by the lazy-encoder.
 *
 * @param {Item | GC | Skip} left
 * @param {number} diff
 * @return {Item | GC}
 */ const $4bf7ba9bbb4881ae$var$sliceStruct = (left, diff)=>{
    if (left.constructor === $4bf7ba9bbb4881ae$export$12d259ff017e6b58) {
        const { client: client, clock: clock } = left.id;
        return new $4bf7ba9bbb4881ae$export$12d259ff017e6b58($4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(client, clock + diff), left.length - diff);
    } else if (left.constructor === $4bf7ba9bbb4881ae$export$38d24f5c1eb0e4c0) {
        const { client: client, clock: clock } = left.id;
        return new $4bf7ba9bbb4881ae$export$38d24f5c1eb0e4c0($4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(client, clock + diff), left.length - diff);
    } else {
        const leftItem = /** @type {Item} */ left;
        const { client: client, clock: clock } = leftItem.id;
        return new $4bf7ba9bbb4881ae$export$6d08773d2e66f8f2($4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(client, clock + diff), null, $4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(client, clock + diff - 1), null, leftItem.rightOrigin, leftItem.parent, leftItem.parentSub, leftItem.content.splice(diff));
    }
};
/**
 *
 * This function works similarly to `readUpdateV2`.
 *
 * @param {Array<Uint8Array>} updates
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} [YDecoder]
 * @param {typeof UpdateEncoderV1 | typeof UpdateEncoderV2} [YEncoder]
 * @return {Uint8Array}
 */ const $4bf7ba9bbb4881ae$export$ce273d78de0331d1 = (updates, YDecoder = $4bf7ba9bbb4881ae$export$1c932452355c5571, YEncoder = $4bf7ba9bbb4881ae$export$30c99e08943e1c2)=>{
    if (updates.length === 1) return updates[0];
    const updateDecoders = updates.map((update)=>new YDecoder($dirF1.createDecoder(update)));
    let lazyStructDecoders = updateDecoders.map((decoder)=>new $4bf7ba9bbb4881ae$var$LazyStructReader(decoder, true));
    /**
   * @todo we don't need offset because we always slice before
   * @type {null | { struct: Item | GC | Skip, offset: number }}
   */ let currWrite = null;
    const updateEncoder = new YEncoder();
    // write structs lazily
    const lazyStructEncoder = new $4bf7ba9bbb4881ae$var$LazyStructWriter(updateEncoder);
    // Note: We need to ensure that all lazyStructDecoders are fully consumed
    // Note: Should merge document updates whenever possible - even from different updates
    // Note: Should handle that some operations cannot be applied yet ()
    while(true){
        // Write higher clients first ⇒ sort by clientID & clock and remove decoders without content
        lazyStructDecoders = lazyStructDecoders.filter((dec)=>dec.curr !== null);
        lazyStructDecoders.sort(/** @type {function(any,any):number} */ (dec1, dec2)=>{
            if (dec1.curr.id.client === dec2.curr.id.client) {
                const clockDiff = dec1.curr.id.clock - dec2.curr.id.clock;
                if (clockDiff === 0) // @todo remove references to skip since the structDecoders must filter Skips.
                return dec1.curr.constructor === dec2.curr.constructor ? 0 : dec1.curr.constructor === $4bf7ba9bbb4881ae$export$38d24f5c1eb0e4c0 ? 1 : -1 // we are filtering skips anyway.
                ;
                else return clockDiff;
            } else return dec2.curr.id.client - dec1.curr.id.client;
        });
        if (lazyStructDecoders.length === 0) break;
        const currDecoder = lazyStructDecoders[0];
        // write from currDecoder until the next operation is from another client or if filler-struct
        // then we need to reorder the decoders and find the next operation to write
        const firstClient = /** @type {Item | GC} */ currDecoder.curr.id.client;
        if (currWrite !== null) {
            let curr = /** @type {Item | GC | null} */ currDecoder.curr;
            let iterated = false;
            // iterate until we find something that we haven't written already
            // remember: first the high client-ids are written
            while(curr !== null && curr.id.clock + curr.length <= currWrite.struct.id.clock + currWrite.struct.length && curr.id.client >= currWrite.struct.id.client){
                curr = currDecoder.next();
                iterated = true;
            }
            if (curr === null || // current decoder is empty
            curr.id.client !== firstClient || // check whether there is another decoder that has has updates from `firstClient`
            iterated && curr.id.clock > currWrite.struct.id.clock + currWrite.struct.length // the above while loop was used and we are potentially missing updates
            ) continue;
            if (firstClient !== currWrite.struct.id.client) {
                $4bf7ba9bbb4881ae$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
                currWrite = {
                    struct: curr,
                    offset: 0
                };
                currDecoder.next();
            } else if (currWrite.struct.id.clock + currWrite.struct.length < curr.id.clock) {
                // @todo write currStruct & set currStruct = Skip(clock = currStruct.id.clock + currStruct.length, length = curr.id.clock - self.clock)
                if (currWrite.struct.constructor === $4bf7ba9bbb4881ae$export$38d24f5c1eb0e4c0) // extend existing skip
                currWrite.struct.length = curr.id.clock + curr.length - currWrite.struct.id.clock;
                else {
                    $4bf7ba9bbb4881ae$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
                    const diff = curr.id.clock - currWrite.struct.id.clock - currWrite.struct.length;
                    /**
             * @type {Skip}
             */ const struct = new $4bf7ba9bbb4881ae$export$38d24f5c1eb0e4c0($4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(firstClient, currWrite.struct.id.clock + currWrite.struct.length), diff);
                    currWrite = {
                        struct: struct,
                        offset: 0
                    };
                }
            } else {
                const diff = currWrite.struct.id.clock + currWrite.struct.length - curr.id.clock;
                if (diff > 0) {
                    if (currWrite.struct.constructor === $4bf7ba9bbb4881ae$export$38d24f5c1eb0e4c0) // prefer to slice Skip because the other struct might contain more information
                    currWrite.struct.length -= diff;
                    else curr = $4bf7ba9bbb4881ae$var$sliceStruct(curr, diff);
                }
                if (!currWrite.struct.mergeWith(/** @type {any} */ curr)) {
                    $4bf7ba9bbb4881ae$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
                    currWrite = {
                        struct: curr,
                        offset: 0
                    };
                    currDecoder.next();
                }
            }
        } else {
            currWrite = {
                struct: /** @type {Item | GC} */ currDecoder.curr,
                offset: 0
            };
            currDecoder.next();
        }
        for(let next = currDecoder.curr; next !== null && next.id.client === firstClient && next.id.clock === currWrite.struct.id.clock + currWrite.struct.length && next.constructor !== $4bf7ba9bbb4881ae$export$38d24f5c1eb0e4c0; next = currDecoder.next()){
            $4bf7ba9bbb4881ae$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
            currWrite = {
                struct: next,
                offset: 0
            };
        }
    }
    if (currWrite !== null) {
        $4bf7ba9bbb4881ae$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
        currWrite = null;
    }
    $4bf7ba9bbb4881ae$var$finishLazyStructWriting(lazyStructEncoder);
    const dss = updateDecoders.map((decoder)=>$4bf7ba9bbb4881ae$var$readDeleteSet(decoder));
    const ds = $4bf7ba9bbb4881ae$var$mergeDeleteSets(dss);
    $4bf7ba9bbb4881ae$var$writeDeleteSet(updateEncoder, ds);
    return updateEncoder.toUint8Array();
};
/**
 * @param {Uint8Array} update
 * @param {Uint8Array} sv
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} [YDecoder]
 * @param {typeof UpdateEncoderV1 | typeof UpdateEncoderV2} [YEncoder]
 */ const $4bf7ba9bbb4881ae$export$a8143edf39d2ad8e = (update, sv, YDecoder = $4bf7ba9bbb4881ae$export$1c932452355c5571, YEncoder = $4bf7ba9bbb4881ae$export$30c99e08943e1c2)=>{
    const state = $4bf7ba9bbb4881ae$export$324ac6fb20a844e3(sv);
    const encoder = new YEncoder();
    const lazyStructWriter = new $4bf7ba9bbb4881ae$var$LazyStructWriter(encoder);
    const decoder = new YDecoder($dirF1.createDecoder(update));
    const reader = new $4bf7ba9bbb4881ae$var$LazyStructReader(decoder, false);
    while(reader.curr){
        const curr = reader.curr;
        const currClient = curr.id.client;
        const svClock = state.get(currClient) || 0;
        if (reader.curr.constructor === $4bf7ba9bbb4881ae$export$38d24f5c1eb0e4c0) {
            // the first written struct shouldn't be a skip
            reader.next();
            continue;
        }
        if (curr.id.clock + curr.length > svClock) {
            $4bf7ba9bbb4881ae$var$writeStructToLazyStructWriter(lazyStructWriter, curr, $5qKvF.max(svClock - curr.id.clock, 0));
            reader.next();
            while(reader.curr && reader.curr.id.client === currClient){
                $4bf7ba9bbb4881ae$var$writeStructToLazyStructWriter(lazyStructWriter, reader.curr, 0);
                reader.next();
            }
        } else // read until something new comes up
        while(reader.curr && reader.curr.id.client === currClient && reader.curr.id.clock + reader.curr.length <= svClock)reader.next();
    }
    $4bf7ba9bbb4881ae$var$finishLazyStructWriting(lazyStructWriter);
    // write ds
    const ds = $4bf7ba9bbb4881ae$var$readDeleteSet(decoder);
    $4bf7ba9bbb4881ae$var$writeDeleteSet(encoder, ds);
    return encoder.toUint8Array();
};
/**
 * @param {Uint8Array} update
 * @param {Uint8Array} sv
 */ const $4bf7ba9bbb4881ae$export$bf60b51d6c283426 = (update, sv)=>$4bf7ba9bbb4881ae$export$a8143edf39d2ad8e(update, sv, $4bf7ba9bbb4881ae$export$1aa46d9818b5d1ec, $4bf7ba9bbb4881ae$export$99171b804d9c5b54);
/**
 * @param {LazyStructWriter} lazyWriter
 */ const $4bf7ba9bbb4881ae$var$flushLazyStructWriter = (lazyWriter)=>{
    if (lazyWriter.written > 0) {
        lazyWriter.clientStructs.push({
            written: lazyWriter.written,
            restEncoder: $6E0HV.toUint8Array(lazyWriter.encoder.restEncoder)
        });
        lazyWriter.encoder.restEncoder = $6E0HV.createEncoder();
        lazyWriter.written = 0;
    }
};
/**
 * @param {LazyStructWriter} lazyWriter
 * @param {Item | GC} struct
 * @param {number} offset
 */ const $4bf7ba9bbb4881ae$var$writeStructToLazyStructWriter = (lazyWriter, struct, offset)=>{
    // flush curr if we start another client
    if (lazyWriter.written > 0 && lazyWriter.currClient !== struct.id.client) $4bf7ba9bbb4881ae$var$flushLazyStructWriter(lazyWriter);
    if (lazyWriter.written === 0) {
        lazyWriter.currClient = struct.id.client;
        // write next client
        lazyWriter.encoder.writeClient(struct.id.client);
        // write startClock
        $6E0HV.writeVarUint(lazyWriter.encoder.restEncoder, struct.id.clock + offset);
    }
    struct.write(lazyWriter.encoder, offset);
    lazyWriter.written++;
};
/**
 * Call this function when we collected all parts and want to
 * put all the parts together. After calling this method,
 * you can continue using the UpdateEncoder.
 *
 * @param {LazyStructWriter} lazyWriter
 */ const $4bf7ba9bbb4881ae$var$finishLazyStructWriting = (lazyWriter)=>{
    $4bf7ba9bbb4881ae$var$flushLazyStructWriter(lazyWriter);
    // this is a fresh encoder because we called flushCurr
    const restEncoder = lazyWriter.encoder.restEncoder;
    /**
   * Now we put all the fragments together.
   * This works similarly to `writeClientsStructs`
   */ // write # states that were updated - i.e. the clients
    $6E0HV.writeVarUint(restEncoder, lazyWriter.clientStructs.length);
    for(let i = 0; i < lazyWriter.clientStructs.length; i++){
        const partStructs = lazyWriter.clientStructs[i];
        /**
     * Works similarly to `writeStructs`
     */ // write # encoded structs
        $6E0HV.writeVarUint(restEncoder, partStructs.written);
        // write the rest of the fragment
        $6E0HV.writeUint8Array(restEncoder, partStructs.restEncoder);
    }
};
/**
 * @param {Uint8Array} update
 * @param {function(Item|GC|Skip):Item|GC|Skip} blockTransformer
 * @param {typeof UpdateDecoderV2 | typeof UpdateDecoderV1} YDecoder
 * @param {typeof UpdateEncoderV2 | typeof UpdateEncoderV1 } YEncoder
 */ const $4bf7ba9bbb4881ae$var$convertUpdateFormat = (update, blockTransformer, YDecoder, YEncoder)=>{
    const updateDecoder = new YDecoder($dirF1.createDecoder(update));
    const lazyDecoder = new $4bf7ba9bbb4881ae$var$LazyStructReader(updateDecoder, false);
    const updateEncoder = new YEncoder();
    const lazyWriter = new $4bf7ba9bbb4881ae$var$LazyStructWriter(updateEncoder);
    for(let curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next())$4bf7ba9bbb4881ae$var$writeStructToLazyStructWriter(lazyWriter, blockTransformer(curr), 0);
    $4bf7ba9bbb4881ae$var$finishLazyStructWriting(lazyWriter);
    const ds = $4bf7ba9bbb4881ae$var$readDeleteSet(updateDecoder);
    $4bf7ba9bbb4881ae$var$writeDeleteSet(updateEncoder, ds);
    return updateEncoder.toUint8Array();
};
/**
 * @typedef {Object} ObfuscatorOptions
 * @property {boolean} [ObfuscatorOptions.formatting=true]
 * @property {boolean} [ObfuscatorOptions.subdocs=true]
 * @property {boolean} [ObfuscatorOptions.yxml=true] Whether to obfuscate nodeName / hookName
 */ /**
 * @param {ObfuscatorOptions} obfuscator
 */ const $4bf7ba9bbb4881ae$var$createObfuscator = ({ formatting: formatting = true, subdocs: subdocs = true, yxml: yxml = true } = {})=>{
    let i = 0;
    const mapKeyCache = $dh5fq.create();
    const nodeNameCache = $dh5fq.create();
    const formattingKeyCache = $dh5fq.create();
    const formattingValueCache = $dh5fq.create();
    formattingValueCache.set(null, null); // end of a formatting range should always be the end of a formatting range
    /**
   * @param {Item|GC|Skip} block
   * @return {Item|GC|Skip}
   */ return (block)=>{
        switch(block.constructor){
            case $4bf7ba9bbb4881ae$export$12d259ff017e6b58:
            case $4bf7ba9bbb4881ae$export$38d24f5c1eb0e4c0:
                return block;
            case $4bf7ba9bbb4881ae$export$6d08773d2e66f8f2:
                {
                    const item = /** @type {Item} */ block;
                    const content = item.content;
                    switch(content.constructor){
                        case $4bf7ba9bbb4881ae$export$3b06e0b3a2ece602:
                            break;
                        case $4bf7ba9bbb4881ae$export$e2e108cbe2e4f865:
                            if (yxml) {
                                const type = /** @type {ContentType} */ content.type;
                                if (type instanceof $4bf7ba9bbb4881ae$export$4db87581d3ca170d) type.nodeName = $dh5fq.setIfUndefined(nodeNameCache, type.nodeName, ()=>"node-" + i);
                                if (type instanceof $4bf7ba9bbb4881ae$export$ec64c1dd5e7a264) type.hookName = $dh5fq.setIfUndefined(nodeNameCache, type.hookName, ()=>"hook-" + i);
                            }
                            break;
                        case $4bf7ba9bbb4881ae$export$1d788b93bbb631a0:
                            {
                                const c = /** @type {ContentAny} */ content;
                                c.arr = c.arr.map(()=>i);
                                break;
                            }
                        case $4bf7ba9bbb4881ae$export$e8d530cdf62d1cbd:
                            {
                                const c = /** @type {ContentBinary} */ content;
                                c.content = new Uint8Array([
                                    i
                                ]);
                                break;
                            }
                        case $4bf7ba9bbb4881ae$export$b564c0e69572c0e:
                            {
                                const c = /** @type {ContentDoc} */ content;
                                if (subdocs) {
                                    c.opts = {};
                                    c.doc.guid = i + "";
                                }
                                break;
                            }
                        case $4bf7ba9bbb4881ae$export$c3787ba7f6086664:
                            {
                                const c = /** @type {ContentEmbed} */ content;
                                c.embed = {};
                                break;
                            }
                        case $4bf7ba9bbb4881ae$export$3194899188fb5a88:
                            {
                                const c = /** @type {ContentFormat} */ content;
                                if (formatting) {
                                    c.key = $dh5fq.setIfUndefined(formattingKeyCache, c.key, ()=>i + "");
                                    c.value = $dh5fq.setIfUndefined(formattingValueCache, c.value, ()=>({
                                            i: i
                                        }));
                                }
                                break;
                            }
                        case $4bf7ba9bbb4881ae$export$6a907ea8f733ecf3:
                            {
                                const c = /** @type {ContentJSON} */ content;
                                c.arr = c.arr.map(()=>i);
                                break;
                            }
                        case $4bf7ba9bbb4881ae$export$ee670b2cf091bbb6:
                            {
                                const c = /** @type {ContentString} */ content;
                                c.str = $dVtwn.repeat(i % 10 + "", c.str.length);
                                break;
                            }
                        default:
                            // unknown content type
                            $iVMsw.unexpectedCase();
                    }
                    if (item.parentSub) item.parentSub = $dh5fq.setIfUndefined(mapKeyCache, item.parentSub, ()=>i + "");
                    i++;
                    return block;
                }
            default:
                // unknown block-type
                $iVMsw.unexpectedCase();
        }
    };
};
/**
 * This function obfuscates the content of a Yjs update. This is useful to share
 * buggy Yjs documents while significantly limiting the possibility that a
 * developer can on the user. Note that it might still be possible to deduce
 * some information by analyzing the "structure" of the document or by analyzing
 * the typing behavior using the CRDT-related metadata that is still kept fully
 * intact.
 *
 * @param {Uint8Array} update
 * @param {ObfuscatorOptions} [opts]
 */ const $4bf7ba9bbb4881ae$export$2dc24d59ec48a24e = (update, opts)=>$4bf7ba9bbb4881ae$var$convertUpdateFormat(update, $4bf7ba9bbb4881ae$var$createObfuscator(opts), $4bf7ba9bbb4881ae$export$1aa46d9818b5d1ec, $4bf7ba9bbb4881ae$export$99171b804d9c5b54);
/**
 * @param {Uint8Array} update
 * @param {ObfuscatorOptions} [opts]
 */ const $4bf7ba9bbb4881ae$export$90648fb14f8c31aa = (update, opts)=>$4bf7ba9bbb4881ae$var$convertUpdateFormat(update, $4bf7ba9bbb4881ae$var$createObfuscator(opts), $4bf7ba9bbb4881ae$export$1c932452355c5571, $4bf7ba9bbb4881ae$export$30c99e08943e1c2);
/**
 * @param {Uint8Array} update
 */ const $4bf7ba9bbb4881ae$export$162408325d5832c = (update)=>$4bf7ba9bbb4881ae$var$convertUpdateFormat(update, $4NUz5.id, $4bf7ba9bbb4881ae$export$1aa46d9818b5d1ec, $4bf7ba9bbb4881ae$export$30c99e08943e1c2);
/**
 * @param {Uint8Array} update
 */ const $4bf7ba9bbb4881ae$export$afffbdeed14adbd = (update)=>$4bf7ba9bbb4881ae$var$convertUpdateFormat(update, $4NUz5.id, $4bf7ba9bbb4881ae$export$1c932452355c5571, $4bf7ba9bbb4881ae$export$99171b804d9c5b54);
const $4bf7ba9bbb4881ae$var$errorComputeChanges = "You must not compute changes after the event-handler fired.";
/**
 * @template {AbstractType<any>} T
 * YEvent describes the changes on a YType.
 */ class $4bf7ba9bbb4881ae$export$80fac438977fb51c {
    /**
   * @param {T} target The changed type.
   * @param {Transaction} transaction
   */ constructor(target, transaction){
        /**
     * The type on which this event was created on.
     * @type {T}
     */ this.target = target;
        /**
     * The current target on which the observe callback is called.
     * @type {AbstractType<any>}
     */ this.currentTarget = target;
        /**
     * The transaction that triggered this event.
     * @type {Transaction}
     */ this.transaction = transaction;
        /**
     * @type {Object|null}
     */ this._changes = null;
        /**
     * @type {null | Map<string, { action: 'add' | 'update' | 'delete', oldValue: any, newValue: any }>}
     */ this._keys = null;
        /**
     * @type {null | Array<{ insert?: string | Array<any> | object | AbstractType<any>, retain?: number, delete?: number, attributes?: Object<string, any> }>}
     */ this._delta = null;
        /**
     * @type {Array<string|number>|null}
     */ this._path = null;
    }
    /**
   * Computes the path from `y` to the changed type.
   *
   * @todo v14 should standardize on path: Array<{parent, index}> because that is easier to work with.
   *
   * The following property holds:
   * @example
   *   let type = y
   *   event.path.forEach(dir => {
   *     type = type.get(dir)
   *   })
   *   type === event.target // => true
   */ get path() {
        return this._path || (this._path = $4bf7ba9bbb4881ae$var$getPathTo(this.currentTarget, this.target));
    }
    /**
   * Check if a struct is deleted by this event.
   *
   * In contrast to change.deleted, this method also returns true if the struct was added and then deleted.
   *
   * @param {AbstractStruct} struct
   * @return {boolean}
   */ deletes(struct) {
        return $4bf7ba9bbb4881ae$export$dcb04af092e44fde(this.transaction.deleteSet, struct.id);
    }
    /**
   * @type {Map<string, { action: 'add' | 'update' | 'delete', oldValue: any, newValue: any }>}
   */ get keys() {
        if (this._keys === null) {
            if (this.transaction.doc._transactionCleanups.length === 0) throw $iVMsw.create($4bf7ba9bbb4881ae$var$errorComputeChanges);
            const keys = new Map();
            const target = this.target;
            const changed = /** @type Set<string|null> */ this.transaction.changed.get(target);
            changed.forEach((key)=>{
                if (key !== null) {
                    const item = /** @type {Item} */ target._map.get(key);
                    /**
           * @type {'delete' | 'add' | 'update'}
           */ let action;
                    let oldValue;
                    if (this.adds(item)) {
                        let prev = item.left;
                        while(prev !== null && this.adds(prev))prev = prev.left;
                        if (this.deletes(item)) {
                            if (prev !== null && this.deletes(prev)) {
                                action = "delete";
                                oldValue = $iiUWJ.last(prev.content.getContent());
                            } else return;
                        } else if (prev !== null && this.deletes(prev)) {
                            action = "update";
                            oldValue = $iiUWJ.last(prev.content.getContent());
                        } else {
                            action = "add";
                            oldValue = undefined;
                        }
                    } else {
                        if (this.deletes(item)) {
                            action = "delete";
                            oldValue = $iiUWJ.last(/** @type {Item} */ item.content.getContent());
                        } else return; // nop
                    }
                    keys.set(key, {
                        action: action,
                        oldValue: oldValue
                    });
                }
            });
            this._keys = keys;
        }
        return this._keys;
    }
    /**
   * This is a computed property. Note that this can only be safely computed during the
   * event call. Computing this property after other changes happened might result in
   * unexpected behavior (incorrect computation of deltas). A safe way to collect changes
   * is to store the `changes` or the `delta` object. Avoid storing the `transaction` object.
   *
   * @type {Array<{insert?: string | Array<any> | object | AbstractType<any>, retain?: number, delete?: number, attributes?: Object<string, any>}>}
   */ get delta() {
        return this.changes.delta;
    }
    /**
   * Check if a struct is added by this event.
   *
   * In contrast to change.deleted, this method also returns true if the struct was added and then deleted.
   *
   * @param {AbstractStruct} struct
   * @return {boolean}
   */ adds(struct) {
        return struct.id.clock >= (this.transaction.beforeState.get(struct.id.client) || 0);
    }
    /**
   * This is a computed property. Note that this can only be safely computed during the
   * event call. Computing this property after other changes happened might result in
   * unexpected behavior (incorrect computation of deltas). A safe way to collect changes
   * is to store the `changes` or the `delta` object. Avoid storing the `transaction` object.
   *
   * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string, delete?:number, retain?:number}>}}
   */ get changes() {
        let changes = this._changes;
        if (changes === null) {
            if (this.transaction.doc._transactionCleanups.length === 0) throw $iVMsw.create($4bf7ba9bbb4881ae$var$errorComputeChanges);
            const target = this.target;
            const added = $bUD5M.create();
            const deleted = $bUD5M.create();
            /**
       * @type {Array<{insert:Array<any>}|{delete:number}|{retain:number}>}
       */ const delta = [];
            changes = {
                added: added,
                deleted: deleted,
                delta: delta,
                keys: this.keys
            };
            const changed = /** @type Set<string|null> */ this.transaction.changed.get(target);
            if (changed.has(null)) {
                /**
         * @type {any}
         */ let lastOp = null;
                const packOp = ()=>{
                    if (lastOp) delta.push(lastOp);
                };
                for(let item = target._start; item !== null; item = item.right){
                    if (item.deleted) {
                        if (this.deletes(item) && !this.adds(item)) {
                            if (lastOp === null || lastOp.delete === undefined) {
                                packOp();
                                lastOp = {
                                    delete: 0
                                };
                            }
                            lastOp.delete += item.length;
                            deleted.add(item);
                        } // else nop
                    } else if (this.adds(item)) {
                        if (lastOp === null || lastOp.insert === undefined) {
                            packOp();
                            lastOp = {
                                insert: []
                            };
                        }
                        lastOp.insert = lastOp.insert.concat(item.content.getContent());
                        added.add(item);
                    } else {
                        if (lastOp === null || lastOp.retain === undefined) {
                            packOp();
                            lastOp = {
                                retain: 0
                            };
                        }
                        lastOp.retain += item.length;
                    }
                }
                if (lastOp !== null && lastOp.retain === undefined) packOp();
            }
            this._changes = changes;
        }
        return /** @type {any} */ changes;
    }
}
/**
 * Compute the path from this type to the specified target.
 *
 * @example
 *   // `child` should be accessible via `type.get(path[0]).get(path[1])..`
 *   const path = type.getPathTo(child)
 *   // assuming `type instanceof YArray`
 *   console.log(path) // might look like => [2, 'key1']
 *   child === type.get(path[0]).get(path[1])
 *
 * @param {AbstractType<any>} parent
 * @param {AbstractType<any>} child target
 * @return {Array<string|number>} Path to the target
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$getPathTo = (parent, child)=>{
    const path = [];
    while(child._item !== null && child !== parent){
        if (child._item.parentSub !== null) // parent is map-ish
        path.unshift(child._item.parentSub);
        else {
            // parent is array-ish
            let i = 0;
            let c = /** @type {AbstractType<any>} */ child._item.parent._start;
            while(c !== child._item && c !== null){
                if (!c.deleted) i++;
                c = c.right;
            }
            path.unshift(i);
        }
        child = /** @type {AbstractType<any>} */ child._item.parent;
    }
    return path;
};
const $4bf7ba9bbb4881ae$var$maxSearchMarker = 80;
/**
 * A unique timestamp that identifies each marker.
 *
 * Time is relative,.. this is more like an ever-increasing clock.
 *
 * @type {number}
 */ let $4bf7ba9bbb4881ae$var$globalSearchMarkerTimestamp = 0;
class $4bf7ba9bbb4881ae$var$ArraySearchMarker {
    /**
   * @param {Item} p
   * @param {number} index
   */ constructor(p, index){
        p.marker = true;
        this.p = p;
        this.index = index;
        this.timestamp = $4bf7ba9bbb4881ae$var$globalSearchMarkerTimestamp++;
    }
}
/**
 * @param {ArraySearchMarker} marker
 */ const $4bf7ba9bbb4881ae$var$refreshMarkerTimestamp = (marker)=>{
    marker.timestamp = $4bf7ba9bbb4881ae$var$globalSearchMarkerTimestamp++;
};
/**
 * This is rather complex so this function is the only thing that should overwrite a marker
 *
 * @param {ArraySearchMarker} marker
 * @param {Item} p
 * @param {number} index
 */ const $4bf7ba9bbb4881ae$var$overwriteMarker = (marker, p, index)=>{
    marker.p.marker = false;
    marker.p = p;
    p.marker = true;
    marker.index = index;
    marker.timestamp = $4bf7ba9bbb4881ae$var$globalSearchMarkerTimestamp++;
};
/**
 * @param {Array<ArraySearchMarker>} searchMarker
 * @param {Item} p
 * @param {number} index
 */ const $4bf7ba9bbb4881ae$var$markPosition = (searchMarker, p, index)=>{
    if (searchMarker.length >= $4bf7ba9bbb4881ae$var$maxSearchMarker) {
        // override oldest marker (we don't want to create more objects)
        const marker = searchMarker.reduce((a, b)=>a.timestamp < b.timestamp ? a : b);
        $4bf7ba9bbb4881ae$var$overwriteMarker(marker, p, index);
        return marker;
    } else {
        // create new marker
        const pm = new $4bf7ba9bbb4881ae$var$ArraySearchMarker(p, index);
        searchMarker.push(pm);
        return pm;
    }
};
/**
 * Search marker help us to find positions in the associative array faster.
 *
 * They speed up the process of finding a position without much bookkeeping.
 *
 * A maximum of `maxSearchMarker` objects are created.
 *
 * This function always returns a refreshed marker (updated timestamp)
 *
 * @param {AbstractType<any>} yarray
 * @param {number} index
 */ const $4bf7ba9bbb4881ae$var$findMarker = (yarray, index)=>{
    if (yarray._start === null || index === 0 || yarray._searchMarker === null) return null;
    const marker = yarray._searchMarker.length === 0 ? null : yarray._searchMarker.reduce((a, b)=>$5qKvF.abs(index - a.index) < $5qKvF.abs(index - b.index) ? a : b);
    let p = yarray._start;
    let pindex = 0;
    if (marker !== null) {
        p = marker.p;
        pindex = marker.index;
        $4bf7ba9bbb4881ae$var$refreshMarkerTimestamp(marker); // we used it, we might need to use it again
    }
    // iterate to right if possible
    while(p.right !== null && pindex < index){
        if (!p.deleted && p.countable) {
            if (index < pindex + p.length) break;
            pindex += p.length;
        }
        p = p.right;
    }
    // iterate to left if necessary (might be that pindex > index)
    while(p.left !== null && pindex > index){
        p = p.left;
        if (!p.deleted && p.countable) pindex -= p.length;
    }
    // we want to make sure that p can't be merged with left, because that would screw up everything
    // in that cas just return what we have (it is most likely the best marker anyway)
    // iterate to left until p can't be merged with left
    while(p.left !== null && p.left.id.client === p.id.client && p.left.id.clock + p.left.length === p.id.clock){
        p = p.left;
        if (!p.deleted && p.countable) pindex -= p.length;
    }
    // @todo remove!
    // assure position
    // {
    //   let start = yarray._start
    //   let pos = 0
    //   while (start !== p) {
    //     if (!start.deleted && start.countable) {
    //       pos += start.length
    //     }
    //     start = /** @type {Item} */ (start.right)
    //   }
    //   if (pos !== pindex) {
    //     debugger
    //     throw new Error('Gotcha position fail!')
    //   }
    // }
    // if (marker) {
    //   if (window.lengthes == null) {
    //     window.lengthes = []
    //     window.getLengthes = () => window.lengthes.sort((a, b) => a - b)
    //   }
    //   window.lengthes.push(marker.index - pindex)
    //   console.log('distance', marker.index - pindex, 'len', p && p.parent.length)
    // }
    if (marker !== null && $5qKvF.abs(marker.index - pindex) < /** @type {YText|YArray<any>} */ p.parent.length / $4bf7ba9bbb4881ae$var$maxSearchMarker) {
        // adjust existing marker
        $4bf7ba9bbb4881ae$var$overwriteMarker(marker, p, pindex);
        return marker;
    } else // create new marker
    return $4bf7ba9bbb4881ae$var$markPosition(yarray._searchMarker, p, pindex);
};
/**
 * Update markers when a change happened.
 *
 * This should be called before doing a deletion!
 *
 * @param {Array<ArraySearchMarker>} searchMarker
 * @param {number} index
 * @param {number} len If insertion, len is positive. If deletion, len is negative.
 */ const $4bf7ba9bbb4881ae$var$updateMarkerChanges = (searchMarker, index, len)=>{
    for(let i = searchMarker.length - 1; i >= 0; i--){
        const m = searchMarker[i];
        if (len > 0) {
            /**
       * @type {Item|null}
       */ let p = m.p;
            p.marker = false;
            // Ideally we just want to do a simple position comparison, but this will only work if
            // search markers don't point to deleted items for formats.
            // Iterate marker to prev undeleted countable position so we know what to do when updating a position
            while(p && (p.deleted || !p.countable)){
                p = p.left;
                if (p && !p.deleted && p.countable) // adjust position. the loop should break now
                m.index -= p.length;
            }
            if (p === null || p.marker === true) {
                // remove search marker if updated position is null or if position is already marked
                searchMarker.splice(i, 1);
                continue;
            }
            m.p = p;
            p.marker = true;
        }
        if (index < m.index || len > 0 && index === m.index) m.index = $5qKvF.max(index, m.index + len);
    }
};
/**
 * Accumulate all (list) children of a type and return them as an Array.
 *
 * @param {AbstractType<any>} t
 * @return {Array<Item>}
 */ const $4bf7ba9bbb4881ae$export$5418d693f13991b3 = (t)=>{
    let s = t._start;
    const arr = [];
    while(s){
        arr.push(s);
        s = s.right;
    }
    return arr;
};
/**
 * Call event listeners with an event. This will also add an event to all
 * parents (for `.observeDeep` handlers).
 *
 * @template EventType
 * @param {AbstractType<EventType>} type
 * @param {Transaction} transaction
 * @param {EventType} event
 */ const $4bf7ba9bbb4881ae$var$callTypeObservers = (type, transaction, event)=>{
    const changedType = type;
    const changedParentTypes = transaction.changedParentTypes;
    while(true){
        // @ts-ignore
        $dh5fq.setIfUndefined(changedParentTypes, type, ()=>[]).push(event);
        if (type._item === null) break;
        type = /** @type {AbstractType<any>} */ type._item.parent;
    }
    $4bf7ba9bbb4881ae$var$callEventHandlerListeners(changedType._eH, event, transaction);
};
/**
 * @template EventType
 * Abstract Yjs Type class
 */ class $4bf7ba9bbb4881ae$export$c265dc8338484497 {
    constructor(){
        /**
     * @type {Item|null}
     */ this._item = null;
        /**
     * @type {Map<string,Item>}
     */ this._map = new Map();
        /**
     * @type {Item|null}
     */ this._start = null;
        /**
     * @type {Doc|null}
     */ this.doc = null;
        this._length = 0;
        /**
     * Event handlers
     * @type {EventHandler<EventType,Transaction>}
     */ this._eH = $4bf7ba9bbb4881ae$var$createEventHandler();
        /**
     * Deep event handlers
     * @type {EventHandler<Array<YEvent<any>>,Transaction>}
     */ this._dEH = $4bf7ba9bbb4881ae$var$createEventHandler();
        /**
     * @type {null | Array<ArraySearchMarker>}
     */ this._searchMarker = null;
    }
    /**
   * @return {AbstractType<any>|null}
   */ get parent() {
        return this._item ? /** @type {AbstractType<any>} */ this._item.parent : null;
    }
    /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item|null} item
   */ _integrate(y, item) {
        this.doc = y;
        this._item = item;
    }
    /**
   * @return {AbstractType<EventType>}
   */ _copy() {
        throw $iVMsw.methodUnimplemented();
    }
    /**
   * @return {AbstractType<EventType>}
   */ clone() {
        throw $iVMsw.methodUnimplemented();
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} _encoder
   */ _write(_encoder) {}
    /**
   * The first non-deleted item
   */ get _first() {
        let n = this._start;
        while(n !== null && n.deleted)n = n.right;
        return n;
    }
    /**
   * Creates YEvent and calls all type observers.
   * Must be implemented by each type.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} _parentSubs Keys changed on this type. `null` if list was modified.
   */ _callObserver(transaction, _parentSubs) {
        if (!transaction.local && this._searchMarker) this._searchMarker.length = 0;
    }
    /**
   * Observe all events that are created on this type.
   *
   * @param {function(EventType, Transaction):void} f Observer function
   */ observe(f) {
        $4bf7ba9bbb4881ae$var$addEventHandlerListener(this._eH, f);
    }
    /**
   * Observe all events that are created by this type and its children.
   *
   * @param {function(Array<YEvent<any>>,Transaction):void} f Observer function
   */ observeDeep(f) {
        $4bf7ba9bbb4881ae$var$addEventHandlerListener(this._dEH, f);
    }
    /**
   * Unregister an observer function.
   *
   * @param {function(EventType,Transaction):void} f Observer function
   */ unobserve(f) {
        $4bf7ba9bbb4881ae$var$removeEventHandlerListener(this._eH, f);
    }
    /**
   * Unregister an observer function.
   *
   * @param {function(Array<YEvent<any>>,Transaction):void} f Observer function
   */ unobserveDeep(f) {
        $4bf7ba9bbb4881ae$var$removeEventHandlerListener(this._dEH, f);
    }
    /**
   * @abstract
   * @return {any}
   */ toJSON() {}
}
/**
 * @param {AbstractType<any>} type
 * @param {number} start
 * @param {number} end
 * @return {Array<any>}
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$typeListSlice = (type, start, end)=>{
    if (start < 0) start = type._length + start;
    if (end < 0) end = type._length + end;
    let len = end - start;
    const cs = [];
    let n = type._start;
    while(n !== null && len > 0){
        if (n.countable && !n.deleted) {
            const c = n.content.getContent();
            if (c.length <= start) start -= c.length;
            else {
                for(let i = start; i < c.length && len > 0; i++){
                    cs.push(c[i]);
                    len--;
                }
                start = 0;
            }
        }
        n = n.right;
    }
    return cs;
};
/**
 * @param {AbstractType<any>} type
 * @return {Array<any>}
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$typeListToArray = (type)=>{
    const cs = [];
    let n = type._start;
    while(n !== null){
        if (n.countable && !n.deleted) {
            const c = n.content.getContent();
            for(let i = 0; i < c.length; i++)cs.push(c[i]);
        }
        n = n.right;
    }
    return cs;
};
/**
 * @param {AbstractType<any>} type
 * @param {Snapshot} snapshot
 * @return {Array<any>}
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$export$9de42b6dda4c7e48 = (type, snapshot)=>{
    const cs = [];
    let n = type._start;
    while(n !== null){
        if (n.countable && $4bf7ba9bbb4881ae$var$isVisible(n, snapshot)) {
            const c = n.content.getContent();
            for(let i = 0; i < c.length; i++)cs.push(c[i]);
        }
        n = n.right;
    }
    return cs;
};
/**
 * Executes a provided function on once on overy element of this YArray.
 *
 * @param {AbstractType<any>} type
 * @param {function(any,number,any):void} f A function to execute on every element of this YArray.
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$typeListForEach = (type, f)=>{
    let index = 0;
    let n = type._start;
    while(n !== null){
        if (n.countable && !n.deleted) {
            const c = n.content.getContent();
            for(let i = 0; i < c.length; i++)f(c[i], index++, type);
        }
        n = n.right;
    }
};
/**
 * @template C,R
 * @param {AbstractType<any>} type
 * @param {function(C,number,AbstractType<any>):R} f
 * @return {Array<R>}
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$typeListMap = (type, f)=>{
    /**
   * @type {Array<any>}
   */ const result = [];
    $4bf7ba9bbb4881ae$var$typeListForEach(type, (c, i)=>{
        result.push(f(c, i, type));
    });
    return result;
};
/**
 * @param {AbstractType<any>} type
 * @return {IterableIterator<any>}
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$typeListCreateIterator = (type)=>{
    let n = type._start;
    /**
   * @type {Array<any>|null}
   */ let currentContent = null;
    let currentContentIndex = 0;
    return {
        [Symbol.iterator] () {
            return this;
        },
        next: ()=>{
            // find some content
            if (currentContent === null) {
                while(n !== null && n.deleted)n = n.right;
                // check if we reached the end, no need to check currentContent, because it does not exist
                if (n === null) return {
                    done: true,
                    value: undefined
                };
                // we found n, so we can set currentContent
                currentContent = n.content.getContent();
                currentContentIndex = 0;
                n = n.right; // we used the content of n, now iterate to next
            }
            const value = currentContent[currentContentIndex++];
            // check if we need to empty currentContent
            if (currentContent.length <= currentContentIndex) currentContent = null;
            return {
                done: false,
                value: value
            };
        }
    };
};
/**
 * @param {AbstractType<any>} type
 * @param {number} index
 * @return {any}
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$typeListGet = (type, index)=>{
    const marker = $4bf7ba9bbb4881ae$var$findMarker(type, index);
    let n = type._start;
    if (marker !== null) {
        n = marker.p;
        index -= marker.index;
    }
    for(; n !== null; n = n.right)if (!n.deleted && n.countable) {
        if (index < n.length) return n.content.getContent()[index];
        index -= n.length;
    }
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {Item?} referenceItem
 * @param {Array<Object<string,any>|Array<any>|boolean|number|null|string|Uint8Array>} content
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$typeListInsertGenericsAfter = (transaction, parent, referenceItem, content)=>{
    let left = referenceItem;
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    const store = doc.store;
    const right = referenceItem === null ? parent._start : referenceItem.right;
    /**
   * @type {Array<Object|Array<any>|number|null>}
   */ let jsonContent = [];
    const packJsonContent = ()=>{
        if (jsonContent.length > 0) {
            left = new $4bf7ba9bbb4881ae$export$6d08773d2e66f8f2($4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(ownClientId, $4bf7ba9bbb4881ae$export$50fdfeece43146fd(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $4bf7ba9bbb4881ae$export$1d788b93bbb631a0(jsonContent));
            left.integrate(transaction, 0);
            jsonContent = [];
        }
    };
    content.forEach((c)=>{
        if (c === null) jsonContent.push(c);
        else switch(c.constructor){
            case Number:
            case Object:
            case Boolean:
            case Array:
            case String:
                jsonContent.push(c);
                break;
            default:
                packJsonContent();
                switch(c.constructor){
                    case Uint8Array:
                    case ArrayBuffer:
                        left = new $4bf7ba9bbb4881ae$export$6d08773d2e66f8f2($4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(ownClientId, $4bf7ba9bbb4881ae$export$50fdfeece43146fd(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $4bf7ba9bbb4881ae$export$e8d530cdf62d1cbd(new Uint8Array(/** @type {Uint8Array} */ c)));
                        left.integrate(transaction, 0);
                        break;
                    case $4bf7ba9bbb4881ae$export$bceacc74c2212615:
                        left = new $4bf7ba9bbb4881ae$export$6d08773d2e66f8f2($4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(ownClientId, $4bf7ba9bbb4881ae$export$50fdfeece43146fd(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $4bf7ba9bbb4881ae$export$b564c0e69572c0e(/** @type {Doc} */ c));
                        left.integrate(transaction, 0);
                        break;
                    default:
                        if (c instanceof $4bf7ba9bbb4881ae$export$c265dc8338484497) {
                            left = new $4bf7ba9bbb4881ae$export$6d08773d2e66f8f2($4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(ownClientId, $4bf7ba9bbb4881ae$export$50fdfeece43146fd(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $4bf7ba9bbb4881ae$export$e2e108cbe2e4f865(c));
                            left.integrate(transaction, 0);
                        } else throw new Error("Unexpected content type in insert operation");
                }
        }
    });
    packJsonContent();
};
const $4bf7ba9bbb4881ae$var$lengthExceeded = ()=>$iVMsw.create("Length exceeded!");
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {number} index
 * @param {Array<Object<string,any>|Array<any>|number|null|string|Uint8Array>} content
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$typeListInsertGenerics = (transaction, parent, index, content)=>{
    if (index > parent._length) throw $4bf7ba9bbb4881ae$var$lengthExceeded();
    if (index === 0) {
        if (parent._searchMarker) $4bf7ba9bbb4881ae$var$updateMarkerChanges(parent._searchMarker, index, content.length);
        return $4bf7ba9bbb4881ae$var$typeListInsertGenericsAfter(transaction, parent, null, content);
    }
    const startIndex = index;
    const marker = $4bf7ba9bbb4881ae$var$findMarker(parent, index);
    let n = parent._start;
    if (marker !== null) {
        n = marker.p;
        index -= marker.index;
        // we need to iterate one to the left so that the algorithm works
        if (index === 0) {
            // @todo refactor this as it actually doesn't consider formats
            n = n.prev; // important! get the left undeleted item so that we can actually decrease index
            index += n && n.countable && !n.deleted ? n.length : 0;
        }
    }
    for(; n !== null; n = n.right)if (!n.deleted && n.countable) {
        if (index <= n.length) {
            if (index < n.length) // insert in-between
            $4bf7ba9bbb4881ae$var$getItemCleanStart(transaction, $4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(n.id.client, n.id.clock + index));
            break;
        }
        index -= n.length;
    }
    if (parent._searchMarker) $4bf7ba9bbb4881ae$var$updateMarkerChanges(parent._searchMarker, startIndex, content.length);
    return $4bf7ba9bbb4881ae$var$typeListInsertGenericsAfter(transaction, parent, n, content);
};
/**
 * Pushing content is special as we generally want to push after the last item. So we don't have to update
 * the serach marker.
 *
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {Array<Object<string,any>|Array<any>|number|null|string|Uint8Array>} content
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$typeListPushGenerics = (transaction, parent, content)=>{
    // Use the marker with the highest index and iterate to the right.
    const marker = (parent._searchMarker || []).reduce((maxMarker, currMarker)=>currMarker.index > maxMarker.index ? currMarker : maxMarker, {
        index: 0,
        p: parent._start
    });
    let n = marker.p;
    if (n) while(n.right)n = n.right;
    return $4bf7ba9bbb4881ae$var$typeListInsertGenericsAfter(transaction, parent, n, content);
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {number} index
 * @param {number} length
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$typeListDelete = (transaction, parent, index, length)=>{
    if (length === 0) return;
    const startIndex = index;
    const startLength = length;
    const marker = $4bf7ba9bbb4881ae$var$findMarker(parent, index);
    let n = parent._start;
    if (marker !== null) {
        n = marker.p;
        index -= marker.index;
    }
    // compute the first item to be deleted
    for(; n !== null && index > 0; n = n.right)if (!n.deleted && n.countable) {
        if (index < n.length) $4bf7ba9bbb4881ae$var$getItemCleanStart(transaction, $4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(n.id.client, n.id.clock + index));
        index -= n.length;
    }
    // delete all items until done
    while(length > 0 && n !== null){
        if (!n.deleted) {
            if (length < n.length) $4bf7ba9bbb4881ae$var$getItemCleanStart(transaction, $4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(n.id.client, n.id.clock + length));
            n.delete(transaction);
            length -= n.length;
        }
        n = n.right;
    }
    if (length > 0) throw $4bf7ba9bbb4881ae$var$lengthExceeded();
    if (parent._searchMarker) $4bf7ba9bbb4881ae$var$updateMarkerChanges(parent._searchMarker, startIndex, -startLength + length /* in case we remove the above exception */ );
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {string} key
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$typeMapDelete = (transaction, parent, key)=>{
    const c = parent._map.get(key);
    if (c !== undefined) c.delete(transaction);
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @param {Object|number|null|Array<any>|string|Uint8Array|AbstractType<any>} value
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$typeMapSet = (transaction, parent, key, value)=>{
    const left = parent._map.get(key) || null;
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    let content;
    if (value == null) content = new $4bf7ba9bbb4881ae$export$1d788b93bbb631a0([
        value
    ]);
    else switch(value.constructor){
        case Number:
        case Object:
        case Boolean:
        case Array:
        case String:
            content = new $4bf7ba9bbb4881ae$export$1d788b93bbb631a0([
                value
            ]);
            break;
        case Uint8Array:
            content = new $4bf7ba9bbb4881ae$export$e8d530cdf62d1cbd(/** @type {Uint8Array} */ value);
            break;
        case $4bf7ba9bbb4881ae$export$bceacc74c2212615:
            content = new $4bf7ba9bbb4881ae$export$b564c0e69572c0e(/** @type {Doc} */ value);
            break;
        default:
            if (value instanceof $4bf7ba9bbb4881ae$export$c265dc8338484497) content = new $4bf7ba9bbb4881ae$export$e2e108cbe2e4f865(value);
            else throw new Error("Unexpected content type");
    }
    new $4bf7ba9bbb4881ae$export$6d08773d2e66f8f2($4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(ownClientId, $4bf7ba9bbb4881ae$export$50fdfeece43146fd(doc.store, ownClientId)), left, left && left.lastId, null, null, parent, key, content).integrate(transaction, 0);
};
/**
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @return {Object<string,any>|number|null|Array<any>|string|Uint8Array|AbstractType<any>|undefined}
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$typeMapGet = (parent, key)=>{
    const val = parent._map.get(key);
    return val !== undefined && !val.deleted ? val.content.getContent()[val.length - 1] : undefined;
};
/**
 * @param {AbstractType<any>} parent
 * @return {Object<string,Object<string,any>|number|null|Array<any>|string|Uint8Array|AbstractType<any>|undefined>}
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$typeMapGetAll = (parent)=>{
    /**
   * @type {Object<string,any>}
   */ const res = {};
    parent._map.forEach((value, key)=>{
        if (!value.deleted) res[key] = value.content.getContent()[value.length - 1];
    });
    return res;
};
/**
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @return {boolean}
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$typeMapHas = (parent, key)=>{
    const val = parent._map.get(key);
    return val !== undefined && !val.deleted;
};
/**
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @param {Snapshot} snapshot
 * @return {Object<string,any>|number|null|Array<any>|string|Uint8Array|AbstractType<any>|undefined}
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$export$a7c089bf6c22a1db = (parent, key, snapshot)=>{
    let v = parent._map.get(key) || null;
    while(v !== null && (!snapshot.sv.has(v.id.client) || v.id.clock >= (snapshot.sv.get(v.id.client) || 0)))v = v.left;
    return v !== null && $4bf7ba9bbb4881ae$var$isVisible(v, snapshot) ? v.content.getContent()[v.length - 1] : undefined;
};
/**
 * @param {AbstractType<any>} parent
 * @param {Snapshot} snapshot
 * @return {Object<string,Object<string,any>|number|null|Array<any>|string|Uint8Array|AbstractType<any>|undefined>}
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$export$7769bdedaef2c91b = (parent, snapshot)=>{
    /**
   * @type {Object<string,any>}
   */ const res = {};
    parent._map.forEach((value, key)=>{
        /**
     * @type {Item|null}
     */ let v = value;
        while(v !== null && (!snapshot.sv.has(v.id.client) || v.id.clock >= (snapshot.sv.get(v.id.client) || 0)))v = v.left;
        if (v !== null && $4bf7ba9bbb4881ae$var$isVisible(v, snapshot)) res[key] = v.content.getContent()[v.length - 1];
    });
    return res;
};
/**
 * @param {Map<string,Item>} map
 * @return {IterableIterator<Array<any>>}
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$createMapIterator = (map)=>$2H3N4.iteratorFilter(map.entries(), /** @param {any} entry */ (entry)=>!entry[1].deleted);
/**
 * @module YArray
 */ /**
 * Event that describes the changes on a YArray
 * @template T
 * @extends YEvent<YArray<T>>
 */ class $4bf7ba9bbb4881ae$export$a095f7fee639264a extends $4bf7ba9bbb4881ae$export$80fac438977fb51c {
    /**
   * @param {YArray<T>} yarray The changed type
   * @param {Transaction} transaction The transaction object
   */ constructor(yarray, transaction){
        super(yarray, transaction);
        this._transaction = transaction;
    }
}
/**
 * A shared Array implementation.
 * @template T
 * @extends AbstractType<YArrayEvent<T>>
 * @implements {Iterable<T>}
 */ class $4bf7ba9bbb4881ae$export$c4be6576ca6fe4aa extends $4bf7ba9bbb4881ae$export$c265dc8338484497 {
    constructor(){
        super();
        /**
     * @type {Array<any>?}
     * @private
     */ this._prelimContent = [];
        /**
     * @type {Array<ArraySearchMarker>}
     */ this._searchMarker = [];
    }
    /**
   * Construct a new YArray containing the specified items.
   * @template {Object<string,any>|Array<any>|number|null|string|Uint8Array} T
   * @param {Array<T>} items
   * @return {YArray<T>}
   */ static from(items) {
        /**
     * @type {YArray<T>}
     */ const a = new $4bf7ba9bbb4881ae$export$c4be6576ca6fe4aa();
        a.push(items);
        return a;
    }
    /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */ _integrate(y, item) {
        super._integrate(y, item);
        this.insert(0, /** @type {Array<any>} */ this._prelimContent);
        this._prelimContent = null;
    }
    /**
   * @return {YArray<T>}
   */ _copy() {
        return new $4bf7ba9bbb4881ae$export$c4be6576ca6fe4aa();
    }
    /**
   * @return {YArray<T>}
   */ clone() {
        /**
     * @type {YArray<T>}
     */ const arr = new $4bf7ba9bbb4881ae$export$c4be6576ca6fe4aa();
        arr.insert(0, this.toArray().map((el)=>el instanceof $4bf7ba9bbb4881ae$export$c265dc8338484497 ? /** @type {typeof el} */ el.clone() : el));
        return arr;
    }
    get length() {
        return this._prelimContent === null ? this._length : this._prelimContent.length;
    }
    /**
   * Creates YArrayEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */ _callObserver(transaction, parentSubs) {
        super._callObserver(transaction, parentSubs);
        $4bf7ba9bbb4881ae$var$callTypeObservers(this, transaction, new $4bf7ba9bbb4881ae$export$a095f7fee639264a(this, transaction));
    }
    /**
   * Inserts new content at an index.
   *
   * Important: This function expects an array of content. Not just a content
   * object. The reason for this "weirdness" is that inserting several elements
   * is very efficient when it is done as a single operation.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  yarray.insert(0, ['a'])
   *  // Insert numbers 1, 2 at position 1
   *  yarray.insert(1, [1, 2])
   *
   * @param {number} index The index to insert content at.
   * @param {Array<T>} content The array of content
   */ insert(index, content) {
        if (this.doc !== null) $4bf7ba9bbb4881ae$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $4bf7ba9bbb4881ae$var$typeListInsertGenerics(transaction, this, index, /** @type {any} */ content);
        });
        else /** @type {Array<any>} */ this._prelimContent.splice(index, 0, ...content);
    }
    /**
   * Appends content to this YArray.
   *
   * @param {Array<T>} content Array of content to append.
   *
   * @todo Use the following implementation in all types.
   */ push(content) {
        if (this.doc !== null) $4bf7ba9bbb4881ae$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $4bf7ba9bbb4881ae$var$typeListPushGenerics(transaction, this, /** @type {any} */ content);
        });
        else /** @type {Array<any>} */ this._prelimContent.push(...content);
    }
    /**
   * Preppends content to this YArray.
   *
   * @param {Array<T>} content Array of content to preppend.
   */ unshift(content) {
        this.insert(0, content);
    }
    /**
   * Deletes elements starting from an index.
   *
   * @param {number} index Index at which to start deleting elements
   * @param {number} length The number of elements to remove. Defaults to 1.
   */ delete(index, length = 1) {
        if (this.doc !== null) $4bf7ba9bbb4881ae$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $4bf7ba9bbb4881ae$var$typeListDelete(transaction, this, index, length);
        });
        else /** @type {Array<any>} */ this._prelimContent.splice(index, length);
    }
    /**
   * Returns the i-th element from a YArray.
   *
   * @param {number} index The index of the element to return from the YArray
   * @return {T}
   */ get(index) {
        return $4bf7ba9bbb4881ae$var$typeListGet(this, index);
    }
    /**
   * Transforms this YArray to a JavaScript Array.
   *
   * @return {Array<T>}
   */ toArray() {
        return $4bf7ba9bbb4881ae$var$typeListToArray(this);
    }
    /**
   * Transforms this YArray to a JavaScript Array.
   *
   * @param {number} [start]
   * @param {number} [end]
   * @return {Array<T>}
   */ slice(start = 0, end = this.length) {
        return $4bf7ba9bbb4881ae$var$typeListSlice(this, start, end);
    }
    /**
   * Transforms this Shared Type to a JSON object.
   *
   * @return {Array<any>}
   */ toJSON() {
        return this.map((c)=>c instanceof $4bf7ba9bbb4881ae$export$c265dc8338484497 ? c.toJSON() : c);
    }
    /**
   * Returns an Array with the result of calling a provided function on every
   * element of this YArray.
   *
   * @template M
   * @param {function(T,number,YArray<T>):M} f Function that produces an element of the new Array
   * @return {Array<M>} A new array with each element being the result of the
   *                 callback function
   */ map(f) {
        return $4bf7ba9bbb4881ae$var$typeListMap(this, /** @type {any} */ f);
    }
    /**
   * Executes a provided function once on overy element of this YArray.
   *
   * @param {function(T,number,YArray<T>):void} f A function to execute on every element of this YArray.
   */ forEach(f) {
        $4bf7ba9bbb4881ae$var$typeListForEach(this, f);
    }
    /**
   * @return {IterableIterator<T>}
   */ [Symbol.iterator]() {
        return $4bf7ba9bbb4881ae$var$typeListCreateIterator(this);
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ _write(encoder) {
        encoder.writeTypeRef($4bf7ba9bbb4881ae$var$YArrayRefID);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} _decoder
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$readYArray = (_decoder)=>new $4bf7ba9bbb4881ae$export$c4be6576ca6fe4aa();
/**
 * @module YMap
 */ /**
 * @template T
 * @extends YEvent<YMap<T>>
 * Event that describes the changes on a YMap.
 */ class $4bf7ba9bbb4881ae$export$33aab1b1a47c1cc3 extends $4bf7ba9bbb4881ae$export$80fac438977fb51c {
    /**
   * @param {YMap<T>} ymap The YArray that changed.
   * @param {Transaction} transaction
   * @param {Set<any>} subs The keys that changed.
   */ constructor(ymap, transaction, subs){
        super(ymap, transaction);
        this.keysChanged = subs;
    }
}
/**
 * @template MapType
 * A shared Map implementation.
 *
 * @extends AbstractType<YMapEvent<MapType>>
 * @implements {Iterable<[string, MapType]>}
 */ class $4bf7ba9bbb4881ae$export$a5c7b93649eaf8f8 extends $4bf7ba9bbb4881ae$export$c265dc8338484497 {
    /**
   *
   * @param {Iterable<readonly [string, any]>=} entries - an optional iterable to initialize the YMap
   */ constructor(entries){
        super();
        /**
     * @type {Map<string,any>?}
     * @private
     */ this._prelimContent = null;
        if (entries === undefined) this._prelimContent = new Map();
        else this._prelimContent = new Map(entries);
    }
    /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */ _integrate(y, item) {
        super._integrate(y, item); /** @type {Map<string, any>} */ 
        this._prelimContent.forEach((value, key)=>{
            this.set(key, value);
        });
        this._prelimContent = null;
    }
    /**
   * @return {YMap<MapType>}
   */ _copy() {
        return new $4bf7ba9bbb4881ae$export$a5c7b93649eaf8f8();
    }
    /**
   * @return {YMap<MapType>}
   */ clone() {
        /**
     * @type {YMap<MapType>}
     */ const map = new $4bf7ba9bbb4881ae$export$a5c7b93649eaf8f8();
        this.forEach((value, key)=>{
            map.set(key, value instanceof $4bf7ba9bbb4881ae$export$c265dc8338484497 ? /** @type {typeof value} */ value.clone() : value);
        });
        return map;
    }
    /**
   * Creates YMapEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */ _callObserver(transaction, parentSubs) {
        $4bf7ba9bbb4881ae$var$callTypeObservers(this, transaction, new $4bf7ba9bbb4881ae$export$33aab1b1a47c1cc3(this, transaction, parentSubs));
    }
    /**
   * Transforms this Shared Type to a JSON object.
   *
   * @return {Object<string,any>}
   */ toJSON() {
        /**
     * @type {Object<string,MapType>}
     */ const map = {};
        this._map.forEach((item, key)=>{
            if (!item.deleted) {
                const v = item.content.getContent()[item.length - 1];
                map[key] = v instanceof $4bf7ba9bbb4881ae$export$c265dc8338484497 ? v.toJSON() : v;
            }
        });
        return map;
    }
    /**
   * Returns the size of the YMap (count of key/value pairs)
   *
   * @return {number}
   */ get size() {
        return [
            ...$4bf7ba9bbb4881ae$var$createMapIterator(this._map)
        ].length;
    }
    /**
   * Returns the keys for each element in the YMap Type.
   *
   * @return {IterableIterator<string>}
   */ keys() {
        return $2H3N4.iteratorMap($4bf7ba9bbb4881ae$var$createMapIterator(this._map), /** @param {any} v */ (v)=>v[0]);
    }
    /**
   * Returns the values for each element in the YMap Type.
   *
   * @return {IterableIterator<MapType>}
   */ values() {
        return $2H3N4.iteratorMap($4bf7ba9bbb4881ae$var$createMapIterator(this._map), /** @param {any} v */ (v)=>v[1].content.getContent()[v[1].length - 1]);
    }
    /**
   * Returns an Iterator of [key, value] pairs
   *
   * @return {IterableIterator<[string, MapType]>}
   */ entries() {
        return $2H3N4.iteratorMap($4bf7ba9bbb4881ae$var$createMapIterator(this._map), /** @param {any} v */ (v)=>/** @type {any} */ [
                v[0],
                v[1].content.getContent()[v[1].length - 1]
            ]);
    }
    /**
   * Executes a provided function on once on every key-value pair.
   *
   * @param {function(MapType,string,YMap<MapType>):void} f A function to execute on every element of this YArray.
   */ forEach(f) {
        this._map.forEach((item, key)=>{
            if (!item.deleted) f(item.content.getContent()[item.length - 1], key, this);
        });
    }
    /**
   * Returns an Iterator of [key, value] pairs
   *
   * @return {IterableIterator<[string, MapType]>}
   */ [Symbol.iterator]() {
        return this.entries();
    }
    /**
   * Remove a specified element from this YMap.
   *
   * @param {string} key The key of the element to remove.
   */ delete(key) {
        if (this.doc !== null) $4bf7ba9bbb4881ae$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $4bf7ba9bbb4881ae$var$typeMapDelete(transaction, this, key);
        });
        else /** @type {Map<string, any>} */ this._prelimContent.delete(key);
    }
    /**
   * Adds or updates an element with a specified key and value.
   * @template {MapType} VAL
   *
   * @param {string} key The key of the element to add to this YMap
   * @param {VAL} value The value of the element to add
   * @return {VAL}
   */ set(key, value) {
        if (this.doc !== null) $4bf7ba9bbb4881ae$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $4bf7ba9bbb4881ae$var$typeMapSet(transaction, this, key, /** @type {any} */ value);
        });
        else /** @type {Map<string, any>} */ this._prelimContent.set(key, value);
        return value;
    }
    /**
   * Returns a specified element from this YMap.
   *
   * @param {string} key
   * @return {MapType|undefined}
   */ get(key) {
        return /** @type {any} */ $4bf7ba9bbb4881ae$var$typeMapGet(this, key);
    }
    /**
   * Returns a boolean indicating whether the specified key exists or not.
   *
   * @param {string} key The key to test.
   * @return {boolean}
   */ has(key) {
        return $4bf7ba9bbb4881ae$var$typeMapHas(this, key);
    }
    /**
   * Removes all elements from this YMap.
   */ clear() {
        if (this.doc !== null) $4bf7ba9bbb4881ae$export$dac1bad6146b2469(this.doc, (transaction)=>{
            this.forEach(function(_value, key, map) {
                $4bf7ba9bbb4881ae$var$typeMapDelete(transaction, map, key);
            });
        });
        else /** @type {Map<string, any>} */ this._prelimContent.clear();
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ _write(encoder) {
        encoder.writeTypeRef($4bf7ba9bbb4881ae$var$YMapRefID);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} _decoder
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$readYMap = (_decoder)=>new $4bf7ba9bbb4881ae$export$a5c7b93649eaf8f8();
/**
 * @module YText
 */ /**
 * @param {any} a
 * @param {any} b
 * @return {boolean}
 */ const $4bf7ba9bbb4881ae$var$equalAttrs = (a, b)=>a === b || typeof a === "object" && typeof b === "object" && a && b && $kLkle.equalFlat(a, b);
class $4bf7ba9bbb4881ae$var$ItemTextListPosition {
    /**
   * @param {Item|null} left
   * @param {Item|null} right
   * @param {number} index
   * @param {Map<string,any>} currentAttributes
   */ constructor(left, right, index, currentAttributes){
        this.left = left;
        this.right = right;
        this.index = index;
        this.currentAttributes = currentAttributes;
    }
    /**
   * Only call this if you know that this.right is defined
   */ forward() {
        if (this.right === null) $iVMsw.unexpectedCase();
        switch(this.right.content.constructor){
            case $4bf7ba9bbb4881ae$export$3194899188fb5a88:
                if (!this.right.deleted) $4bf7ba9bbb4881ae$var$updateCurrentAttributes(this.currentAttributes, /** @type {ContentFormat} */ this.right.content);
                break;
            default:
                if (!this.right.deleted) this.index += this.right.length;
                break;
        }
        this.left = this.right;
        this.right = this.right.right;
    }
}
/**
 * @param {Transaction} transaction
 * @param {ItemTextListPosition} pos
 * @param {number} count steps to move forward
 * @return {ItemTextListPosition}
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$findNextPosition = (transaction, pos, count)=>{
    while(pos.right !== null && count > 0){
        switch(pos.right.content.constructor){
            case $4bf7ba9bbb4881ae$export$3194899188fb5a88:
                if (!pos.right.deleted) $4bf7ba9bbb4881ae$var$updateCurrentAttributes(pos.currentAttributes, /** @type {ContentFormat} */ pos.right.content);
                break;
            default:
                if (!pos.right.deleted) {
                    if (count < pos.right.length) // split right
                    $4bf7ba9bbb4881ae$var$getItemCleanStart(transaction, $4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(pos.right.id.client, pos.right.id.clock + count));
                    pos.index += pos.right.length;
                    count -= pos.right.length;
                }
                break;
        }
        pos.left = pos.right;
        pos.right = pos.right.right;
    // pos.forward() - we don't forward because that would halve the performance because we already do the checks above
    }
    return pos;
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {number} index
 * @param {boolean} useSearchMarker
 * @return {ItemTextListPosition}
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$findPosition = (transaction, parent, index, useSearchMarker)=>{
    const currentAttributes = new Map();
    const marker = useSearchMarker ? $4bf7ba9bbb4881ae$var$findMarker(parent, index) : null;
    if (marker) {
        const pos = new $4bf7ba9bbb4881ae$var$ItemTextListPosition(marker.p.left, marker.p, marker.index, currentAttributes);
        return $4bf7ba9bbb4881ae$var$findNextPosition(transaction, pos, index - marker.index);
    } else {
        const pos = new $4bf7ba9bbb4881ae$var$ItemTextListPosition(null, parent._start, 0, currentAttributes);
        return $4bf7ba9bbb4881ae$var$findNextPosition(transaction, pos, index);
    }
};
/**
 * Negate applied formats
 *
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {Map<string,any>} negatedAttributes
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$insertNegatedAttributes = (transaction, parent, currPos, negatedAttributes)=>{
    // check if we really need to remove attributes
    while(currPos.right !== null && (currPos.right.deleted === true || currPos.right.content.constructor === $4bf7ba9bbb4881ae$export$3194899188fb5a88 && $4bf7ba9bbb4881ae$var$equalAttrs(negatedAttributes.get(/** @type {ContentFormat} */ currPos.right.content.key), /** @type {ContentFormat} */ currPos.right.content.value))){
        if (!currPos.right.deleted) negatedAttributes.delete(/** @type {ContentFormat} */ currPos.right.content.key);
        currPos.forward();
    }
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    negatedAttributes.forEach((val, key)=>{
        const left = currPos.left;
        const right = currPos.right;
        const nextFormat = new $4bf7ba9bbb4881ae$export$6d08773d2e66f8f2($4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(ownClientId, $4bf7ba9bbb4881ae$export$50fdfeece43146fd(doc.store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $4bf7ba9bbb4881ae$export$3194899188fb5a88(key, val));
        nextFormat.integrate(transaction, 0);
        currPos.right = nextFormat;
        currPos.forward();
    });
};
/**
 * @param {Map<string,any>} currentAttributes
 * @param {ContentFormat} format
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$updateCurrentAttributes = (currentAttributes, format)=>{
    const { key: key, value: value } = format;
    if (value === null) currentAttributes.delete(key);
    else currentAttributes.set(key, value);
};
/**
 * @param {ItemTextListPosition} currPos
 * @param {Object<string,any>} attributes
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$minimizeAttributeChanges = (currPos, attributes)=>{
    // go right while attributes[right.key] === right.value (or right is deleted)
    while(true){
        if (currPos.right === null) break;
        else if (currPos.right.deleted || currPos.right.content.constructor === $4bf7ba9bbb4881ae$export$3194899188fb5a88 && $4bf7ba9bbb4881ae$var$equalAttrs(attributes[/** @type {ContentFormat} */ currPos.right.content.key] ?? null, /** @type {ContentFormat} */ currPos.right.content.value)) ;
        else break;
        currPos.forward();
    }
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {Object<string,any>} attributes
 * @return {Map<string,any>}
 *
 * @private
 * @function
 **/ const $4bf7ba9bbb4881ae$var$insertAttributes = (transaction, parent, currPos, attributes)=>{
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    const negatedAttributes = new Map();
    // insert format-start items
    for(const key in attributes){
        const val = attributes[key];
        const currentVal = currPos.currentAttributes.get(key) ?? null;
        if (!$4bf7ba9bbb4881ae$var$equalAttrs(currentVal, val)) {
            // save negated attribute (set null if currentVal undefined)
            negatedAttributes.set(key, currentVal);
            const { left: left, right: right } = currPos;
            currPos.right = new $4bf7ba9bbb4881ae$export$6d08773d2e66f8f2($4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(ownClientId, $4bf7ba9bbb4881ae$export$50fdfeece43146fd(doc.store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $4bf7ba9bbb4881ae$export$3194899188fb5a88(key, val));
            currPos.right.integrate(transaction, 0);
            currPos.forward();
        }
    }
    return negatedAttributes;
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {string|object|AbstractType<any>} text
 * @param {Object<string,any>} attributes
 *
 * @private
 * @function
 **/ const $4bf7ba9bbb4881ae$var$insertText = (transaction, parent, currPos, text, attributes)=>{
    currPos.currentAttributes.forEach((_val, key)=>{
        if (attributes[key] === undefined) attributes[key] = null;
    });
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    $4bf7ba9bbb4881ae$var$minimizeAttributeChanges(currPos, attributes);
    const negatedAttributes = $4bf7ba9bbb4881ae$var$insertAttributes(transaction, parent, currPos, attributes);
    // insert content
    const content = text.constructor === String ? new $4bf7ba9bbb4881ae$export$ee670b2cf091bbb6(/** @type {string} */ text) : text instanceof $4bf7ba9bbb4881ae$export$c265dc8338484497 ? new $4bf7ba9bbb4881ae$export$e2e108cbe2e4f865(text) : new $4bf7ba9bbb4881ae$export$c3787ba7f6086664(text);
    let { left: left, right: right, index: index } = currPos;
    if (parent._searchMarker) $4bf7ba9bbb4881ae$var$updateMarkerChanges(parent._searchMarker, currPos.index, content.getLength());
    right = new $4bf7ba9bbb4881ae$export$6d08773d2e66f8f2($4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(ownClientId, $4bf7ba9bbb4881ae$export$50fdfeece43146fd(doc.store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, content);
    right.integrate(transaction, 0);
    currPos.right = right;
    currPos.index = index;
    currPos.forward();
    $4bf7ba9bbb4881ae$var$insertNegatedAttributes(transaction, parent, currPos, negatedAttributes);
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {number} length
 * @param {Object<string,any>} attributes
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$formatText = (transaction, parent, currPos, length, attributes)=>{
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    $4bf7ba9bbb4881ae$var$minimizeAttributeChanges(currPos, attributes);
    const negatedAttributes = $4bf7ba9bbb4881ae$var$insertAttributes(transaction, parent, currPos, attributes);
    // iterate until first non-format or null is found
    // delete all formats with attributes[format.key] != null
    // also check the attributes after the first non-format as we do not want to insert redundant negated attributes there
    // eslint-disable-next-line no-labels
    iterationLoop: while(currPos.right !== null && (length > 0 || negatedAttributes.size > 0 && (currPos.right.deleted || currPos.right.content.constructor === $4bf7ba9bbb4881ae$export$3194899188fb5a88))){
        if (!currPos.right.deleted) switch(currPos.right.content.constructor){
            case $4bf7ba9bbb4881ae$export$3194899188fb5a88:
                {
                    const { key: key, value: value } = /** @type {ContentFormat} */ currPos.right.content;
                    const attr = attributes[key];
                    if (attr !== undefined) {
                        if ($4bf7ba9bbb4881ae$var$equalAttrs(attr, value)) negatedAttributes.delete(key);
                        else {
                            if (length === 0) break iterationLoop;
                            negatedAttributes.set(key, value);
                        }
                        currPos.right.delete(transaction);
                    } else currPos.currentAttributes.set(key, value);
                    break;
                }
            default:
                if (length < currPos.right.length) $4bf7ba9bbb4881ae$var$getItemCleanStart(transaction, $4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(currPos.right.id.client, currPos.right.id.clock + length));
                length -= currPos.right.length;
                break;
        }
        currPos.forward();
    }
    // Quill just assumes that the editor starts with a newline and that it always
    // ends with a newline. We only insert that newline when a new newline is
    // inserted - i.e when length is bigger than type.length
    if (length > 0) {
        let newlines = "";
        for(; length > 0; length--)newlines += "\n";
        currPos.right = new $4bf7ba9bbb4881ae$export$6d08773d2e66f8f2($4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(ownClientId, $4bf7ba9bbb4881ae$export$50fdfeece43146fd(doc.store, ownClientId)), currPos.left, currPos.left && currPos.left.lastId, currPos.right, currPos.right && currPos.right.id, parent, null, new $4bf7ba9bbb4881ae$export$ee670b2cf091bbb6(newlines));
        currPos.right.integrate(transaction, 0);
        currPos.forward();
    }
    $4bf7ba9bbb4881ae$var$insertNegatedAttributes(transaction, parent, currPos, negatedAttributes);
};
/**
 * Call this function after string content has been deleted in order to
 * clean up formatting Items.
 *
 * @param {Transaction} transaction
 * @param {Item} start
 * @param {Item|null} curr exclusive end, automatically iterates to the next Content Item
 * @param {Map<string,any>} startAttributes
 * @param {Map<string,any>} currAttributes
 * @return {number} The amount of formatting Items deleted.
 *
 * @function
 */ const $4bf7ba9bbb4881ae$var$cleanupFormattingGap = (transaction, start, curr, startAttributes, currAttributes)=>{
    /**
   * @type {Item|null}
   */ let end = start;
    /**
   * @type {Map<string,ContentFormat>}
   */ const endFormats = $dh5fq.create();
    while(end && (!end.countable || end.deleted)){
        if (!end.deleted && end.content.constructor === $4bf7ba9bbb4881ae$export$3194899188fb5a88) {
            const cf = /** @type {ContentFormat} */ end.content;
            endFormats.set(cf.key, cf);
        }
        end = end.right;
    }
    let cleanups = 0;
    let reachedCurr = false;
    while(start !== end){
        if (curr === start) reachedCurr = true;
        if (!start.deleted) {
            const content = start.content;
            switch(content.constructor){
                case $4bf7ba9bbb4881ae$export$3194899188fb5a88:
                    {
                        const { key: key, value: value } = /** @type {ContentFormat} */ content;
                        const startAttrValue = startAttributes.get(key) ?? null;
                        if (endFormats.get(key) !== content || startAttrValue === value) {
                            // Either this format is overwritten or it is not necessary because the attribute already existed.
                            start.delete(transaction);
                            cleanups++;
                            if (!reachedCurr && (currAttributes.get(key) ?? null) === value && startAttrValue !== value) {
                                if (startAttrValue === null) currAttributes.delete(key);
                                else currAttributes.set(key, startAttrValue);
                            }
                        }
                        if (!reachedCurr && !start.deleted) $4bf7ba9bbb4881ae$var$updateCurrentAttributes(currAttributes, /** @type {ContentFormat} */ content);
                        break;
                    }
            }
        }
        start = /** @type {Item} */ start.right;
    }
    return cleanups;
};
/**
 * @param {Transaction} transaction
 * @param {Item | null} item
 */ const $4bf7ba9bbb4881ae$var$cleanupContextlessFormattingGap = (transaction, item)=>{
    // iterate until item.right is null or content
    while(item && item.right && (item.right.deleted || !item.right.countable))item = item.right;
    const attrs = new Set();
    // iterate back until a content item is found
    while(item && (item.deleted || !item.countable)){
        if (!item.deleted && item.content.constructor === $4bf7ba9bbb4881ae$export$3194899188fb5a88) {
            const key = /** @type {ContentFormat} */ item.content.key;
            if (attrs.has(key)) item.delete(transaction);
            else attrs.add(key);
        }
        item = item.left;
    }
};
/**
 * This function is experimental and subject to change / be removed.
 *
 * Ideally, we don't need this function at all. Formatting attributes should be cleaned up
 * automatically after each change. This function iterates twice over the complete YText type
 * and removes unnecessary formatting attributes. This is also helpful for testing.
 *
 * This function won't be exported anymore as soon as there is confidence that the YText type works as intended.
 *
 * @param {YText} type
 * @return {number} How many formatting attributes have been cleaned up.
 */ const $4bf7ba9bbb4881ae$export$5d9f53c13ebffb65 = (type)=>{
    let res = 0;
    $4bf7ba9bbb4881ae$export$dac1bad6146b2469(/** @type {Doc} */ type.doc, (transaction)=>{
        let start = /** @type {Item} */ type._start;
        let end = type._start;
        let startAttributes = $dh5fq.create();
        const currentAttributes = $dh5fq.copy(startAttributes);
        while(end){
            if (end.deleted === false) switch(end.content.constructor){
                case $4bf7ba9bbb4881ae$export$3194899188fb5a88:
                    $4bf7ba9bbb4881ae$var$updateCurrentAttributes(currentAttributes, /** @type {ContentFormat} */ end.content);
                    break;
                default:
                    res += $4bf7ba9bbb4881ae$var$cleanupFormattingGap(transaction, start, end, startAttributes, currentAttributes);
                    startAttributes = $dh5fq.copy(currentAttributes);
                    start = end;
                    break;
            }
            end = end.right;
        }
    });
    return res;
};
/**
 * This will be called by the transction once the event handlers are called to potentially cleanup
 * formatting attributes.
 *
 * @param {Transaction} transaction
 */ const $4bf7ba9bbb4881ae$var$cleanupYTextAfterTransaction = (transaction)=>{
    /**
   * @type {Set<YText>}
   */ const needFullCleanup = new Set();
    // check if another formatting item was inserted
    const doc = transaction.doc;
    for (const [client, afterClock] of transaction.afterState.entries()){
        const clock = transaction.beforeState.get(client) || 0;
        if (afterClock === clock) continue;
        $4bf7ba9bbb4881ae$var$iterateStructs(transaction, /** @type {Array<Item|GC>} */ doc.store.clients.get(client), clock, afterClock, (item)=>{
            if (!item.deleted && /** @type {Item} */ item.content.constructor === $4bf7ba9bbb4881ae$export$3194899188fb5a88 && item.constructor !== $4bf7ba9bbb4881ae$export$12d259ff017e6b58) needFullCleanup.add(/** @type {any} */ item.parent);
        });
    }
    // cleanup in a new transaction
    $4bf7ba9bbb4881ae$export$dac1bad6146b2469(doc, (t)=>{
        $4bf7ba9bbb4881ae$export$8afefebbaf4e4c78(transaction, transaction.deleteSet, (item)=>{
            if (item instanceof $4bf7ba9bbb4881ae$export$12d259ff017e6b58 || !/** @type {YText} */ item.parent._hasFormatting || needFullCleanup.has(/** @type {YText} */ item.parent)) return;
            const parent = /** @type {YText} */ item.parent;
            if (item.content.constructor === $4bf7ba9bbb4881ae$export$3194899188fb5a88) needFullCleanup.add(parent);
            else // If no formatting attribute was inserted or deleted, we can make due with contextless
            // formatting cleanups.
            // Contextless: it is not necessary to compute currentAttributes for the affected position.
            $4bf7ba9bbb4881ae$var$cleanupContextlessFormattingGap(t, item);
        });
        // If a formatting item was inserted, we simply clean the whole type.
        // We need to compute currentAttributes for the current position anyway.
        for (const yText of needFullCleanup)$4bf7ba9bbb4881ae$export$5d9f53c13ebffb65(yText);
    });
};
/**
 * @param {Transaction} transaction
 * @param {ItemTextListPosition} currPos
 * @param {number} length
 * @return {ItemTextListPosition}
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$deleteText = (transaction, currPos, length)=>{
    const startLength = length;
    const startAttrs = $dh5fq.copy(currPos.currentAttributes);
    const start = currPos.right;
    while(length > 0 && currPos.right !== null){
        if (currPos.right.deleted === false) switch(currPos.right.content.constructor){
            case $4bf7ba9bbb4881ae$export$e2e108cbe2e4f865:
            case $4bf7ba9bbb4881ae$export$c3787ba7f6086664:
            case $4bf7ba9bbb4881ae$export$ee670b2cf091bbb6:
                if (length < currPos.right.length) $4bf7ba9bbb4881ae$var$getItemCleanStart(transaction, $4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(currPos.right.id.client, currPos.right.id.clock + length));
                length -= currPos.right.length;
                currPos.right.delete(transaction);
                break;
        }
        currPos.forward();
    }
    if (start) $4bf7ba9bbb4881ae$var$cleanupFormattingGap(transaction, start, currPos.right, startAttrs, currPos.currentAttributes);
    const parent = /** @type {AbstractType<any>} */ /** @type {Item} */ (currPos.left || currPos.right).parent;
    if (parent._searchMarker) $4bf7ba9bbb4881ae$var$updateMarkerChanges(parent._searchMarker, currPos.index, -startLength + length);
    return currPos;
};
/**
 * The Quill Delta format represents changes on a text document with
 * formatting information. For mor information visit {@link https://quilljs.com/docs/delta/|Quill Delta}
 *
 * @example
 *   {
 *     ops: [
 *       { insert: 'Gandalf', attributes: { bold: true } },
 *       { insert: ' the ' },
 *       { insert: 'Grey', attributes: { color: '#cccccc' } }
 *     ]
 *   }
 *
 */ /**
  * Attributes that can be assigned to a selection of text.
  *
  * @example
  *   {
  *     bold: true,
  *     font-size: '40px'
  *   }
  *
  * @typedef {Object} TextAttributes
  */ /**
 * @extends YEvent<YText>
 * Event that describes the changes on a YText type.
 */ class $4bf7ba9bbb4881ae$export$51155b8ebb74188a extends $4bf7ba9bbb4881ae$export$80fac438977fb51c {
    /**
   * @param {YText} ytext
   * @param {Transaction} transaction
   * @param {Set<any>} subs The keys that changed
   */ constructor(ytext, transaction, subs){
        super(ytext, transaction);
        /**
     * Whether the children changed.
     * @type {Boolean}
     * @private
     */ this.childListChanged = false;
        /**
     * Set of all changed attributes.
     * @type {Set<string>}
     */ this.keysChanged = new Set();
        subs.forEach((sub)=>{
            if (sub === null) this.childListChanged = true;
            else this.keysChanged.add(sub);
        });
    }
    /**
   * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string, delete?:number, retain?:number}>}}
   */ get changes() {
        if (this._changes === null) {
            /**
       * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string|AbstractType<any>|object, delete?:number, retain?:number}>}}
       */ const changes = {
                keys: this.keys,
                delta: this.delta,
                added: new Set(),
                deleted: new Set()
            };
            this._changes = changes;
        }
        return /** @type {any} */ this._changes;
    }
    /**
   * Compute the changes in the delta format.
   * A {@link https://quilljs.com/docs/delta/|Quill Delta}) that represents the changes on the document.
   *
   * @type {Array<{insert?:string|object|AbstractType<any>, delete?:number, retain?:number, attributes?: Object<string,any>}>}
   *
   * @public
   */ get delta() {
        if (this._delta === null) {
            const y = /** @type {Doc} */ this.target.doc;
            /**
       * @type {Array<{insert?:string|object|AbstractType<any>, delete?:number, retain?:number, attributes?: Object<string,any>}>}
       */ const delta = [];
            $4bf7ba9bbb4881ae$export$dac1bad6146b2469(y, (transaction)=>{
                const currentAttributes = new Map(); // saves all current attributes for insert
                const oldAttributes = new Map();
                let item = this.target._start;
                /**
         * @type {string?}
         */ let action = null;
                /**
         * @type {Object<string,any>}
         */ const attributes = {}; // counts added or removed new attributes for retain
                /**
         * @type {string|object}
         */ let insert = "";
                let retain = 0;
                let deleteLen = 0;
                const addOp = ()=>{
                    if (action !== null) {
                        /**
             * @type {any}
             */ let op = null;
                        switch(action){
                            case "delete":
                                if (deleteLen > 0) op = {
                                    delete: deleteLen
                                };
                                deleteLen = 0;
                                break;
                            case "insert":
                                if (typeof insert === "object" || insert.length > 0) {
                                    op = {
                                        insert: insert
                                    };
                                    if (currentAttributes.size > 0) {
                                        op.attributes = {};
                                        currentAttributes.forEach((value, key)=>{
                                            if (value !== null) op.attributes[key] = value;
                                        });
                                    }
                                }
                                insert = "";
                                break;
                            case "retain":
                                if (retain > 0) {
                                    op = {
                                        retain: retain
                                    };
                                    if (!$kLkle.isEmpty(attributes)) op.attributes = $kLkle.assign({}, attributes);
                                }
                                retain = 0;
                                break;
                        }
                        if (op) delta.push(op);
                        action = null;
                    }
                };
                while(item !== null){
                    switch(item.content.constructor){
                        case $4bf7ba9bbb4881ae$export$e2e108cbe2e4f865:
                        case $4bf7ba9bbb4881ae$export$c3787ba7f6086664:
                            if (this.adds(item)) {
                                if (!this.deletes(item)) {
                                    addOp();
                                    action = "insert";
                                    insert = item.content.getContent()[0];
                                    addOp();
                                }
                            } else if (this.deletes(item)) {
                                if (action !== "delete") {
                                    addOp();
                                    action = "delete";
                                }
                                deleteLen += 1;
                            } else if (!item.deleted) {
                                if (action !== "retain") {
                                    addOp();
                                    action = "retain";
                                }
                                retain += 1;
                            }
                            break;
                        case $4bf7ba9bbb4881ae$export$ee670b2cf091bbb6:
                            if (this.adds(item)) {
                                if (!this.deletes(item)) {
                                    if (action !== "insert") {
                                        addOp();
                                        action = "insert";
                                    }
                                    insert += /** @type {ContentString} */ item.content.str;
                                }
                            } else if (this.deletes(item)) {
                                if (action !== "delete") {
                                    addOp();
                                    action = "delete";
                                }
                                deleteLen += item.length;
                            } else if (!item.deleted) {
                                if (action !== "retain") {
                                    addOp();
                                    action = "retain";
                                }
                                retain += item.length;
                            }
                            break;
                        case $4bf7ba9bbb4881ae$export$3194899188fb5a88:
                            {
                                const { key: key, value: value } = /** @type {ContentFormat} */ item.content;
                                if (this.adds(item)) {
                                    if (!this.deletes(item)) {
                                        const curVal = currentAttributes.get(key) ?? null;
                                        if (!$4bf7ba9bbb4881ae$var$equalAttrs(curVal, value)) {
                                            if (action === "retain") addOp();
                                            if ($4bf7ba9bbb4881ae$var$equalAttrs(value, oldAttributes.get(key) ?? null)) delete attributes[key];
                                            else attributes[key] = value;
                                        } else if (value !== null) item.delete(transaction);
                                    }
                                } else if (this.deletes(item)) {
                                    oldAttributes.set(key, value);
                                    const curVal = currentAttributes.get(key) ?? null;
                                    if (!$4bf7ba9bbb4881ae$var$equalAttrs(curVal, value)) {
                                        if (action === "retain") addOp();
                                        attributes[key] = curVal;
                                    }
                                } else if (!item.deleted) {
                                    oldAttributes.set(key, value);
                                    const attr = attributes[key];
                                    if (attr !== undefined) {
                                        if (!$4bf7ba9bbb4881ae$var$equalAttrs(attr, value)) {
                                            if (action === "retain") addOp();
                                            if (value === null) delete attributes[key];
                                            else attributes[key] = value;
                                        } else if (attr !== null) item.delete(transaction);
                                    }
                                }
                                if (!item.deleted) {
                                    if (action === "insert") addOp();
                                    $4bf7ba9bbb4881ae$var$updateCurrentAttributes(currentAttributes, /** @type {ContentFormat} */ item.content);
                                }
                                break;
                            }
                    }
                    item = item.right;
                }
                addOp();
                while(delta.length > 0){
                    const lastOp = delta[delta.length - 1];
                    if (lastOp.retain !== undefined && lastOp.attributes === undefined) // retain delta's if they don't assign attributes
                    delta.pop();
                    else break;
                }
            });
            this._delta = delta;
        }
        return /** @type {any} */ this._delta;
    }
}
/**
 * Type that represents text with formatting information.
 *
 * This type replaces y-richtext as this implementation is able to handle
 * block formats (format information on a paragraph), embeds (complex elements
 * like pictures and videos), and text formats (**bold**, *italic*).
 *
 * @extends AbstractType<YTextEvent>
 */ class $4bf7ba9bbb4881ae$export$5f1af8db9871e1d6 extends $4bf7ba9bbb4881ae$export$c265dc8338484497 {
    /**
   * @param {String} [string] The initial value of the YText.
   */ constructor(string){
        super();
        /**
     * Array of pending operations on this type
     * @type {Array<function():void>?}
     */ this._pending = string !== undefined ? [
            ()=>this.insert(0, string)
        ] : [];
        /**
     * @type {Array<ArraySearchMarker>|null}
     */ this._searchMarker = [];
        /**
     * Whether this YText contains formatting attributes.
     * This flag is updated when a formatting item is integrated (see ContentFormat.integrate)
     */ this._hasFormatting = false;
    }
    /**
   * Number of characters of this text type.
   *
   * @type {number}
   */ get length() {
        return this._length;
    }
    /**
   * @param {Doc} y
   * @param {Item} item
   */ _integrate(y, item) {
        super._integrate(y, item);
        try {
            /** @type {Array<function>} */ this._pending.forEach((f)=>f());
        } catch (e) {
            console.error(e);
        }
        this._pending = null;
    }
    _copy() {
        return new $4bf7ba9bbb4881ae$export$5f1af8db9871e1d6();
    }
    /**
   * @return {YText}
   */ clone() {
        const text = new $4bf7ba9bbb4881ae$export$5f1af8db9871e1d6();
        text.applyDelta(this.toDelta());
        return text;
    }
    /**
   * Creates YTextEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */ _callObserver(transaction, parentSubs) {
        super._callObserver(transaction, parentSubs);
        const event = new $4bf7ba9bbb4881ae$export$51155b8ebb74188a(this, transaction, parentSubs);
        $4bf7ba9bbb4881ae$var$callTypeObservers(this, transaction, event);
        // If a remote change happened, we try to cleanup potential formatting duplicates.
        if (!transaction.local && this._hasFormatting) transaction._needFormattingCleanup = true;
    }
    /**
   * Returns the unformatted string representation of this YText type.
   *
   * @public
   */ toString() {
        let str = "";
        /**
     * @type {Item|null}
     */ let n = this._start;
        while(n !== null){
            if (!n.deleted && n.countable && n.content.constructor === $4bf7ba9bbb4881ae$export$ee670b2cf091bbb6) str += /** @type {ContentString} */ n.content.str;
            n = n.right;
        }
        return str;
    }
    /**
   * Returns the unformatted string representation of this YText type.
   *
   * @return {string}
   * @public
   */ toJSON() {
        return this.toString();
    }
    /**
   * Apply a {@link Delta} on this shared YText type.
   *
   * @param {any} delta The changes to apply on this element.
   * @param {object}  opts
   * @param {boolean} [opts.sanitize] Sanitize input delta. Removes ending newlines if set to true.
   *
   *
   * @public
   */ applyDelta(delta, { sanitize: sanitize = true } = {}) {
        if (this.doc !== null) $4bf7ba9bbb4881ae$export$dac1bad6146b2469(this.doc, (transaction)=>{
            const currPos = new $4bf7ba9bbb4881ae$var$ItemTextListPosition(null, this._start, 0, new Map());
            for(let i = 0; i < delta.length; i++){
                const op = delta[i];
                if (op.insert !== undefined) {
                    // Quill assumes that the content starts with an empty paragraph.
                    // Yjs/Y.Text assumes that it starts empty. We always hide that
                    // there is a newline at the end of the content.
                    // If we omit this step, clients will see a different number of
                    // paragraphs, but nothing bad will happen.
                    const ins = !sanitize && typeof op.insert === "string" && i === delta.length - 1 && currPos.right === null && op.insert.slice(-1) === "\n" ? op.insert.slice(0, -1) : op.insert;
                    if (typeof ins !== "string" || ins.length > 0) $4bf7ba9bbb4881ae$var$insertText(transaction, this, currPos, ins, op.attributes || {});
                } else if (op.retain !== undefined) $4bf7ba9bbb4881ae$var$formatText(transaction, this, currPos, op.retain, op.attributes || {});
                else if (op.delete !== undefined) $4bf7ba9bbb4881ae$var$deleteText(transaction, currPos, op.delete);
            }
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.applyDelta(delta));
    }
    /**
   * Returns the Delta representation of this YText type.
   *
   * @param {Snapshot} [snapshot]
   * @param {Snapshot} [prevSnapshot]
   * @param {function('removed' | 'added', ID):any} [computeYChange]
   * @return {any} The Delta representation of this type.
   *
   * @public
   */ toDelta(snapshot, prevSnapshot, computeYChange) {
        /**
     * @type{Array<any>}
     */ const ops = [];
        const currentAttributes = new Map();
        const doc = /** @type {Doc} */ this.doc;
        let str = "";
        let n = this._start;
        function packStr() {
            if (str.length > 0) {
                // pack str with attributes to ops
                /**
         * @type {Object<string,any>}
         */ const attributes = {};
                let addAttributes = false;
                currentAttributes.forEach((value, key)=>{
                    addAttributes = true;
                    attributes[key] = value;
                });
                /**
         * @type {Object<string,any>}
         */ const op = {
                    insert: str
                };
                if (addAttributes) op.attributes = attributes;
                ops.push(op);
                str = "";
            }
        }
        const computeDelta = ()=>{
            while(n !== null){
                if ($4bf7ba9bbb4881ae$var$isVisible(n, snapshot) || prevSnapshot !== undefined && $4bf7ba9bbb4881ae$var$isVisible(n, prevSnapshot)) switch(n.content.constructor){
                    case $4bf7ba9bbb4881ae$export$ee670b2cf091bbb6:
                        {
                            const cur = currentAttributes.get("ychange");
                            if (snapshot !== undefined && !$4bf7ba9bbb4881ae$var$isVisible(n, snapshot)) {
                                if (cur === undefined || cur.user !== n.id.client || cur.type !== "removed") {
                                    packStr();
                                    currentAttributes.set("ychange", computeYChange ? computeYChange("removed", n.id) : {
                                        type: "removed"
                                    });
                                }
                            } else if (prevSnapshot !== undefined && !$4bf7ba9bbb4881ae$var$isVisible(n, prevSnapshot)) {
                                if (cur === undefined || cur.user !== n.id.client || cur.type !== "added") {
                                    packStr();
                                    currentAttributes.set("ychange", computeYChange ? computeYChange("added", n.id) : {
                                        type: "added"
                                    });
                                }
                            } else if (cur !== undefined) {
                                packStr();
                                currentAttributes.delete("ychange");
                            }
                            str += /** @type {ContentString} */ n.content.str;
                            break;
                        }
                    case $4bf7ba9bbb4881ae$export$e2e108cbe2e4f865:
                    case $4bf7ba9bbb4881ae$export$c3787ba7f6086664:
                        {
                            packStr();
                            /**
               * @type {Object<string,any>}
               */ const op = {
                                insert: n.content.getContent()[0]
                            };
                            if (currentAttributes.size > 0) {
                                const attrs = /** @type {Object<string,any>} */ {};
                                op.attributes = attrs;
                                currentAttributes.forEach((value, key)=>{
                                    attrs[key] = value;
                                });
                            }
                            ops.push(op);
                            break;
                        }
                    case $4bf7ba9bbb4881ae$export$3194899188fb5a88:
                        if ($4bf7ba9bbb4881ae$var$isVisible(n, snapshot)) {
                            packStr();
                            $4bf7ba9bbb4881ae$var$updateCurrentAttributes(currentAttributes, /** @type {ContentFormat} */ n.content);
                        }
                        break;
                }
                n = n.right;
            }
            packStr();
        };
        if (snapshot || prevSnapshot) // snapshots are merged again after the transaction, so we need to keep the
        // transaction alive until we are done
        $4bf7ba9bbb4881ae$export$dac1bad6146b2469(doc, (transaction)=>{
            if (snapshot) $4bf7ba9bbb4881ae$var$splitSnapshotAffectedStructs(transaction, snapshot);
            if (prevSnapshot) $4bf7ba9bbb4881ae$var$splitSnapshotAffectedStructs(transaction, prevSnapshot);
            computeDelta();
        }, "cleanup");
        else computeDelta();
        return ops;
    }
    /**
   * Insert text at a given index.
   *
   * @param {number} index The index at which to start inserting.
   * @param {String} text The text to insert at the specified position.
   * @param {TextAttributes} [attributes] Optionally define some formatting
   *                                    information to apply on the inserted
   *                                    Text.
   * @public
   */ insert(index, text, attributes) {
        if (text.length <= 0) return;
        const y = this.doc;
        if (y !== null) $4bf7ba9bbb4881ae$export$dac1bad6146b2469(y, (transaction)=>{
            const pos = $4bf7ba9bbb4881ae$var$findPosition(transaction, this, index, !attributes);
            if (!attributes) {
                attributes = {};
                // @ts-ignore
                pos.currentAttributes.forEach((v, k)=>{
                    attributes[k] = v;
                });
            }
            $4bf7ba9bbb4881ae$var$insertText(transaction, this, pos, text, attributes);
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.insert(index, text, attributes));
    }
    /**
   * Inserts an embed at a index.
   *
   * @param {number} index The index to insert the embed at.
   * @param {Object | AbstractType<any>} embed The Object that represents the embed.
   * @param {TextAttributes} [attributes] Attribute information to apply on the
   *                                    embed
   *
   * @public
   */ insertEmbed(index, embed, attributes) {
        const y = this.doc;
        if (y !== null) $4bf7ba9bbb4881ae$export$dac1bad6146b2469(y, (transaction)=>{
            const pos = $4bf7ba9bbb4881ae$var$findPosition(transaction, this, index, !attributes);
            $4bf7ba9bbb4881ae$var$insertText(transaction, this, pos, embed, attributes || {});
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.insertEmbed(index, embed, attributes || {}));
    }
    /**
   * Deletes text starting from an index.
   *
   * @param {number} index Index at which to start deleting.
   * @param {number} length The number of characters to remove. Defaults to 1.
   *
   * @public
   */ delete(index, length) {
        if (length === 0) return;
        const y = this.doc;
        if (y !== null) $4bf7ba9bbb4881ae$export$dac1bad6146b2469(y, (transaction)=>{
            $4bf7ba9bbb4881ae$var$deleteText(transaction, $4bf7ba9bbb4881ae$var$findPosition(transaction, this, index, true), length);
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.delete(index, length));
    }
    /**
   * Assigns properties to a range of text.
   *
   * @param {number} index The position where to start formatting.
   * @param {number} length The amount of characters to assign properties to.
   * @param {TextAttributes} attributes Attribute information to apply on the
   *                                    text.
   *
   * @public
   */ format(index, length, attributes) {
        if (length === 0) return;
        const y = this.doc;
        if (y !== null) $4bf7ba9bbb4881ae$export$dac1bad6146b2469(y, (transaction)=>{
            const pos = $4bf7ba9bbb4881ae$var$findPosition(transaction, this, index, false);
            if (pos.right === null) return;
            $4bf7ba9bbb4881ae$var$formatText(transaction, this, pos, length, attributes);
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.format(index, length, attributes));
    }
    /**
   * Removes an attribute.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that is to be removed.
   *
   * @public
   */ removeAttribute(attributeName) {
        if (this.doc !== null) $4bf7ba9bbb4881ae$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $4bf7ba9bbb4881ae$var$typeMapDelete(transaction, this, attributeName);
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.removeAttribute(attributeName));
    }
    /**
   * Sets or updates an attribute.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that is to be set.
   * @param {any} attributeValue The attribute value that is to be set.
   *
   * @public
   */ setAttribute(attributeName, attributeValue) {
        if (this.doc !== null) $4bf7ba9bbb4881ae$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $4bf7ba9bbb4881ae$var$typeMapSet(transaction, this, attributeName, attributeValue);
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.setAttribute(attributeName, attributeValue));
    }
    /**
   * Returns an attribute value that belongs to the attribute name.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that identifies the
   *                               queried value.
   * @return {any} The queried attribute value.
   *
   * @public
   */ getAttribute(attributeName) {
        return /** @type {any} */ $4bf7ba9bbb4881ae$var$typeMapGet(this, attributeName);
    }
    /**
   * Returns all attribute name/value pairs in a JSON Object.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @return {Object<string, any>} A JSON Object that describes the attributes.
   *
   * @public
   */ getAttributes() {
        return $4bf7ba9bbb4881ae$var$typeMapGetAll(this);
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ _write(encoder) {
        encoder.writeTypeRef($4bf7ba9bbb4881ae$var$YTextRefID);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} _decoder
 * @return {YText}
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$readYText = (_decoder)=>new $4bf7ba9bbb4881ae$export$5f1af8db9871e1d6();
/**
 * @module YXml
 */ /**
 * Define the elements to which a set of CSS queries apply.
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Selectors|CSS_Selectors}
 *
 * @example
 *   query = '.classSelector'
 *   query = 'nodeSelector'
 *   query = '#idSelector'
 *
 * @typedef {string} CSS_Selector
 */ /**
 * Dom filter function.
 *
 * @callback domFilter
 * @param {string} nodeName The nodeName of the element
 * @param {Map} attributes The map of attributes.
 * @return {boolean} Whether to include the Dom node in the YXmlElement.
 */ /**
 * Represents a subset of the nodes of a YXmlElement / YXmlFragment and a
 * position within them.
 *
 * Can be created with {@link YXmlFragment#createTreeWalker}
 *
 * @public
 * @implements {Iterable<YXmlElement|YXmlText|YXmlElement|YXmlHook>}
 */ class $4bf7ba9bbb4881ae$var$YXmlTreeWalker {
    /**
   * @param {YXmlFragment | YXmlElement} root
   * @param {function(AbstractType<any>):boolean} [f]
   */ constructor(root, f = ()=>true){
        this._filter = f;
        this._root = root;
        /**
     * @type {Item}
     */ this._currentNode = /** @type {Item} */ root._start;
        this._firstCall = true;
    }
    [Symbol.iterator]() {
        return this;
    }
    /**
   * Get the next node.
   *
   * @return {IteratorResult<YXmlElement|YXmlText|YXmlHook>} The next node.
   *
   * @public
   */ next() {
        /**
     * @type {Item|null}
     */ let n = this._currentNode;
        let type = n && n.content && /** @type {any} */ n.content.type;
        if (n !== null && (!this._firstCall || n.deleted || !this._filter(type))) do {
            type = /** @type {any} */ n.content.type;
            if (!n.deleted && (type.constructor === $4bf7ba9bbb4881ae$export$4db87581d3ca170d || type.constructor === $4bf7ba9bbb4881ae$export$d5ce8c3e1731f1a7) && type._start !== null) // walk down in the tree
            n = type._start;
            else // walk right or up in the tree
            while(n !== null){
                if (n.right !== null) {
                    n = n.right;
                    break;
                } else if (n.parent === this._root) n = null;
                else n = /** @type {AbstractType<any>} */ n.parent._item;
            }
        }while (n !== null && (n.deleted || !this._filter(/** @type {ContentType} */ n.content.type)));
        this._firstCall = false;
        if (n === null) // @ts-ignore
        return {
            value: undefined,
            done: true
        };
        this._currentNode = n;
        return {
            value: /** @type {any} */ n.content.type,
            done: false
        };
    }
}
/**
 * Represents a list of {@link YXmlElement}.and {@link YXmlText} types.
 * A YxmlFragment is similar to a {@link YXmlElement}, but it does not have a
 * nodeName and it does not have attributes. Though it can be bound to a DOM
 * element - in this case the attributes and the nodeName are not shared.
 *
 * @public
 * @extends AbstractType<YXmlEvent>
 */ class $4bf7ba9bbb4881ae$export$d5ce8c3e1731f1a7 extends $4bf7ba9bbb4881ae$export$c265dc8338484497 {
    constructor(){
        super();
        /**
     * @type {Array<any>|null}
     */ this._prelimContent = [];
    }
    /**
   * @type {YXmlElement|YXmlText|null}
   */ get firstChild() {
        const first = this._first;
        return first ? first.content.getContent()[0] : null;
    }
    /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */ _integrate(y, item) {
        super._integrate(y, item);
        this.insert(0, /** @type {Array<any>} */ this._prelimContent);
        this._prelimContent = null;
    }
    _copy() {
        return new $4bf7ba9bbb4881ae$export$d5ce8c3e1731f1a7();
    }
    /**
   * @return {YXmlFragment}
   */ clone() {
        const el = new $4bf7ba9bbb4881ae$export$d5ce8c3e1731f1a7();
        // @ts-ignore
        el.insert(0, this.toArray().map((item)=>item instanceof $4bf7ba9bbb4881ae$export$c265dc8338484497 ? item.clone() : item));
        return el;
    }
    get length() {
        return this._prelimContent === null ? this._length : this._prelimContent.length;
    }
    /**
   * Create a subtree of childNodes.
   *
   * @example
   * const walker = elem.createTreeWalker(dom => dom.nodeName === 'div')
   * for (let node in walker) {
   *   // `node` is a div node
   *   nop(node)
   * }
   *
   * @param {function(AbstractType<any>):boolean} filter Function that is called on each child element and
   *                          returns a Boolean indicating whether the child
   *                          is to be included in the subtree.
   * @return {YXmlTreeWalker} A subtree and a position within it.
   *
   * @public
   */ createTreeWalker(filter) {
        return new $4bf7ba9bbb4881ae$var$YXmlTreeWalker(this, filter);
    }
    /**
   * Returns the first YXmlElement that matches the query.
   * Similar to DOM's {@link querySelector}.
   *
   * Query support:
   *   - tagname
   * TODO:
   *   - id
   *   - attribute
   *
   * @param {CSS_Selector} query The query on the children.
   * @return {YXmlElement|YXmlText|YXmlHook|null} The first element that matches the query or null.
   *
   * @public
   */ querySelector(query) {
        query = query.toUpperCase();
        // @ts-ignore
        const iterator = new $4bf7ba9bbb4881ae$var$YXmlTreeWalker(this, (element)=>element.nodeName && element.nodeName.toUpperCase() === query);
        const next = iterator.next();
        if (next.done) return null;
        else return next.value;
    }
    /**
   * Returns all YXmlElements that match the query.
   * Similar to Dom's {@link querySelectorAll}.
   *
   * @todo Does not yet support all queries. Currently only query by tagName.
   *
   * @param {CSS_Selector} query The query on the children
   * @return {Array<YXmlElement|YXmlText|YXmlHook|null>} The elements that match this query.
   *
   * @public
   */ querySelectorAll(query) {
        query = query.toUpperCase();
        // @ts-ignore
        return $iiUWJ.from(new $4bf7ba9bbb4881ae$var$YXmlTreeWalker(this, (element)=>element.nodeName && element.nodeName.toUpperCase() === query));
    }
    /**
   * Creates YXmlEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */ _callObserver(transaction, parentSubs) {
        $4bf7ba9bbb4881ae$var$callTypeObservers(this, transaction, new $4bf7ba9bbb4881ae$export$88c9145a0c3b556c(this, parentSubs, transaction));
    }
    /**
   * Get the string representation of all the children of this YXmlFragment.
   *
   * @return {string} The string representation of all children.
   */ toString() {
        return $4bf7ba9bbb4881ae$var$typeListMap(this, (xml)=>xml.toString()).join("");
    }
    /**
   * @return {string}
   */ toJSON() {
        return this.toString();
    }
    /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks={}] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Node} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */ toDOM(_document = document, hooks = {}, binding) {
        const fragment = _document.createDocumentFragment();
        if (binding !== undefined) binding._createAssociation(fragment, this);
        $4bf7ba9bbb4881ae$var$typeListForEach(this, (xmlType)=>{
            fragment.insertBefore(xmlType.toDOM(_document, hooks, binding), null);
        });
        return fragment;
    }
    /**
   * Inserts new content at an index.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  xml.insert(0, [new Y.XmlText('text')])
   *
   * @param {number} index The index to insert content at
   * @param {Array<YXmlElement|YXmlText>} content The array of content
   */ insert(index, content) {
        if (this.doc !== null) $4bf7ba9bbb4881ae$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $4bf7ba9bbb4881ae$var$typeListInsertGenerics(transaction, this, index, content);
        });
        else // @ts-ignore _prelimContent is defined because this is not yet integrated
        this._prelimContent.splice(index, 0, ...content);
    }
    /**
   * Inserts new content at an index.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  xml.insert(0, [new Y.XmlText('text')])
   *
   * @param {null|Item|YXmlElement|YXmlText} ref The index to insert content at
   * @param {Array<YXmlElement|YXmlText>} content The array of content
   */ insertAfter(ref, content) {
        if (this.doc !== null) $4bf7ba9bbb4881ae$export$dac1bad6146b2469(this.doc, (transaction)=>{
            const refItem = ref && ref instanceof $4bf7ba9bbb4881ae$export$c265dc8338484497 ? ref._item : ref;
            $4bf7ba9bbb4881ae$var$typeListInsertGenericsAfter(transaction, this, refItem, content);
        });
        else {
            const pc = /** @type {Array<any>} */ this._prelimContent;
            const index = ref === null ? 0 : pc.findIndex((el)=>el === ref) + 1;
            if (index === 0 && ref !== null) throw $iVMsw.create("Reference item not found");
            pc.splice(index, 0, ...content);
        }
    }
    /**
   * Deletes elements starting from an index.
   *
   * @param {number} index Index at which to start deleting elements
   * @param {number} [length=1] The number of elements to remove. Defaults to 1.
   */ delete(index, length = 1) {
        if (this.doc !== null) $4bf7ba9bbb4881ae$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $4bf7ba9bbb4881ae$var$typeListDelete(transaction, this, index, length);
        });
        else // @ts-ignore _prelimContent is defined because this is not yet integrated
        this._prelimContent.splice(index, length);
    }
    /**
   * Transforms this YArray to a JavaScript Array.
   *
   * @return {Array<YXmlElement|YXmlText|YXmlHook>}
   */ toArray() {
        return $4bf7ba9bbb4881ae$var$typeListToArray(this);
    }
    /**
   * Appends content to this YArray.
   *
   * @param {Array<YXmlElement|YXmlText>} content Array of content to append.
   */ push(content) {
        this.insert(this.length, content);
    }
    /**
   * Preppends content to this YArray.
   *
   * @param {Array<YXmlElement|YXmlText>} content Array of content to preppend.
   */ unshift(content) {
        this.insert(0, content);
    }
    /**
   * Returns the i-th element from a YArray.
   *
   * @param {number} index The index of the element to return from the YArray
   * @return {YXmlElement|YXmlText}
   */ get(index) {
        return $4bf7ba9bbb4881ae$var$typeListGet(this, index);
    }
    /**
   * Transforms this YArray to a JavaScript Array.
   *
   * @param {number} [start]
   * @param {number} [end]
   * @return {Array<YXmlElement|YXmlText>}
   */ slice(start = 0, end = this.length) {
        return $4bf7ba9bbb4881ae$var$typeListSlice(this, start, end);
    }
    /**
   * Executes a provided function on once on overy child element.
   *
   * @param {function(YXmlElement|YXmlText,number, typeof self):void} f A function to execute on every element of this YArray.
   */ forEach(f) {
        $4bf7ba9bbb4881ae$var$typeListForEach(this, f);
    }
    /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */ _write(encoder) {
        encoder.writeTypeRef($4bf7ba9bbb4881ae$var$YXmlFragmentRefID);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} _decoder
 * @return {YXmlFragment}
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$readYXmlFragment = (_decoder)=>new $4bf7ba9bbb4881ae$export$d5ce8c3e1731f1a7();
/**
 * @typedef {Object|number|null|Array<any>|string|Uint8Array|AbstractType<any>} ValueTypes
 */ /**
 * An YXmlElement imitates the behavior of a
 * https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element
 *
 * * An YXmlElement has attributes (key value pairs)
 * * An YXmlElement has childElements that must inherit from YXmlElement
 *
 * @template {{ [key: string]: ValueTypes }} [KV={ [key: string]: string }]
 */ class $4bf7ba9bbb4881ae$export$4db87581d3ca170d extends $4bf7ba9bbb4881ae$export$d5ce8c3e1731f1a7 {
    constructor(nodeName = "UNDEFINED"){
        super();
        this.nodeName = nodeName;
        /**
     * @type {Map<string, any>|null}
     */ this._prelimAttrs = new Map();
    }
    /**
   * @type {YXmlElement|YXmlText|null}
   */ get nextSibling() {
        const n = this._item ? this._item.next : null;
        return n ? /** @type {YXmlElement|YXmlText} */ /** @type {ContentType} */ n.content.type : null;
    }
    /**
   * @type {YXmlElement|YXmlText|null}
   */ get prevSibling() {
        const n = this._item ? this._item.prev : null;
        return n ? /** @type {YXmlElement|YXmlText} */ /** @type {ContentType} */ n.content.type : null;
    }
    /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */ _integrate(y, item) {
        super._integrate(y, item);
        /** @type {Map<string, any>} */ this._prelimAttrs.forEach((value, key)=>{
            this.setAttribute(key, value);
        });
        this._prelimAttrs = null;
    }
    /**
   * Creates an Item with the same effect as this Item (without position effect)
   *
   * @return {YXmlElement}
   */ _copy() {
        return new $4bf7ba9bbb4881ae$export$4db87581d3ca170d(this.nodeName);
    }
    /**
   * @return {YXmlElement<KV>}
   */ clone() {
        /**
     * @type {YXmlElement<KV>}
     */ const el = new $4bf7ba9bbb4881ae$export$4db87581d3ca170d(this.nodeName);
        const attrs = this.getAttributes();
        $kLkle.forEach(attrs, (value, key)=>{
            if (typeof value === "string") el.setAttribute(key, value);
        });
        // @ts-ignore
        el.insert(0, this.toArray().map((item)=>item instanceof $4bf7ba9bbb4881ae$export$c265dc8338484497 ? item.clone() : item));
        return el;
    }
    /**
   * Returns the XML serialization of this YXmlElement.
   * The attributes are ordered by attribute-name, so you can easily use this
   * method to compare YXmlElements
   *
   * @return {string} The string representation of this type.
   *
   * @public
   */ toString() {
        const attrs = this.getAttributes();
        const stringBuilder = [];
        const keys = [];
        for(const key in attrs)keys.push(key);
        keys.sort();
        const keysLen = keys.length;
        for(let i = 0; i < keysLen; i++){
            const key = keys[i];
            stringBuilder.push(key + '="' + attrs[key] + '"');
        }
        const nodeName = this.nodeName.toLocaleLowerCase();
        const attrsString = stringBuilder.length > 0 ? " " + stringBuilder.join(" ") : "";
        return `<${nodeName}${attrsString}>${super.toString()}</${nodeName}>`;
    }
    /**
   * Removes an attribute from this YXmlElement.
   *
   * @param {string} attributeName The attribute name that is to be removed.
   *
   * @public
   */ removeAttribute(attributeName) {
        if (this.doc !== null) $4bf7ba9bbb4881ae$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $4bf7ba9bbb4881ae$var$typeMapDelete(transaction, this, attributeName);
        });
        else /** @type {Map<string,any>} */ this._prelimAttrs.delete(attributeName);
    }
    /**
   * Sets or updates an attribute.
   *
   * @template {keyof KV & string} KEY
   *
   * @param {KEY} attributeName The attribute name that is to be set.
   * @param {KV[KEY]} attributeValue The attribute value that is to be set.
   *
   * @public
   */ setAttribute(attributeName, attributeValue) {
        if (this.doc !== null) $4bf7ba9bbb4881ae$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $4bf7ba9bbb4881ae$var$typeMapSet(transaction, this, attributeName, attributeValue);
        });
        else /** @type {Map<string, any>} */ this._prelimAttrs.set(attributeName, attributeValue);
    }
    /**
   * Returns an attribute value that belongs to the attribute name.
   *
   * @template {keyof KV & string} KEY
   *
   * @param {KEY} attributeName The attribute name that identifies the
   *                               queried value.
   * @return {KV[KEY]|undefined} The queried attribute value.
   *
   * @public
   */ getAttribute(attributeName) {
        return /** @type {any} */ $4bf7ba9bbb4881ae$var$typeMapGet(this, attributeName);
    }
    /**
   * Returns whether an attribute exists
   *
   * @param {string} attributeName The attribute name to check for existence.
   * @return {boolean} whether the attribute exists.
   *
   * @public
   */ hasAttribute(attributeName) {
        return /** @type {any} */ $4bf7ba9bbb4881ae$var$typeMapHas(this, attributeName);
    }
    /**
   * Returns all attribute name/value pairs in a JSON Object.
   *
   * @param {Snapshot} [snapshot]
   * @return {{ [Key in Extract<keyof KV,string>]?: KV[Key]}} A JSON Object that describes the attributes.
   *
   * @public
   */ getAttributes(snapshot) {
        return /** @type {any} */ snapshot ? $4bf7ba9bbb4881ae$export$7769bdedaef2c91b(this, snapshot) : $4bf7ba9bbb4881ae$var$typeMapGetAll(this);
    }
    /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks={}] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Node} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */ toDOM(_document = document, hooks = {}, binding) {
        const dom = _document.createElement(this.nodeName);
        const attrs = this.getAttributes();
        for(const key in attrs){
            const value = attrs[key];
            if (typeof value === "string") dom.setAttribute(key, value);
        }
        $4bf7ba9bbb4881ae$var$typeListForEach(this, (yxml)=>{
            dom.appendChild(yxml.toDOM(_document, hooks, binding));
        });
        if (binding !== undefined) binding._createAssociation(dom, this);
        return dom;
    }
    /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */ _write(encoder) {
        encoder.writeTypeRef($4bf7ba9bbb4881ae$var$YXmlElementRefID);
        encoder.writeKey(this.nodeName);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {YXmlElement}
 *
 * @function
 */ const $4bf7ba9bbb4881ae$var$readYXmlElement = (decoder)=>new $4bf7ba9bbb4881ae$export$4db87581d3ca170d(decoder.readKey());
/**
 * @extends YEvent<YXmlElement|YXmlText|YXmlFragment>
 * An Event that describes changes on a YXml Element or Yxml Fragment
 */ class $4bf7ba9bbb4881ae$export$88c9145a0c3b556c extends $4bf7ba9bbb4881ae$export$80fac438977fb51c {
    /**
   * @param {YXmlElement|YXmlText|YXmlFragment} target The target on which the event is created.
   * @param {Set<string|null>} subs The set of changed attributes. `null` is included if the
   *                   child list changed.
   * @param {Transaction} transaction The transaction instance with wich the
   *                                  change was created.
   */ constructor(target, subs, transaction){
        super(target, transaction);
        /**
     * Whether the children changed.
     * @type {Boolean}
     * @private
     */ this.childListChanged = false;
        /**
     * Set of all changed attributes.
     * @type {Set<string>}
     */ this.attributesChanged = new Set();
        subs.forEach((sub)=>{
            if (sub === null) this.childListChanged = true;
            else this.attributesChanged.add(sub);
        });
    }
}
/**
 * You can manage binding to a custom type with YXmlHook.
 *
 * @extends {YMap<any>}
 */ class $4bf7ba9bbb4881ae$export$ec64c1dd5e7a264 extends $4bf7ba9bbb4881ae$export$a5c7b93649eaf8f8 {
    /**
   * @param {string} hookName nodeName of the Dom Node.
   */ constructor(hookName){
        super();
        /**
     * @type {string}
     */ this.hookName = hookName;
    }
    /**
   * Creates an Item with the same effect as this Item (without position effect)
   */ _copy() {
        return new $4bf7ba9bbb4881ae$export$ec64c1dd5e7a264(this.hookName);
    }
    /**
   * @return {YXmlHook}
   */ clone() {
        const el = new $4bf7ba9bbb4881ae$export$ec64c1dd5e7a264(this.hookName);
        this.forEach((value, key)=>{
            el.set(key, value);
        });
        return el;
    }
    /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object.<string, any>} [hooks] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type
   * @return {Element} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */ toDOM(_document = document, hooks = {}, binding) {
        const hook = hooks[this.hookName];
        let dom;
        if (hook !== undefined) dom = hook.createDom(this);
        else dom = document.createElement(this.hookName);
        dom.setAttribute("data-yjs-hook", this.hookName);
        if (binding !== undefined) binding._createAssociation(dom, this);
        return dom;
    }
    /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */ _write(encoder) {
        encoder.writeTypeRef($4bf7ba9bbb4881ae$var$YXmlHookRefID);
        encoder.writeKey(this.hookName);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {YXmlHook}
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$readYXmlHook = (decoder)=>new $4bf7ba9bbb4881ae$export$ec64c1dd5e7a264(decoder.readKey());
/**
 * Represents text in a Dom Element. In the future this type will also handle
 * simple formatting information like bold and italic.
 */ class $4bf7ba9bbb4881ae$export$b35b8f45887823df extends $4bf7ba9bbb4881ae$export$5f1af8db9871e1d6 {
    /**
   * @type {YXmlElement|YXmlText|null}
   */ get nextSibling() {
        const n = this._item ? this._item.next : null;
        return n ? /** @type {YXmlElement|YXmlText} */ /** @type {ContentType} */ n.content.type : null;
    }
    /**
   * @type {YXmlElement|YXmlText|null}
   */ get prevSibling() {
        const n = this._item ? this._item.prev : null;
        return n ? /** @type {YXmlElement|YXmlText} */ /** @type {ContentType} */ n.content.type : null;
    }
    _copy() {
        return new $4bf7ba9bbb4881ae$export$b35b8f45887823df();
    }
    /**
   * @return {YXmlText}
   */ clone() {
        const text = new $4bf7ba9bbb4881ae$export$b35b8f45887823df();
        text.applyDelta(this.toDelta());
        return text;
    }
    /**
   * Creates a Dom Element that mirrors this YXmlText.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Text} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */ toDOM(_document = document, hooks, binding) {
        const dom = _document.createTextNode(this.toString());
        if (binding !== undefined) binding._createAssociation(dom, this);
        return dom;
    }
    toString() {
        // @ts-ignore
        return this.toDelta().map((delta)=>{
            const nestedNodes = [];
            for(const nodeName in delta.attributes){
                const attrs = [];
                for(const key in delta.attributes[nodeName])attrs.push({
                    key: key,
                    value: delta.attributes[nodeName][key]
                });
                // sort attributes to get a unique order
                attrs.sort((a, b)=>a.key < b.key ? -1 : 1);
                nestedNodes.push({
                    nodeName: nodeName,
                    attrs: attrs
                });
            }
            // sort node order to get a unique order
            nestedNodes.sort((a, b)=>a.nodeName < b.nodeName ? -1 : 1);
            // now convert to dom string
            let str = "";
            for(let i = 0; i < nestedNodes.length; i++){
                const node = nestedNodes[i];
                str += `<${node.nodeName}`;
                for(let j = 0; j < node.attrs.length; j++){
                    const attr = node.attrs[j];
                    str += ` ${attr.key}="${attr.value}"`;
                }
                str += ">";
            }
            str += delta.insert;
            for(let i = nestedNodes.length - 1; i >= 0; i--)str += `</${nestedNodes[i].nodeName}>`;
            return str;
        }).join("");
    }
    /**
   * @return {string}
   */ toJSON() {
        return this.toString();
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ _write(encoder) {
        encoder.writeTypeRef($4bf7ba9bbb4881ae$var$YXmlTextRefID);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {YXmlText}
 *
 * @private
 * @function
 */ const $4bf7ba9bbb4881ae$var$readYXmlText = (decoder)=>new $4bf7ba9bbb4881ae$export$b35b8f45887823df();
class $4bf7ba9bbb4881ae$export$3cf6f9765c5c3196 {
    /**
   * @param {ID} id
   * @param {number} length
   */ constructor(id, length){
        this.id = id;
        this.length = length;
    }
    /**
   * @type {boolean}
   */ get deleted() {
        throw $iVMsw.methodUnimplemented();
    }
    /**
   * Merge this struct with the item to the right.
   * This method is already assuming that `this.id.clock + this.length === this.id.clock`.
   * Also this method does *not* remove right from StructStore!
   * @param {AbstractStruct} right
   * @return {boolean} wether this merged with right
   */ mergeWith(right) {
        return false;
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   * @param {number} offset
   * @param {number} encodingRef
   */ write(encoder, offset, encodingRef) {
        throw $iVMsw.methodUnimplemented();
    }
    /**
   * @param {Transaction} transaction
   * @param {number} offset
   */ integrate(transaction, offset) {
        throw $iVMsw.methodUnimplemented();
    }
}
const $4bf7ba9bbb4881ae$var$structGCRefNumber = 0;
/**
 * @private
 */ class $4bf7ba9bbb4881ae$export$12d259ff017e6b58 extends $4bf7ba9bbb4881ae$export$3cf6f9765c5c3196 {
    get deleted() {
        return true;
    }
    delete() {}
    /**
   * @param {GC} right
   * @return {boolean}
   */ mergeWith(right) {
        if (this.constructor !== right.constructor) return false;
        this.length += right.length;
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {number} offset
   */ integrate(transaction, offset) {
        if (offset > 0) {
            this.id.clock += offset;
            this.length -= offset;
        }
        $4bf7ba9bbb4881ae$var$addStruct(transaction.doc.store, this);
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeInfo($4bf7ba9bbb4881ae$var$structGCRefNumber);
        encoder.writeLen(this.length - offset);
    }
    /**
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */ getMissing(transaction, store) {
        return null;
    }
}
class $4bf7ba9bbb4881ae$export$e8d530cdf62d1cbd {
    /**
   * @param {Uint8Array} content
   */ constructor(content){
        this.content = content;
    }
    /**
   * @return {number}
   */ getLength() {
        return 1;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [
            this.content
        ];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentBinary}
   */ copy() {
        return new $4bf7ba9bbb4881ae$export$e8d530cdf62d1cbd(this.content);
    }
    /**
   * @param {number} offset
   * @return {ContentBinary}
   */ splice(offset) {
        throw $iVMsw.methodUnimplemented();
    }
    /**
   * @param {ContentBinary} right
   * @return {boolean}
   */ mergeWith(right) {
        return false;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {}
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeBuf(this.content);
    }
    /**
   * @return {number}
   */ getRef() {
        return 3;
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2 } decoder
 * @return {ContentBinary}
 */ const $4bf7ba9bbb4881ae$var$readContentBinary = (decoder)=>new $4bf7ba9bbb4881ae$export$e8d530cdf62d1cbd(decoder.readBuf());
class $4bf7ba9bbb4881ae$export$3b06e0b3a2ece602 {
    /**
   * @param {number} len
   */ constructor(len){
        this.len = len;
    }
    /**
   * @return {number}
   */ getLength() {
        return this.len;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return false;
    }
    /**
   * @return {ContentDeleted}
   */ copy() {
        return new $4bf7ba9bbb4881ae$export$3b06e0b3a2ece602(this.len);
    }
    /**
   * @param {number} offset
   * @return {ContentDeleted}
   */ splice(offset) {
        const right = new $4bf7ba9bbb4881ae$export$3b06e0b3a2ece602(this.len - offset);
        this.len = offset;
        return right;
    }
    /**
   * @param {ContentDeleted} right
   * @return {boolean}
   */ mergeWith(right) {
        this.len += right.len;
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {
        $4bf7ba9bbb4881ae$var$addToDeleteSet(transaction.deleteSet, item.id.client, item.id.clock, this.len);
        item.markDeleted();
    }
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeLen(this.len - offset);
    }
    /**
   * @return {number}
   */ getRef() {
        return 1;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2 } decoder
 * @return {ContentDeleted}
 */ const $4bf7ba9bbb4881ae$var$readContentDeleted = (decoder)=>new $4bf7ba9bbb4881ae$export$3b06e0b3a2ece602(decoder.readLen());
/**
 * @param {string} guid
 * @param {Object<string, any>} opts
 */ const $4bf7ba9bbb4881ae$var$createDocFromOpts = (guid, opts)=>new $4bf7ba9bbb4881ae$export$bceacc74c2212615({
        guid: guid,
        ...opts,
        shouldLoad: opts.shouldLoad || opts.autoLoad || false
    });
/**
 * @private
 */ class $4bf7ba9bbb4881ae$export$b564c0e69572c0e {
    /**
   * @param {Doc} doc
   */ constructor(doc){
        if (doc._item) console.error("This document was already integrated as a sub-document. You should create a second instance instead with the same guid.");
        /**
     * @type {Doc}
     */ this.doc = doc;
        /**
     * @type {any}
     */ const opts = {};
        this.opts = opts;
        if (!doc.gc) opts.gc = false;
        if (doc.autoLoad) opts.autoLoad = true;
        if (doc.meta !== null) opts.meta = doc.meta;
    }
    /**
   * @return {number}
   */ getLength() {
        return 1;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [
            this.doc
        ];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentDoc}
   */ copy() {
        return new $4bf7ba9bbb4881ae$export$b564c0e69572c0e($4bf7ba9bbb4881ae$var$createDocFromOpts(this.doc.guid, this.opts));
    }
    /**
   * @param {number} offset
   * @return {ContentDoc}
   */ splice(offset) {
        throw $iVMsw.methodUnimplemented();
    }
    /**
   * @param {ContentDoc} right
   * @return {boolean}
   */ mergeWith(right) {
        return false;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {
        // this needs to be reflected in doc.destroy as well
        this.doc._item = item;
        transaction.subdocsAdded.add(this.doc);
        if (this.doc.shouldLoad) transaction.subdocsLoaded.add(this.doc);
    }
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {
        if (transaction.subdocsAdded.has(this.doc)) transaction.subdocsAdded.delete(this.doc);
        else transaction.subdocsRemoved.add(this.doc);
    }
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeString(this.doc.guid);
        encoder.writeAny(this.opts);
    }
    /**
   * @return {number}
   */ getRef() {
        return 9;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentDoc}
 */ const $4bf7ba9bbb4881ae$var$readContentDoc = (decoder)=>new $4bf7ba9bbb4881ae$export$b564c0e69572c0e($4bf7ba9bbb4881ae$var$createDocFromOpts(decoder.readString(), decoder.readAny()));
/**
 * @private
 */ class $4bf7ba9bbb4881ae$export$c3787ba7f6086664 {
    /**
   * @param {Object} embed
   */ constructor(embed){
        this.embed = embed;
    }
    /**
   * @return {number}
   */ getLength() {
        return 1;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [
            this.embed
        ];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentEmbed}
   */ copy() {
        return new $4bf7ba9bbb4881ae$export$c3787ba7f6086664(this.embed);
    }
    /**
   * @param {number} offset
   * @return {ContentEmbed}
   */ splice(offset) {
        throw $iVMsw.methodUnimplemented();
    }
    /**
   * @param {ContentEmbed} right
   * @return {boolean}
   */ mergeWith(right) {
        return false;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {}
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeJSON(this.embed);
    }
    /**
   * @return {number}
   */ getRef() {
        return 5;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentEmbed}
 */ const $4bf7ba9bbb4881ae$var$readContentEmbed = (decoder)=>new $4bf7ba9bbb4881ae$export$c3787ba7f6086664(decoder.readJSON());
/**
 * @private
 */ class $4bf7ba9bbb4881ae$export$3194899188fb5a88 {
    /**
   * @param {string} key
   * @param {Object} value
   */ constructor(key, value){
        this.key = key;
        this.value = value;
    }
    /**
   * @return {number}
   */ getLength() {
        return 1;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return false;
    }
    /**
   * @return {ContentFormat}
   */ copy() {
        return new $4bf7ba9bbb4881ae$export$3194899188fb5a88(this.key, this.value);
    }
    /**
   * @param {number} _offset
   * @return {ContentFormat}
   */ splice(_offset) {
        throw $iVMsw.methodUnimplemented();
    }
    /**
   * @param {ContentFormat} _right
   * @return {boolean}
   */ mergeWith(_right) {
        return false;
    }
    /**
   * @param {Transaction} _transaction
   * @param {Item} item
   */ integrate(_transaction, item) {
        // @todo searchmarker are currently unsupported for rich text documents
        const p = /** @type {YText} */ item.parent;
        p._searchMarker = null;
        p._hasFormatting = true;
    }
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeKey(this.key);
        encoder.writeJSON(this.value);
    }
    /**
   * @return {number}
   */ getRef() {
        return 6;
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentFormat}
 */ const $4bf7ba9bbb4881ae$var$readContentFormat = (decoder)=>new $4bf7ba9bbb4881ae$export$3194899188fb5a88(decoder.readKey(), decoder.readJSON());
/**
 * @private
 */ class $4bf7ba9bbb4881ae$export$6a907ea8f733ecf3 {
    /**
   * @param {Array<any>} arr
   */ constructor(arr){
        /**
     * @type {Array<any>}
     */ this.arr = arr;
    }
    /**
   * @return {number}
   */ getLength() {
        return this.arr.length;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return this.arr;
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentJSON}
   */ copy() {
        return new $4bf7ba9bbb4881ae$export$6a907ea8f733ecf3(this.arr);
    }
    /**
   * @param {number} offset
   * @return {ContentJSON}
   */ splice(offset) {
        const right = new $4bf7ba9bbb4881ae$export$6a907ea8f733ecf3(this.arr.slice(offset));
        this.arr = this.arr.slice(0, offset);
        return right;
    }
    /**
   * @param {ContentJSON} right
   * @return {boolean}
   */ mergeWith(right) {
        this.arr = this.arr.concat(right.arr);
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {}
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        const len = this.arr.length;
        encoder.writeLen(len - offset);
        for(let i = offset; i < len; i++){
            const c = this.arr[i];
            encoder.writeString(c === undefined ? "undefined" : JSON.stringify(c));
        }
    }
    /**
   * @return {number}
   */ getRef() {
        return 2;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentJSON}
 */ const $4bf7ba9bbb4881ae$var$readContentJSON = (decoder)=>{
    const len = decoder.readLen();
    const cs = [];
    for(let i = 0; i < len; i++){
        const c = decoder.readString();
        if (c === "undefined") cs.push(undefined);
        else cs.push(JSON.parse(c));
    }
    return new $4bf7ba9bbb4881ae$export$6a907ea8f733ecf3(cs);
};
class $4bf7ba9bbb4881ae$export$1d788b93bbb631a0 {
    /**
   * @param {Array<any>} arr
   */ constructor(arr){
        /**
     * @type {Array<any>}
     */ this.arr = arr;
    }
    /**
   * @return {number}
   */ getLength() {
        return this.arr.length;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return this.arr;
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentAny}
   */ copy() {
        return new $4bf7ba9bbb4881ae$export$1d788b93bbb631a0(this.arr);
    }
    /**
   * @param {number} offset
   * @return {ContentAny}
   */ splice(offset) {
        const right = new $4bf7ba9bbb4881ae$export$1d788b93bbb631a0(this.arr.slice(offset));
        this.arr = this.arr.slice(0, offset);
        return right;
    }
    /**
   * @param {ContentAny} right
   * @return {boolean}
   */ mergeWith(right) {
        this.arr = this.arr.concat(right.arr);
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {}
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        const len = this.arr.length;
        encoder.writeLen(len - offset);
        for(let i = offset; i < len; i++){
            const c = this.arr[i];
            encoder.writeAny(c);
        }
    }
    /**
   * @return {number}
   */ getRef() {
        return 8;
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentAny}
 */ const $4bf7ba9bbb4881ae$var$readContentAny = (decoder)=>{
    const len = decoder.readLen();
    const cs = [];
    for(let i = 0; i < len; i++)cs.push(decoder.readAny());
    return new $4bf7ba9bbb4881ae$export$1d788b93bbb631a0(cs);
};
/**
 * @private
 */ class $4bf7ba9bbb4881ae$export$ee670b2cf091bbb6 {
    /**
   * @param {string} str
   */ constructor(str){
        /**
     * @type {string}
     */ this.str = str;
    }
    /**
   * @return {number}
   */ getLength() {
        return this.str.length;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return this.str.split("");
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentString}
   */ copy() {
        return new $4bf7ba9bbb4881ae$export$ee670b2cf091bbb6(this.str);
    }
    /**
   * @param {number} offset
   * @return {ContentString}
   */ splice(offset) {
        const right = new $4bf7ba9bbb4881ae$export$ee670b2cf091bbb6(this.str.slice(offset));
        this.str = this.str.slice(0, offset);
        // Prevent encoding invalid documents because of splitting of surrogate pairs: https://github.com/yjs/yjs/issues/248
        const firstCharCode = this.str.charCodeAt(offset - 1);
        if (firstCharCode >= 0xD800 && firstCharCode <= 0xDBFF) {
            // Last character of the left split is the start of a surrogate utf16/ucs2 pair.
            // We don't support splitting of surrogate pairs because this may lead to invalid documents.
            // Replace the invalid character with a unicode replacement character (� / U+FFFD)
            this.str = this.str.slice(0, offset - 1) + "\uFFFD";
            // replace right as well
            right.str = "\uFFFD" + right.str.slice(1);
        }
        return right;
    }
    /**
   * @param {ContentString} right
   * @return {boolean}
   */ mergeWith(right) {
        this.str += right.str;
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {}
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeString(offset === 0 ? this.str : this.str.slice(offset));
    }
    /**
   * @return {number}
   */ getRef() {
        return 4;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentString}
 */ const $4bf7ba9bbb4881ae$var$readContentString = (decoder)=>new $4bf7ba9bbb4881ae$export$ee670b2cf091bbb6(decoder.readString());
/**
 * @type {Array<function(UpdateDecoderV1 | UpdateDecoderV2):AbstractType<any>>}
 * @private
 */ const $4bf7ba9bbb4881ae$var$typeRefs = [
    $4bf7ba9bbb4881ae$var$readYArray,
    $4bf7ba9bbb4881ae$var$readYMap,
    $4bf7ba9bbb4881ae$var$readYText,
    $4bf7ba9bbb4881ae$var$readYXmlElement,
    $4bf7ba9bbb4881ae$var$readYXmlFragment,
    $4bf7ba9bbb4881ae$var$readYXmlHook,
    $4bf7ba9bbb4881ae$var$readYXmlText
];
const $4bf7ba9bbb4881ae$var$YArrayRefID = 0;
const $4bf7ba9bbb4881ae$var$YMapRefID = 1;
const $4bf7ba9bbb4881ae$var$YTextRefID = 2;
const $4bf7ba9bbb4881ae$var$YXmlElementRefID = 3;
const $4bf7ba9bbb4881ae$var$YXmlFragmentRefID = 4;
const $4bf7ba9bbb4881ae$var$YXmlHookRefID = 5;
const $4bf7ba9bbb4881ae$var$YXmlTextRefID = 6;
/**
 * @private
 */ class $4bf7ba9bbb4881ae$export$e2e108cbe2e4f865 {
    /**
   * @param {AbstractType<any>} type
   */ constructor(type){
        /**
     * @type {AbstractType<any>}
     */ this.type = type;
    }
    /**
   * @return {number}
   */ getLength() {
        return 1;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [
            this.type
        ];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentType}
   */ copy() {
        return new $4bf7ba9bbb4881ae$export$e2e108cbe2e4f865(this.type._copy());
    }
    /**
   * @param {number} offset
   * @return {ContentType}
   */ splice(offset) {
        throw $iVMsw.methodUnimplemented();
    }
    /**
   * @param {ContentType} right
   * @return {boolean}
   */ mergeWith(right) {
        return false;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {
        this.type._integrate(transaction.doc, item);
    }
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {
        let item = this.type._start;
        while(item !== null){
            if (!item.deleted) item.delete(transaction);
            else if (item.id.clock < (transaction.beforeState.get(item.id.client) || 0)) // This will be gc'd later and we want to merge it if possible
            // We try to merge all deleted items after each transaction,
            // but we have no knowledge about that this needs to be merged
            // since it is not in transaction.ds. Hence we add it to transaction._mergeStructs
            transaction._mergeStructs.push(item);
            item = item.right;
        }
        this.type._map.forEach((item)=>{
            if (!item.deleted) item.delete(transaction);
            else if (item.id.clock < (transaction.beforeState.get(item.id.client) || 0)) // same as above
            transaction._mergeStructs.push(item);
        });
        transaction.changed.delete(this.type);
    }
    /**
   * @param {StructStore} store
   */ gc(store) {
        let item = this.type._start;
        while(item !== null){
            item.gc(store, true);
            item = item.right;
        }
        this.type._start = null;
        this.type._map.forEach(/** @param {Item | null} item */ (item)=>{
            while(item !== null){
                item.gc(store, true);
                item = item.left;
            }
        });
        this.type._map = new Map();
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        this.type._write(encoder);
    }
    /**
   * @return {number}
   */ getRef() {
        return 7;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentType}
 */ const $4bf7ba9bbb4881ae$var$readContentType = (decoder)=>new $4bf7ba9bbb4881ae$export$e2e108cbe2e4f865($4bf7ba9bbb4881ae$var$typeRefs[decoder.readTypeRef()](decoder));
/**
 * @todo This should return several items
 *
 * @param {StructStore} store
 * @param {ID} id
 * @return {{item:Item, diff:number}}
 */ const $4bf7ba9bbb4881ae$var$followRedone = (store, id)=>{
    /**
   * @type {ID|null}
   */ let nextID = id;
    let diff = 0;
    let item;
    do {
        if (diff > 0) nextID = $4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(nextID.client, nextID.clock + diff);
        item = $4bf7ba9bbb4881ae$export$f92dfeb71e9bb569(store, nextID);
        diff = nextID.clock - item.id.clock;
        nextID = item.redone;
    }while (nextID !== null && item instanceof $4bf7ba9bbb4881ae$export$6d08773d2e66f8f2);
    return {
        item: item,
        diff: diff
    };
};
/**
 * Make sure that neither item nor any of its parents is ever deleted.
 *
 * This property does not persist when storing it into a database or when
 * sending it to other peers
 *
 * @param {Item|null} item
 * @param {boolean} keep
 */ const $4bf7ba9bbb4881ae$var$keepItem = (item, keep)=>{
    while(item !== null && item.keep !== keep){
        item.keep = keep;
        item = /** @type {AbstractType<any>} */ item.parent._item;
    }
};
/**
 * Split leftItem into two items
 * @param {Transaction} transaction
 * @param {Item} leftItem
 * @param {number} diff
 * @return {Item}
 *
 * @function
 * @private
 */ const $4bf7ba9bbb4881ae$var$splitItem = (transaction, leftItem, diff)=>{
    // create rightItem
    const { client: client, clock: clock } = leftItem.id;
    const rightItem = new $4bf7ba9bbb4881ae$export$6d08773d2e66f8f2($4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(client, clock + diff), leftItem, $4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(client, clock + diff - 1), leftItem.right, leftItem.rightOrigin, leftItem.parent, leftItem.parentSub, leftItem.content.splice(diff));
    if (leftItem.deleted) rightItem.markDeleted();
    if (leftItem.keep) rightItem.keep = true;
    if (leftItem.redone !== null) rightItem.redone = $4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(leftItem.redone.client, leftItem.redone.clock + diff);
    // update left (do not set leftItem.rightOrigin as it will lead to problems when syncing)
    leftItem.right = rightItem;
    // update right
    if (rightItem.right !== null) rightItem.right.left = rightItem;
    // right is more specific.
    transaction._mergeStructs.push(rightItem);
    // update parent._map
    if (rightItem.parentSub !== null && rightItem.right === null) /** @type {AbstractType<any>} */ rightItem.parent._map.set(rightItem.parentSub, rightItem);
    leftItem.length = diff;
    return rightItem;
};
/**
 * @param {Array<StackItem>} stack
 * @param {ID} id
 */ const $4bf7ba9bbb4881ae$var$isDeletedByUndoStack = (stack, id)=>$iiUWJ.some(stack, /** @param {StackItem} s */ (s)=>$4bf7ba9bbb4881ae$export$dcb04af092e44fde(s.deletions, id));
/**
 * Redoes the effect of this operation.
 *
 * @param {Transaction} transaction The Yjs instance.
 * @param {Item} item
 * @param {Set<Item>} redoitems
 * @param {DeleteSet} itemsToDelete
 * @param {boolean} ignoreRemoteMapChanges
 * @param {import('../utils/UndoManager.js').UndoManager} um
 *
 * @return {Item|null}
 *
 * @private
 */ const $4bf7ba9bbb4881ae$var$redoItem = (transaction, item, redoitems, itemsToDelete, ignoreRemoteMapChanges, um)=>{
    const doc = transaction.doc;
    const store = doc.store;
    const ownClientID = doc.clientID;
    const redone = item.redone;
    if (redone !== null) return $4bf7ba9bbb4881ae$var$getItemCleanStart(transaction, redone);
    let parentItem = /** @type {AbstractType<any>} */ item.parent._item;
    /**
   * @type {Item|null}
   */ let left = null;
    /**
   * @type {Item|null}
   */ let right;
    // make sure that parent is redone
    if (parentItem !== null && parentItem.deleted === true) {
        // try to undo parent if it will be undone anyway
        if (parentItem.redone === null && (!redoitems.has(parentItem) || $4bf7ba9bbb4881ae$var$redoItem(transaction, parentItem, redoitems, itemsToDelete, ignoreRemoteMapChanges, um) === null)) return null;
        while(parentItem.redone !== null)parentItem = $4bf7ba9bbb4881ae$var$getItemCleanStart(transaction, parentItem.redone);
    }
    const parentType = parentItem === null ? /** @type {AbstractType<any>} */ item.parent : /** @type {ContentType} */ parentItem.content.type;
    if (item.parentSub === null) {
        // Is an array item. Insert at the old position
        left = item.left;
        right = item;
        // find next cloned_redo items
        while(left !== null){
            /**
       * @type {Item|null}
       */ let leftTrace = left;
            // trace redone until parent matches
            while(leftTrace !== null && /** @type {AbstractType<any>} */ leftTrace.parent._item !== parentItem)leftTrace = leftTrace.redone === null ? null : $4bf7ba9bbb4881ae$var$getItemCleanStart(transaction, leftTrace.redone);
            if (leftTrace !== null && /** @type {AbstractType<any>} */ leftTrace.parent._item === parentItem) {
                left = leftTrace;
                break;
            }
            left = left.left;
        }
        while(right !== null){
            /**
       * @type {Item|null}
       */ let rightTrace = right;
            // trace redone until parent matches
            while(rightTrace !== null && /** @type {AbstractType<any>} */ rightTrace.parent._item !== parentItem)rightTrace = rightTrace.redone === null ? null : $4bf7ba9bbb4881ae$var$getItemCleanStart(transaction, rightTrace.redone);
            if (rightTrace !== null && /** @type {AbstractType<any>} */ rightTrace.parent._item === parentItem) {
                right = rightTrace;
                break;
            }
            right = right.right;
        }
    } else {
        right = null;
        if (item.right && !ignoreRemoteMapChanges) {
            left = item;
            // Iterate right while right is in itemsToDelete
            // If it is intended to delete right while item is redone, we can expect that item should replace right.
            while(left !== null && left.right !== null && (left.right.redone || $4bf7ba9bbb4881ae$export$dcb04af092e44fde(itemsToDelete, left.right.id) || $4bf7ba9bbb4881ae$var$isDeletedByUndoStack(um.undoStack, left.right.id) || $4bf7ba9bbb4881ae$var$isDeletedByUndoStack(um.redoStack, left.right.id))){
                left = left.right;
                // follow redone
                while(left.redone)left = $4bf7ba9bbb4881ae$var$getItemCleanStart(transaction, left.redone);
            }
            if (left && left.right !== null) // It is not possible to redo this item because it conflicts with a
            // change from another client
            return null;
        } else left = parentType._map.get(item.parentSub) || null;
    }
    const nextClock = $4bf7ba9bbb4881ae$export$50fdfeece43146fd(store, ownClientID);
    const nextId = $4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(ownClientID, nextClock);
    const redoneItem = new $4bf7ba9bbb4881ae$export$6d08773d2e66f8f2(nextId, left, left && left.lastId, right, right && right.id, parentType, item.parentSub, item.content.copy());
    item.redone = nextId;
    $4bf7ba9bbb4881ae$var$keepItem(redoneItem, true);
    redoneItem.integrate(transaction, 0);
    return redoneItem;
};
/**
 * Abstract class that represents any content.
 */ class $4bf7ba9bbb4881ae$export$6d08773d2e66f8f2 extends $4bf7ba9bbb4881ae$export$3cf6f9765c5c3196 {
    /**
   * @param {ID} id
   * @param {Item | null} left
   * @param {ID | null} origin
   * @param {Item | null} right
   * @param {ID | null} rightOrigin
   * @param {AbstractType<any>|ID|null} parent Is a type if integrated, is null if it is possible to copy parent from left or right, is ID before integration to search for it.
   * @param {string | null} parentSub
   * @param {AbstractContent} content
   */ constructor(id, left, origin, right, rightOrigin, parent, parentSub, content){
        super(id, content.getLength());
        /**
     * The item that was originally to the left of this item.
     * @type {ID | null}
     */ this.origin = origin;
        /**
     * The item that is currently to the left of this item.
     * @type {Item | null}
     */ this.left = left;
        /**
     * The item that is currently to the right of this item.
     * @type {Item | null}
     */ this.right = right;
        /**
     * The item that was originally to the right of this item.
     * @type {ID | null}
     */ this.rightOrigin = rightOrigin;
        /**
     * @type {AbstractType<any>|ID|null}
     */ this.parent = parent;
        /**
     * If the parent refers to this item with some kind of key (e.g. YMap, the
     * key is specified here. The key is then used to refer to the list in which
     * to insert this item. If `parentSub = null` type._start is the list in
     * which to insert to. Otherwise it is `parent._map`.
     * @type {String | null}
     */ this.parentSub = parentSub;
        /**
     * If this type's effect is redone this type refers to the type that undid
     * this operation.
     * @type {ID | null}
     */ this.redone = null;
        /**
     * @type {AbstractContent}
     */ this.content = content;
        /**
     * bit1: keep
     * bit2: countable
     * bit3: deleted
     * bit4: mark - mark node as fast-search-marker
     * @type {number} byte
     */ this.info = this.content.isCountable() ? $51l7Q.BIT2 : 0;
    }
    /**
   * This is used to mark the item as an indexed fast-search marker
   *
   * @type {boolean}
   */ set marker(isMarked) {
        if ((this.info & $51l7Q.BIT4) > 0 !== isMarked) this.info ^= $51l7Q.BIT4;
    }
    get marker() {
        return (this.info & $51l7Q.BIT4) > 0;
    }
    /**
   * If true, do not garbage collect this Item.
   */ get keep() {
        return (this.info & $51l7Q.BIT1) > 0;
    }
    set keep(doKeep) {
        if (this.keep !== doKeep) this.info ^= $51l7Q.BIT1;
    }
    get countable() {
        return (this.info & $51l7Q.BIT2) > 0;
    }
    /**
   * Whether this item was deleted or not.
   * @type {Boolean}
   */ get deleted() {
        return (this.info & $51l7Q.BIT3) > 0;
    }
    set deleted(doDelete) {
        if (this.deleted !== doDelete) this.info ^= $51l7Q.BIT3;
    }
    markDeleted() {
        this.info |= $51l7Q.BIT3;
    }
    /**
   * Return the creator clientID of the missing op or define missing items and return null.
   *
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */ getMissing(transaction, store) {
        if (this.origin && this.origin.client !== this.id.client && this.origin.clock >= $4bf7ba9bbb4881ae$export$50fdfeece43146fd(store, this.origin.client)) return this.origin.client;
        if (this.rightOrigin && this.rightOrigin.client !== this.id.client && this.rightOrigin.clock >= $4bf7ba9bbb4881ae$export$50fdfeece43146fd(store, this.rightOrigin.client)) return this.rightOrigin.client;
        if (this.parent && this.parent.constructor === $4bf7ba9bbb4881ae$export$8be180ec26319f9f && this.id.client !== this.parent.client && this.parent.clock >= $4bf7ba9bbb4881ae$export$50fdfeece43146fd(store, this.parent.client)) return this.parent.client;
        // We have all missing ids, now find the items
        if (this.origin) {
            this.left = $4bf7ba9bbb4881ae$var$getItemCleanEnd(transaction, store, this.origin);
            this.origin = this.left.lastId;
        }
        if (this.rightOrigin) {
            this.right = $4bf7ba9bbb4881ae$var$getItemCleanStart(transaction, this.rightOrigin);
            this.rightOrigin = this.right.id;
        }
        if (this.left && this.left.constructor === $4bf7ba9bbb4881ae$export$12d259ff017e6b58 || this.right && this.right.constructor === $4bf7ba9bbb4881ae$export$12d259ff017e6b58) this.parent = null;
        else if (!this.parent) {
            // only set parent if this shouldn't be garbage collected
            if (this.left && this.left.constructor === $4bf7ba9bbb4881ae$export$6d08773d2e66f8f2) {
                this.parent = this.left.parent;
                this.parentSub = this.left.parentSub;
            }
            if (this.right && this.right.constructor === $4bf7ba9bbb4881ae$export$6d08773d2e66f8f2) {
                this.parent = this.right.parent;
                this.parentSub = this.right.parentSub;
            }
        } else if (this.parent.constructor === $4bf7ba9bbb4881ae$export$8be180ec26319f9f) {
            const parentItem = $4bf7ba9bbb4881ae$export$f92dfeb71e9bb569(store, this.parent);
            if (parentItem.constructor === $4bf7ba9bbb4881ae$export$12d259ff017e6b58) this.parent = null;
            else this.parent = /** @type {ContentType} */ parentItem.content.type;
        }
        return null;
    }
    /**
   * @param {Transaction} transaction
   * @param {number} offset
   */ integrate(transaction, offset) {
        if (offset > 0) {
            this.id.clock += offset;
            this.left = $4bf7ba9bbb4881ae$var$getItemCleanEnd(transaction, transaction.doc.store, $4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(this.id.client, this.id.clock - 1));
            this.origin = this.left.lastId;
            this.content = this.content.splice(offset);
            this.length -= offset;
        }
        if (this.parent) {
            if (!this.left && (!this.right || this.right.left !== null) || this.left && this.left.right !== this.right) {
                /**
         * @type {Item|null}
         */ let left = this.left;
                /**
         * @type {Item|null}
         */ let o;
                // set o to the first conflicting item
                if (left !== null) o = left.right;
                else if (this.parentSub !== null) {
                    o = /** @type {AbstractType<any>} */ this.parent._map.get(this.parentSub) || null;
                    while(o !== null && o.left !== null)o = o.left;
                } else o = /** @type {AbstractType<any>} */ this.parent._start;
                // TODO: use something like DeleteSet here (a tree implementation would be best)
                // @todo use global set definitions
                /**
         * @type {Set<Item>}
         */ const conflictingItems = new Set();
                /**
         * @type {Set<Item>}
         */ const itemsBeforeOrigin = new Set();
                // Let c in conflictingItems, b in itemsBeforeOrigin
                // ***{origin}bbbb{this}{c,b}{c,b}{o}***
                // Note that conflictingItems is a subset of itemsBeforeOrigin
                while(o !== null && o !== this.right){
                    itemsBeforeOrigin.add(o);
                    conflictingItems.add(o);
                    if ($4bf7ba9bbb4881ae$export$c0af976e7e459c02(this.origin, o.origin)) {
                        // case 1
                        if (o.id.client < this.id.client) {
                            left = o;
                            conflictingItems.clear();
                        } else if ($4bf7ba9bbb4881ae$export$c0af976e7e459c02(this.rightOrigin, o.rightOrigin)) break;
                         // else, o might be integrated before an item that this conflicts with. If so, we will find it in the next iterations
                    } else if (o.origin !== null && itemsBeforeOrigin.has($4bf7ba9bbb4881ae$export$f92dfeb71e9bb569(transaction.doc.store, o.origin))) // case 2
                    {
                        if (!conflictingItems.has($4bf7ba9bbb4881ae$export$f92dfeb71e9bb569(transaction.doc.store, o.origin))) {
                            left = o;
                            conflictingItems.clear();
                        }
                    } else break;
                    o = o.right;
                }
                this.left = left;
            }
            // reconnect left/right + update parent map/start if necessary
            if (this.left !== null) {
                const right = this.left.right;
                this.right = right;
                this.left.right = this;
            } else {
                let r;
                if (this.parentSub !== null) {
                    r = /** @type {AbstractType<any>} */ this.parent._map.get(this.parentSub) || null;
                    while(r !== null && r.left !== null)r = r.left;
                } else {
                    r = /** @type {AbstractType<any>} */ this.parent._start; /** @type {AbstractType<any>} */ 
                    this.parent._start = this;
                }
                this.right = r;
            }
            if (this.right !== null) this.right.left = this;
            else if (this.parentSub !== null) {
                // set as current parent value if right === null and this is parentSub
                /** @type {AbstractType<any>} */ this.parent._map.set(this.parentSub, this);
                if (this.left !== null) // this is the current attribute value of parent. delete right
                this.left.delete(transaction);
            }
            // adjust length of parent
            if (this.parentSub === null && this.countable && !this.deleted) /** @type {AbstractType<any>} */ this.parent._length += this.length;
            $4bf7ba9bbb4881ae$var$addStruct(transaction.doc.store, this);
            this.content.integrate(transaction, this);
            // add parent to transaction.changed
            $4bf7ba9bbb4881ae$var$addChangedTypeToTransaction(transaction, /** @type {AbstractType<any>} */ this.parent, this.parentSub);
            if (/** @type {AbstractType<any>} */ this.parent._item !== null && /** @type {AbstractType<any>} */ this.parent._item.deleted || this.parentSub !== null && this.right !== null) // delete if parent is deleted or if this is not the current attribute value of parent
            this.delete(transaction);
        } else // parent is not defined. Integrate GC struct instead
        new $4bf7ba9bbb4881ae$export$12d259ff017e6b58(this.id, this.length).integrate(transaction, 0);
    }
    /**
   * Returns the next non-deleted item
   */ get next() {
        let n = this.right;
        while(n !== null && n.deleted)n = n.right;
        return n;
    }
    /**
   * Returns the previous non-deleted item
   */ get prev() {
        let n = this.left;
        while(n !== null && n.deleted)n = n.left;
        return n;
    }
    /**
   * Computes the last content address of this Item.
   */ get lastId() {
        // allocating ids is pretty costly because of the amount of ids created, so we try to reuse whenever possible
        return this.length === 1 ? this.id : $4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(this.id.client, this.id.clock + this.length - 1);
    }
    /**
   * Try to merge two items
   *
   * @param {Item} right
   * @return {boolean}
   */ mergeWith(right) {
        if (this.constructor === right.constructor && $4bf7ba9bbb4881ae$export$c0af976e7e459c02(right.origin, this.lastId) && this.right === right && $4bf7ba9bbb4881ae$export$c0af976e7e459c02(this.rightOrigin, right.rightOrigin) && this.id.client === right.id.client && this.id.clock + this.length === right.id.clock && this.deleted === right.deleted && this.redone === null && right.redone === null && this.content.constructor === right.content.constructor && this.content.mergeWith(right.content)) {
            const searchMarker = /** @type {AbstractType<any>} */ this.parent._searchMarker;
            if (searchMarker) searchMarker.forEach((marker)=>{
                if (marker.p === right) {
                    // right is going to be "forgotten" so we need to update the marker
                    marker.p = this;
                    // adjust marker index
                    if (!this.deleted && this.countable) marker.index -= this.length;
                }
            });
            if (right.keep) this.keep = true;
            this.right = right.right;
            if (this.right !== null) this.right.left = this;
            this.length += right.length;
            return true;
        }
        return false;
    }
    /**
   * Mark this Item as deleted.
   *
   * @param {Transaction} transaction
   */ delete(transaction) {
        if (!this.deleted) {
            const parent = /** @type {AbstractType<any>} */ this.parent;
            // adjust the length of parent
            if (this.countable && this.parentSub === null) parent._length -= this.length;
            this.markDeleted();
            $4bf7ba9bbb4881ae$var$addToDeleteSet(transaction.deleteSet, this.id.client, this.id.clock, this.length);
            $4bf7ba9bbb4881ae$var$addChangedTypeToTransaction(transaction, parent, this.parentSub);
            this.content.delete(transaction);
        }
    }
    /**
   * @param {StructStore} store
   * @param {boolean} parentGCd
   */ gc(store, parentGCd) {
        if (!this.deleted) throw $iVMsw.unexpectedCase();
        this.content.gc(store);
        if (parentGCd) $4bf7ba9bbb4881ae$var$replaceStruct(store, this, new $4bf7ba9bbb4881ae$export$12d259ff017e6b58(this.id, this.length));
        else this.content = new $4bf7ba9bbb4881ae$export$3b06e0b3a2ece602(this.length);
    }
    /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   * @param {number} offset
   */ write(encoder, offset) {
        const origin = offset > 0 ? $4bf7ba9bbb4881ae$export$6c7d4e6171d008d0(this.id.client, this.id.clock + offset - 1) : this.origin;
        const rightOrigin = this.rightOrigin;
        const parentSub = this.parentSub;
        const info = this.content.getRef() & $51l7Q.BITS5 | (origin === null ? 0 : $51l7Q.BIT8) | // origin is defined
        (rightOrigin === null ? 0 : $51l7Q.BIT7) | // right origin is defined
        (parentSub === null ? 0 : $51l7Q.BIT6); // parentSub is non-null
        encoder.writeInfo(info);
        if (origin !== null) encoder.writeLeftID(origin);
        if (rightOrigin !== null) encoder.writeRightID(rightOrigin);
        if (origin === null && rightOrigin === null) {
            const parent = /** @type {AbstractType<any>} */ this.parent;
            if (parent._item !== undefined) {
                const parentItem = parent._item;
                if (parentItem === null) {
                    // parent type on y._map
                    // find the correct key
                    const ykey = $4bf7ba9bbb4881ae$export$e726a40920d54663(parent);
                    encoder.writeParentInfo(true); // write parentYKey
                    encoder.writeString(ykey);
                } else {
                    encoder.writeParentInfo(false); // write parent id
                    encoder.writeLeftID(parentItem.id);
                }
            } else if (parent.constructor === String) {
                encoder.writeParentInfo(true); // write parentYKey
                encoder.writeString(parent);
            } else if (parent.constructor === $4bf7ba9bbb4881ae$export$8be180ec26319f9f) {
                encoder.writeParentInfo(false); // write parent id
                encoder.writeLeftID(parent);
            } else $iVMsw.unexpectedCase();
            if (parentSub !== null) encoder.writeString(parentSub);
        }
        this.content.write(encoder, offset);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @param {number} info
 */ const $4bf7ba9bbb4881ae$var$readItemContent = (decoder, info)=>$4bf7ba9bbb4881ae$var$contentRefs[info & $51l7Q.BITS5](decoder);
/**
 * A lookup map for reading Item content.
 *
 * @type {Array<function(UpdateDecoderV1 | UpdateDecoderV2):AbstractContent>}
 */ const $4bf7ba9bbb4881ae$var$contentRefs = [
    ()=>{
        $iVMsw.unexpectedCase();
    },
    $4bf7ba9bbb4881ae$var$readContentDeleted,
    $4bf7ba9bbb4881ae$var$readContentJSON,
    $4bf7ba9bbb4881ae$var$readContentBinary,
    $4bf7ba9bbb4881ae$var$readContentString,
    $4bf7ba9bbb4881ae$var$readContentEmbed,
    $4bf7ba9bbb4881ae$var$readContentFormat,
    $4bf7ba9bbb4881ae$var$readContentType,
    $4bf7ba9bbb4881ae$var$readContentAny,
    $4bf7ba9bbb4881ae$var$readContentDoc,
    ()=>{
        $iVMsw.unexpectedCase();
    } // 10 - Skip is not ItemContent
];
const $4bf7ba9bbb4881ae$var$structSkipRefNumber = 10;
/**
 * @private
 */ class $4bf7ba9bbb4881ae$export$38d24f5c1eb0e4c0 extends $4bf7ba9bbb4881ae$export$3cf6f9765c5c3196 {
    get deleted() {
        return true;
    }
    delete() {}
    /**
   * @param {Skip} right
   * @return {boolean}
   */ mergeWith(right) {
        if (this.constructor !== right.constructor) return false;
        this.length += right.length;
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {number} offset
   */ integrate(transaction, offset) {
        // skip structs cannot be integrated
        $iVMsw.unexpectedCase();
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeInfo($4bf7ba9bbb4881ae$var$structSkipRefNumber);
        // write as VarUint because Skips can't make use of predictable length-encoding
        $6E0HV.writeVarUint(encoder.restEncoder, this.length - offset);
    }
    /**
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */ getMissing(transaction, store) {
        return null;
    }
}
/** eslint-env browser */ const $4bf7ba9bbb4881ae$var$glo = /** @type {any} */ typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {};
const $4bf7ba9bbb4881ae$var$importIdentifier = "__ $YJS$ __";
if ($4bf7ba9bbb4881ae$var$glo[$4bf7ba9bbb4881ae$var$importIdentifier] === true) /**
   * Dear reader of this message. Please take this seriously.
   *
   * If you see this message, make sure that you only import one version of Yjs. In many cases,
   * your package manager installs two versions of Yjs that are used by different packages within your project.
   * Another reason for this message is that some parts of your project use the commonjs version of Yjs
   * and others use the EcmaScript version of Yjs.
   *
   * This often leads to issues that are hard to debug. We often need to perform constructor checks,
   * e.g. `struct instanceof GC`. If you imported different versions of Yjs, it is impossible for us to
   * do the constructor checks anymore - which might break the CRDT algorithm.
   *
   * https://github.com/yjs/yjs/issues/438
   */ console.error("Yjs was already imported. This breaks constructor checks and will lead to issues! - https://github.com/yjs/yjs/issues/438");
$4bf7ba9bbb4881ae$var$glo[$4bf7ba9bbb4881ae$var$importIdentifier] = true;

});
parcelRegister("3S8dv", function(module, exports) {

$parcel$export(module.exports, "ObservableV2", () => $2d1cc9e974523d72$export$e23d3436ce401adc);
/**
 * Observable class prototype.
 *
 * @module observable
 */ 
var $dh5fq = parcelRequire("dh5fq");

var $bUD5M = parcelRequire("bUD5M");

var $iiUWJ = parcelRequire("iiUWJ");
class $2d1cc9e974523d72$export$e23d3436ce401adc {
    constructor(){
        /**
     * Some desc.
     * @type {Map<string, Set<any>>}
     */ this._observers = $dh5fq.create();
    }
    /**
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name
   * @param {EVENTS[NAME]} f
   */ on(name, f) {
        $dh5fq.setIfUndefined(this._observers, /** @type {string} */ name, $bUD5M.create).add(f);
        return f;
    }
    /**
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name
   * @param {EVENTS[NAME]} f
   */ once(name, f) {
        /**
     * @param  {...any} args
     */ const _f = (...args)=>{
            this.off(name, /** @type {any} */ _f);
            f(...args);
        };
        this.on(name, /** @type {any} */ _f);
    }
    /**
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name
   * @param {EVENTS[NAME]} f
   */ off(name, f) {
        const observers = this._observers.get(name);
        if (observers !== undefined) {
            observers.delete(f);
            if (observers.size === 0) this._observers.delete(name);
        }
    }
    /**
   * Emit a named event. All registered event listeners that listen to the
   * specified name will receive the event.
   *
   * @todo This should catch exceptions
   *
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name The event name.
   * @param {Parameters<EVENTS[NAME]>} args The arguments that are applied to the event listener.
   */ emit(name, args) {
        // copy all listeners to an array first to make sure that no event is emitted to listeners that are subscribed while the event handler is called.
        return $iiUWJ.from((this._observers.get(name) || $dh5fq.create()).values()).forEach((f)=>f(...args));
    }
    destroy() {
        this._observers = $dh5fq.create();
    }
}
class $2d1cc9e974523d72$export$77cea355fa80b5f4 {
    constructor(){
        /**
     * Some desc.
     * @type {Map<N, any>}
     */ this._observers = $dh5fq.create();
    }
    /**
   * @param {N} name
   * @param {function} f
   */ on(name, f) {
        $dh5fq.setIfUndefined(this._observers, name, $bUD5M.create).add(f);
    }
    /**
   * @param {N} name
   * @param {function} f
   */ once(name, f) {
        /**
     * @param  {...any} args
     */ const _f = (...args)=>{
            this.off(name, _f);
            f(...args);
        };
        this.on(name, _f);
    }
    /**
   * @param {N} name
   * @param {function} f
   */ off(name, f) {
        const observers = this._observers.get(name);
        if (observers !== undefined) {
            observers.delete(f);
            if (observers.size === 0) this._observers.delete(name);
        }
    }
    /**
   * Emit a named event. All registered event listeners that listen to the
   * specified name will receive the event.
   *
   * @todo This should catch exceptions
   *
   * @param {N} name The event name.
   * @param {Array<any>} args The arguments that are applied to the event listener.
   */ emit(name, args) {
        // copy all listeners to an array first to make sure that no event is emitted to listeners that are subscribed while the event handler is called.
        return $iiUWJ.from((this._observers.get(name) || $dh5fq.create()).values()).forEach((f)=>f(...args));
    }
    destroy() {
        this._observers = $dh5fq.create();
    }
} /* c8 ignore end */ 

});
parcelRegister("dh5fq", function(module, exports) {

$parcel$export(module.exports, "create", () => $9aa0eef8cf9b7c5d$export$185802fd694ee1f5);
$parcel$export(module.exports, "copy", () => $9aa0eef8cf9b7c5d$export$784d13d8ee351f07);
$parcel$export(module.exports, "setIfUndefined", () => $9aa0eef8cf9b7c5d$export$dccd489362a8619);
$parcel$export(module.exports, "map", () => $9aa0eef8cf9b7c5d$export$871de8747c9eaa88);
$parcel$export(module.exports, "any", () => $9aa0eef8cf9b7c5d$export$4154a199d7d90455);
/**
 * Utility module to work with key-value stores.
 *
 * @module map
 */ /**
 * Creates a new Map instance.
 *
 * @function
 * @return {Map<any, any>}
 *
 * @function
 */ const $9aa0eef8cf9b7c5d$export$185802fd694ee1f5 = ()=>new Map();
const $9aa0eef8cf9b7c5d$export$784d13d8ee351f07 = (m)=>{
    const r = $9aa0eef8cf9b7c5d$export$185802fd694ee1f5();
    m.forEach((v, k)=>{
        r.set(k, v);
    });
    return r;
};
const $9aa0eef8cf9b7c5d$export$dccd489362a8619 = (map, key, createT)=>{
    let set = map.get(key);
    if (set === undefined) map.set(key, set = createT());
    return set;
};
const $9aa0eef8cf9b7c5d$export$871de8747c9eaa88 = (m, f)=>{
    const res = [];
    for (const [key, value] of m)res.push(f(value, key));
    return res;
};
const $9aa0eef8cf9b7c5d$export$4154a199d7d90455 = (m, f)=>{
    for (const [key, value] of m){
        if (f(value, key)) return true;
    }
    return false;
};
const $9aa0eef8cf9b7c5d$export$84bf76cd7afc7469 = (m, f)=>{
    for (const [key, value] of m){
        if (!f(value, key)) return false;
    }
    return true;
};

});

parcelRegister("bUD5M", function(module, exports) {

$parcel$export(module.exports, "create", () => $8ac33f8e79bfeab7$export$185802fd694ee1f5);
$parcel$export(module.exports, "from", () => $8ac33f8e79bfeab7$export$6788812c4e6611e6);
/**
 * Utility module to work with sets.
 *
 * @module set
 */ const $8ac33f8e79bfeab7$export$185802fd694ee1f5 = ()=>new Set();
const $8ac33f8e79bfeab7$export$45b10814cc054894 = (set)=>Array.from(set);
const $8ac33f8e79bfeab7$export$43128fadae87b74a = (set)=>set.values().next().value || undefined;
const $8ac33f8e79bfeab7$export$6788812c4e6611e6 = (entries)=>new Set(entries);

});

parcelRegister("iiUWJ", function(module, exports) {

$parcel$export(module.exports, "last", () => $d53614cae2ce1259$export$4c7897fafd92b108);
$parcel$export(module.exports, "appendTo", () => $d53614cae2ce1259$export$9ceefe31f12a3778);
$parcel$export(module.exports, "from", () => $d53614cae2ce1259$export$6788812c4e6611e6);
$parcel$export(module.exports, "some", () => $d53614cae2ce1259$export$ad14ef4001db2bcd);
$parcel$export(module.exports, "equalFlat", () => $d53614cae2ce1259$export$4f1c34abb2bb4c8);
$parcel$export(module.exports, "unfold", () => $d53614cae2ce1259$export$c48e357c1a89b78d);
$parcel$export(module.exports, "isArray", () => $d53614cae2ce1259$export$43bee75e5e14138e);
$parcel$export(module.exports, "map", () => $d53614cae2ce1259$export$871de8747c9eaa88);
/**
 * Utility module to work with Arrays.
 *
 * @module array
 */ 
var $bUD5M = parcelRequire("bUD5M");
const $d53614cae2ce1259$export$4c7897fafd92b108 = (arr)=>arr[arr.length - 1];
const $d53614cae2ce1259$export$185802fd694ee1f5 = ()=>/** @type {Array<C>} */ [];
const $d53614cae2ce1259$export$784d13d8ee351f07 = (a)=>/** @type {Array<D>} */ a.slice();
const $d53614cae2ce1259$export$9ceefe31f12a3778 = (dest, src)=>{
    for(let i = 0; i < src.length; i++)dest.push(src[i]);
};
const $d53614cae2ce1259$export$6788812c4e6611e6 = Array.from;
const $d53614cae2ce1259$export$7ecc1a3b11b57dab = (arr, f)=>{
    for(let i = 0; i < arr.length; i++){
        if (!f(arr[i], i, arr)) return false;
    }
    return true;
};
const $d53614cae2ce1259$export$ad14ef4001db2bcd = (arr, f)=>{
    for(let i = 0; i < arr.length; i++){
        if (f(arr[i], i, arr)) return true;
    }
    return false;
};
const $d53614cae2ce1259$export$4f1c34abb2bb4c8 = (a, b)=>a.length === b.length && $d53614cae2ce1259$export$7ecc1a3b11b57dab(a, (item, index)=>item === b[index]);
const $d53614cae2ce1259$export$bffa455ba8c619a6 = (arr)=>$d53614cae2ce1259$export$93e2b83da34ff82a(arr, /** @type {Array<ELEM>} */ [], (acc, val)=>acc.concat(val));
const $d53614cae2ce1259$export$c48e357c1a89b78d = (len, f)=>{
    const array = new Array(len);
    for(let i = 0; i < len; i++)array[i] = f(i, array);
    return array;
};
const $d53614cae2ce1259$export$93e2b83da34ff82a = (arr, seed, folder)=>arr.reduce(folder, seed);
const $d53614cae2ce1259$export$43bee75e5e14138e = Array.isArray;
const $d53614cae2ce1259$export$7a5d5c156e7dc406 = (arr)=>$d53614cae2ce1259$export$6788812c4e6611e6($bUD5M.from(arr));
const $d53614cae2ce1259$export$abf0e2545164275f = (arr, mapper)=>{
    /**
   * @type {Set<M>}
   */ const happened = $bUD5M.create();
    /**
   * @type {Array<T>}
   */ const result = [];
    for(let i = 0; i < arr.length; i++){
        const el = arr[i];
        const mapped = mapper(el);
        if (!happened.has(mapped)) {
            happened.add(mapped);
            result.push(el);
        }
    }
    return result;
};
const $d53614cae2ce1259$export$871de8747c9eaa88 = (arr, mapper)=>{
    /**
   * @type {Array<any>}
   */ const res = Array(arr.length);
    for(let i = 0; i < arr.length; i++)res[i] = mapper(/** @type {any} */ arr[i], i, /** @type {any} */ arr);
    return /** @type {any} */ res;
};

});


parcelRegister("5qKvF", function(module, exports) {

$parcel$export(module.exports, "floor", () => $3f4375554eb7b68e$export$a3fe094919f356fd);
$parcel$export(module.exports, "ceil", () => $3f4375554eb7b68e$export$803ce6b71a0a94b2);
$parcel$export(module.exports, "abs", () => $3f4375554eb7b68e$export$2335f513bbd82c6d);
$parcel$export(module.exports, "round", () => $3f4375554eb7b68e$export$2077e0241d6afd3c);
$parcel$export(module.exports, "log10", () => $3f4375554eb7b68e$export$75e08744a3ff8516);
$parcel$export(module.exports, "min", () => $3f4375554eb7b68e$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $3f4375554eb7b68e$export$8960430cfd85939f);
$parcel$export(module.exports, "exp10", () => $3f4375554eb7b68e$export$1bb2a14208c790f7);
$parcel$export(module.exports, "isNegativeZero", () => $3f4375554eb7b68e$export$dc0a61f4a9121f92);
/**
 * Common Math expressions.
 *
 * @module math
 */ const $3f4375554eb7b68e$export$a3fe094919f356fd = Math.floor;
const $3f4375554eb7b68e$export$803ce6b71a0a94b2 = Math.ceil;
const $3f4375554eb7b68e$export$2335f513bbd82c6d = Math.abs;
const $3f4375554eb7b68e$export$46de3d998ca9a030 = Math.imul;
const $3f4375554eb7b68e$export$2077e0241d6afd3c = Math.round;
const $3f4375554eb7b68e$export$75e08744a3ff8516 = Math.log10;
const $3f4375554eb7b68e$export$b9fae0bba9d9094d = Math.log2;
const $3f4375554eb7b68e$export$bef1f36f5486a6a3 = Math.log;
const $3f4375554eb7b68e$export$eba8049fb5020b81 = Math.sqrt;
const $3f4375554eb7b68e$export$e16d8520af44a096 = (a, b)=>a + b;
const $3f4375554eb7b68e$export$96ec731ed4dcb222 = (a, b)=>a < b ? a : b;
const $3f4375554eb7b68e$export$8960430cfd85939f = (a, b)=>a > b ? a : b;
const $3f4375554eb7b68e$export$c9f5652083b8129d = Number.isNaN;
const $3f4375554eb7b68e$export$9c297f60e22e3389 = Math.pow;
const $3f4375554eb7b68e$export$1bb2a14208c790f7 = (exp)=>Math.pow(10, exp);
const $3f4375554eb7b68e$export$c5552dfdbc7cec71 = Math.sign;
const $3f4375554eb7b68e$export$dc0a61f4a9121f92 = (n)=>n !== 0 ? n < 0 : 1 / n < 0;

});

parcelRegister("6E0HV", function(module, exports) {

$parcel$export(module.exports, "createEncoder", () => $4d670700afc0580a$export$4e76eeb6df88c889);
$parcel$export(module.exports, "encode", () => $4d670700afc0580a$export$c564cdbbe6da493);
$parcel$export(module.exports, "toUint8Array", () => $4d670700afc0580a$export$73470fd2221e6aef);
$parcel$export(module.exports, "write", () => $4d670700afc0580a$export$68d8715fc104d294);
$parcel$export(module.exports, "writeUint8", () => $4d670700afc0580a$export$826a1a6619653272);
$parcel$export(module.exports, "writeVarUint", () => $4d670700afc0580a$export$872f48c75febcd2b);
$parcel$export(module.exports, "writeVarInt", () => $4d670700afc0580a$export$ff90f819e16cc9bb);
$parcel$export(module.exports, "writeVarUint8Array", () => $4d670700afc0580a$export$f7d11515275e88a2);
$parcel$export(module.exports, "writeVarString", () => $4d670700afc0580a$export$dde49cb52d5f1650);
$parcel$export(module.exports, "writeBinaryEncoder", () => $4d670700afc0580a$export$c029b62321ea3da);
$parcel$export(module.exports, "writeUint8Array", () => $4d670700afc0580a$export$73b5e63e27d2b4c7);
$parcel$export(module.exports, "writeAny", () => $4d670700afc0580a$export$264b1e8551468ea);
$parcel$export(module.exports, "RleEncoder", () => $4d670700afc0580a$export$8fa72bb4fa9409ff);
$parcel$export(module.exports, "UintOptRleEncoder", () => $4d670700afc0580a$export$785ebd3312c38061);
$parcel$export(module.exports, "IntDiffOptRleEncoder", () => $4d670700afc0580a$export$7542c66a59375c6f);
$parcel$export(module.exports, "StringEncoder", () => $4d670700afc0580a$export$7dcdc5c32f31c550);
/**
 * Efficient schema-less binary encoding with support for variable length encoding.
 *
 * Use [lib0/encoding] with [lib0/decoding]. Every encoding function has a corresponding decoding function.
 *
 * Encodes numbers in little-endian order (least to most significant byte order)
 * and is compatible with Golang's binary encoding (https://golang.org/pkg/encoding/binary/)
 * which is also used in Protocol Buffers.
 *
 * ```js
 * // encoding step
 * const encoder = encoding.createEncoder()
 * encoding.writeVarUint(encoder, 256)
 * encoding.writeVarString(encoder, 'Hello world!')
 * const buf = encoding.toUint8Array(encoder)
 * ```
 *
 * ```js
 * // decoding step
 * const decoder = decoding.createDecoder(buf)
 * decoding.readVarUint(decoder) // => 256
 * decoding.readVarString(decoder) // => 'Hello world!'
 * decoding.hasContent(decoder) // => false - all data is read
 * ```
 *
 * @module encoding
 */ 
var $5qKvF = parcelRequire("5qKvF");

var $74Oxs = parcelRequire("74Oxs");

var $51l7Q = parcelRequire("51l7Q");

var $dVtwn = parcelRequire("dVtwn");

var $iiUWJ = parcelRequire("iiUWJ");
class $4d670700afc0580a$export$a50aceb0e02a00aa {
    constructor(){
        this.cpos = 0;
        this.cbuf = new Uint8Array(100);
        /**
     * @type {Array<Uint8Array>}
     */ this.bufs = [];
    }
}
const $4d670700afc0580a$export$4e76eeb6df88c889 = ()=>new $4d670700afc0580a$export$a50aceb0e02a00aa();
const $4d670700afc0580a$export$c564cdbbe6da493 = (f)=>{
    const encoder = $4d670700afc0580a$export$4e76eeb6df88c889();
    f(encoder);
    return $4d670700afc0580a$export$73470fd2221e6aef(encoder);
};
const $4d670700afc0580a$export$f24224f1c91d8156 = (encoder)=>{
    let len = encoder.cpos;
    for(let i = 0; i < encoder.bufs.length; i++)len += encoder.bufs[i].length;
    return len;
};
const $4d670700afc0580a$export$7ad75c69830b76d7 = (encoder)=>encoder.cpos > 0 || encoder.bufs.length > 0;
const $4d670700afc0580a$export$73470fd2221e6aef = (encoder)=>{
    const uint8arr = new Uint8Array($4d670700afc0580a$export$f24224f1c91d8156(encoder));
    let curPos = 0;
    for(let i = 0; i < encoder.bufs.length; i++){
        const d = encoder.bufs[i];
        uint8arr.set(d, curPos);
        curPos += d.length;
    }
    uint8arr.set(new Uint8Array(encoder.cbuf.buffer, 0, encoder.cpos), curPos);
    return uint8arr;
};
const $4d670700afc0580a$export$39fb588b9aff60c5 = (encoder, len)=>{
    const bufferLen = encoder.cbuf.length;
    if (bufferLen - encoder.cpos < len) {
        encoder.bufs.push(new Uint8Array(encoder.cbuf.buffer, 0, encoder.cpos));
        encoder.cbuf = new Uint8Array($5qKvF.max(bufferLen, len) * 2);
        encoder.cpos = 0;
    }
};
const $4d670700afc0580a$export$68d8715fc104d294 = (encoder, num)=>{
    const bufferLen = encoder.cbuf.length;
    if (encoder.cpos === bufferLen) {
        encoder.bufs.push(encoder.cbuf);
        encoder.cbuf = new Uint8Array(bufferLen * 2);
        encoder.cpos = 0;
    }
    encoder.cbuf[encoder.cpos++] = num;
};
const $4d670700afc0580a$export$adaa4cf7ef1b65be = (encoder, pos, num)=>{
    let buffer = null;
    // iterate all buffers and adjust position
    for(let i = 0; i < encoder.bufs.length && buffer === null; i++){
        const b = encoder.bufs[i];
        if (pos < b.length) buffer = b // found buffer
        ;
        else pos -= b.length;
    }
    if (buffer === null) // use current buffer
    buffer = encoder.cbuf;
    buffer[pos] = num;
};
const $4d670700afc0580a$export$826a1a6619653272 = $4d670700afc0580a$export$68d8715fc104d294;
const $4d670700afc0580a$export$83964ea8501fbf8 = $4d670700afc0580a$export$adaa4cf7ef1b65be;
const $4d670700afc0580a$export$ba6b74b6f3145a00 = (encoder, num)=>{
    $4d670700afc0580a$export$68d8715fc104d294(encoder, num & $51l7Q.BITS8);
    $4d670700afc0580a$export$68d8715fc104d294(encoder, num >>> 8 & $51l7Q.BITS8);
};
const $4d670700afc0580a$export$f86e1edc3d839287 = (encoder, pos, num)=>{
    $4d670700afc0580a$export$adaa4cf7ef1b65be(encoder, pos, num & $51l7Q.BITS8);
    $4d670700afc0580a$export$adaa4cf7ef1b65be(encoder, pos + 1, num >>> 8 & $51l7Q.BITS8);
};
const $4d670700afc0580a$export$835343b0f7799f5b = (encoder, num)=>{
    for(let i = 0; i < 4; i++){
        $4d670700afc0580a$export$68d8715fc104d294(encoder, num & $51l7Q.BITS8);
        num >>>= 8;
    }
};
const $4d670700afc0580a$export$efed0d8c16230d13 = (encoder, num)=>{
    for(let i = 3; i >= 0; i--)$4d670700afc0580a$export$68d8715fc104d294(encoder, num >>> 8 * i & $51l7Q.BITS8);
};
const $4d670700afc0580a$export$5517b6394fc440fb = (encoder, pos, num)=>{
    for(let i = 0; i < 4; i++){
        $4d670700afc0580a$export$adaa4cf7ef1b65be(encoder, pos + i, num & $51l7Q.BITS8);
        num >>>= 8;
    }
};
const $4d670700afc0580a$export$872f48c75febcd2b = (encoder, num)=>{
    while(num > $51l7Q.BITS7){
        $4d670700afc0580a$export$68d8715fc104d294(encoder, $51l7Q.BIT8 | $51l7Q.BITS7 & num);
        num = $5qKvF.floor(num / 128) // shift >>> 7
        ;
    }
    $4d670700afc0580a$export$68d8715fc104d294(encoder, $51l7Q.BITS7 & num);
};
const $4d670700afc0580a$export$ff90f819e16cc9bb = (encoder, num)=>{
    const isNegative = $5qKvF.isNegativeZero(num);
    if (isNegative) num = -num;
    //             |- whether to continue reading         |- whether is negative     |- number
    $4d670700afc0580a$export$68d8715fc104d294(encoder, (num > $51l7Q.BITS6 ? $51l7Q.BIT8 : 0) | (isNegative ? $51l7Q.BIT7 : 0) | $51l7Q.BITS6 & num);
    num = $5qKvF.floor(num / 64) // shift >>> 6
    ;
    // We don't need to consider the case of num === 0 so we can use a different
    // pattern here than above.
    while(num > 0){
        $4d670700afc0580a$export$68d8715fc104d294(encoder, (num > $51l7Q.BITS7 ? $51l7Q.BIT8 : 0) | $51l7Q.BITS7 & num);
        num = $5qKvF.floor(num / 128) // shift >>> 7
        ;
    }
};
/**
 * A cache to store strings temporarily
 */ const $4d670700afc0580a$var$_strBuffer = new Uint8Array(30000);
const $4d670700afc0580a$var$_maxStrBSize = $4d670700afc0580a$var$_strBuffer.length / 3;
const $4d670700afc0580a$export$dff327976627e12b = (encoder, str)=>{
    if (str.length < $4d670700afc0580a$var$_maxStrBSize) {
        // We can encode the string into the existing buffer
        /* c8 ignore next */ const written = $dVtwn.utf8TextEncoder.encodeInto(str, $4d670700afc0580a$var$_strBuffer).written || 0;
        $4d670700afc0580a$export$872f48c75febcd2b(encoder, written);
        for(let i = 0; i < written; i++)$4d670700afc0580a$export$68d8715fc104d294(encoder, $4d670700afc0580a$var$_strBuffer[i]);
    } else $4d670700afc0580a$export$f7d11515275e88a2(encoder, $dVtwn.encodeUtf8(str));
};
const $4d670700afc0580a$export$94cf4193edfe959a = (encoder, str)=>{
    const encodedString = unescape(encodeURIComponent(str));
    const len = encodedString.length;
    $4d670700afc0580a$export$872f48c75febcd2b(encoder, len);
    for(let i = 0; i < len; i++)$4d670700afc0580a$export$68d8715fc104d294(encoder, /** @type {number} */ encodedString.codePointAt(i));
};
const $4d670700afc0580a$export$dde49cb52d5f1650 = $dVtwn.utf8TextEncoder && /** @type {any} */ $dVtwn.utf8TextEncoder.encodeInto ? $4d670700afc0580a$export$dff327976627e12b : $4d670700afc0580a$export$94cf4193edfe959a;
const $4d670700afc0580a$export$be5604ffb9fbbd0c = (encoder, str)=>$4d670700afc0580a$export$6c17d6eec4abdaa6(encoder, $dVtwn.encodeUtf8(str));
const $4d670700afc0580a$export$6c17d6eec4abdaa6 = (encoder, buf)=>{
    for(let i = 0; i < buf.length; i++){
        const b = buf[i];
        if (b === 0 || b === 1) $4d670700afc0580a$export$68d8715fc104d294(encoder, 1);
        $4d670700afc0580a$export$68d8715fc104d294(encoder, buf[i]);
    }
    $4d670700afc0580a$export$68d8715fc104d294(encoder, 0);
};
const $4d670700afc0580a$export$c029b62321ea3da = (encoder, append)=>$4d670700afc0580a$export$73b5e63e27d2b4c7(encoder, $4d670700afc0580a$export$73470fd2221e6aef(append));
const $4d670700afc0580a$export$73b5e63e27d2b4c7 = (encoder, uint8Array)=>{
    const bufferLen = encoder.cbuf.length;
    const cpos = encoder.cpos;
    const leftCopyLen = $5qKvF.min(bufferLen - cpos, uint8Array.length);
    const rightCopyLen = uint8Array.length - leftCopyLen;
    encoder.cbuf.set(uint8Array.subarray(0, leftCopyLen), cpos);
    encoder.cpos += leftCopyLen;
    if (rightCopyLen > 0) {
        // Still something to write, write right half..
        // Append new buffer
        encoder.bufs.push(encoder.cbuf);
        // must have at least size of remaining buffer
        encoder.cbuf = new Uint8Array($5qKvF.max(bufferLen * 2, rightCopyLen));
        // copy array
        encoder.cbuf.set(uint8Array.subarray(leftCopyLen));
        encoder.cpos = rightCopyLen;
    }
};
const $4d670700afc0580a$export$f7d11515275e88a2 = (encoder, uint8Array)=>{
    $4d670700afc0580a$export$872f48c75febcd2b(encoder, uint8Array.byteLength);
    $4d670700afc0580a$export$73b5e63e27d2b4c7(encoder, uint8Array);
};
const $4d670700afc0580a$export$1f031ae9c71bd530 = (encoder, len)=>{
    $4d670700afc0580a$export$39fb588b9aff60c5(encoder, len);
    const dview = new DataView(encoder.cbuf.buffer, encoder.cpos, len);
    encoder.cpos += len;
    return dview;
};
const $4d670700afc0580a$export$a33455db0a9638a6 = (encoder, num)=>$4d670700afc0580a$export$1f031ae9c71bd530(encoder, 4).setFloat32(0, num, false);
const $4d670700afc0580a$export$231a04cea676c54c = (encoder, num)=>$4d670700afc0580a$export$1f031ae9c71bd530(encoder, 8).setFloat64(0, num, false);
const $4d670700afc0580a$export$4fbfa93dd6e14543 = (encoder, num)=>/** @type {any} */ $4d670700afc0580a$export$1f031ae9c71bd530(encoder, 8).setBigInt64(0, num, false);
const $4d670700afc0580a$export$663ca46034903888 = (encoder, num)=>/** @type {any} */ $4d670700afc0580a$export$1f031ae9c71bd530(encoder, 8).setBigUint64(0, num, false);
const $4d670700afc0580a$var$floatTestBed = new DataView(new ArrayBuffer(4));
/**
 * Check if a number can be encoded as a 32 bit float.
 *
 * @param {number} num
 * @return {boolean}
 */ const $4d670700afc0580a$var$isFloat32 = (num)=>{
    $4d670700afc0580a$var$floatTestBed.setFloat32(0, num);
    return $4d670700afc0580a$var$floatTestBed.getFloat32(0) === num;
};
const $4d670700afc0580a$export$264b1e8551468ea = (encoder, data)=>{
    switch(typeof data){
        case "string":
            // TYPE 119: STRING
            $4d670700afc0580a$export$68d8715fc104d294(encoder, 119);
            $4d670700afc0580a$export$dde49cb52d5f1650(encoder, data);
            break;
        case "number":
            if ($74Oxs.isInteger(data) && $5qKvF.abs(data) <= $51l7Q.BITS31) {
                // TYPE 125: INTEGER
                $4d670700afc0580a$export$68d8715fc104d294(encoder, 125);
                $4d670700afc0580a$export$ff90f819e16cc9bb(encoder, data);
            } else if ($4d670700afc0580a$var$isFloat32(data)) {
                // TYPE 124: FLOAT32
                $4d670700afc0580a$export$68d8715fc104d294(encoder, 124);
                $4d670700afc0580a$export$a33455db0a9638a6(encoder, data);
            } else {
                // TYPE 123: FLOAT64
                $4d670700afc0580a$export$68d8715fc104d294(encoder, 123);
                $4d670700afc0580a$export$231a04cea676c54c(encoder, data);
            }
            break;
        case "bigint":
            // TYPE 122: BigInt
            $4d670700afc0580a$export$68d8715fc104d294(encoder, 122);
            $4d670700afc0580a$export$4fbfa93dd6e14543(encoder, data);
            break;
        case "object":
            if (data === null) // TYPE 126: null
            $4d670700afc0580a$export$68d8715fc104d294(encoder, 126);
            else if ($iiUWJ.isArray(data)) {
                // TYPE 117: Array
                $4d670700afc0580a$export$68d8715fc104d294(encoder, 117);
                $4d670700afc0580a$export$872f48c75febcd2b(encoder, data.length);
                for(let i = 0; i < data.length; i++)$4d670700afc0580a$export$264b1e8551468ea(encoder, data[i]);
            } else if (data instanceof Uint8Array) {
                // TYPE 116: ArrayBuffer
                $4d670700afc0580a$export$68d8715fc104d294(encoder, 116);
                $4d670700afc0580a$export$f7d11515275e88a2(encoder, data);
            } else {
                // TYPE 118: Object
                $4d670700afc0580a$export$68d8715fc104d294(encoder, 118);
                const keys = Object.keys(data);
                $4d670700afc0580a$export$872f48c75febcd2b(encoder, keys.length);
                for(let i = 0; i < keys.length; i++){
                    const key = keys[i];
                    $4d670700afc0580a$export$dde49cb52d5f1650(encoder, key);
                    $4d670700afc0580a$export$264b1e8551468ea(encoder, data[key]);
                }
            }
            break;
        case "boolean":
            // TYPE 120/121: boolean (true/false)
            $4d670700afc0580a$export$68d8715fc104d294(encoder, data ? 120 : 121);
            break;
        default:
            // TYPE 127: undefined
            $4d670700afc0580a$export$68d8715fc104d294(encoder, 127);
    }
};
class $4d670700afc0580a$export$8fa72bb4fa9409ff extends $4d670700afc0580a$export$a50aceb0e02a00aa {
    /**
   * @param {function(Encoder, T):void} writer
   */ constructor(writer){
        super();
        /**
     * The writer
     */ this.w = writer;
        /**
     * Current state
     * @type {T|null}
     */ this.s = null;
        this.count = 0;
    }
    /**
   * @param {T} v
   */ write(v) {
        if (this.s === v) this.count++;
        else {
            if (this.count > 0) // flush counter, unless this is the first value (count = 0)
            $4d670700afc0580a$export$872f48c75febcd2b(this, this.count - 1) // since count is always > 0, we can decrement by one. non-standard encoding ftw
            ;
            this.count = 1;
            // write first value
            this.w(this, v);
            this.s = v;
        }
    }
}
class $4d670700afc0580a$export$c636f3fa46f2752c extends $4d670700afc0580a$export$a50aceb0e02a00aa {
    /**
   * @param {number} start
   */ constructor(start){
        super();
        /**
     * Current state
     * @type {number}
     */ this.s = start;
    }
    /**
   * @param {number} v
   */ write(v) {
        $4d670700afc0580a$export$ff90f819e16cc9bb(this, v - this.s);
        this.s = v;
    }
}
class $4d670700afc0580a$export$29917ece4cb403fb extends $4d670700afc0580a$export$a50aceb0e02a00aa {
    /**
   * @param {number} start
   */ constructor(start){
        super();
        /**
     * Current state
     * @type {number}
     */ this.s = start;
        this.count = 0;
    }
    /**
   * @param {number} v
   */ write(v) {
        if (this.s === v && this.count > 0) this.count++;
        else {
            if (this.count > 0) // flush counter, unless this is the first value (count = 0)
            $4d670700afc0580a$export$872f48c75febcd2b(this, this.count - 1) // since count is always > 0, we can decrement by one. non-standard encoding ftw
            ;
            this.count = 1;
            // write first value
            $4d670700afc0580a$export$ff90f819e16cc9bb(this, v - this.s);
            this.s = v;
        }
    }
}
/**
 * @param {UintOptRleEncoder} encoder
 */ const $4d670700afc0580a$var$flushUintOptRleEncoder = (encoder)=>{
    if (encoder.count > 0) {
        // flush counter, unless this is the first value (count = 0)
        // case 1: just a single value. set sign to positive
        // case 2: write several values. set sign to negative to indicate that there is a length coming
        $4d670700afc0580a$export$ff90f819e16cc9bb(encoder.encoder, encoder.count === 1 ? encoder.s : -encoder.s);
        if (encoder.count > 1) $4d670700afc0580a$export$872f48c75febcd2b(encoder.encoder, encoder.count - 2) // since count is always > 1, we can decrement by one. non-standard encoding ftw
        ;
    }
};
class $4d670700afc0580a$export$785ebd3312c38061 {
    constructor(){
        this.encoder = new $4d670700afc0580a$export$a50aceb0e02a00aa();
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
    }
    /**
   * @param {number} v
   */ write(v) {
        if (this.s === v) this.count++;
        else {
            $4d670700afc0580a$var$flushUintOptRleEncoder(this);
            this.count = 1;
            this.s = v;
        }
    }
    /**
   * Flush the encoded state and transform this to a Uint8Array.
   *
   * Note that this should only be called once.
   */ toUint8Array() {
        $4d670700afc0580a$var$flushUintOptRleEncoder(this);
        return $4d670700afc0580a$export$73470fd2221e6aef(this.encoder);
    }
}
class $4d670700afc0580a$export$f460a01fb0702193 {
    constructor(){
        this.encoder = new $4d670700afc0580a$export$a50aceb0e02a00aa();
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
    }
    /**
   * @param {number} v
   */ write(v) {
        if (this.s + this.count === v) this.count++;
        else {
            $4d670700afc0580a$var$flushUintOptRleEncoder(this);
            this.count = 1;
            this.s = v;
        }
    }
    /**
   * Flush the encoded state and transform this to a Uint8Array.
   *
   * Note that this should only be called once.
   */ toUint8Array() {
        $4d670700afc0580a$var$flushUintOptRleEncoder(this);
        return $4d670700afc0580a$export$73470fd2221e6aef(this.encoder);
    }
}
/**
 * @param {IntDiffOptRleEncoder} encoder
 */ const $4d670700afc0580a$var$flushIntDiffOptRleEncoder = (encoder)=>{
    if (encoder.count > 0) {
        //          31 bit making up the diff | wether to write the counter
        // const encodedDiff = encoder.diff << 1 | (encoder.count === 1 ? 0 : 1)
        const encodedDiff = encoder.diff * 2 + (encoder.count === 1 ? 0 : 1);
        // flush counter, unless this is the first value (count = 0)
        // case 1: just a single value. set first bit to positive
        // case 2: write several values. set first bit to negative to indicate that there is a length coming
        $4d670700afc0580a$export$ff90f819e16cc9bb(encoder.encoder, encodedDiff);
        if (encoder.count > 1) $4d670700afc0580a$export$872f48c75febcd2b(encoder.encoder, encoder.count - 2) // since count is always > 1, we can decrement by one. non-standard encoding ftw
        ;
    }
};
class $4d670700afc0580a$export$7542c66a59375c6f {
    constructor(){
        this.encoder = new $4d670700afc0580a$export$a50aceb0e02a00aa();
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
        this.diff = 0;
    }
    /**
   * @param {number} v
   */ write(v) {
        if (this.diff === v - this.s) {
            this.s = v;
            this.count++;
        } else {
            $4d670700afc0580a$var$flushIntDiffOptRleEncoder(this);
            this.count = 1;
            this.diff = v - this.s;
            this.s = v;
        }
    }
    /**
   * Flush the encoded state and transform this to a Uint8Array.
   *
   * Note that this should only be called once.
   */ toUint8Array() {
        $4d670700afc0580a$var$flushIntDiffOptRleEncoder(this);
        return $4d670700afc0580a$export$73470fd2221e6aef(this.encoder);
    }
}
class $4d670700afc0580a$export$7dcdc5c32f31c550 {
    constructor(){
        /**
     * @type {Array<string>}
     */ this.sarr = [];
        this.s = "";
        this.lensE = new $4d670700afc0580a$export$785ebd3312c38061();
    }
    /**
   * @param {string} string
   */ write(string) {
        this.s += string;
        if (this.s.length > 19) {
            this.sarr.push(this.s);
            this.s = "";
        }
        this.lensE.write(string.length);
    }
    toUint8Array() {
        const encoder = new $4d670700afc0580a$export$a50aceb0e02a00aa();
        this.sarr.push(this.s);
        this.s = "";
        $4d670700afc0580a$export$dde49cb52d5f1650(encoder, this.sarr.join(""));
        $4d670700afc0580a$export$73b5e63e27d2b4c7(encoder, this.lensE.toUint8Array());
        return $4d670700afc0580a$export$73470fd2221e6aef(encoder);
    }
}

});
parcelRegister("74Oxs", function(module, exports) {

$parcel$export(module.exports, "MAX_SAFE_INTEGER", () => $52701c0a4325b6d8$export$18510406f204a1b9);
$parcel$export(module.exports, "isInteger", () => $52701c0a4325b6d8$export$a287f47fed4544b8);
/**
 * Utility helpers for working with numbers.
 *
 * @module number
 */ 
var $5qKvF = parcelRequire("5qKvF");

var $51l7Q = parcelRequire("51l7Q");
const $52701c0a4325b6d8$export$18510406f204a1b9 = Number.MAX_SAFE_INTEGER;
const $52701c0a4325b6d8$export$91ddad910c1af487 = Number.MIN_SAFE_INTEGER;
const $52701c0a4325b6d8$export$7accc3db8e859605 = -2147483648;
const $52701c0a4325b6d8$export$a5f353c3c14c00d0 = $51l7Q.BITS31;
const $52701c0a4325b6d8$export$f055c566d4c0f541 = $51l7Q.BITS32;
const $52701c0a4325b6d8$export$a287f47fed4544b8 = Number.isInteger || ((num)=>typeof num === "number" && isFinite(num) && $5qKvF.floor(num) === num);
const $52701c0a4325b6d8$export$c9f5652083b8129d = Number.isNaN;
const $52701c0a4325b6d8$export$5f87784a266e50a4 = Number.parseInt;
const $52701c0a4325b6d8$export$33de6ea056a4cdbb = (n)=>{
    n &= $51l7Q.BITS32;
    let count = 0;
    while(n){
        n &= n - 1;
        count++;
    }
    return count;
};

});
parcelRegister("51l7Q", function(module, exports) {

$parcel$export(module.exports, "BIT1", () => $3a7d6ed40a35815d$export$ee2c6657cb286da4);
$parcel$export(module.exports, "BIT2", () => $3a7d6ed40a35815d$export$1f117f3b0edc2676);
$parcel$export(module.exports, "BIT3", () => $3a7d6ed40a35815d$export$e5294f8c78cf7711);
$parcel$export(module.exports, "BIT4", () => $3a7d6ed40a35815d$export$873ae8db4cef5125);
$parcel$export(module.exports, "BIT6", () => $3a7d6ed40a35815d$export$daf23f774967089);
$parcel$export(module.exports, "BIT7", () => $3a7d6ed40a35815d$export$eb5a8e0006ab4bb5);
$parcel$export(module.exports, "BIT8", () => $3a7d6ed40a35815d$export$e25597372303a045);
$parcel$export(module.exports, "BITS5", () => $3a7d6ed40a35815d$export$bc2aba63e4099c09);
$parcel$export(module.exports, "BITS6", () => $3a7d6ed40a35815d$export$f39f4e074e983a34);
$parcel$export(module.exports, "BITS7", () => $3a7d6ed40a35815d$export$f84d6bebff154ceb);
$parcel$export(module.exports, "BITS8", () => $3a7d6ed40a35815d$export$c880072ee0e87648);
$parcel$export(module.exports, "BITS21", () => $3a7d6ed40a35815d$export$b5ffbef7f0f6f536);
$parcel$export(module.exports, "BITS31", () => $3a7d6ed40a35815d$export$87ec42487f19c66c);
$parcel$export(module.exports, "BITS32", () => $3a7d6ed40a35815d$export$3ea07c5174cba08a);
/* eslint-env browser */ /**
 * Binary data constants.
 *
 * @module binary
 */ /**
 * n-th bit activated.
 *
 * @type {number}
 */ const $3a7d6ed40a35815d$export$ee2c6657cb286da4 = 1;
const $3a7d6ed40a35815d$export$1f117f3b0edc2676 = 2;
const $3a7d6ed40a35815d$export$e5294f8c78cf7711 = 4;
const $3a7d6ed40a35815d$export$873ae8db4cef5125 = 8;
const $3a7d6ed40a35815d$export$b6e6496517dfbd31 = 16;
const $3a7d6ed40a35815d$export$daf23f774967089 = 32;
const $3a7d6ed40a35815d$export$eb5a8e0006ab4bb5 = 64;
const $3a7d6ed40a35815d$export$e25597372303a045 = 128;
const $3a7d6ed40a35815d$export$f15587807021fe79 = 256;
const $3a7d6ed40a35815d$export$70939d57ba836c5 = 512;
const $3a7d6ed40a35815d$export$9ec47920d80e8c85 = 1024;
const $3a7d6ed40a35815d$export$bc5dd16b35d4584b = 2048;
const $3a7d6ed40a35815d$export$76a85e893e6d6ecc = 4096;
const $3a7d6ed40a35815d$export$fb6ca64a3ffa3aa9 = 8192;
const $3a7d6ed40a35815d$export$e7adc86ee9ea4b00 = 16384;
const $3a7d6ed40a35815d$export$6aa68b9346d558bb = 32768;
const $3a7d6ed40a35815d$export$5d7aab37466c79ea = 65536;
const $3a7d6ed40a35815d$export$3aa401309ff3940 = 131072;
const $3a7d6ed40a35815d$export$1fd8467d3320465f = 262144;
const $3a7d6ed40a35815d$export$d1dceb84a396f684 = 524288;
const $3a7d6ed40a35815d$export$ef62e7729d79baec = 1048576;
const $3a7d6ed40a35815d$export$40651ae3846a7710 = 2097152;
const $3a7d6ed40a35815d$export$e03976987cb0b818 = 4194304;
const $3a7d6ed40a35815d$export$dd5dceb22223d8ef = 8388608;
const $3a7d6ed40a35815d$export$aecaefba6ae044e4 = 16777216;
const $3a7d6ed40a35815d$export$6e47d6f6c411c0e1 = 33554432;
const $3a7d6ed40a35815d$export$321a8fda0150a18 = 67108864;
const $3a7d6ed40a35815d$export$d7843230fff08622 = 134217728;
const $3a7d6ed40a35815d$export$9fe7219cb72d1ed8 = 268435456;
const $3a7d6ed40a35815d$export$c85121a54e1cc97f = 536870912;
const $3a7d6ed40a35815d$export$76075a64dc7c21ef = 1073741824;
const $3a7d6ed40a35815d$export$49d5cdcf29800e09 = -2147483648;
const $3a7d6ed40a35815d$export$853d99058378c102 = 0;
const $3a7d6ed40a35815d$export$b859c32a415b3ec1 = 1;
const $3a7d6ed40a35815d$export$decefe6957191373 = 3;
const $3a7d6ed40a35815d$export$d1defff3cbd2c6f4 = 7;
const $3a7d6ed40a35815d$export$8d2b432c8c02ae65 = 15;
const $3a7d6ed40a35815d$export$bc2aba63e4099c09 = 31;
const $3a7d6ed40a35815d$export$f39f4e074e983a34 = 63;
const $3a7d6ed40a35815d$export$f84d6bebff154ceb = 127;
const $3a7d6ed40a35815d$export$c880072ee0e87648 = 255;
const $3a7d6ed40a35815d$export$cbbfa5d3c076ad8c = 511;
const $3a7d6ed40a35815d$export$e365aa75b5fa7293 = 1023;
const $3a7d6ed40a35815d$export$51bfc23c1b7b60c3 = 2047;
const $3a7d6ed40a35815d$export$3b0a099b88523ac = 4095;
const $3a7d6ed40a35815d$export$8345c1c06d3e5fc1 = 8191;
const $3a7d6ed40a35815d$export$e20cffba663a7688 = 16383;
const $3a7d6ed40a35815d$export$cd0970fd37b207c6 = 32767;
const $3a7d6ed40a35815d$export$250487b182389b6a = 65535;
const $3a7d6ed40a35815d$export$9d6e01d73abdaadb = $3a7d6ed40a35815d$export$3aa401309ff3940 - 1;
const $3a7d6ed40a35815d$export$eedeab0ac4009664 = $3a7d6ed40a35815d$export$1fd8467d3320465f - 1;
const $3a7d6ed40a35815d$export$e1840c3c33a76ffc = $3a7d6ed40a35815d$export$d1dceb84a396f684 - 1;
const $3a7d6ed40a35815d$export$f0ae3ba8312e92e3 = $3a7d6ed40a35815d$export$ef62e7729d79baec - 1;
const $3a7d6ed40a35815d$export$b5ffbef7f0f6f536 = $3a7d6ed40a35815d$export$40651ae3846a7710 - 1;
const $3a7d6ed40a35815d$export$33ae34bc8e747862 = $3a7d6ed40a35815d$export$e03976987cb0b818 - 1;
const $3a7d6ed40a35815d$export$3629272792e6a9a0 = $3a7d6ed40a35815d$export$dd5dceb22223d8ef - 1;
const $3a7d6ed40a35815d$export$a07300a4cc2ba23c = $3a7d6ed40a35815d$export$aecaefba6ae044e4 - 1;
const $3a7d6ed40a35815d$export$9137f2824b26e02b = $3a7d6ed40a35815d$export$6e47d6f6c411c0e1 - 1;
const $3a7d6ed40a35815d$export$94d4c3aa7cfbb8dd = $3a7d6ed40a35815d$export$321a8fda0150a18 - 1;
const $3a7d6ed40a35815d$export$8af89455097efce0 = $3a7d6ed40a35815d$export$d7843230fff08622 - 1;
const $3a7d6ed40a35815d$export$dee9196bb8567fe9 = $3a7d6ed40a35815d$export$9fe7219cb72d1ed8 - 1;
const $3a7d6ed40a35815d$export$bd0b5ef1d89e90f = $3a7d6ed40a35815d$export$c85121a54e1cc97f - 1;
const $3a7d6ed40a35815d$export$e5560e011efa8766 = $3a7d6ed40a35815d$export$76075a64dc7c21ef - 1;
const $3a7d6ed40a35815d$export$87ec42487f19c66c = 0x7FFFFFFF;
const $3a7d6ed40a35815d$export$3ea07c5174cba08a = 0xFFFFFFFF;

});


parcelRegister("dVtwn", function(module, exports) {

$parcel$export(module.exports, "fromCharCode", () => $a2377f87b16765a5$export$30216c0101da0ee0);
$parcel$export(module.exports, "fromCamelCase", () => $a2377f87b16765a5$export$87429743646c3257);
$parcel$export(module.exports, "utf8TextEncoder", () => $a2377f87b16765a5$export$f3ce4806f2484eb);
$parcel$export(module.exports, "encodeUtf8", () => $a2377f87b16765a5$export$8f647c2204da8484);
$parcel$export(module.exports, "utf8TextDecoder", () => $a2377f87b16765a5$export$f477633695bbbcd);
$parcel$export(module.exports, "decodeUtf8", () => $a2377f87b16765a5$export$72118b85b055afd);
$parcel$export(module.exports, "repeat", () => $a2377f87b16765a5$export$76d90c956114f2c2);

var $iiUWJ = parcelRequire("iiUWJ");
const $a2377f87b16765a5$export$30216c0101da0ee0 = String.fromCharCode;
const $a2377f87b16765a5$export$73bfc63873071f74 = String.fromCodePoint;
const $a2377f87b16765a5$export$e3a9a653b2a11ac1 = $a2377f87b16765a5$export$30216c0101da0ee0(65535);
/**
 * @param {string} s
 * @return {string}
 */ const $a2377f87b16765a5$var$toLowerCase = (s)=>s.toLowerCase();
const $a2377f87b16765a5$var$trimLeftRegex = /^\s*/g;
const $a2377f87b16765a5$export$c5557f40488c48ec = (s)=>s.replace($a2377f87b16765a5$var$trimLeftRegex, "");
const $a2377f87b16765a5$var$fromCamelCaseRegex = /([A-Z])/g;
const $a2377f87b16765a5$export$87429743646c3257 = (s, separator)=>$a2377f87b16765a5$export$c5557f40488c48ec(s.replace($a2377f87b16765a5$var$fromCamelCaseRegex, (match)=>`${separator}${$a2377f87b16765a5$var$toLowerCase(match)}`));
const $a2377f87b16765a5$export$ba35f6b806a3dbd4 = (str)=>unescape(encodeURIComponent(str)).length;
const $a2377f87b16765a5$export$83d8cea287b4dfcd = (str)=>{
    const encodedString = unescape(encodeURIComponent(str));
    const len = encodedString.length;
    const buf = new Uint8Array(len);
    for(let i = 0; i < len; i++)buf[i] = /** @type {number} */ encodedString.codePointAt(i);
    return buf;
};
const $a2377f87b16765a5$export$f3ce4806f2484eb = /** @type {TextEncoder} */ typeof TextEncoder !== "undefined" ? new TextEncoder() : null;
const $a2377f87b16765a5$export$9a0a70804ee285dd = (str)=>$a2377f87b16765a5$export$f3ce4806f2484eb.encode(str);
const $a2377f87b16765a5$export$8f647c2204da8484 = $a2377f87b16765a5$export$f3ce4806f2484eb ? $a2377f87b16765a5$export$9a0a70804ee285dd : $a2377f87b16765a5$export$83d8cea287b4dfcd;
const $a2377f87b16765a5$export$154b750182ae32cf = (buf)=>{
    let remainingLen = buf.length;
    let encodedString = "";
    let bufPos = 0;
    while(remainingLen > 0){
        const nextLen = remainingLen < 10000 ? remainingLen : 10000;
        const bytes = buf.subarray(bufPos, bufPos + nextLen);
        bufPos += nextLen;
        // Starting with ES5.1 we can supply a generic array-like object as arguments
        encodedString += String.fromCodePoint.apply(null, /** @type {any} */ bytes);
        remainingLen -= nextLen;
    }
    return decodeURIComponent(escape(encodedString));
};
let $a2377f87b16765a5$export$f477633695bbbcd = typeof TextDecoder === "undefined" ? null : new TextDecoder("utf-8", {
    fatal: true,
    ignoreBOM: true
});
/* c8 ignore start */ if ($a2377f87b16765a5$export$f477633695bbbcd && $a2377f87b16765a5$export$f477633695bbbcd.decode(new Uint8Array()).length === 1) // Safari doesn't handle BOM correctly.
// This fixes a bug in Safari 13.0.5 where it produces a BOM the first time it is called.
// utf8TextDecoder.decode(new Uint8Array()).length === 1 on the first call and
// utf8TextDecoder.decode(new Uint8Array()).length === 1 on the second call
// Another issue is that from then on no BOM chars are recognized anymore
/* c8 ignore next */ $a2377f87b16765a5$export$f477633695bbbcd = null;
const $a2377f87b16765a5$export$23d5f1ce72f56168 = (buf)=>/** @type {TextDecoder} */ $a2377f87b16765a5$export$f477633695bbbcd.decode(buf);
const $a2377f87b16765a5$export$72118b85b055afd = $a2377f87b16765a5$export$f477633695bbbcd ? $a2377f87b16765a5$export$23d5f1ce72f56168 : $a2377f87b16765a5$export$154b750182ae32cf;
const $a2377f87b16765a5$export$869882364835d202 = (str, index, remove, insert = "")=>str.slice(0, index) + insert + str.slice(index + remove);
const $a2377f87b16765a5$export$76d90c956114f2c2 = (source, n)=>$iiUWJ.unfold(n, ()=>source).join("");

});


parcelRegister("dirF1", function(module, exports) {

$parcel$export(module.exports, "createDecoder", () => $9ae2699cf6e5f69c$export$f8c898e83b60faaa);
$parcel$export(module.exports, "hasContent", () => $9ae2699cf6e5f69c$export$7ad75c69830b76d7);
$parcel$export(module.exports, "readVarUint8Array", () => $9ae2699cf6e5f69c$export$7418bbc18dee40f3);
$parcel$export(module.exports, "readVarUint", () => $9ae2699cf6e5f69c$export$5a476e4dbe7923d5);
$parcel$export(module.exports, "readUint8", () => $9ae2699cf6e5f69c$export$d5778a2beba4ceef);
$parcel$export(module.exports, "readVarInt", () => $9ae2699cf6e5f69c$export$1dd5b9ddf6575ae8);
$parcel$export(module.exports, "readVarString", () => $9ae2699cf6e5f69c$export$3b64b4d753b81ec2);
$parcel$export(module.exports, "readAny", () => $9ae2699cf6e5f69c$export$82863139061f472f);
$parcel$export(module.exports, "RleDecoder", () => $9ae2699cf6e5f69c$export$f1f1200492b832af);
$parcel$export(module.exports, "UintOptRleDecoder", () => $9ae2699cf6e5f69c$export$2dc62fb2f864b82e);
$parcel$export(module.exports, "IntDiffOptRleDecoder", () => $9ae2699cf6e5f69c$export$d502ab0bf048a596);
$parcel$export(module.exports, "StringDecoder", () => $9ae2699cf6e5f69c$export$63a7aa211a91ed69);
/**
 * Efficient schema-less binary decoding with support for variable length encoding.
 *
 * Use [lib0/decoding] with [lib0/encoding]. Every encoding function has a corresponding decoding function.
 *
 * Encodes numbers in little-endian order (least to most significant byte order)
 * and is compatible with Golang's binary encoding (https://golang.org/pkg/encoding/binary/)
 * which is also used in Protocol Buffers.
 *
 * ```js
 * // encoding step
 * const encoder = encoding.createEncoder()
 * encoding.writeVarUint(encoder, 256)
 * encoding.writeVarString(encoder, 'Hello world!')
 * const buf = encoding.toUint8Array(encoder)
 * ```
 *
 * ```js
 * // decoding step
 * const decoder = decoding.createDecoder(buf)
 * decoding.readVarUint(decoder) // => 256
 * decoding.readVarString(decoder) // => 'Hello world!'
 * decoding.hasContent(decoder) // => false - all data is read
 * ```
 *
 * @module decoding
 */ 
var $51l7Q = parcelRequire("51l7Q");

var $5qKvF = parcelRequire("5qKvF");

var $74Oxs = parcelRequire("74Oxs");

var $dVtwn = parcelRequire("dVtwn");

var $iVMsw = parcelRequire("iVMsw");

var $6E0HV = parcelRequire("6E0HV");
const $9ae2699cf6e5f69c$var$errorUnexpectedEndOfArray = $iVMsw.create("Unexpected end of array");
const $9ae2699cf6e5f69c$var$errorIntegerOutOfRange = $iVMsw.create("Integer out of Range");
class $9ae2699cf6e5f69c$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array Binary data to decode
   */ constructor(uint8Array){
        /**
     * Decoding target.
     *
     * @type {Uint8Array}
     */ this.arr = uint8Array;
        /**
     * Current decoding position.
     *
     * @type {number}
     */ this.pos = 0;
    }
}
const $9ae2699cf6e5f69c$export$f8c898e83b60faaa = (uint8Array)=>new $9ae2699cf6e5f69c$export$f9de6ca0bc043724(uint8Array);
const $9ae2699cf6e5f69c$export$7ad75c69830b76d7 = (decoder)=>decoder.pos !== decoder.arr.length;
const $9ae2699cf6e5f69c$export$9cd59f9826255e47 = (decoder, newPos = decoder.pos)=>{
    const _decoder = $9ae2699cf6e5f69c$export$f8c898e83b60faaa(decoder.arr);
    _decoder.pos = newPos;
    return _decoder;
};
const $9ae2699cf6e5f69c$export$e21b2fe168d56a89 = (decoder, len)=>{
    const view = new Uint8Array(decoder.arr.buffer, decoder.pos + decoder.arr.byteOffset, len);
    decoder.pos += len;
    return view;
};
const $9ae2699cf6e5f69c$export$7418bbc18dee40f3 = (decoder)=>$9ae2699cf6e5f69c$export$e21b2fe168d56a89(decoder, $9ae2699cf6e5f69c$export$5a476e4dbe7923d5(decoder));
const $9ae2699cf6e5f69c$export$8c9f57cb3e3e2d3b = (decoder)=>$9ae2699cf6e5f69c$export$e21b2fe168d56a89(decoder, decoder.arr.length - decoder.pos);
const $9ae2699cf6e5f69c$export$228a9507fbdfcdb6 = (decoder)=>decoder.pos++;
const $9ae2699cf6e5f69c$export$d5778a2beba4ceef = (decoder)=>decoder.arr[decoder.pos++];
const $9ae2699cf6e5f69c$export$ef14636f4cf20706 = (decoder)=>{
    const uint = decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8);
    decoder.pos += 2;
    return uint;
};
const $9ae2699cf6e5f69c$export$967c96218130b9ba = (decoder)=>{
    const uint = decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8) + (decoder.arr[decoder.pos + 2] << 16) + (decoder.arr[decoder.pos + 3] << 24) >>> 0;
    decoder.pos += 4;
    return uint;
};
const $9ae2699cf6e5f69c$export$adb88b5d4ab91f4e = (decoder)=>{
    const uint = decoder.arr[decoder.pos + 3] + (decoder.arr[decoder.pos + 2] << 8) + (decoder.arr[decoder.pos + 1] << 16) + (decoder.arr[decoder.pos] << 24) >>> 0;
    decoder.pos += 4;
    return uint;
};
const $9ae2699cf6e5f69c$export$c6eca102d0b41ca0 = (decoder)=>decoder.arr[decoder.pos];
const $9ae2699cf6e5f69c$export$e5eb1e52afa13f8d = (decoder)=>decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8);
const $9ae2699cf6e5f69c$export$67e54e775d28f9ae = (decoder)=>decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8) + (decoder.arr[decoder.pos + 2] << 16) + (decoder.arr[decoder.pos + 3] << 24) >>> 0;
const $9ae2699cf6e5f69c$export$5a476e4dbe7923d5 = (decoder)=>{
    let num = 0;
    let mult = 1;
    const len = decoder.arr.length;
    while(decoder.pos < len){
        const r = decoder.arr[decoder.pos++];
        // num = num | ((r & binary.BITS7) << len)
        num = num + (r & $51l7Q.BITS7) * mult // shift $r << (7*#iterations) and add it to num
        ;
        mult *= 128 // next iteration, shift 7 "more" to the left
        ;
        if (r < $51l7Q.BIT8) return num;
        /* c8 ignore start */ if (num > $74Oxs.MAX_SAFE_INTEGER) throw $9ae2699cf6e5f69c$var$errorIntegerOutOfRange;
    /* c8 ignore stop */ }
    throw $9ae2699cf6e5f69c$var$errorUnexpectedEndOfArray;
};
const $9ae2699cf6e5f69c$export$1dd5b9ddf6575ae8 = (decoder)=>{
    let r = decoder.arr[decoder.pos++];
    let num = r & $51l7Q.BITS6;
    let mult = 64;
    const sign = (r & $51l7Q.BIT7) > 0 ? -1 : 1;
    if ((r & $51l7Q.BIT8) === 0) // don't continue reading
    return sign * num;
    const len = decoder.arr.length;
    while(decoder.pos < len){
        r = decoder.arr[decoder.pos++];
        // num = num | ((r & binary.BITS7) << len)
        num = num + (r & $51l7Q.BITS7) * mult;
        mult *= 128;
        if (r < $51l7Q.BIT8) return sign * num;
        /* c8 ignore start */ if (num > $74Oxs.MAX_SAFE_INTEGER) throw $9ae2699cf6e5f69c$var$errorIntegerOutOfRange;
    /* c8 ignore stop */ }
    throw $9ae2699cf6e5f69c$var$errorUnexpectedEndOfArray;
};
const $9ae2699cf6e5f69c$export$dc86e1eb544aa5ab = (decoder)=>{
    const pos = decoder.pos;
    const s = $9ae2699cf6e5f69c$export$5a476e4dbe7923d5(decoder);
    decoder.pos = pos;
    return s;
};
const $9ae2699cf6e5f69c$export$47c43df02cd47fca = (decoder)=>{
    const pos = decoder.pos;
    const s = $9ae2699cf6e5f69c$export$1dd5b9ddf6575ae8(decoder);
    decoder.pos = pos;
    return s;
};
const $9ae2699cf6e5f69c$export$e73299e6158668bb = (decoder)=>{
    let remainingLen = $9ae2699cf6e5f69c$export$5a476e4dbe7923d5(decoder);
    if (remainingLen === 0) return "";
    else {
        let encodedString = String.fromCodePoint($9ae2699cf6e5f69c$export$d5778a2beba4ceef(decoder)) // remember to decrease remainingLen
        ;
        if (--remainingLen < 100) while(remainingLen--)encodedString += String.fromCodePoint($9ae2699cf6e5f69c$export$d5778a2beba4ceef(decoder));
        else while(remainingLen > 0){
            const nextLen = remainingLen < 10000 ? remainingLen : 10000;
            // this is dangerous, we create a fresh array view from the existing buffer
            const bytes = decoder.arr.subarray(decoder.pos, decoder.pos + nextLen);
            decoder.pos += nextLen;
            // Starting with ES5.1 we can supply a generic array-like object as arguments
            encodedString += String.fromCodePoint.apply(null, /** @type {any} */ bytes);
            remainingLen -= nextLen;
        }
        return decodeURIComponent(escape(encodedString));
    }
};
const $9ae2699cf6e5f69c$export$7247eefae50fb91a = (decoder)=>/** @type any */ $dVtwn.utf8TextDecoder.decode($9ae2699cf6e5f69c$export$7418bbc18dee40f3(decoder));
const $9ae2699cf6e5f69c$export$3b64b4d753b81ec2 = $dVtwn.utf8TextDecoder ? $9ae2699cf6e5f69c$export$7247eefae50fb91a : $9ae2699cf6e5f69c$export$e73299e6158668bb;
const $9ae2699cf6e5f69c$export$23764cfecad9ae2f = (decoder)=>{
    const encoder = $6E0HV.createEncoder();
    let b;
    while(true){
        b = $9ae2699cf6e5f69c$export$d5778a2beba4ceef(decoder);
        if (b === 0) return $6E0HV.toUint8Array(encoder);
        if (b === 1) b = $9ae2699cf6e5f69c$export$d5778a2beba4ceef(decoder);
        $6E0HV.write(encoder, b);
    }
};
const $9ae2699cf6e5f69c$export$d38ec182b293d566 = (decoder)=>$dVtwn.decodeUtf8($9ae2699cf6e5f69c$export$23764cfecad9ae2f(decoder));
const $9ae2699cf6e5f69c$export$91c1f3f0dd9bd2f5 = (decoder)=>{
    const pos = decoder.pos;
    const s = $9ae2699cf6e5f69c$export$3b64b4d753b81ec2(decoder);
    decoder.pos = pos;
    return s;
};
const $9ae2699cf6e5f69c$export$d7dd05f632129fe5 = (decoder, len)=>{
    const dv = new DataView(decoder.arr.buffer, decoder.arr.byteOffset + decoder.pos, len);
    decoder.pos += len;
    return dv;
};
const $9ae2699cf6e5f69c$export$dbc4aa781d9afe3b = (decoder)=>$9ae2699cf6e5f69c$export$d7dd05f632129fe5(decoder, 4).getFloat32(0, false);
const $9ae2699cf6e5f69c$export$d89a471990a89a7f = (decoder)=>$9ae2699cf6e5f69c$export$d7dd05f632129fe5(decoder, 8).getFloat64(0, false);
const $9ae2699cf6e5f69c$export$99e633bd4f295d85 = (decoder)=>/** @type {any} */ $9ae2699cf6e5f69c$export$d7dd05f632129fe5(decoder, 8).getBigInt64(0, false);
const $9ae2699cf6e5f69c$export$21575c47d1f9b652 = (decoder)=>/** @type {any} */ $9ae2699cf6e5f69c$export$d7dd05f632129fe5(decoder, 8).getBigUint64(0, false);
/**
 * @type {Array<function(Decoder):any>}
 */ const $9ae2699cf6e5f69c$var$readAnyLookupTable = [
    (decoder)=>undefined,
    (decoder)=>null,
    $9ae2699cf6e5f69c$export$1dd5b9ddf6575ae8,
    $9ae2699cf6e5f69c$export$dbc4aa781d9afe3b,
    $9ae2699cf6e5f69c$export$d89a471990a89a7f,
    $9ae2699cf6e5f69c$export$99e633bd4f295d85,
    (decoder)=>false,
    (decoder)=>true,
    $9ae2699cf6e5f69c$export$3b64b4d753b81ec2,
    (decoder)=>{
        const len = $9ae2699cf6e5f69c$export$5a476e4dbe7923d5(decoder);
        /**
     * @type {Object<string,any>}
     */ const obj = {};
        for(let i = 0; i < len; i++){
            const key = $9ae2699cf6e5f69c$export$3b64b4d753b81ec2(decoder);
            obj[key] = $9ae2699cf6e5f69c$export$82863139061f472f(decoder);
        }
        return obj;
    },
    (decoder)=>{
        const len = $9ae2699cf6e5f69c$export$5a476e4dbe7923d5(decoder);
        const arr = [];
        for(let i = 0; i < len; i++)arr.push($9ae2699cf6e5f69c$export$82863139061f472f(decoder));
        return arr;
    },
    $9ae2699cf6e5f69c$export$7418bbc18dee40f3 // CASE 116: Uint8Array
];
const $9ae2699cf6e5f69c$export$82863139061f472f = (decoder)=>$9ae2699cf6e5f69c$var$readAnyLookupTable[127 - $9ae2699cf6e5f69c$export$d5778a2beba4ceef(decoder)](decoder);
class $9ae2699cf6e5f69c$export$f1f1200492b832af extends $9ae2699cf6e5f69c$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array
   * @param {function(Decoder):T} reader
   */ constructor(uint8Array, reader){
        super(uint8Array);
        /**
     * The reader
     */ this.reader = reader;
        /**
     * Current state
     * @type {T|null}
     */ this.s = null;
        this.count = 0;
    }
    read() {
        if (this.count === 0) {
            this.s = this.reader(this);
            if ($9ae2699cf6e5f69c$export$7ad75c69830b76d7(this)) this.count = $9ae2699cf6e5f69c$export$5a476e4dbe7923d5(this) + 1 // see encoder implementation for the reason why this is incremented
            ;
            else this.count = -1 // read the current value forever
            ;
        }
        this.count--;
        return /** @type {T} */ this.s;
    }
}
class $9ae2699cf6e5f69c$export$938378143fffe1b4 extends $9ae2699cf6e5f69c$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array
   * @param {number} start
   */ constructor(uint8Array, start){
        super(uint8Array);
        /**
     * Current state
     * @type {number}
     */ this.s = start;
    }
    /**
   * @return {number}
   */ read() {
        this.s += $9ae2699cf6e5f69c$export$1dd5b9ddf6575ae8(this);
        return this.s;
    }
}
class $9ae2699cf6e5f69c$export$595b36f1b42934c6 extends $9ae2699cf6e5f69c$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array
   * @param {number} start
   */ constructor(uint8Array, start){
        super(uint8Array);
        /**
     * Current state
     * @type {number}
     */ this.s = start;
        this.count = 0;
    }
    /**
   * @return {number}
   */ read() {
        if (this.count === 0) {
            this.s += $9ae2699cf6e5f69c$export$1dd5b9ddf6575ae8(this);
            if ($9ae2699cf6e5f69c$export$7ad75c69830b76d7(this)) this.count = $9ae2699cf6e5f69c$export$5a476e4dbe7923d5(this) + 1 // see encoder implementation for the reason why this is incremented
            ;
            else this.count = -1 // read the current value forever
            ;
        }
        this.count--;
        return /** @type {number} */ this.s;
    }
}
class $9ae2699cf6e5f69c$export$2dc62fb2f864b82e extends $9ae2699cf6e5f69c$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array
   */ constructor(uint8Array){
        super(uint8Array);
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
    }
    read() {
        if (this.count === 0) {
            this.s = $9ae2699cf6e5f69c$export$1dd5b9ddf6575ae8(this);
            // if the sign is negative, we read the count too, otherwise count is 1
            const isNegative = $5qKvF.isNegativeZero(this.s);
            this.count = 1;
            if (isNegative) {
                this.s = -this.s;
                this.count = $9ae2699cf6e5f69c$export$5a476e4dbe7923d5(this) + 2;
            }
        }
        this.count--;
        return /** @type {number} */ this.s;
    }
}
class $9ae2699cf6e5f69c$export$727389af14dfe417 extends $9ae2699cf6e5f69c$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array
   */ constructor(uint8Array){
        super(uint8Array);
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
    }
    read() {
        if (this.count === 0) {
            this.s = $9ae2699cf6e5f69c$export$1dd5b9ddf6575ae8(this);
            // if the sign is negative, we read the count too, otherwise count is 1
            const isNegative = $5qKvF.isNegativeZero(this.s);
            this.count = 1;
            if (isNegative) {
                this.s = -this.s;
                this.count = $9ae2699cf6e5f69c$export$5a476e4dbe7923d5(this) + 2;
            }
        }
        this.count--;
        return /** @type {number} */ this.s++;
    }
}
class $9ae2699cf6e5f69c$export$d502ab0bf048a596 extends $9ae2699cf6e5f69c$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array
   */ constructor(uint8Array){
        super(uint8Array);
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
        this.diff = 0;
    }
    /**
   * @return {number}
   */ read() {
        if (this.count === 0) {
            const diff = $9ae2699cf6e5f69c$export$1dd5b9ddf6575ae8(this);
            // if the first bit is set, we read more data
            const hasCount = diff & 1;
            this.diff = $5qKvF.floor(diff / 2) // shift >> 1
            ;
            this.count = 1;
            if (hasCount) this.count = $9ae2699cf6e5f69c$export$5a476e4dbe7923d5(this) + 2;
        }
        this.s += this.diff;
        this.count--;
        return this.s;
    }
}
class $9ae2699cf6e5f69c$export$63a7aa211a91ed69 {
    /**
   * @param {Uint8Array} uint8Array
   */ constructor(uint8Array){
        this.decoder = new $9ae2699cf6e5f69c$export$2dc62fb2f864b82e(uint8Array);
        this.str = $9ae2699cf6e5f69c$export$3b64b4d753b81ec2(this.decoder);
        /**
     * @type {number}
     */ this.spos = 0;
    }
    /**
   * @return {string}
   */ read() {
        const end = this.spos + this.decoder.read();
        const res = this.str.slice(this.spos, end);
        this.spos = end;
        return res;
    }
}

});
parcelRegister("iVMsw", function(module, exports) {

$parcel$export(module.exports, "create", () => $dc8323ce455f6c8f$export$185802fd694ee1f5);
$parcel$export(module.exports, "methodUnimplemented", () => $dc8323ce455f6c8f$export$73ced5c7e10d6d0f);
$parcel$export(module.exports, "unexpectedCase", () => $dc8323ce455f6c8f$export$965b6bccecbd9673);
/**
 * Error helpers.
 *
 * @module error
 */ /**
 * @param {string} s
 * @return {Error}
 */ /* c8 ignore next */ const $dc8323ce455f6c8f$export$185802fd694ee1f5 = (s)=>new Error(s);
const $dc8323ce455f6c8f$export$73ced5c7e10d6d0f = ()=>{
    throw $dc8323ce455f6c8f$export$185802fd694ee1f5("Method unimplemented");
};
const $dc8323ce455f6c8f$export$965b6bccecbd9673 = ()=>{
    throw $dc8323ce455f6c8f$export$185802fd694ee1f5("Unexpected case");
};

});


parcelRegister("8HsF3", function(module, exports) {

$parcel$export(module.exports, "uint32", () => $65589266ea3e2d87$export$de9ffb9418dd7d0d);
$parcel$export(module.exports, "uuidv4", () => $65589266ea3e2d87$export$abe4376e1bf796d6);
/**
 * Isomorphic module for true random numbers / buffers / uuids.
 *
 * Attention: falls back to Math.random if the browser does not support crypto.
 *
 * @module random
 */ 
var $5qKvF = parcelRequire("5qKvF");

var $51l7Q = parcelRequire("51l7Q");

var $iKPDI = parcelRequire("iKPDI");
const $65589266ea3e2d87$export$bb0a9c36cf454ea0 = Math.random;
const $65589266ea3e2d87$export$de9ffb9418dd7d0d = ()=>(0, $iKPDI.getRandomValues)(new Uint32Array(1))[0];
const $65589266ea3e2d87$export$6bf94e3d82617e4e = ()=>{
    const arr = (0, $iKPDI.getRandomValues)(new Uint32Array(8));
    return (arr[0] & $51l7Q.BITS21) * ($51l7Q.BITS32 + 1) + (arr[1] >>> 0);
};
const $65589266ea3e2d87$export$a9a18ae5ba42aeab = (arr)=>arr[$5qKvF.floor($65589266ea3e2d87$export$bb0a9c36cf454ea0() * arr.length)];
// @ts-ignore
const $65589266ea3e2d87$var$uuidv4Template = "10000000-1000-4000-8000-100000000000";
const $65589266ea3e2d87$export$abe4376e1bf796d6 = ()=>$65589266ea3e2d87$var$uuidv4Template.replace(/[018]/g, /** @param {number} c */ (c)=>(c ^ $65589266ea3e2d87$export$de9ffb9418dd7d0d() & 15 >> c / 4).toString(16));

});
parcelRegister("iKPDI", function(module, exports) {

$parcel$export(module.exports, "getRandomValues", () => $da7494647bbc1609$export$960b9ff25e7d4257);
/* eslint-env browser */ const $da7494647bbc1609$export$f45422fd2e8042d4 = crypto.subtle;
const $da7494647bbc1609$export$960b9ff25e7d4257 = crypto.getRandomValues.bind(crypto);

});


parcelRegister("d23gX", function(module, exports) {

$parcel$export(module.exports, "create", () => $97ce001b08f40e73$export$185802fd694ee1f5);
/**
 * Utility helpers to work with promises.
 *
 * @module promise
 */ 
var $c48Az = parcelRequire("c48Az");
const $97ce001b08f40e73$export$185802fd694ee1f5 = (f)=>/** @type {Promise<T>} */ new Promise(f);
const $97ce001b08f40e73$export$fe201bb3bbe031e9 = (f)=>new Promise(f);
const $97ce001b08f40e73$export$84bf76cd7afc7469 = Promise.all.bind(Promise);
const $97ce001b08f40e73$export$2800f3ceda99eb84 = (reason)=>Promise.reject(reason);
const $97ce001b08f40e73$export$f7ad0328861e2f03 = (res)=>Promise.resolve(res);
const $97ce001b08f40e73$export$65eff93aa071dbbd = (res)=>Promise.resolve(res);
const $97ce001b08f40e73$export$a40009bd2c363351 = (timeout, check, intervalResolution = 10)=>$97ce001b08f40e73$export$185802fd694ee1f5((resolve, reject)=>{
        const startTime = $c48Az.getUnixTime();
        const hasTimeout = timeout > 0;
        const untilInterval = ()=>{
            if (check()) {
                clearInterval(intervalHandle);
                resolve();
            } else if (hasTimeout) /* c8 ignore else */ {
                if ($c48Az.getUnixTime() - startTime > timeout) {
                    clearInterval(intervalHandle);
                    reject(new Error("Timeout"));
                }
            }
        };
        const intervalHandle = setInterval(untilInterval, intervalResolution);
    });
const $97ce001b08f40e73$export$5c069c93d2b7493f = (timeout)=>$97ce001b08f40e73$export$185802fd694ee1f5((resolve, reject)=>setTimeout(resolve, timeout));
const $97ce001b08f40e73$export$4369c812aac99591 = (p)=>p instanceof Promise || p && p.then && p.catch && p.finally;

});
parcelRegister("c48Az", function(module, exports) {

$parcel$export(module.exports, "getUnixTime", () => $8c8c854c0e4d245c$export$1f77c0008d16313);
/**
 * Utility module to work with time.
 *
 * @module time
 */ 
var $8alJj = parcelRequire("8alJj");

var $5qKvF = parcelRequire("5qKvF");
const $8c8c854c0e4d245c$export$aa350b96d91cd94 = ()=>new Date();
const $8c8c854c0e4d245c$export$1f77c0008d16313 = Date.now;
const $8c8c854c0e4d245c$export$70cb903099cabea3 = (d)=>{
    if (d < 60000) {
        const p = $8alJj.prefix(d, -1);
        return $5qKvF.round(p.n * 100) / 100 + p.prefix + "s";
    }
    d = $5qKvF.floor(d / 1000);
    const seconds = d % 60;
    const minutes = $5qKvF.floor(d / 60) % 60;
    const hours = $5qKvF.floor(d / 3600) % 24;
    const days = $5qKvF.floor(d / 86400);
    if (days > 0) return days + "d" + (hours > 0 || minutes > 30 ? " " + (minutes > 30 ? hours + 1 : hours) + "h" : "");
    if (hours > 0) /* c8 ignore next */ return hours + "h" + (minutes > 0 || seconds > 30 ? " " + (seconds > 30 ? minutes + 1 : minutes) + "min" : "");
    return minutes + "min" + (seconds > 0 ? " " + seconds + "s" : "");
};

});
parcelRegister("8alJj", function(module, exports) {

$parcel$export(module.exports, "prefix", () => $5f201cf89c3bc6ab$export$82e9f45cca5ba907);
/**
 * Utility module to convert metric values.
 *
 * @module metric
 */ 
var $5qKvF = parcelRequire("5qKvF");
const $5f201cf89c3bc6ab$export$3c3f39195836e927 = 1e24;
const $5f201cf89c3bc6ab$export$bc1fc8bc8e1895cf = 1e21;
const $5f201cf89c3bc6ab$export$91377b751fc464a0 = 1e18;
const $5f201cf89c3bc6ab$export$fc10d2598c9417a5 = 1e15;
const $5f201cf89c3bc6ab$export$ce366dc9d5abf7ac = 1e12;
const $5f201cf89c3bc6ab$export$197e40aa3a484017 = 1e9;
const $5f201cf89c3bc6ab$export$580f1e8cf64f2815 = 1e6;
const $5f201cf89c3bc6ab$export$a3ed9693cfbf67fa = 1e3;
const $5f201cf89c3bc6ab$export$6ec17edd70114a88 = 1e2;
const $5f201cf89c3bc6ab$export$6ffbaf3528ca9f3f = 10;
const $5f201cf89c3bc6ab$export$ec5800edbd9f0b69 = 0.1;
const $5f201cf89c3bc6ab$export$9faf718fe58aaa35 = 0.01;
const $5f201cf89c3bc6ab$export$fab274f99578ceb6 = 1e-3;
const $5f201cf89c3bc6ab$export$77bd0ce503b87b26 = 1e-6;
const $5f201cf89c3bc6ab$export$ddef5c050164e23e = 1e-9;
const $5f201cf89c3bc6ab$export$e10c52a2ab594201 = 1e-12;
const $5f201cf89c3bc6ab$export$c49f04803481822 = 1e-15;
const $5f201cf89c3bc6ab$export$5510a0bcf77f39 = 1e-18;
const $5f201cf89c3bc6ab$export$2b85cc24af20b7fe = 1e-21;
const $5f201cf89c3bc6ab$export$a2878e23774b59ce = 1e-24;
const $5f201cf89c3bc6ab$var$prefixUp = [
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
const $5f201cf89c3bc6ab$var$prefixDown = [
    "",
    "m",
    "\u03BC",
    "n",
    "p",
    "f",
    "a",
    "z",
    "y"
];
const $5f201cf89c3bc6ab$export$82e9f45cca5ba907 = (n, baseMultiplier = 0)=>{
    const nPow = n === 0 ? 0 : $5qKvF.log10(n);
    let mult = 0;
    while(nPow < mult * 3 && baseMultiplier > -8){
        baseMultiplier--;
        mult--;
    }
    while(nPow >= 3 + mult * 3 && baseMultiplier < 8){
        baseMultiplier++;
        mult++;
    }
    const prefix = baseMultiplier < 0 ? $5f201cf89c3bc6ab$var$prefixDown[-baseMultiplier] : $5f201cf89c3bc6ab$var$prefixUp[baseMultiplier];
    return {
        n: $5qKvF.round((mult > 0 ? n / $5qKvF.exp10(mult * 3) : n * $5qKvF.exp10(mult * -3)) * 1e12) / 1e12,
        prefix: prefix
    };
};

});



parcelRegister("fuxjU", function(module, exports) {

$parcel$export(module.exports, "copyUint8Array", () => $b473810976d76ae3$export$fe6f60023cd5ffaf);
/**
 * Utility functions to work with buffers (Uint8Array).
 *
 * @module buffer
 */ 
var $dVtwn = parcelRequire("dVtwn");

var $gXB0J = parcelRequire("gXB0J");

var $iiUWJ = parcelRequire("iiUWJ");

var $5qKvF = parcelRequire("5qKvF");

var $6E0HV = parcelRequire("6E0HV");

var $dirF1 = parcelRequire("dirF1");

var $N0o3H = parcelRequire("N0o3H");
var $b473810976d76ae3$require$Buffer = $N0o3H.Buffer;
const $b473810976d76ae3$export$79a0c4c40eecffbb = (len)=>new Uint8Array(len);
const $b473810976d76ae3$export$f3c8b5f6d250ec43 = (buffer, byteOffset, length)=>new Uint8Array(buffer, byteOffset, length);
const $b473810976d76ae3$export$1b999ddd54e5bed1 = (buffer)=>new Uint8Array(buffer);
/* c8 ignore start */ /**
 * @param {Uint8Array} bytes
 * @return {string}
 */ const $b473810976d76ae3$var$toBase64Browser = (bytes)=>{
    let s = "";
    for(let i = 0; i < bytes.byteLength; i++)s += $dVtwn.fromCharCode(bytes[i]);
    // eslint-disable-next-line no-undef
    return btoa(s);
};
/* c8 ignore stop */ /**
 * @param {Uint8Array} bytes
 * @return {string}
 */ const $b473810976d76ae3$var$toBase64Node = (bytes)=>$b473810976d76ae3$require$Buffer.from(bytes.buffer, bytes.byteOffset, bytes.byteLength).toString("base64");
/* c8 ignore start */ /**
 * @param {string} s
 * @return {Uint8Array}
 */ const $b473810976d76ae3$var$fromBase64Browser = (s)=>{
    // eslint-disable-next-line no-undef
    const a = atob(s);
    const bytes = $b473810976d76ae3$export$79a0c4c40eecffbb(a.length);
    for(let i = 0; i < a.length; i++)bytes[i] = a.charCodeAt(i);
    return bytes;
};
/* c8 ignore stop */ /**
 * @param {string} s
 */ const $b473810976d76ae3$var$fromBase64Node = (s)=>{
    const buf = $b473810976d76ae3$require$Buffer.from(s, "base64");
    return $b473810976d76ae3$export$f3c8b5f6d250ec43(buf.buffer, buf.byteOffset, buf.byteLength);
};
const $b473810976d76ae3$export$37cc283d8fbd3462 = $gXB0J.isBrowser ? $b473810976d76ae3$var$toBase64Browser : $b473810976d76ae3$var$toBase64Node;
const $b473810976d76ae3$export$c537b38001c583b7 = $gXB0J.isBrowser ? $b473810976d76ae3$var$fromBase64Browser : $b473810976d76ae3$var$fromBase64Node;
const $b473810976d76ae3$export$31f478961f22a29 = (buf)=>$b473810976d76ae3$export$37cc283d8fbd3462(buf).replaceAll("+", "-").replaceAll("/", "_").replaceAll("=", "");
const $b473810976d76ae3$export$2fcb175ca881fa06 = (base64)=>$b473810976d76ae3$export$c537b38001c583b7(base64.replaceAll("-", "+").replaceAll("_", "/"));
const $b473810976d76ae3$export$f4915efbb94d4d01 = (buf)=>$iiUWJ.map(buf, (b)=>b.toString(16).padStart(2, "0")).join("");
const $b473810976d76ae3$export$99a70112ceb8327b = (hex)=>{
    const hlen = hex.length;
    const buf = new Uint8Array($5qKvF.ceil(hlen / 2));
    for(let i = 0; i < hlen; i += 2)buf[buf.length - i / 2 - 1] = Number.parseInt(hex.slice(hlen - i - 2, hlen - i), 16);
    return buf;
};
const $b473810976d76ae3$export$fe6f60023cd5ffaf = (uint8Array)=>{
    const newBuf = $b473810976d76ae3$export$79a0c4c40eecffbb(uint8Array.byteLength);
    newBuf.set(uint8Array);
    return newBuf;
};
const $b473810976d76ae3$export$355ad3726be07997 = (data)=>$6E0HV.encode((encoder)=>$6E0HV.writeAny(encoder, data));
const $b473810976d76ae3$export$929c279cfec29a23 = (buf)=>$dirF1.readAny($dirF1.createDecoder(buf));
const $b473810976d76ae3$export$e87773390ebfdab4 = (bs, N)=>{
    if (N === 0) return bs;
    bs = new Uint8Array(bs);
    bs[0] <<= N;
    for(let i = 1; i < bs.length; i++){
        bs[i - 1] |= bs[i] >>> 8 - N;
        bs[i] <<= N;
    }
    return bs;
};

});
parcelRegister("gXB0J", function(module, exports) {

$parcel$export(module.exports, "isBrowser", () => $c58edd9824652bfe$export$4e09c449d6c407f7);
$parcel$export(module.exports, "getVariable", () => $c58edd9824652bfe$export$39fb32ac18db3f88);
$parcel$export(module.exports, "supportsColor", () => $c58edd9824652bfe$export$fcbe44f5d6fcebd);
/**
 * Isomorphic module to work access the environment (query params, env variables).
 *
 * @module map
 */ 
var $dh5fq = parcelRequire("dh5fq");

var $dVtwn = parcelRequire("dVtwn");

var $3YVmW = parcelRequire("3YVmW");

var $7956w = parcelRequire("7956w");

var $4NUz5 = parcelRequire("4NUz5");

var $ibaza = parcelRequire("ibaza");
const $c58edd9824652bfe$export$8ee0fc9ee280b4ee = typeof $ibaza !== "undefined" && $ibaza.release && /node|io\.js/.test($ibaza.release.name) && Object.prototype.toString.call(typeof $ibaza !== "undefined" ? $ibaza : 0) === "[object process]";
const $c58edd9824652bfe$export$4e09c449d6c407f7 = typeof window !== "undefined" && typeof document !== "undefined" && !$c58edd9824652bfe$export$8ee0fc9ee280b4ee;
const $c58edd9824652bfe$export$9ac100e40613ea10 = typeof navigator !== "undefined" ? /Mac/.test(navigator.platform) : false;
/**
 * @type {Map<string,string>}
 */ let $c58edd9824652bfe$var$params;
const $c58edd9824652bfe$var$args = [];
/* c8 ignore start */ const $c58edd9824652bfe$var$computeParams = ()=>{
    if ($c58edd9824652bfe$var$params === undefined) {
        if ($c58edd9824652bfe$export$8ee0fc9ee280b4ee) {
            $c58edd9824652bfe$var$params = $dh5fq.create();
            const pargs = $ibaza.argv;
            let currParamName = null;
            for(let i = 0; i < pargs.length; i++){
                const parg = pargs[i];
                if (parg[0] === "-") {
                    if (currParamName !== null) $c58edd9824652bfe$var$params.set(currParamName, "");
                    currParamName = parg;
                } else if (currParamName !== null) {
                    $c58edd9824652bfe$var$params.set(currParamName, parg);
                    currParamName = null;
                } else $c58edd9824652bfe$var$args.push(parg);
            }
            if (currParamName !== null) $c58edd9824652bfe$var$params.set(currParamName, "");
        // in ReactNative for example this would not be true (unless connected to the Remote Debugger)
        } else if (typeof location === "object") {
            $c58edd9824652bfe$var$params = $dh5fq.create(); // eslint-disable-next-line no-undef
            (location.search || "?").slice(1).split("&").forEach((kv)=>{
                if (kv.length !== 0) {
                    const [key, value] = kv.split("=");
                    $c58edd9824652bfe$var$params.set(`--${$dVtwn.fromCamelCase(key, "-")}`, value);
                    $c58edd9824652bfe$var$params.set(`-${$dVtwn.fromCamelCase(key, "-")}`, value);
                }
            });
        } else $c58edd9824652bfe$var$params = $dh5fq.create();
    }
    return $c58edd9824652bfe$var$params;
};
const $c58edd9824652bfe$export$3ad523d4e4ddff75 = (name)=>$c58edd9824652bfe$var$computeParams().has(name);
const $c58edd9824652bfe$export$ecf541e09a511845 = (name, defaultVal)=>$c58edd9824652bfe$var$computeParams().get(name) || defaultVal;
const $c58edd9824652bfe$export$39fb32ac18db3f88 = (name)=>$c58edd9824652bfe$export$8ee0fc9ee280b4ee ? $3YVmW.undefinedToNull($ibaza.env[name.toUpperCase().replaceAll("-", "_")]) : $3YVmW.undefinedToNull($7956w.varStorage.getItem(name));
const $c58edd9824652bfe$export$137940a4fd07b923 = (name)=>$c58edd9824652bfe$var$computeParams().get("--" + name) || $c58edd9824652bfe$export$39fb32ac18db3f88(name);
const $c58edd9824652bfe$export$e336c1d2b3b2390d = (name)=>{
    const c = $c58edd9824652bfe$export$137940a4fd07b923(name);
    if (c == null) throw new Error(`Expected configuration "${name.toUpperCase().replaceAll("-", "_")}"`);
    return c;
};
const $c58edd9824652bfe$export$41f29dc169f5b0eb = (name)=>$c58edd9824652bfe$export$3ad523d4e4ddff75("--" + name) || $c58edd9824652bfe$export$39fb32ac18db3f88(name) !== null;
const $c58edd9824652bfe$export$d71d1489bc353e92 = $c58edd9824652bfe$export$41f29dc169f5b0eb("production");
/* c8 ignore next 2 */ const $c58edd9824652bfe$var$forceColor = $c58edd9824652bfe$export$8ee0fc9ee280b4ee && $4NUz5.isOneOf(undefined, [
    "true",
    "1",
    "2"
]);
const $c58edd9824652bfe$export$fcbe44f5d6fcebd = !$c58edd9824652bfe$export$3ad523d4e4ddff75("no-colors") && (!$c58edd9824652bfe$export$8ee0fc9ee280b4ee || $ibaza.stdout.isTTY || $c58edd9824652bfe$var$forceColor) && (!$c58edd9824652bfe$export$8ee0fc9ee280b4ee || $c58edd9824652bfe$export$3ad523d4e4ddff75("color") || $c58edd9824652bfe$var$forceColor || $c58edd9824652bfe$export$39fb32ac18db3f88("COLORTERM") !== null || ($c58edd9824652bfe$export$39fb32ac18db3f88("TERM") || "").includes("color") /* c8 ignore stop */ );

});
parcelRegister("3YVmW", function(module, exports) {

$parcel$export(module.exports, "undefinedToNull", () => $2e6379f9ec5a0ffb$export$43874719a1af321f);
/**
 * Often used conditions.
 *
 * @module conditions
 */ /**
 * @template T
 * @param {T|null|undefined} v
 * @return {T|null}
 */ /* c8 ignore next */ const $2e6379f9ec5a0ffb$export$43874719a1af321f = (v)=>v === undefined ? null : v;

});

parcelRegister("7956w", function(module, exports) {

$parcel$export(module.exports, "varStorage", () => $533d553e195c2768$export$86b84a8d42aa2c65);
/* eslint-env browser */ /**
 * Isomorphic variable storage.
 *
 * Uses LocalStorage in the browser and falls back to in-memory storage.
 *
 * @module storage
 */ /* c8 ignore start */ class $533d553e195c2768$var$VarStoragePolyfill {
    constructor(){
        this.map = new Map();
    }
    /**
   * @param {string} key
   * @param {any} newValue
   */ setItem(key, newValue) {
        this.map.set(key, newValue);
    }
    /**
   * @param {string} key
   */ getItem(key) {
        return this.map.get(key);
    }
}
/* c8 ignore stop */ /**
 * @type {any}
 */ let $533d553e195c2768$var$_localStorage = new $533d553e195c2768$var$VarStoragePolyfill();
let $533d553e195c2768$var$usePolyfill = true;
/* c8 ignore start */ try {
    // if the same-origin rule is violated, accessing localStorage might thrown an error
    if (typeof localStorage !== "undefined" && localStorage) {
        $533d553e195c2768$var$_localStorage = localStorage;
        $533d553e195c2768$var$usePolyfill = false;
    }
} catch (e) {}
const $533d553e195c2768$export$86b84a8d42aa2c65 = $533d553e195c2768$var$_localStorage;
const $533d553e195c2768$export$bd913411069e59d3 = (eventHandler)=>$533d553e195c2768$var$usePolyfill || addEventListener("storage", /** @type {any} */ eventHandler);
const $533d553e195c2768$export$ff6a13ad336aa064 = (eventHandler)=>$533d553e195c2768$var$usePolyfill || removeEventListener("storage", /** @type {any} */ eventHandler);

});

parcelRegister("4NUz5", function(module, exports) {

$parcel$export(module.exports, "callAll", () => $37f79da7b684f95f$export$9dd9a52f2dd5b9ce);
$parcel$export(module.exports, "nop", () => $37f79da7b684f95f$export$b5f1cfe7b08e6ed5);
$parcel$export(module.exports, "id", () => $37f79da7b684f95f$export$d560c7e4a29451c2);
$parcel$export(module.exports, "isOneOf", () => $37f79da7b684f95f$export$532a90c0e5e8e48c);
/**
 * Common functions and function call helpers.
 *
 * @module function
 */ 
var $iiUWJ = parcelRequire("iiUWJ");

var $kLkle = parcelRequire("kLkle");
const $37f79da7b684f95f$export$9dd9a52f2dd5b9ce = (fs, args, i = 0)=>{
    try {
        for(; i < fs.length; i++)fs[i](...args);
    } finally{
        if (i < fs.length) $37f79da7b684f95f$export$9dd9a52f2dd5b9ce(fs, args, i + 1);
    }
};
const $37f79da7b684f95f$export$b5f1cfe7b08e6ed5 = ()=>{};
const $37f79da7b684f95f$export$5635d7ef4b8fee1c = (f)=>f();
const $37f79da7b684f95f$export$d560c7e4a29451c2 = (a)=>a;
const $37f79da7b684f95f$export$bbb1dcf8c6c6bac1 = (a, b)=>a === b;
const $37f79da7b684f95f$export$6ca82605a98f2278 = (a, b)=>a === b || a != null && b != null && a.constructor === b.constructor && ($iiUWJ.isArray(a) && $iiUWJ.equalFlat(a, /** @type {Array<T>} */ b) || typeof a === "object" && $kLkle.equalFlat(a, b));
const $37f79da7b684f95f$export$2ca9a723affd5d11 = (a, b)=>{
    if (a == null || b == null) return $37f79da7b684f95f$export$bbb1dcf8c6c6bac1(a, b);
    if (a.constructor !== b.constructor) return false;
    if (a === b) return true;
    switch(a.constructor){
        case ArrayBuffer:
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // eslint-disable-next-line no-fallthrough
        case Uint8Array:
            if (a.byteLength !== b.byteLength) return false;
            for(let i = 0; i < a.length; i++){
                if (a[i] !== b[i]) return false;
            }
            break;
        case Set:
            if (a.size !== b.size) return false;
            for (const value of a){
                if (!b.has(value)) return false;
            }
            break;
        case Map:
            if (a.size !== b.size) return false;
            for (const key of a.keys()){
                if (!b.has(key) || !$37f79da7b684f95f$export$2ca9a723affd5d11(a.get(key), b.get(key))) return false;
            }
            break;
        case Object:
            if ($kLkle.length(a) !== $kLkle.length(b)) return false;
            for(const key in a){
                if (!$kLkle.hasProperty(a, key) || !$37f79da7b684f95f$export$2ca9a723affd5d11(a[key], b[key])) return false;
            }
            break;
        case Array:
            if (a.length !== b.length) return false;
            for(let i = 0; i < a.length; i++){
                if (!$37f79da7b684f95f$export$2ca9a723affd5d11(a[i], b[i])) return false;
            }
            break;
        default:
            return false;
    }
    return true;
};
const $37f79da7b684f95f$export$532a90c0e5e8e48c = (value, options)=>options.includes(value);
const $37f79da7b684f95f$export$43bee75e5e14138e = $iiUWJ.isArray;
const $37f79da7b684f95f$export$844ec244b1367d54 = (s)=>s && s.constructor === String;
const $37f79da7b684f95f$export$7e4aa119212bc614 = (n)=>n != null && n.constructor === Number;
const $37f79da7b684f95f$export$226b3eccf92c9ed9 = (n, T)=>n && n.constructor === T;
const $37f79da7b684f95f$export$6306e0d85c68df69 = (T)=>/**
   * @param {any} n
   * @return {n is InstanceType<TYPE>}
   **/ (n)=>n && n.constructor === T;

});
parcelRegister("kLkle", function(module, exports) {

$parcel$export(module.exports, "assign", () => $f1d7f9d5d2e2633c$export$e6e34fd1f2686227);
$parcel$export(module.exports, "forEach", () => $f1d7f9d5d2e2633c$export$4b80e395e36b5a56);
$parcel$export(module.exports, "length", () => $f1d7f9d5d2e2633c$export$f24224f1c91d8156);
$parcel$export(module.exports, "isEmpty", () => $f1d7f9d5d2e2633c$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "hasProperty", () => $f1d7f9d5d2e2633c$export$bf9617eaf5d2451);
$parcel$export(module.exports, "equalFlat", () => $f1d7f9d5d2e2633c$export$4f1c34abb2bb4c8);
/**
 * Utility functions for working with EcmaScript objects.
 *
 * @module object
 */ /**
 * @return {Object<string,any>} obj
 */ const $f1d7f9d5d2e2633c$export$185802fd694ee1f5 = ()=>Object.create(null);
const $f1d7f9d5d2e2633c$export$e6e34fd1f2686227 = Object.assign;
const $f1d7f9d5d2e2633c$export$ed97f33186d4b816 = Object.keys;
const $f1d7f9d5d2e2633c$export$4b80e395e36b5a56 = (obj, f)=>{
    for(const key in obj)f(obj[key], key);
};
const $f1d7f9d5d2e2633c$export$871de8747c9eaa88 = (obj, f)=>{
    const results = [];
    for(const key in obj)results.push(f(obj[key], key));
    return results;
};
const $f1d7f9d5d2e2633c$export$f24224f1c91d8156 = (obj)=>$f1d7f9d5d2e2633c$export$ed97f33186d4b816(obj).length;
const $f1d7f9d5d2e2633c$export$ad14ef4001db2bcd = (obj, f)=>{
    for(const key in obj){
        if (f(obj[key], key)) return true;
    }
    return false;
};
const $f1d7f9d5d2e2633c$export$dd1bc94b04021eeb = (obj)=>{
    // eslint-disable-next-line
    for(const _k in obj)return false;
    return true;
};
const $f1d7f9d5d2e2633c$export$7ecc1a3b11b57dab = (obj, f)=>{
    for(const key in obj){
        if (!f(obj[key], key)) return false;
    }
    return true;
};
const $f1d7f9d5d2e2633c$export$bf9617eaf5d2451 = (obj, key)=>Object.prototype.hasOwnProperty.call(obj, key);
const $f1d7f9d5d2e2633c$export$4f1c34abb2bb4c8 = (a, b)=>a === b || $f1d7f9d5d2e2633c$export$f24224f1c91d8156(a) === $f1d7f9d5d2e2633c$export$f24224f1c91d8156(b) && $f1d7f9d5d2e2633c$export$7ecc1a3b11b57dab(a, (val, key)=>(val !== undefined || $f1d7f9d5d2e2633c$export$bf9617eaf5d2451(b, key)) && b[key] === val);

});


parcelRegister("ibaza", function(module, exports) {
// shim for using process in browser
var $d3c1734dacb01657$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d3c1734dacb01657$var$cachedSetTimeout;
var $d3c1734dacb01657$var$cachedClearTimeout;
function $d3c1734dacb01657$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $d3c1734dacb01657$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        else $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        else $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    }
})();
function $d3c1734dacb01657$var$runTimeout(fun) {
    if ($d3c1734dacb01657$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedSetTimeout === $d3c1734dacb01657$var$defaultSetTimout || !$d3c1734dacb01657$var$cachedSetTimeout) && setTimeout) {
        $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d3c1734dacb01657$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d3c1734dacb01657$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d3c1734dacb01657$var$runClearTimeout(marker) {
    if ($d3c1734dacb01657$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedClearTimeout === $d3c1734dacb01657$var$defaultClearTimeout || !$d3c1734dacb01657$var$cachedClearTimeout) && clearTimeout) {
        $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d3c1734dacb01657$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d3c1734dacb01657$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d3c1734dacb01657$var$queue = [];
var $d3c1734dacb01657$var$draining = false;
var $d3c1734dacb01657$var$currentQueue;
var $d3c1734dacb01657$var$queueIndex = -1;
function $d3c1734dacb01657$var$cleanUpNextTick() {
    if (!$d3c1734dacb01657$var$draining || !$d3c1734dacb01657$var$currentQueue) return;
    $d3c1734dacb01657$var$draining = false;
    if ($d3c1734dacb01657$var$currentQueue.length) $d3c1734dacb01657$var$queue = $d3c1734dacb01657$var$currentQueue.concat($d3c1734dacb01657$var$queue);
    else $d3c1734dacb01657$var$queueIndex = -1;
    if ($d3c1734dacb01657$var$queue.length) $d3c1734dacb01657$var$drainQueue();
}
function $d3c1734dacb01657$var$drainQueue() {
    if ($d3c1734dacb01657$var$draining) return;
    var timeout = $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$cleanUpNextTick);
    $d3c1734dacb01657$var$draining = true;
    var len = $d3c1734dacb01657$var$queue.length;
    while(len){
        $d3c1734dacb01657$var$currentQueue = $d3c1734dacb01657$var$queue;
        $d3c1734dacb01657$var$queue = [];
        while(++$d3c1734dacb01657$var$queueIndex < len)if ($d3c1734dacb01657$var$currentQueue) $d3c1734dacb01657$var$currentQueue[$d3c1734dacb01657$var$queueIndex].run();
        $d3c1734dacb01657$var$queueIndex = -1;
        len = $d3c1734dacb01657$var$queue.length;
    }
    $d3c1734dacb01657$var$currentQueue = null;
    $d3c1734dacb01657$var$draining = false;
    $d3c1734dacb01657$var$runClearTimeout(timeout);
}
$d3c1734dacb01657$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d3c1734dacb01657$var$queue.push(new $d3c1734dacb01657$var$Item(fun, args));
    if ($d3c1734dacb01657$var$queue.length === 1 && !$d3c1734dacb01657$var$draining) $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$drainQueue);
};
// v8 likes predictible objects
function $d3c1734dacb01657$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d3c1734dacb01657$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d3c1734dacb01657$var$process.title = "browser";
$d3c1734dacb01657$var$process.browser = true;
$d3c1734dacb01657$var$process.env = {};
$d3c1734dacb01657$var$process.argv = [];
$d3c1734dacb01657$var$process.version = ""; // empty string to avoid regexp issues
$d3c1734dacb01657$var$process.versions = {};
function $d3c1734dacb01657$var$noop() {}
$d3c1734dacb01657$var$process.on = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.addListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.once = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.off = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeAllListeners = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.emit = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependOnceListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.listeners = function(name) {
    return [];
};
$d3c1734dacb01657$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$d3c1734dacb01657$var$process.cwd = function() {
    return "/";
};
$d3c1734dacb01657$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$d3c1734dacb01657$var$process.umask = function() {
    return 0;
};

});



parcelRegister("98BSr", function(module, exports) {

$parcel$export(module.exports, "print", () => $6a723e03694e1489$export$c2d084dc44961371);
$parcel$export(module.exports, "warn", () => $6a723e03694e1489$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "BOLD", () => (parcelRequire("b2PaR")).BOLD);
$parcel$export(module.exports, "UNBOLD", () => (parcelRequire("b2PaR")).UNBOLD);
$parcel$export(module.exports, "RED", () => (parcelRequire("b2PaR")).RED);
$parcel$export(module.exports, "ORANGE", () => (parcelRequire("b2PaR")).ORANGE);
/**
 * Isomorphic logging module with support for colors!
 *
 * @module logging
 */ 
var $gXB0J = parcelRequire("gXB0J");

var $bUD5M = parcelRequire("bUD5M");

var $bMhVF = parcelRequire("bMhVF");

var $jptUw = parcelRequire("jptUw");

var $33UTY = parcelRequire("33UTY");

var $dh5fq = parcelRequire("dh5fq");

var $8kHzU = parcelRequire("8kHzU");

var $5qKvF = parcelRequire("5qKvF");

var $b2PaR = parcelRequire("b2PaR");
/**
 * @type {Object<Symbol,pair.Pair<string,string>>}
 */ const $6a723e03694e1489$var$_browserStyleMap = {
    [$b2PaR.BOLD]: $bMhVF.create("font-weight", "bold"),
    [$b2PaR.UNBOLD]: $bMhVF.create("font-weight", "normal"),
    [$b2PaR.BLUE]: $bMhVF.create("color", "blue"),
    [$b2PaR.GREEN]: $bMhVF.create("color", "green"),
    [$b2PaR.GREY]: $bMhVF.create("color", "grey"),
    [$b2PaR.RED]: $bMhVF.create("color", "red"),
    [$b2PaR.PURPLE]: $bMhVF.create("color", "purple"),
    [$b2PaR.ORANGE]: $bMhVF.create("color", "orange"),
    [$b2PaR.UNCOLOR]: $bMhVF.create("color", "black")
};
/**
 * @param {Array<string|Symbol|Object|number|function():any>} args
 * @return {Array<string|object|number>}
 */ /* c8 ignore start */ const $6a723e03694e1489$var$computeBrowserLoggingArgs = (args)=>{
    if (args.length === 1 && args[0]?.constructor === Function) args = /** @type {Array<string|Symbol|Object|number>} */ /** @type {[function]} */ args[0]();
    const strBuilder = [];
    const styles = [];
    const currentStyle = $dh5fq.create();
    /**
   * @type {Array<string|Object|number>}
   */ let logArgs = [];
    // try with formatting until we find something unsupported
    let i = 0;
    for(; i < args.length; i++){
        const arg = args[i];
        // @ts-ignore
        const style = $6a723e03694e1489$var$_browserStyleMap[arg];
        if (style !== undefined) currentStyle.set(style.left, style.right);
        else {
            if (arg === undefined) break;
            if (arg.constructor === String || arg.constructor === Number) {
                const style = $jptUw.mapToStyleString(currentStyle);
                if (i > 0 || style.length > 0) {
                    strBuilder.push("%c" + arg);
                    styles.push(style);
                } else strBuilder.push(arg);
            } else break;
        }
    }
    if (i > 0) {
        // create logArgs with what we have so far
        logArgs = styles;
        logArgs.unshift(strBuilder.join(""));
    }
    // append the rest
    for(; i < args.length; i++){
        const arg = args[i];
        if (!(arg instanceof Symbol)) logArgs.push(arg);
    }
    return logArgs;
};
/* c8 ignore stop */ /* c8 ignore start */ const $6a723e03694e1489$var$computeLoggingArgs = $gXB0J.supportsColor ? $6a723e03694e1489$var$computeBrowserLoggingArgs : $b2PaR.computeNoColorLoggingArgs;
const $6a723e03694e1489$export$c2d084dc44961371 = (...args)=>{
    console.log(...$6a723e03694e1489$var$computeLoggingArgs(args));
    /* c8 ignore next */ $6a723e03694e1489$export$6f0283bff34730a1.forEach((vc)=>vc.print(args));
};
const $6a723e03694e1489$export$c106dd0671a0fc2d = (...args)=>{
    console.warn(...$6a723e03694e1489$var$computeLoggingArgs(args));
    args.unshift($b2PaR.ORANGE);
    $6a723e03694e1489$export$6f0283bff34730a1.forEach((vc)=>vc.print(args));
};
const $6a723e03694e1489$export$55ee1551a3f962e6 = (err)=>{
    console.error(err);
    $6a723e03694e1489$export$6f0283bff34730a1.forEach((vc)=>vc.printError(err));
};
const $6a723e03694e1489$export$85acd411250ab137 = (url, height)=>{
    if ($gXB0J.isBrowser) console.log("%c                      ", `font-size: ${height}px; background-size: contain; background-repeat: no-repeat; background-image: url(${url})`);
    $6a723e03694e1489$export$6f0283bff34730a1.forEach((vc)=>vc.printImg(url, height));
};
const $6a723e03694e1489$export$fcd48d8a033dbfbf = (base64, height)=>$6a723e03694e1489$export$85acd411250ab137(`data:image/gif;base64,${base64}`, height);
const $6a723e03694e1489$export$e5e25fbcc1f7affe = (...args)=>{
    console.group(...$6a723e03694e1489$var$computeLoggingArgs(args));
    /* c8 ignore next */ $6a723e03694e1489$export$6f0283bff34730a1.forEach((vc)=>vc.group(args));
};
const $6a723e03694e1489$export$488ef8fb3416a29f = (...args)=>{
    console.groupCollapsed(...$6a723e03694e1489$var$computeLoggingArgs(args));
    /* c8 ignore next */ $6a723e03694e1489$export$6f0283bff34730a1.forEach((vc)=>vc.groupCollapsed(args));
};
const $6a723e03694e1489$export$a57f3dfe595273e6 = ()=>{
    console.groupEnd();
    /* c8 ignore next */ $6a723e03694e1489$export$6f0283bff34730a1.forEach((vc)=>vc.groupEnd());
};
const $6a723e03694e1489$export$76dff282388623b3 = (createNode)=>$6a723e03694e1489$export$6f0283bff34730a1.forEach((vc)=>vc.printDom(createNode()));
const $6a723e03694e1489$export$98f2e847362d891 = (canvas, height)=>$6a723e03694e1489$export$85acd411250ab137(canvas.toDataURL(), height);
const $6a723e03694e1489$export$6f0283bff34730a1 = $bUD5M.create();
/**
 * @param {Array<string|Symbol|Object|number>} args
 * @return {Array<Element>}
 */ /* c8 ignore start */ const $6a723e03694e1489$var$_computeLineSpans = (args)=>{
    const spans = [];
    const currentStyle = new Map();
    // try with formatting until we find something unsupported
    let i = 0;
    for(; i < args.length; i++){
        let arg = args[i];
        // @ts-ignore
        const style = $6a723e03694e1489$var$_browserStyleMap[arg];
        if (style !== undefined) currentStyle.set(style.left, style.right);
        else {
            if (arg === undefined) arg = "undefined ";
            if (arg.constructor === String || arg.constructor === Number) {
                // @ts-ignore
                const span = $jptUw.element("span", [
                    $bMhVF.create("style", $jptUw.mapToStyleString(currentStyle))
                ], [
                    $jptUw.text(arg.toString())
                ]);
                if (span.innerHTML === "") span.innerHTML = "&nbsp;";
                spans.push(span);
            } else break;
        }
    }
    // append the rest
    for(; i < args.length; i++){
        let content = args[i];
        if (!(content instanceof Symbol)) {
            if (content.constructor !== String && content.constructor !== Number) content = " " + $33UTY.stringify(content) + " ";
            spans.push($jptUw.element("span", [], [
                $jptUw.text(/** @type {string} */ content)
            ]));
        }
    }
    return spans;
};
/* c8 ignore stop */ const $6a723e03694e1489$var$lineStyle = "font-family:monospace;border-bottom:1px solid #e2e2e2;padding:2px;";
class $6a723e03694e1489$export$79dd518d42f6d7a1 {
    /**
   * @param {Element} dom
   */ constructor(dom){
        this.dom = dom;
        /**
     * @type {Element}
     */ this.ccontainer = this.dom;
        this.depth = 0;
        $6a723e03694e1489$export$6f0283bff34730a1.add(this);
    }
    /**
   * @param {Array<string|Symbol|Object|number>} args
   * @param {boolean} collapsed
   */ group(args, collapsed = false) {
        $8kHzU.enqueue(()=>{
            const triangleDown = $jptUw.element("span", [
                $bMhVF.create("hidden", collapsed),
                $bMhVF.create("style", "color:grey;font-size:120%;")
            ], [
                $jptUw.text("\u25BC")
            ]);
            const triangleRight = $jptUw.element("span", [
                $bMhVF.create("hidden", !collapsed),
                $bMhVF.create("style", "color:grey;font-size:125%;")
            ], [
                $jptUw.text("\u25B6")
            ]);
            const content = $jptUw.element("div", [
                $bMhVF.create("style", `${$6a723e03694e1489$var$lineStyle};padding-left:${this.depth * 10}px`)
            ], [
                triangleDown,
                triangleRight,
                $jptUw.text(" ")
            ].concat($6a723e03694e1489$var$_computeLineSpans(args)));
            const nextContainer = $jptUw.element("div", [
                $bMhVF.create("hidden", collapsed)
            ]);
            const nextLine = $jptUw.element("div", [], [
                content,
                nextContainer
            ]);
            $jptUw.append(this.ccontainer, [
                nextLine
            ]);
            this.ccontainer = nextContainer;
            this.depth++;
            // when header is clicked, collapse/uncollapse container
            $jptUw.addEventListener(content, "click", (_event)=>{
                nextContainer.toggleAttribute("hidden");
                triangleDown.toggleAttribute("hidden");
                triangleRight.toggleAttribute("hidden");
            });
        });
    }
    /**
   * @param {Array<string|Symbol|Object|number>} args
   */ groupCollapsed(args) {
        this.group(args, true);
    }
    groupEnd() {
        $8kHzU.enqueue(()=>{
            if (this.depth > 0) {
                this.depth--;
                // @ts-ignore
                this.ccontainer = this.ccontainer.parentElement.parentElement;
            }
        });
    }
    /**
   * @param {Array<string|Symbol|Object|number>} args
   */ print(args) {
        $8kHzU.enqueue(()=>{
            $jptUw.append(this.ccontainer, [
                $jptUw.element("div", [
                    $bMhVF.create("style", `${$6a723e03694e1489$var$lineStyle};padding-left:${this.depth * 10}px`)
                ], $6a723e03694e1489$var$_computeLineSpans(args))
            ]);
        });
    }
    /**
   * @param {Error} err
   */ printError(err) {
        this.print([
            $b2PaR.RED,
            $b2PaR.BOLD,
            err.toString()
        ]);
    }
    /**
   * @param {string} url
   * @param {number} height
   */ printImg(url, height) {
        $8kHzU.enqueue(()=>{
            $jptUw.append(this.ccontainer, [
                $jptUw.element("img", [
                    $bMhVF.create("src", url),
                    $bMhVF.create("height", `${$5qKvF.round(height * 1.5)}px`)
                ])
            ]);
        });
    }
    /**
   * @param {Node} node
   */ printDom(node) {
        $8kHzU.enqueue(()=>{
            $jptUw.append(this.ccontainer, [
                node
            ]);
        });
    }
    destroy() {
        $8kHzU.enqueue(()=>{
            $6a723e03694e1489$export$6f0283bff34730a1.delete(this);
        });
    }
}
const $6a723e03694e1489$export$3b589da4ab12cf23 = (dom)=>new $6a723e03694e1489$export$79dd518d42f6d7a1(dom);
const $6a723e03694e1489$export$c2977e725d59a2fd = (moduleName)=>$b2PaR.createModuleLogger($6a723e03694e1489$export$c2d084dc44961371, moduleName);

});
parcelRegister("bMhVF", function(module, exports) {

$parcel$export(module.exports, "create", () => $893215bb5254c6e4$export$185802fd694ee1f5);
$parcel$export(module.exports, "forEach", () => $893215bb5254c6e4$export$4b80e395e36b5a56);
/**
 * Working with value pairs.
 *
 * @module pair
 */ /**
 * @template L,R
 */ class $893215bb5254c6e4$export$d63d7cff08fe4dc9 {
    /**
   * @param {L} left
   * @param {R} right
   */ constructor(left, right){
        this.left = left;
        this.right = right;
    }
}
const $893215bb5254c6e4$export$185802fd694ee1f5 = (left, right)=>new $893215bb5254c6e4$export$d63d7cff08fe4dc9(left, right);
const $893215bb5254c6e4$export$ca0ea131672c5a9b = (right, left)=>new $893215bb5254c6e4$export$d63d7cff08fe4dc9(left, right);
const $893215bb5254c6e4$export$4b80e395e36b5a56 = (arr, f)=>arr.forEach((p)=>f(p.left, p.right));
const $893215bb5254c6e4$export$871de8747c9eaa88 = (arr, f)=>arr.map((p)=>f(p.left, p.right));

});

parcelRegister("jptUw", function(module, exports) {

$parcel$export(module.exports, "append", () => $e2178dc34fa6c79b$export$10d8903dec122b9d);
$parcel$export(module.exports, "addEventListener", () => $e2178dc34fa6c79b$export$3f65cefe8380dbea);
$parcel$export(module.exports, "element", () => $e2178dc34fa6c79b$export$8454457683f90105);
$parcel$export(module.exports, "text", () => $e2178dc34fa6c79b$export$6f093cfa640b7166);
$parcel$export(module.exports, "mapToStyleString", () => $e2178dc34fa6c79b$export$7d9cafe158c3b49);
/* eslint-env browser */ /**
 * Utility module to work with the DOM.
 *
 * @module dom
 */ 
var $bMhVF = parcelRequire("bMhVF");

var $dh5fq = parcelRequire("dh5fq");
const $e2178dc34fa6c79b$export$2a111da947c407d2 = /** @type {Document} */ typeof document !== "undefined" ? document : {};
const $e2178dc34fa6c79b$export$c8a8987d4410bf2d = (name)=>$e2178dc34fa6c79b$export$2a111da947c407d2.createElement(name);
const $e2178dc34fa6c79b$export$fb51152cd5328759 = ()=>$e2178dc34fa6c79b$export$2a111da947c407d2.createDocumentFragment();
const $e2178dc34fa6c79b$export$b2ce9ad90858ed7a = (text)=>$e2178dc34fa6c79b$export$2a111da947c407d2.createTextNode(text);
const $e2178dc34fa6c79b$export$fb621bb527230cda = /** @type {DOMParser} */ typeof DOMParser !== "undefined" ? new DOMParser() : null;
const $e2178dc34fa6c79b$export$77c9ee5a14f9d7cf = (el, name, opts)=>el.dispatchEvent(new CustomEvent(name, opts));
const $e2178dc34fa6c79b$export$74da2cba014bdc09 = (el, attrs)=>{
    $bMhVF.forEach(attrs, (key, value)=>{
        if (value === false) el.removeAttribute(key);
        else if (value === true) el.setAttribute(key, "");
        else // @ts-ignore
        el.setAttribute(key, value);
    });
    return el;
};
const $e2178dc34fa6c79b$export$ba744f7d152abea1 = (el, attrs)=>{
    attrs.forEach((value, key)=>{
        el.setAttribute(key, value);
    });
    return el;
};
const $e2178dc34fa6c79b$export$f00aeb236b6f05af = (children)=>{
    const fragment = $e2178dc34fa6c79b$export$fb51152cd5328759();
    for(let i = 0; i < children.length; i++)$e2178dc34fa6c79b$export$1b8e57c9ea42f1d2(fragment, children[i]);
    return fragment;
};
const $e2178dc34fa6c79b$export$10d8903dec122b9d = (parent, nodes)=>{
    $e2178dc34fa6c79b$export$1b8e57c9ea42f1d2(parent, $e2178dc34fa6c79b$export$f00aeb236b6f05af(nodes));
    return parent;
};
const $e2178dc34fa6c79b$export$cd7f480d6b8286c3 = (el)=>el.remove();
const $e2178dc34fa6c79b$export$3f65cefe8380dbea = (el, name, f)=>el.addEventListener(name, f);
const $e2178dc34fa6c79b$export$8ff9f68337b520c0 = (el, name, f)=>el.removeEventListener(name, f);
const $e2178dc34fa6c79b$export$40a4ed63e5cb7043 = (node, listeners)=>{
    $bMhVF.forEach(listeners, (name, f)=>$e2178dc34fa6c79b$export$3f65cefe8380dbea(node, name, f));
    return node;
};
const $e2178dc34fa6c79b$export$8c7b13b21690651d = (node, listeners)=>{
    $bMhVF.forEach(listeners, (name, f)=>$e2178dc34fa6c79b$export$8ff9f68337b520c0(node, name, f));
    return node;
};
const $e2178dc34fa6c79b$export$8454457683f90105 = (name, attrs = [], children = [])=>$e2178dc34fa6c79b$export$10d8903dec122b9d($e2178dc34fa6c79b$export$74da2cba014bdc09($e2178dc34fa6c79b$export$c8a8987d4410bf2d(name), attrs), children);
const $e2178dc34fa6c79b$export$67ea982130081db = (width, height)=>{
    const c = /** @type {HTMLCanvasElement} */ $e2178dc34fa6c79b$export$c8a8987d4410bf2d("canvas");
    c.height = height;
    c.width = width;
    return c;
};
const $e2178dc34fa6c79b$export$6f093cfa640b7166 = $e2178dc34fa6c79b$export$b2ce9ad90858ed7a;
const $e2178dc34fa6c79b$export$7f60f118cd3e6292 = (pair)=>`${pair.left}:${pair.right};`;
const $e2178dc34fa6c79b$export$3d24a00500154f45 = (pairs)=>pairs.map($e2178dc34fa6c79b$export$7f60f118cd3e6292).join("");
const $e2178dc34fa6c79b$export$7d9cafe158c3b49 = (m)=>$dh5fq.map(m, (value, key)=>`${key}:${value};`).join("");
const $e2178dc34fa6c79b$export$78fb49a702cc1f2 = (el, query)=>el.querySelector(query);
const $e2178dc34fa6c79b$export$2e83b5c43fb7af7b = (el, query)=>el.querySelectorAll(query);
const $e2178dc34fa6c79b$export$83595b84fc78b9b4 = (id)=>/** @type {HTMLElement} */ $e2178dc34fa6c79b$export$2a111da947c407d2.getElementById(id);
/**
 * @param {string} html
 * @return {HTMLElement}
 */ const $e2178dc34fa6c79b$var$_parse = (html)=>$e2178dc34fa6c79b$export$fb621bb527230cda.parseFromString(`<html><body>${html}</body></html>`, "text/html").body;
const $e2178dc34fa6c79b$export$e1152f5efcc82ad = (html)=>$e2178dc34fa6c79b$export$f00aeb236b6f05af(/** @type {any} */ $e2178dc34fa6c79b$var$_parse(html).childNodes);
const $e2178dc34fa6c79b$export$b23064c2dcaf2b63 = (html)=>/** @type HTMLElement */ $e2178dc34fa6c79b$var$_parse(html).firstElementChild;
const $e2178dc34fa6c79b$export$e6a6680780233a77 = (oldEl, newEl)=>oldEl.replaceWith(newEl);
const $e2178dc34fa6c79b$export$86b68c7dbeb53c22 = (parent, el, ref)=>parent.insertBefore(el, ref);
const $e2178dc34fa6c79b$export$1b8e57c9ea42f1d2 = (parent, child)=>parent.appendChild(child);
const $e2178dc34fa6c79b$export$51c8a276ee4b8f51 = $e2178dc34fa6c79b$export$2a111da947c407d2.ELEMENT_NODE;
const $e2178dc34fa6c79b$export$5bcc40203615fc2e = $e2178dc34fa6c79b$export$2a111da947c407d2.TEXT_NODE;
const $e2178dc34fa6c79b$export$e5fc6332c1c8eb8e = $e2178dc34fa6c79b$export$2a111da947c407d2.CDATA_SECTION_NODE;
const $e2178dc34fa6c79b$export$3d597a6ef0f08b0a = $e2178dc34fa6c79b$export$2a111da947c407d2.COMMENT_NODE;
const $e2178dc34fa6c79b$export$4139dcda4f7f83db = $e2178dc34fa6c79b$export$2a111da947c407d2.DOCUMENT_NODE;
const $e2178dc34fa6c79b$export$e9e7ddfdb004b848 = $e2178dc34fa6c79b$export$2a111da947c407d2.DOCUMENT_TYPE_NODE;
const $e2178dc34fa6c79b$export$b86725031ae151ee = $e2178dc34fa6c79b$export$2a111da947c407d2.DOCUMENT_FRAGMENT_NODE;
const $e2178dc34fa6c79b$export$1aa65d86db59b879 = (node, type)=>node.nodeType === type;
const $e2178dc34fa6c79b$export$3c81af374b054d6a = (parent, child)=>{
    let p = child.parentNode;
    while(p && p !== parent)p = p.parentNode;
    return p === parent;
} /* c8 ignore stop */ ;

});

parcelRegister("33UTY", function(module, exports) {

$parcel$export(module.exports, "stringify", () => $23adca70719e5676$export$fac44ee5b035f737);
/**
 * JSON utility functions.
 *
 * @module json
 */ /**
 * Transform JavaScript object to JSON.
 *
 * @param {any} object
 * @return {string}
 */ const $23adca70719e5676$export$fac44ee5b035f737 = JSON.stringify;
const $23adca70719e5676$export$98e6a39c04603d36 = JSON.parse;

});

parcelRegister("8kHzU", function(module, exports) {

$parcel$export(module.exports, "enqueue", () => $6111feb680fcee6f$export$513072ba72100d9c);
/* global requestIdleCallback, requestAnimationFrame, cancelIdleCallback, cancelAnimationFrame */ /**
 * Utility module to work with EcmaScript's event loop.
 *
 * @module eventloop
 */ /**
 * @type {Array<function>}
 */ let $6111feb680fcee6f$var$queue = [];
const $6111feb680fcee6f$var$_runQueue = ()=>{
    for(let i = 0; i < $6111feb680fcee6f$var$queue.length; i++)$6111feb680fcee6f$var$queue[i]();
    $6111feb680fcee6f$var$queue = [];
};
const $6111feb680fcee6f$export$513072ba72100d9c = (f)=>{
    $6111feb680fcee6f$var$queue.push(f);
    if ($6111feb680fcee6f$var$queue.length === 1) setTimeout($6111feb680fcee6f$var$_runQueue, 0);
};
/**
 * @typedef {Object} TimeoutObject
 * @property {function} TimeoutObject.destroy
 */ /**
 * @param {function(number):void} clearFunction
 */ const $6111feb680fcee6f$var$createTimeoutClass = (clearFunction)=>class TT {
        /**
   * @param {number} timeoutId
   */ constructor(timeoutId){
            this._ = timeoutId;
        }
        destroy() {
            clearFunction(this._);
        }
    };
const $6111feb680fcee6f$var$Timeout = $6111feb680fcee6f$var$createTimeoutClass(clearTimeout);
const $6111feb680fcee6f$export$83e74882c5df8fe1 = (timeout, callback)=>new $6111feb680fcee6f$var$Timeout(setTimeout(callback, timeout));
const $6111feb680fcee6f$var$Interval = $6111feb680fcee6f$var$createTimeoutClass(clearInterval);
const $6111feb680fcee6f$export$3174cdbf0a0cbc84 = (timeout, callback)=>new $6111feb680fcee6f$var$Interval(setInterval(callback, timeout));
const $6111feb680fcee6f$export$c35d437ae5945fcd = $6111feb680fcee6f$var$createTimeoutClass((arg)=>typeof requestAnimationFrame !== "undefined" && cancelAnimationFrame(arg));
const $6111feb680fcee6f$export$1402cba6a733f33a = (cb)=>typeof requestAnimationFrame === "undefined" ? $6111feb680fcee6f$export$83e74882c5df8fe1(0, cb) : new $6111feb680fcee6f$export$c35d437ae5945fcd(requestAnimationFrame(cb));
/* c8 ignore next */ // @ts-ignore
const $6111feb680fcee6f$var$Idle = $6111feb680fcee6f$var$createTimeoutClass((arg)=>typeof cancelIdleCallback !== "undefined" && cancelIdleCallback(arg));
const $6111feb680fcee6f$export$9f62c65f1b707875 = (cb)=>typeof requestIdleCallback !== "undefined" ? new $6111feb680fcee6f$var$Idle(requestIdleCallback(cb)) : $6111feb680fcee6f$export$83e74882c5df8fe1(1000, cb);
const $6111feb680fcee6f$export$21cd608c50c2ba31 = (timeout)=>{
    let timer = -1;
    return (f)=>{
        clearTimeout(timer);
        if (f) timer = /** @type {any} */ setTimeout(f, timeout);
    };
};

});

parcelRegister("b2PaR", function(module, exports) {

$parcel$export(module.exports, "BOLD", () => $80a793bcbffa8b75$export$c1286c4c2a7c066);
$parcel$export(module.exports, "UNBOLD", () => $80a793bcbffa8b75$export$f0ce1666bb40789b);
$parcel$export(module.exports, "BLUE", () => $80a793bcbffa8b75$export$738c3b9a44c87ecc);
$parcel$export(module.exports, "GREY", () => $80a793bcbffa8b75$export$7d278ca694634874);
$parcel$export(module.exports, "GREEN", () => $80a793bcbffa8b75$export$48d4b2cd5bc0e88b);
$parcel$export(module.exports, "RED", () => $80a793bcbffa8b75$export$aa201224bb439d47);
$parcel$export(module.exports, "PURPLE", () => $80a793bcbffa8b75$export$7ffdeca4b2f927a2);
$parcel$export(module.exports, "ORANGE", () => $80a793bcbffa8b75$export$3de5e29ed1757f9b);
$parcel$export(module.exports, "UNCOLOR", () => $80a793bcbffa8b75$export$b586f81201748dd0);
$parcel$export(module.exports, "computeNoColorLoggingArgs", () => $80a793bcbffa8b75$export$3454091cc3c6c473);
$parcel$export(module.exports, "createModuleLogger", () => $80a793bcbffa8b75$export$c2977e725d59a2fd);

var $ifO1p = parcelRequire("ifO1p");

var $c48Az = parcelRequire("c48Az");

var $gXB0J = parcelRequire("gXB0J");

var $4NUz5 = parcelRequire("4NUz5");

var $33UTY = parcelRequire("33UTY");
const $80a793bcbffa8b75$export$c1286c4c2a7c066 = $ifO1p.create();
const $80a793bcbffa8b75$export$f0ce1666bb40789b = $ifO1p.create();
const $80a793bcbffa8b75$export$738c3b9a44c87ecc = $ifO1p.create();
const $80a793bcbffa8b75$export$7d278ca694634874 = $ifO1p.create();
const $80a793bcbffa8b75$export$48d4b2cd5bc0e88b = $ifO1p.create();
const $80a793bcbffa8b75$export$aa201224bb439d47 = $ifO1p.create();
const $80a793bcbffa8b75$export$7ffdeca4b2f927a2 = $ifO1p.create();
const $80a793bcbffa8b75$export$3de5e29ed1757f9b = $ifO1p.create();
const $80a793bcbffa8b75$export$b586f81201748dd0 = $ifO1p.create();
const $80a793bcbffa8b75$export$3454091cc3c6c473 = (args)=>{
    if (args.length === 1 && args[0]?.constructor === Function) args = /** @type {Array<string|Symbol|Object|number>} */ /** @type {[function]} */ args[0]();
    const strBuilder = [];
    const logArgs = [];
    // try with formatting until we find something unsupported
    let i = 0;
    for(; i < args.length; i++){
        const arg = args[i];
        if (arg === undefined) strBuilder.push("undefined");
        else if (arg.constructor === String || arg.constructor === Number) strBuilder.push(arg);
        else if (arg.constructor === Object) logArgs.push(JSON.stringify(arg));
    }
    return logArgs;
};
/* c8 ignore stop */ const $80a793bcbffa8b75$var$loggingColors = [
    $80a793bcbffa8b75$export$48d4b2cd5bc0e88b,
    $80a793bcbffa8b75$export$7ffdeca4b2f927a2,
    $80a793bcbffa8b75$export$3de5e29ed1757f9b,
    $80a793bcbffa8b75$export$738c3b9a44c87ecc
];
let $80a793bcbffa8b75$var$nextColor = 0;
let $80a793bcbffa8b75$var$lastLoggingTime = $c48Az.getUnixTime();
const $80a793bcbffa8b75$export$c2977e725d59a2fd = (_print, moduleName)=>{
    const color = $80a793bcbffa8b75$var$loggingColors[$80a793bcbffa8b75$var$nextColor];
    const debugRegexVar = $gXB0J.getVariable("log");
    const doLogging = debugRegexVar !== null && (debugRegexVar === "*" || debugRegexVar === "true" || new RegExp(debugRegexVar, "gi").test(moduleName));
    $80a793bcbffa8b75$var$nextColor = ($80a793bcbffa8b75$var$nextColor + 1) % $80a793bcbffa8b75$var$loggingColors.length;
    moduleName += ": ";
    return !doLogging ? $4NUz5.nop : (...args)=>{
        if (args.length === 1 && args[0]?.constructor === Function) args = args[0]();
        const timeNow = $c48Az.getUnixTime();
        const timeDiff = timeNow - $80a793bcbffa8b75$var$lastLoggingTime;
        $80a793bcbffa8b75$var$lastLoggingTime = timeNow;
        _print(color, moduleName, $80a793bcbffa8b75$export$b586f81201748dd0, ...args.map((arg)=>{
            if (arg != null && arg.constructor === Uint8Array) arg = Array.from(arg);
            const t = typeof arg;
            switch(t){
                case "string":
                case "symbol":
                    return arg;
                default:
                    return $33UTY.stringify(arg);
            }
        }), color, " +" + timeDiff + "ms");
    };
} /* c8 ignore stop */ ;

});
parcelRegister("ifO1p", function(module, exports) {

$parcel$export(module.exports, "create", () => $d4a06dfdf3b44d39$export$185802fd694ee1f5);
/**
 * Utility module to work with EcmaScript Symbols.
 *
 * @module symbol
 */ /**
 * Return fresh symbol.
 *
 * @return {Symbol}
 */ const $d4a06dfdf3b44d39$export$185802fd694ee1f5 = Symbol;
const $d4a06dfdf3b44d39$export$a244864fd9645c7f = (s)=>typeof s === "symbol";

});



parcelRegister("2H3N4", function(module, exports) {

$parcel$export(module.exports, "iteratorFilter", () => $1f6289a36d4f83c1$export$88f0b2eef157f31a);
$parcel$export(module.exports, "iteratorMap", () => $1f6289a36d4f83c1$export$1570d514f543056a);
/**
 * Utility module to create and manipulate Iterators.
 *
 * @module iterator
 */ /**
 * @template T,R
 * @param {Iterator<T>} iterator
 * @param {function(T):R} f
 * @return {IterableIterator<R>}
 */ const $1f6289a36d4f83c1$export$68b1bda190f54159 = (iterator, f)=>({
        [Symbol.iterator] () {
            return this;
        },
        // @ts-ignore
        next () {
            const r = iterator.next();
            return {
                value: r.done ? undefined : f(r.value),
                done: r.done
            };
        }
    });
const $1f6289a36d4f83c1$export$7342c78d7e13e778 = (next)=>({
        /**
   * @return {IterableIterator<T>}
   */ [Symbol.iterator] () {
            return this;
        },
        next: // @ts-ignore
        next
    });
const $1f6289a36d4f83c1$export$88f0b2eef157f31a = (iterator, filter)=>$1f6289a36d4f83c1$export$7342c78d7e13e778(()=>{
        let res;
        do res = iterator.next();
        while (!res.done && !filter(res.value));
        return res;
    });
const $1f6289a36d4f83c1$export$1570d514f543056a = (iterator, fmap)=>$1f6289a36d4f83c1$export$7342c78d7e13e778(()=>{
        const { done: done, value: value } = iterator.next();
        return {
            done: done,
            value: done ? undefined : fmap(value)
        };
    });

});


parcelRegister("Gs8iu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $07f9bef39fe6830c$export$2e2bcd8739ae039);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $07f9bef39fe6830c$var$extendStatics = function(d, b) {
    $07f9bef39fe6830c$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $07f9bef39fe6830c$var$extendStatics(d, b);
};
function $07f9bef39fe6830c$var$__extends(d, b) {
    $07f9bef39fe6830c$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
function $07f9bef39fe6830c$var$__values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
}
function $07f9bef39fe6830c$var$__read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $07f9bef39fe6830c$var$__spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($07f9bef39fe6830c$var$__read(arguments[i]));
    return ar;
}
var $07f9bef39fe6830c$var$Event = /** @class */ function() {
    function Event(type, target) {
        this.target = target;
        this.type = type;
    }
    return Event;
}();
var $07f9bef39fe6830c$var$ErrorEvent = /** @class */ function(_super) {
    $07f9bef39fe6830c$var$__extends(ErrorEvent, _super);
    function ErrorEvent(error, target) {
        var _this = _super.call(this, "error", target) || this;
        _this.message = error.message;
        _this.error = error;
        return _this;
    }
    return ErrorEvent;
}($07f9bef39fe6830c$var$Event);
var $07f9bef39fe6830c$var$CloseEvent = /** @class */ function(_super) {
    $07f9bef39fe6830c$var$__extends(CloseEvent, _super);
    function CloseEvent(code, reason, target) {
        if (code === void 0) code = 1000;
        if (reason === void 0) reason = "";
        var _this = _super.call(this, "close", target) || this;
        _this.wasClean = true;
        _this.code = code;
        _this.reason = reason;
        return _this;
    }
    return CloseEvent;
}($07f9bef39fe6830c$var$Event);
/*!
 * Reconnecting WebSocket
 * by Pedro Ladaria <pedro.ladaria@gmail.com>
 * https://github.com/pladaria/reconnecting-websocket
 * License MIT
 */ var $07f9bef39fe6830c$var$getGlobalWebSocket = function() {
    if (typeof WebSocket !== "undefined") // @ts-ignore
    return WebSocket;
};
/**
 * Returns true if given argument looks like a WebSocket class
 */ var $07f9bef39fe6830c$var$isWebSocket = function(w) {
    return typeof w !== "undefined" && !!w && w.CLOSING === 2;
};
var $07f9bef39fe6830c$var$DEFAULT = {
    maxReconnectionDelay: 10000,
    minReconnectionDelay: 1000 + Math.random() * 4000,
    minUptime: 5000,
    reconnectionDelayGrowFactor: 1.3,
    connectionTimeout: 4000,
    maxRetries: Infinity,
    maxEnqueuedMessages: Infinity,
    startClosed: false,
    debug: false
};
var $07f9bef39fe6830c$var$ReconnectingWebSocket = /** @class */ function() {
    function ReconnectingWebSocket(url, protocols, options) {
        var _this = this;
        if (options === void 0) options = {};
        this._listeners = {
            error: [],
            message: [],
            open: [],
            close: []
        };
        this._retryCount = -1;
        this._shouldReconnect = true;
        this._connectLock = false;
        this._binaryType = "blob";
        this._closeCalled = false;
        this._messageQueue = [];
        /**
         * An event listener to be called when the WebSocket connection's readyState changes to CLOSED
         */ this.onclose = null;
        /**
         * An event listener to be called when an error occurs
         */ this.onerror = null;
        /**
         * An event listener to be called when a message is received from the server
         */ this.onmessage = null;
        /**
         * An event listener to be called when the WebSocket connection's readyState changes to OPEN;
         * this indicates that the connection is ready to send and receive data
         */ this.onopen = null;
        this._handleOpen = function(event) {
            _this._debug("open event");
            var _a = _this._options.minUptime, minUptime = _a === void 0 ? $07f9bef39fe6830c$var$DEFAULT.minUptime : _a;
            clearTimeout(_this._connectTimeout);
            _this._uptimeTimeout = setTimeout(function() {
                return _this._acceptOpen();
            }, minUptime);
            _this._ws.binaryType = _this._binaryType;
            // send enqueued messages (messages sent before websocket open event)
            _this._messageQueue.forEach(function(message) {
                return _this._ws.send(message);
            });
            _this._messageQueue = [];
            if (_this.onopen) _this.onopen(event);
            _this._listeners.open.forEach(function(listener) {
                return _this._callEventListener(event, listener);
            });
        };
        this._handleMessage = function(event) {
            _this._debug("message event");
            if (_this.onmessage) _this.onmessage(event);
            _this._listeners.message.forEach(function(listener) {
                return _this._callEventListener(event, listener);
            });
        };
        this._handleError = function(event) {
            _this._debug("error event", event.message);
            _this._disconnect(undefined, event.message === "TIMEOUT" ? "timeout" : undefined);
            if (_this.onerror) _this.onerror(event);
            _this._debug("exec error listeners");
            _this._listeners.error.forEach(function(listener) {
                return _this._callEventListener(event, listener);
            });
            _this._connect();
        };
        this._handleClose = function(event) {
            _this._debug("close event");
            _this._clearTimeouts();
            if (_this._shouldReconnect) _this._connect();
            if (_this.onclose) _this.onclose(event);
            _this._listeners.close.forEach(function(listener) {
                return _this._callEventListener(event, listener);
            });
        };
        this._url = url;
        this._protocols = protocols;
        this._options = options;
        if (this._options.startClosed) this._shouldReconnect = false;
        this._connect();
    }
    Object.defineProperty(ReconnectingWebSocket, "CONNECTING", {
        get: function() {
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket, "OPEN", {
        get: function() {
            return 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket, "CLOSING", {
        get: function() {
            return 2;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket, "CLOSED", {
        get: function() {
            return 3;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket.prototype, "CONNECTING", {
        get: function() {
            return ReconnectingWebSocket.CONNECTING;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket.prototype, "OPEN", {
        get: function() {
            return ReconnectingWebSocket.OPEN;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket.prototype, "CLOSING", {
        get: function() {
            return ReconnectingWebSocket.CLOSING;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket.prototype, "CLOSED", {
        get: function() {
            return ReconnectingWebSocket.CLOSED;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket.prototype, "binaryType", {
        get: function() {
            return this._ws ? this._ws.binaryType : this._binaryType;
        },
        set: function(value) {
            this._binaryType = value;
            if (this._ws) this._ws.binaryType = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket.prototype, "retryCount", {
        /**
         * Returns the number or connection retries
         */ get: function() {
            return Math.max(this._retryCount, 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket.prototype, "bufferedAmount", {
        /**
         * The number of bytes of data that have been queued using calls to send() but not yet
         * transmitted to the network. This value resets to zero once all queued data has been sent.
         * This value does not reset to zero when the connection is closed; if you keep calling send(),
         * this will continue to climb. Read only
         */ get: function() {
            var bytes = this._messageQueue.reduce(function(acc, message) {
                if (typeof message === "string") acc += message.length; // not byte size
                else if (message instanceof Blob) acc += message.size;
                else acc += message.byteLength;
                return acc;
            }, 0);
            return bytes + (this._ws ? this._ws.bufferedAmount : 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket.prototype, "extensions", {
        /**
         * The extensions selected by the server. This is currently only the empty string or a list of
         * extensions as negotiated by the connection
         */ get: function() {
            return this._ws ? this._ws.extensions : "";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket.prototype, "protocol", {
        /**
         * A string indicating the name of the sub-protocol the server selected;
         * this will be one of the strings specified in the protocols parameter when creating the
         * WebSocket object
         */ get: function() {
            return this._ws ? this._ws.protocol : "";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket.prototype, "readyState", {
        /**
         * The current state of the connection; this is one of the Ready state constants
         */ get: function() {
            if (this._ws) return this._ws.readyState;
            return this._options.startClosed ? ReconnectingWebSocket.CLOSED : ReconnectingWebSocket.CONNECTING;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReconnectingWebSocket.prototype, "url", {
        /**
         * The URL as resolved by the constructor
         */ get: function() {
            return this._ws ? this._ws.url : "";
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Closes the WebSocket connection or connection attempt, if any. If the connection is already
     * CLOSED, this method does nothing
     */ ReconnectingWebSocket.prototype.close = function(code, reason) {
        if (code === void 0) code = 1000;
        this._closeCalled = true;
        this._shouldReconnect = false;
        this._clearTimeouts();
        if (!this._ws) {
            this._debug("close enqueued: no ws instance");
            return;
        }
        if (this._ws.readyState === this.CLOSED) {
            this._debug("close: already closed");
            return;
        }
        this._ws.close(code, reason);
    };
    /**
     * Closes the WebSocket connection or connection attempt and connects again.
     * Resets retry counter;
     */ ReconnectingWebSocket.prototype.reconnect = function(code, reason) {
        this._shouldReconnect = true;
        this._closeCalled = false;
        this._retryCount = -1;
        if (!this._ws || this._ws.readyState === this.CLOSED) this._connect();
        else {
            this._disconnect(code, reason);
            this._connect();
        }
    };
    /**
     * Enqueue specified data to be transmitted to the server over the WebSocket connection
     */ ReconnectingWebSocket.prototype.send = function(data) {
        if (this._ws && this._ws.readyState === this.OPEN) {
            this._debug("send", data);
            this._ws.send(data);
        } else {
            var _a = this._options.maxEnqueuedMessages, maxEnqueuedMessages = _a === void 0 ? $07f9bef39fe6830c$var$DEFAULT.maxEnqueuedMessages : _a;
            if (this._messageQueue.length < maxEnqueuedMessages) {
                this._debug("enqueue", data);
                this._messageQueue.push(data);
            }
        }
    };
    /**
     * Register an event handler of a specific event type
     */ ReconnectingWebSocket.prototype.addEventListener = function(type, listener) {
        if (this._listeners[type]) // @ts-ignore
        this._listeners[type].push(listener);
    };
    ReconnectingWebSocket.prototype.dispatchEvent = function(event) {
        var e_1, _a;
        var listeners = this._listeners[event.type];
        if (listeners) try {
            for(var listeners_1 = $07f9bef39fe6830c$var$__values(listeners), listeners_1_1 = listeners_1.next(); !listeners_1_1.done; listeners_1_1 = listeners_1.next()){
                var listener = listeners_1_1.value;
                this._callEventListener(event, listener);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (listeners_1_1 && !listeners_1_1.done && (_a = listeners_1.return)) _a.call(listeners_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return true;
    };
    /**
     * Removes an event listener
     */ ReconnectingWebSocket.prototype.removeEventListener = function(type, listener) {
        if (this._listeners[type]) // @ts-ignore
        this._listeners[type] = this._listeners[type].filter(function(l) {
            return l !== listener;
        });
    };
    ReconnectingWebSocket.prototype._debug = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (this._options.debug) // not using spread because compiled version uses Symbols
        // tslint:disable-next-line
        console.log.apply(console, $07f9bef39fe6830c$var$__spread([
            "RWS>"
        ], args));
    };
    ReconnectingWebSocket.prototype._getNextDelay = function() {
        var _a = this._options, _b = _a.reconnectionDelayGrowFactor, reconnectionDelayGrowFactor = _b === void 0 ? $07f9bef39fe6830c$var$DEFAULT.reconnectionDelayGrowFactor : _b, _c = _a.minReconnectionDelay, minReconnectionDelay = _c === void 0 ? $07f9bef39fe6830c$var$DEFAULT.minReconnectionDelay : _c, _d = _a.maxReconnectionDelay, maxReconnectionDelay = _d === void 0 ? $07f9bef39fe6830c$var$DEFAULT.maxReconnectionDelay : _d;
        var delay = 0;
        if (this._retryCount > 0) {
            delay = minReconnectionDelay * Math.pow(reconnectionDelayGrowFactor, this._retryCount - 1);
            if (delay > maxReconnectionDelay) delay = maxReconnectionDelay;
        }
        this._debug("next delay", delay);
        return delay;
    };
    ReconnectingWebSocket.prototype._wait = function() {
        var _this = this;
        return new Promise(function(resolve) {
            setTimeout(resolve, _this._getNextDelay());
        });
    };
    ReconnectingWebSocket.prototype._getNextUrl = function(urlProvider) {
        if (typeof urlProvider === "string") return Promise.resolve(urlProvider);
        if (typeof urlProvider === "function") {
            var url = urlProvider();
            if (typeof url === "string") return Promise.resolve(url);
            if (!!url.then) return url;
        }
        throw Error("Invalid URL");
    };
    ReconnectingWebSocket.prototype._connect = function() {
        var _this = this;
        if (this._connectLock || !this._shouldReconnect) return;
        this._connectLock = true;
        var _a = this._options, _b = _a.maxRetries, maxRetries = _b === void 0 ? $07f9bef39fe6830c$var$DEFAULT.maxRetries : _b, _c = _a.connectionTimeout, connectionTimeout = _c === void 0 ? $07f9bef39fe6830c$var$DEFAULT.connectionTimeout : _c, _d = _a.WebSocket, WebSocket1 = _d === void 0 ? $07f9bef39fe6830c$var$getGlobalWebSocket() : _d;
        if (this._retryCount >= maxRetries) {
            this._debug("max retries reached", this._retryCount, ">=", maxRetries);
            return;
        }
        this._retryCount++;
        this._debug("connect", this._retryCount);
        this._removeListeners();
        if (!$07f9bef39fe6830c$var$isWebSocket(WebSocket1)) throw Error("No valid WebSocket class provided");
        this._wait().then(function() {
            return _this._getNextUrl(_this._url);
        }).then(function(url) {
            // close could be called before creating the ws
            if (_this._closeCalled) return;
            _this._debug("connect", {
                url: url,
                protocols: _this._protocols
            });
            _this._ws = _this._protocols ? new WebSocket1(url, _this._protocols) : new WebSocket1(url);
            _this._ws.binaryType = _this._binaryType;
            _this._connectLock = false;
            _this._addListeners();
            _this._connectTimeout = setTimeout(function() {
                return _this._handleTimeout();
            }, connectionTimeout);
        });
    };
    ReconnectingWebSocket.prototype._handleTimeout = function() {
        this._debug("timeout event");
        this._handleError(new $07f9bef39fe6830c$var$ErrorEvent(Error("TIMEOUT"), this));
    };
    ReconnectingWebSocket.prototype._disconnect = function(code, reason) {
        if (code === void 0) code = 1000;
        this._clearTimeouts();
        if (!this._ws) return;
        this._removeListeners();
        try {
            this._ws.close(code, reason);
            this._handleClose(new $07f9bef39fe6830c$var$CloseEvent(code, reason, this));
        } catch (error) {
        // ignore
        }
    };
    ReconnectingWebSocket.prototype._acceptOpen = function() {
        this._debug("accept open");
        this._retryCount = 0;
    };
    ReconnectingWebSocket.prototype._callEventListener = function(event, listener) {
        if ("handleEvent" in listener) // @ts-ignore
        listener.handleEvent(event);
        else // @ts-ignore
        listener(event);
    };
    ReconnectingWebSocket.prototype._removeListeners = function() {
        if (!this._ws) return;
        this._debug("removeListeners");
        this._ws.removeEventListener("open", this._handleOpen);
        this._ws.removeEventListener("close", this._handleClose);
        this._ws.removeEventListener("message", this._handleMessage);
        // @ts-ignore
        this._ws.removeEventListener("error", this._handleError);
    };
    ReconnectingWebSocket.prototype._addListeners = function() {
        if (!this._ws) return;
        this._debug("addListeners");
        this._ws.addEventListener("open", this._handleOpen);
        this._ws.addEventListener("close", this._handleClose);
        this._ws.addEventListener("message", this._handleMessage);
        // @ts-ignore
        this._ws.addEventListener("error", this._handleError);
    };
    ReconnectingWebSocket.prototype._clearTimeouts = function() {
        clearTimeout(this._connectTimeout);
        clearTimeout(this._uptimeTimeout);
    };
    return ReconnectingWebSocket;
}();
var $07f9bef39fe6830c$export$2e2bcd8739ae039 = $07f9bef39fe6830c$var$ReconnectingWebSocket;

});

var $d1ede43de03c5b3d$exports = {};

var $N0o3H = parcelRequire("N0o3H");
var $d1ede43de03c5b3d$require$Buffer = $N0o3H.Buffer;

var $ibaza = parcelRequire("ibaza");




!function(e, t) {
    return $d1ede43de03c5b3d$exports = t((parcelRequire("izU6i")), (parcelRequire("1zKtH")), (parcelRequire("9Jm1V")), (parcelRequire("Gs8iu")));
}(self, (e, t, n, o)=>(()=>{
        "use strict";
        var r = {
            9332: function(e, t, n) {
                var o = this && this.__createBinding || (Object.create ? function(e, t, n, o) {
                    void 0 === o && (o = n);
                    var r = Object.getOwnPropertyDescriptor(t, n);
                    r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                        enumerable: !0,
                        get: function() {
                            return t[n];
                        }
                    }), Object.defineProperty(e, o, r);
                } : function(e, t, n, o) {
                    void 0 === o && (o = n), e[o] = t[n];
                }), r = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), i = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var n in e)"default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
                    return r(t, e), t;
                }, s = this && this.__awaiter || function(e, t, n, o) {
                    return new (n || (n = Promise))(function(r, i) {
                        function s(e) {
                            try {
                                c(o.next(e));
                            } catch (t) {
                                i(t);
                            }
                        }
                        function a(e) {
                            try {
                                c(o.throw(e));
                            } catch (t) {
                                i(t);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((o = o.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Collaboration = void 0;
                const a = n(8037), c = n(6526), d = i(n(6989)), l = i(n(5741)), u = n(9170), h = n(5608), f = n(4255), p = n(9648), v = n(1096), g = n(3933), y = n(5285), m = n(8907), S = n(9594);
                t.Collaboration = class {
                    constructor(e, t){
                        this.needToClosePDFDoc = !1, this.openPDF = (e)=>s(this, void 0, void 0, function*() {
                                this.needToClosePDFDoc = !0;
                                const t = this.context.pdfViewer, n = e ? Object.assign(Object.assign({}, e), {
                                    fileName: this.docName
                                }) : {
                                    fileName: this.docName
                                };
                                if (this.openFailedPDFDoc) yield t.reopenPDFDoc(this.openFailedPDFDoc, n), this.openFailedPDFDoc = null;
                                else try {
                                    yield t.openPDFByHttpRangeRequest({
                                        range: {
                                            url: this.fileUrl
                                        }
                                    }, n);
                                } catch (o) {
                                    throw this.openFailedPDFDoc = o.pdfDoc, o;
                                }
                            }), this.removeAllOriginalAnnotations = (e)=>s(this, void 0, void 0, function*() {
                                const t = [
                                    "screen",
                                    "link",
                                    "sound"
                                ];
                                S.LOGGER.debug("open PDF file success, starting to remove all original annots");
                                const n = yield e.getPageCount();
                                for(let o = 0; o < n; o++){
                                    const n = yield e.getPageByIndex(o), r = yield n.getAnnots();
                                    for (let e of r){
                                        const o = e.getObjectNumber(), r = e.getType();
                                        -1 === t.indexOf(r) && (yield n.removeAnnotByObjectNumber(o));
                                    }
                                }
                                return S.LOGGER.debug("all original annots removed from PDF file"), !0;
                            }), this.id = e.id, this.fileUrl = e.fileUrl, this.isDocPublic = e.isDocPublic, this.docName = e.docName, this.userAccessType = e.access, this.openFailedPDFDoc = null, this.authorId = e.authorId, this.docPermission = e.docPermission || -1, this.collabStatus = a.CollabStatus.CREATED, this.createdAt = e.createdAt, this.context = t, t.permission = new u.Permission(this.docPermission, this.userAccessType);
                    }
                    canJoin() {
                        return s(this, void 0, void 0, function*() {
                            return !!this.context.token && !!this.isDocPublic;
                        });
                    }
                    isJoined() {
                        return this.context.currentUser.id === this.authorId || this.userAccessType === u.USER_ACCESS_TYPE.OWNER || this.userAccessType === u.USER_ACCESS_TYPE.MEMBER;
                    }
                    join() {
                        return s(this, void 0, void 0, function*() {
                            const e = yield this.canJoin();
                            if (this.isJoined()) return !0;
                            if (!e) return !1;
                            const t = this.context.currentUser, n = this.context.sessionId;
                            return !!t && (yield d.join(this.id, n), this.userAccessType = "member", !0);
                        });
                    }
                    assertPDFDocPermission(e) {
                        if (!(32 & e.getPermissions())) throw new Error("Permission error");
                    }
                    begin(e) {
                        return s(this, void 0, void 0, function*() {
                            const t = this.context.pdfViewer;
                            if (this.context.wsInstance && this.context.currentDocId !== this.id && (yield (0, c.stopCollaboration)(this.context.currentDocId)), this.collabStatus !== a.CollabStatus.CREATED) return !1;
                            if (!(yield this.join())) return !1;
                            const n = yield t.getCurrentPDFDoc();
                            if (!n || (null === n || void 0 === n ? void 0 : n.isDestroyed) || null !== this.openFailedPDFDoc) {
                                yield this.openPDF(e);
                                const n = yield t.getCurrentPDFDoc();
                                this.assertPDFDocPermission(n), t.getEventEmitter().once(m.Event.openFileSuccess, (e)=>s(this, void 0, void 0, function*() {
                                        yield this.removeAllOriginalAnnotations(e);
                                    }));
                            } else this.assertPDFDocPermission(n), yield this.removeAllOriginalAnnotations(n);
                            const o = yield (0, c.startCollaboration)(this.id, y.context);
                            return this.context.currentDocId = this.id, this.context.wsInstance = o, this.context.webSdkBinding.sdkAnnotEventService.initYDoc(), this.context.webSdkBinding.sdkCollabService.observeYDoc(), yield this.context.webSdkBinding.sdkAnnotEventService.initProviders(this.id), this.context.webSdkBinding.sdkAnnotEventService.addAnnotationListener(), this.context.webSdkBinding.mousePointerService.start(o, this.id), this.context.pdfViewer.setUserName(this.context.currentUser.username), this.collabStatus = a.CollabStatus.BEGIN, !0;
                        });
                    }
                    end() {
                        return s(this, void 0, void 0, function*() {
                            if (this.collabStatus !== a.CollabStatus.BEGIN) return !1;
                            if ("owner" !== this.userAccessType) return !1;
                            const e = this.context.sessionId;
                            if (this.needToClosePDFDoc) this.context.pdfViewer.close();
                            return yield (0, c.stopCollaboration)(this.id), yield d.deleteDocument(this.id, e), this.collabStatus = a.CollabStatus.ENDED, !0;
                        });
                    }
                    addMembers(e) {
                        return s(this, void 0, void 0, function*() {
                            if (this.collabStatus === a.CollabStatus.ENDED) return !1;
                            if (e || (0, f.throwParamRequiredError)("members"), "member" === this.userAccessType && !this.isDocPublic) return !1;
                            const t = this.context.sessionId;
                            return yield d.addDocMembers(this.id, t, e), !0;
                        });
                    }
                    getMembers() {
                        return s(this, void 0, void 0, function*() {
                            return this.collabStatus === a.CollabStatus.ENDED && (0, f.throwByCollabStatus)(this.collabStatus), (yield d.getDocMembers(this.id)).map((e)=>new v.Member(e, y.context));
                        });
                    }
                    updatePermission(e) {
                        return s(this, void 0, void 0, function*() {
                            let t = yield this.getPermission();
                            if (this.collabStatus === a.CollabStatus.ENDED) return !1;
                            if (e || (0, f.throwParamRequiredError)("permissionOption"), "owner" !== this.userAccessType) return !1;
                            let n = t.permission;
                            const { isDocPublic: o, isAllowComment: r } = e;
                            if (void 0 !== o && void 0 !== r) {
                                let i = r ? u.DOC_ACTION_PERMISSION.allowComment : u.DOC_ACTION_PERMISSION.onlyView;
                                return n = (o ? u.DOC_ACCESS_PERMISSION.allowAnyone : u.DOC_ACCESS_PERMISSION.allowMembers) + i, yield d.editDocument(this.id, {
                                    isDocPublic: o,
                                    permission: n
                                }), this.isDocPublic = e.isDocPublic, t.permission = n, !0;
                            }
                            if (void 0 !== o && void 0 === r) {
                                let r = t.isAllowComment() ? u.DOC_ACTION_PERMISSION.allowComment : u.DOC_ACTION_PERMISSION.onlyView;
                                return n = (o ? u.DOC_ACCESS_PERMISSION.allowAnyone : u.DOC_ACCESS_PERMISSION.allowMembers) + r, yield d.editDocument(this.id, {
                                    isDocPublic: o,
                                    permission: n
                                }), this.isDocPublic = e.isDocPublic, t.permission = n, !0;
                            }
                            if (void 0 === o && void 0 !== r) {
                                let e = r ? u.DOC_ACTION_PERMISSION.allowComment : u.DOC_ACTION_PERMISSION.onlyView;
                                return n = (t.isAllowAnyone() ? u.DOC_ACCESS_PERMISSION.allowAnyone : u.DOC_ACCESS_PERMISSION.allowMembers) + e, yield d.editDocument(this.id, {
                                    permission: n
                                }), t.permission = n, !0;
                            }
                            return !0;
                        });
                    }
                    updateMemberPermission(e) {
                        return s(this, void 0, void 0, function*() {
                            if (this.collabStatus === a.CollabStatus.ENDED) return !1;
                            if (e || (0, f.throwParamRequiredError)("members"), e[0].hasOwnProperty("id") || (0, f.throwParamRequiredError)("id"), e[0].hasOwnProperty("isAllowComment") || (0, f.throwParamRequiredError)("isAllowComment"), "owner" !== this.userAccessType) return !1;
                            const t = this.context.sessionId;
                            return yield d.editDocMembers(this.id, t, {
                                members: e,
                                emails: []
                            }), !0;
                        });
                    }
                    removeMembers(e) {
                        return s(this, void 0, void 0, function*() {
                            if (this.collabStatus !== a.CollabStatus.BEGIN) return !1;
                            if (e || (0, f.throwParamRequiredError)("members"), e[0].hasOwnProperty("id") || (0, f.throwParamRequiredError)("id"), "owner" !== this.userAccessType) return !1;
                            const t = this.context.sessionId;
                            try {
                                yield d.deleteDocMembers(this.id, t, e.map(({ id: e })=>e));
                            } catch (n) {
                                return !1;
                            }
                            return !0;
                        });
                    }
                    quit() {
                        return s(this, void 0, void 0, function*() {
                            if (this.collabStatus !== a.CollabStatus.BEGIN) return !1;
                            if ("member" !== this.userAccessType) return !1;
                            const e = this.context.currentUser.id, t = this.context.sessionId;
                            return yield d.deleteDocMembers(this.id, t, [
                                e
                            ]), this.collabStatus = a.CollabStatus.ENDED, !0;
                        });
                    }
                    getOnlineMembers() {
                        return s(this, void 0, void 0, function*() {
                            return (yield d.getDocOnlineMembers(this.id)).map((e)=>new v.Member(e, y.context));
                        });
                    }
                    getPermission() {
                        return s(this, void 0, void 0, function*() {
                            return this.collabStatus === a.CollabStatus.ENDED && (0, f.throwByCollabStatus)(this.collabStatus), this.context.permission;
                        });
                    }
                    on(e, t) {
                        this.collabStatus === a.CollabStatus.ENDED && (0, f.throwByCollabStatus)(this.collabStatus), this.context.listener = (e)=>s(this, void 0, void 0, function*() {
                                var n, o;
                                const { type: r, data: i } = e, s = r === h.DocumentAction.MEMBER_ONLINE ? "member-online" : r === h.DocumentAction.MEMBER_OFFLINE ? "member-offline" : r;
                                if (s !== p.ScreenSyncEvent.CREATED) {
                                    if (s === p.ScreenSyncEvent.STOPPED) return i.leader.id === this.context.currentUser.id && this.context.webSdkBinding.sdkScreenSyncService.removeScreenSyncListener(), void t(i, s);
                                    if (s === p.ScreenSyncEvent.MEMBER_JOINED) return i.leader.id === (null === (o = this.context.currentUser) || void 0 === o ? void 0 : o.id) && this.context.webSdkBinding.sdkScreenSyncService.addscreenSyncListener(i.screenSyncId, i.leader.id), void t(i, s);
                                    if (s === p.ScreenSyncEvent.MEMBER_LEAVE) {
                                        let e = this.context.currentUser.id;
                                        return i.creatorId !== e && i.leader.id === e && 0 === i.followerNumber && this.context.webSdkBinding.sdkScreenSyncService.removeScreenSyncListener(), void t({
                                            screenSyncId: i.screenSyncId,
                                            leader: i.leader,
                                            member: i.member
                                        }, s);
                                    }
                                    s !== p.ScreenSyncEvent.SCREENSYNC_DATA ? s !== h.DocumentAction.DELETE_MEMBERS || this.context.sessionId === i.session_id ? s !== h.DocumentAction.DELETE_SHARE ? s !== h.DocumentAction.EDIT_MEMBERS ? s !== h.NetworkConnectionEvent.NetworkConnectionUp && s !== h.NetworkConnectionEvent.NetworkConnectionDown ? d.queryDocMembers(i.docId, [
                                        Number(i.user_id)
                                    ]).then((e)=>{
                                        t(e, s);
                                    }) : t(i, s) : -1 !== i.members.indexOf(this.context.currentUser.id) && t({
                                        collaborationId: i.docId
                                    }, s) : t({
                                        collaborationId: i.docId
                                    }, s) : t(i.members, s) : this.context.webSdkBinding.sdkScreenSyncService.sync(i);
                                } else i.leader.id !== (null === (n = this.context.currentUser) || void 0 === n ? void 0 : n.id) && t(i, s);
                            });
                    }
                    off() {
                        return s(this, void 0, void 0, function*() {
                            return this.collabStatus === a.CollabStatus.ENDED && (0, f.throwByCollabStatus)(this.collabStatus), this.context.listener = void 0, !0;
                        });
                    }
                    createScreenSync(e) {
                        return s(this, void 0, void 0, function*() {
                            let t = yield l.createScreenSync(this.id, this.context.sessionId, e);
                            return new g.ScreenSync(this.context, t);
                        });
                    }
                    getScreenSync(e) {
                        return s(this, void 0, void 0, function*() {
                            if (e || (0, f.throwParamRequiredError)("screenSyncId"), !/^[\u4e00-\u9fa5_a-zA-Z0-9]+$/.test(e)) throw new Error("screenSyncId Format error");
                            let t = yield l.getScreenSync(e);
                            return new g.ScreenSync(this.context, t);
                        });
                    }
                    getScreenSyncList() {
                        return s(this, void 0, void 0, function*() {
                            let e = yield l.getScreenSyncList(this.id, this.context.sessionId);
                            return e ? e.map((e)=>new g.ScreenSync(this.context, e)) : null;
                        });
                    }
                    getCurrentUser() {
                        return s(this, void 0, void 0, function*() {
                            let e = (yield d.getDocMembers(this.id)).filter((e)=>{
                                var t;
                                return e.id === (null === (t = this.context.currentUser) || void 0 === t ? void 0 : t.id);
                            });
                            return new v.Member(e[0], this.context);
                        });
                    }
                    getAnnotJSON(e, t) {
                        var n;
                        let o = null === (n = this.context.webSdkBinding) || void 0 === n ? void 0 : n.sdkAnnotEventService.ydoc;
                        if (!o) return null;
                        let r = o.getMap("pageAnnotMaps");
                        if (!r) return null;
                        let i = r.get(t.toString());
                        if (!i) return null;
                        let s = i.get(e.toString() + `__${t}`);
                        return s ? s.toJSON() : null;
                    }
                    setMousePointerSyncRate(e) {
                        var t;
                        if (isNaN(Number(e))) throw new Error("invalid syncRate value");
                        if (e < 0) throw new Error("invalid syncRate value");
                        return null === (t = this.context.webSdkBinding) || void 0 === t || t.mousePointerService.setSyncRate(e), !0;
                    }
                };
            },
            5285: (e, t)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.context = void 0, t.context = {
                    transport: {
                        httpBaseURL: "http://localhost:8080",
                        websocketURL: "ws//localhost:8080/ws"
                    }
                };
            },
            1096: function(e, t, n) {
                var o = this && this.__createBinding || (Object.create ? function(e, t, n, o) {
                    void 0 === o && (o = n);
                    var r = Object.getOwnPropertyDescriptor(t, n);
                    r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                        enumerable: !0,
                        get: function() {
                            return t[n];
                        }
                    }), Object.defineProperty(e, o, r);
                } : function(e, t, n, o) {
                    void 0 === o && (o = n), e[o] = t[n];
                }), r = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), i = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var n in e)"default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
                    return r(t, e), t;
                }, s = this && this.__awaiter || function(e, t, n, o) {
                    return new (n || (n = Promise))(function(r, i) {
                        function s(e) {
                            try {
                                c(o.next(e));
                            } catch (t) {
                                i(t);
                            }
                        }
                        function a(e) {
                            try {
                                c(o.throw(e));
                            } catch (t) {
                                i(t);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((o = o.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Member = void 0;
                const a = i(n(5741));
                t.Member = class {
                    constructor(e, t){
                        this.id = e.id, this.userName = e.userName, this.email = e.email, this.isAllowComment = e.isAllowComment, this.isInScreenSync = e.isInScreenSync, this.lastRead = e.lastRead, this.context = t;
                    }
                    getScreenSyncInfo() {
                        return s(this, void 0, void 0, function*() {
                            let e = yield a.getScreenSyncByMemberId(this.context.sessionId, this.context.currentDocId, this.id), t = e.members.length - 1;
                            return {
                                id: e.id,
                                followers: t
                            };
                        });
                    }
                };
            },
            3933: function(e, t, n) {
                var o = this && this.__createBinding || (Object.create ? function(e, t, n, o) {
                    void 0 === o && (o = n);
                    var r = Object.getOwnPropertyDescriptor(t, n);
                    r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                        enumerable: !0,
                        get: function() {
                            return t[n];
                        }
                    }), Object.defineProperty(e, o, r);
                } : function(e, t, n, o) {
                    void 0 === o && (o = n), e[o] = t[n];
                }), r = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), i = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var n in e)"default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
                    return r(t, e), t;
                }, s = this && this.__awaiter || function(e, t, n, o) {
                    return new (n || (n = Promise))(function(r, i) {
                        function s(e) {
                            try {
                                c(o.next(e));
                            } catch (t) {
                                i(t);
                            }
                        }
                        function a(e) {
                            try {
                                c(o.throw(e));
                            } catch (t) {
                                i(t);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((o = o.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ScreenSync = void 0;
                const a = i(n(5741)), c = n(1096);
                t.ScreenSync = class {
                    constructor(e, t){
                        this.id = t.id, this.leader = t.leader, this.context = e;
                    }
                    getMembers(e) {
                        return s(this, void 0, void 0, function*() {
                            let t = yield a.getScreenSyncMembers(this.id, e);
                            return t ? t.map((e)=>new c.Member(e, this.context)) : null;
                        });
                    }
                    join() {
                        return s(this, void 0, void 0, function*() {
                            return yield a.joinScreenSync(this.id);
                        });
                    }
                    leave() {
                        var e;
                        return s(this, void 0, void 0, function*() {
                            return (yield a.leaveScreenSync(this.id)) && (this.leader.id === (null === (e = this.context.currentUser) || void 0 === e ? void 0 : e.id) ? this.context.webSdkBinding.sdkScreenSyncService.removeScreenSyncListener() : this.context.webSdkBinding.sdkScreenSyncService.leaveScreenSync()), !0;
                        });
                    }
                    setSyncRate(e) {
                        var t;
                        if (isNaN(Number(e))) throw new Error("invalid syncRate value");
                        if (e < 0) throw new Error("invalid syncRate value");
                        return null === (t = this.context.webSdkBinding) || void 0 === t || t.sdkScreenSyncService.setSyncRate(e), !0;
                    }
                };
            },
            971: function(e, t, n) {
                var o = this && this.__createBinding || (Object.create ? function(e, t, n, o) {
                    void 0 === o && (o = n);
                    var r = Object.getOwnPropertyDescriptor(t, n);
                    r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                        enumerable: !0,
                        get: function() {
                            return t[n];
                        }
                    }), Object.defineProperty(e, o, r);
                } : function(e, t, n, o) {
                    void 0 === o && (o = n), e[o] = t[n];
                }), r = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), i = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var n in e)"default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
                    return r(t, e), t;
                }, s = this && this.__awaiter || function(e, t, n, o) {
                    return new (n || (n = Promise))(function(r, i) {
                        function s(e) {
                            try {
                                c(o.next(e));
                            } catch (t) {
                                i(t);
                            }
                        }
                        function a(e) {
                            try {
                                c(o.throw(e));
                            } catch (t) {
                                i(t);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((o = o.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.WebCollabClient = void 0;
                const a = n(7430), c = i(n(6989)), d = n(7857), l = n(9332), u = n(4255), h = n(5285), f = n(6989);
                t.WebCollabClient = class {
                    constructor(e){
                        this.sessionId = (0, a.slug)(), h.context.pdfViewer = e.pdfViewer, h.context.transport = (0, u.getTransportConfigFromBaseURL)(e.baseURL), h.context.token = e.userProvider().token, h.context.currentUser = e.userProvider(), h.context.sessionId = this.sessionId, h.context.webSdkBinding = new d.WebSdkBinding(e.pdfViewer, h.context);
                    }
                    createCollaboration(e) {
                        return s(this, void 0, void 0, function*() {
                            this.validateDocParam(e);
                            const { id: t } = yield c.createDocument(e);
                            h.context.currentDocId = t;
                            const n = yield c.getDocument(t);
                            return yield h.context.webSdkBinding.sdkCollabService.uploadInitialAnnots(), new l.Collaboration(n, h.context);
                        });
                    }
                    validateDocParam(e) {
                        e.fileUrl.trim() || (0, u.throwParamRequiredError)("fileUrl"), e.hasOwnProperty("isDocPublic") || (0, u.throwParamRequiredError)("isDocPublic"), e.docName.trim() || (0, u.throwParamRequiredError)("docName");
                    }
                    getCollaborationList() {
                        return s(this, void 0, void 0, function*() {
                            return (yield c.getAllDocuments()).map((e)=>new l.Collaboration(e, h.context));
                        });
                    }
                    getCollaboration(e) {
                        return s(this, void 0, void 0, function*() {
                            this.validateCollaborationId(e);
                            const t = yield c.getDocument(e);
                            return new l.Collaboration(t, h.context);
                        });
                    }
                    validateCollaborationId(e) {
                        if (e || (0, u.throwParamRequiredError)("collaborationId"), !/^[\u4e00-\u9fa5_a-zA-Z0-9]+$/.test(e)) throw new Error("collaborationId Format error");
                    }
                    removeCollaboration(e) {
                        return s(this, void 0, void 0, function*() {
                            this.validateCollaborationId(e);
                            try {
                                return yield c.deleteDocument(e, this.sessionId), !0;
                            } catch (t) {
                                return console.log(t), !1;
                            }
                        });
                    }
                    createInvitation(e, t) {
                        return s(this, void 0, void 0, function*() {
                            return this.validateCollaborationId(e), yield c.createInvitation(e, t);
                        });
                    }
                    joinCollaborationWithInvitation(e) {
                        return s(this, void 0, void 0, function*() {
                            e && "" !== e.trim() || (0, u.throwParamRequiredError)("invitationId");
                            const { id: t } = yield c.getDocIdByInvitation(e);
                            return yield this.getCollaboration(t);
                        });
                    }
                    getVersion() {
                        return s(this, void 0, void 0, function*() {
                            return {
                                "collaboration server": {
                                    version: yield (0, f.getCollabServerVersion)()
                                },
                                "collaboration client": {
                                    version: "00fefa47@release/1_2_0"
                                }
                            };
                        });
                    }
                };
            },
            6814: function(e, t, n) {
                var o = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.LoggerFactory = t.ScreenSync = t.Collaboration = t.Permission = t.WebCollabClient = void 0;
                var r = n(971);
                Object.defineProperty(t, "WebCollabClient", {
                    enumerable: !0,
                    get: function() {
                        return r.WebCollabClient;
                    }
                });
                var i = n(9170);
                Object.defineProperty(t, "Permission", {
                    enumerable: !0,
                    get: function() {
                        return i.Permission;
                    }
                });
                var s = n(9332);
                Object.defineProperty(t, "Collaboration", {
                    enumerable: !0,
                    get: function() {
                        return s.Collaboration;
                    }
                });
                var a = n(3933);
                Object.defineProperty(t, "ScreenSync", {
                    enumerable: !0,
                    get: function() {
                        return a.ScreenSync;
                    }
                });
                var c = n(2733);
                Object.defineProperty(t, "LoggerFactory", {
                    enumerable: !0,
                    get: function() {
                        return o(c).default;
                    }
                });
            },
            314: (e, t, n)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                const o = n(1456);
                t.default = class {
                    format(e, t, n) {
                        const o = new Error().stack;
                        let r;
                        if (o) r = "\n  " + o.split("\n")[4].trim();
                        return [
                            {
                                type: "string",
                                style: `color: ${this.levelColor(t)};`,
                                value: `[${this.levelText(t)}]`
                            },
                            {
                                type: "string",
                                style: "color: magenta",
                                value: `{${e}}`
                            }
                        ].concat(n.map((e)=>void 0 === e || null === e ? {
                                type: typeof e,
                                style: "color: megenta;font-weight: bold",
                                value: e + ""
                            } : "string" === typeof e ? {
                                type: typeof e,
                                style: `color: ${this.levelColor(t)}`,
                                value: e
                            } : {
                                type: typeof e,
                                value: e
                            })).concat({
                            type: "string",
                            style: "color: grey;",
                            value: r
                        });
                    }
                    levelColor(e) {
                        switch(e){
                            case o.LEVEL_DEBUG:
                                return "blue";
                            case o.LEVEL_INFO:
                                return "green";
                            case o.LEVEL_WARN:
                                return "#5C3C00";
                            case o.LEVEL_ERROR:
                                return "red";
                        }
                        return "#000";
                    }
                    levelText(e) {
                        switch(e){
                            case o.LEVEL_DEBUG:
                                return "DEBUG";
                            case o.LEVEL_INFO:
                                return "INFO";
                            case o.LEVEL_WARN:
                                return "WARN";
                            case o.LEVEL_ERROR:
                                return "ERROR";
                        }
                        return "UNKNOWN LEVEL";
                    }
                };
            },
            9624: (e, t, n)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                const o = n(1456);
                t.default = class {
                    print(e, t) {
                        const n = e.map((e)=>"string" !== e.type ? " %o" : " %c" + e.value).join("").trim(), r = e.map((e)=>"string" === e.type ? e.style : e.value);
                        switch(r.splice(0, 0, n), t){
                            case o.LEVEL_DEBUG:
                                console.debug(...r);
                                break;
                            case o.LEVEL_INFO:
                                console.info(...r);
                                break;
                            case o.LEVEL_WARN:
                                console.warn(...r);
                                break;
                            case o.LEVEL_ERROR:
                                console.error(...r);
                                break;
                            default:
                                console.log(...r);
                        }
                    }
                };
            },
            5403: (e, t, n)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.NoLogger = void 0;
                const o = n(1456), r = n(3631);
                class i {
                    constructor(e, t, n){
                        this.appender = e, this.layout = t, this.module = n, this.logOff = !1, this.appender = e, this.layout = t, this.module = n, this.logOff = !1;
                    }
                    getMinLevel() {
                        return void 0 === this.minLevel ? r.config.logLevel : this.minLevel;
                    }
                    toggle(e) {
                        this.logOff = "boolean" === typeof e ? e : !this.logOff;
                    }
                    setLevel(e) {
                        this.minLevel = e;
                    }
                    doLog(e, t) {
                        if (this.isLogOff(e)) return;
                        const n = this.layout.format(this.module, e, t);
                        this.appender.print(n, e);
                    }
                    log(e, ...t) {
                        this.doLog(e, t);
                    }
                    debug(...e) {
                        this.doLog(o.LEVEL_DEBUG, e);
                    }
                    info(...e) {
                        this.doLog(o.LEVEL_INFO, e);
                    }
                    warn(...e) {
                        this.doLog(o.LEVEL_WARN, e);
                    }
                    error(...e) {
                        this.doLog(o.LEVEL_ERROR, e);
                    }
                    isLogOff(e) {
                        return this.logOff || r.config.logOff || e < this.getMinLevel();
                    }
                }
                t.default = i;
                t.NoLogger = class extends i {
                    doLog() {}
                };
            },
            2733: function(e, t, n) {
                var o = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                const r = o(n(8489)), i = o(n(5403)), s = o(n(9624)), a = o(n(314)), c = o(n(524)), d = n(3631), l = n(7373), u = {};
                t.default = class {
                    constructor(){}
                    static enableLogger(e) {
                        (0, d.toggleLogOff)(!e);
                    }
                    static setLogLevel(e) {
                        (0, d.setLogLevel)(e);
                    }
                    static getLogger(e) {
                        return u[e] = u[e] || this.createLogger(e);
                    }
                    static createLogger(e) {
                        let t;
                        if ("complex" === d.config.logLayout) t = new a.default();
                        else t = new r.default();
                        const n = d.config.logAppenders.map((e)=>{
                            switch(e){
                                case "console":
                                default:
                                    return new s.default();
                                case "websocket":
                                    return new l.WebsocketAppender();
                            }
                        });
                        return new i.default(new c.default(n), t, e);
                    }
                };
            },
            9594: function(e, t, n) {
                var o = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.LOGGER = void 0;
                const r = o(n(2733));
                t.LOGGER = r.default.getLogger("collab-client");
            },
            524: (e, t)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                t.default = class {
                    constructor(e = []){
                        this.appenders = e;
                    }
                    print(e, t) {
                        this.appenders.forEach((n)=>n.print(e, t));
                    }
                };
            },
            8489: (e, t, n)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                const o = n(1456);
                t.default = class {
                    format(e, t, n) {
                        return [
                            {
                                type: "string",
                                value: `[${this.levelText(t)}]`
                            },
                            {
                                type: "string",
                                value: `{${e}}`
                            }
                        ].concat(n.map((e)=>void 0 === e || null === e ? {
                                type: typeof e,
                                value: e + ""
                            } : {
                                type: typeof e,
                                value: e
                            }));
                    }
                    levelText(e) {
                        switch(e){
                            case o.LEVEL_DEBUG:
                                return "DEBUG";
                            case o.LEVEL_INFO:
                                return "INFO";
                            case o.LEVEL_WARN:
                                return "WARN";
                            case o.LEVEL_ERROR:
                                return "ERROR";
                        }
                        return "UNKNOWN LEVEL";
                    }
                };
            },
            7373: (e, t)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.WebsocketAppender = void 0;
                t.WebsocketAppender = class {
                    constructor(){
                        throw new Error('Unsupported appender: "websocket"');
                    }
                    print(e, t) {}
                };
            },
            3631: (e, t, n)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.toggleLogOff = t.setLogLevel = t.strLogLevel2Num = t.config = void 0;
                const o = n(1456);
                function r(e) {
                    switch(e){
                        case "debug":
                            return o.LEVEL_DEBUG;
                        case "info":
                            return o.LEVEL_INFO;
                        case "warn":
                            return o.LEVEL_WARN;
                        default:
                            return o.LEVEL_ERROR;
                    }
                }
                function i(e) {
                    const n = r(e);
                    switch(n){
                        case o.LEVEL_DEBUG:
                        case o.LEVEL_INFO:
                        case o.LEVEL_WARN:
                        case o.LEVEL_ERROR:
                            t.config.logLevel = n;
                    }
                }
                function s(e) {
                    t.config.logOff = e;
                }
                t.config = {
                    logLevel: o.LEVEL_ERROR,
                    logLayout: "simple",
                    logAppenders: [
                        "console"
                    ],
                    logOff: !1,
                    setLogLevel: i,
                    toggleLogOff: s
                }, t.strLogLevel2Num = r, t.setLogLevel = i, t.toggleLogOff = s;
            },
            1456: (e, t)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.LEVEL_ERROR = t.LEVEL_WARN = t.LEVEL_INFO = t.LEVEL_DEBUG = void 0, t.LEVEL_DEBUG = 0, t.LEVEL_INFO = 2, t.LEVEL_WARN = 4, t.LEVEL_ERROR = 8;
            },
            5692: function(e, t, n) {
                var o = this && this.__createBinding || (Object.create ? function(e, t, n, o) {
                    void 0 === o && (o = n);
                    var r = Object.getOwnPropertyDescriptor(t, n);
                    r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                        enumerable: !0,
                        get: function() {
                            return t[n];
                        }
                    }), Object.defineProperty(e, o, r);
                } : function(e, t, n, o) {
                    void 0 === o && (o = n), e[o] = t[n];
                }), r = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), i = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var n in e)"default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
                    return r(t, e), t;
                }, s = this && this.__awaiter || function(e, t, n, o) {
                    return new (n || (n = Promise))(function(r, i) {
                        function s(e) {
                            try {
                                c(o.next(e));
                            } catch (t) {
                                i(t);
                            }
                        }
                        function a(e) {
                            try {
                                c(o.throw(e));
                            } catch (t) {
                                i(t);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((o = o.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.IndexeddbPersistence = t.clearDocument = t.storeState = t.fetchUpdates = t.PREFERRED_TRIM_SIZE = void 0;
                const a = i(n(9703)), c = i(n(297)), d = n(5750), l = "custom", u = "updates";
                t.PREFERRED_TRIM_SIZE = 500;
                t.fetchUpdates = (e, t)=>s(void 0, void 0, void 0, function*() {
                        const [n] = c.transact(e.db, [
                            u
                        ]), o = yield c.getAll(n, c.createIDBKeyRangeLowerBound(e._dbref, !1));
                        t && t(n), a.transact(e.doc, ()=>{
                            o.forEach((t)=>a.applyUpdate(e.doc, t));
                        }, e, !1);
                        const r = yield c.getLastKey(n);
                        return e._dbref = r + 1, e._dbsize = yield c.count(n), n;
                    });
                t.storeState = (e, n = !0)=>s(void 0, void 0, void 0, function*() {
                        const o = yield (0, t.fetchUpdates)(e);
                        (n || e._dbsize >= t.PREFERRED_TRIM_SIZE) && (yield c.addAutoKey(o, a.encodeStateAsUpdate(e.doc)), yield c.del(o, c.createIDBKeyRangeUpperBound(e._dbref, !0)), e._dbsize = yield c.count(o));
                    });
                t.clearDocument = (e)=>c.deleteDB(e);
                class h extends d.Observable {
                    constructor(e, n){
                        super(), this._dbref = 0, this._dbsize = 0, this._destroyed = !1, this.db = null, this.synced = !1, this._storeTimeout = 1e3, this._storeTimeoutId = null, this._storeUpdate = (e, n)=>{
                            if (this.db && n !== this) {
                                const [n] = c.transact(this.db, [
                                    u
                                ]);
                                c.addAutoKey(n, e), ++this._dbsize >= t.PREFERRED_TRIM_SIZE && (null !== this._storeTimeoutId && clearTimeout(this._storeTimeoutId), this._storeTimeoutId = setTimeout(()=>{
                                    (0, t.storeState)(this, !1), this._storeTimeoutId = null;
                                }, this._storeTimeout));
                            }
                        }, this.destroy = ()=>(this._storeTimeoutId && clearTimeout(this._storeTimeoutId), this.doc.off("update", this._storeUpdate), this.doc.off("destroy", this.destroy), this._destroyed = !0, this._db.then((e)=>{
                                e.close();
                            }).catch((e)=>{
                                this.emit("error", [
                                    e,
                                    this
                                ]);
                            })), this.doc = n, this.name = e, this._db = c.openDB(e, (e)=>c.createStores(e, [
                                [
                                    u,
                                    {
                                        autoIncrement: !0
                                    }
                                ],
                                [
                                    l
                                ]
                            ])), this._db.then((e)=>{
                            this.db = e;
                            return (0, t.fetchUpdates)(this, (e)=>c.addAutoKey(e, a.encodeStateAsUpdate(n))).then(()=>(this._destroyed || (this.emit("synced", [
                                    this
                                ]), this.synced = !0), this));
                        }).catch((e)=>{
                            this.emit("error", [
                                e,
                                this
                            ]);
                        }), n.on("update", this._storeUpdate), n.on("destroy", this.destroy);
                    }
                    clearData() {
                        return this.destroy().then(()=>{
                            c.deleteDB(this.name);
                        });
                    }
                    get(e) {
                        return this._db.then((t)=>{
                            const [n] = c.transact(t, [
                                l
                            ], "readonly");
                            return c.get(n, e);
                        });
                    }
                    set(e, t) {
                        return this._db.then((n)=>{
                            const [o] = c.transact(n, [
                                l
                            ]);
                            return c.put(o, t, e);
                        });
                    }
                    del(e) {
                        return this._db.then((t)=>{
                            const [n] = c.transact(t, [
                                l
                            ]);
                            return c.del(n, e);
                        });
                    }
                }
                t.IndexeddbPersistence = h;
            },
            5378: (e, t, n)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                const o = n(6602);
                t.default = class {
                    constructor(e, t){
                        let n = "number" == typeof e ? e : parseInt(e);
                        this.permission = -1 == n ? o.DOC_ALL_PERMISSIONS : n, this.userAccessType = t;
                    }
                    isOwner() {
                        return "owner" === this.userAccessType;
                    }
                    isMember() {
                        return "member" === this.userAccessType;
                    }
                    isAllowComment() {
                        return (255 & this.permission) == o.DOC_ACTION_PERMISSION.allowComment;
                    }
                    isAllowAnyone() {
                        return (65280 & this.permission) == o.DOC_ACCESS_PERMISSION.allowAnyone;
                    }
                    isAllowMembers() {
                        return (65280 & this.permission) == o.DOC_ACCESS_PERMISSION.allowMembers;
                    }
                };
            },
            6602: (e, t)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.DOC_ACTION_PERMISSION = t.DOC_ACCESS_PERMISSION = t.USER_ACCESS_TYPE = t.DOC_ALL_PERMISSIONS = void 0, t.DOC_ALL_PERMISSIONS = 65535, t.USER_ACCESS_TYPE = {
                    OWNER: "owner",
                    MEMBER: "member",
                    UNJOINED: "unjoined"
                }, function(e) {
                    e[e.allowNone = 0] = "allowNone", e[e.allowAnyone = 65280] = "allowAnyone", e[e.allowUserJoin = 65024] = "allowUserJoin", e[e.allowMembers = 64512] = "allowMembers";
                }(t.DOC_ACCESS_PERMISSION || (t.DOC_ACCESS_PERMISSION = {})), function(e) {
                    e[e.allowComment = 255] = "allowComment", e[e.onlyView = 254] = "onlyView";
                }(t.DOC_ACTION_PERMISSION || (t.DOC_ACTION_PERMISSION = {}));
            },
            9170: function(e, t, n) {
                var o = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.USER_ACCESS_TYPE = t.DOC_ALL_PERMISSIONS = t.DOC_ACTION_PERMISSION = t.DOC_ACCESS_PERMISSION = t.Permission = void 0;
                const r = o(n(5378));
                t.Permission = r.default;
                const i = n(6602);
                Object.defineProperty(t, "DOC_ACCESS_PERMISSION", {
                    enumerable: !0,
                    get: function() {
                        return i.DOC_ACCESS_PERMISSION;
                    }
                }), Object.defineProperty(t, "DOC_ACTION_PERMISSION", {
                    enumerable: !0,
                    get: function() {
                        return i.DOC_ACTION_PERMISSION;
                    }
                }), Object.defineProperty(t, "DOC_ALL_PERMISSIONS", {
                    enumerable: !0,
                    get: function() {
                        return i.DOC_ALL_PERMISSIONS;
                    }
                }), Object.defineProperty(t, "USER_ACCESS_TYPE", {
                    enumerable: !0,
                    get: function() {
                        return i.USER_ACCESS_TYPE;
                    }
                });
            },
            5221: function(e, t, n) {
                var o = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.request = t.axiosInstance = void 0;
                const r = o(n(3300)), i = n(5285);
                t.axiosInstance = r.default.create(), t.axiosInstance.interceptors.response.use(function(e) {
                    return e.data;
                }, function(e) {
                    var t, n;
                    if (e.response.status >= 400 && e.response.status < 500) return null === (t = e.response) || void 0 === t ? void 0 : t.data;
                    throw new Error((null === (n = e.response) || void 0 === n ? void 0 : n.data.message) || e.message);
                }), t.axiosInstance.interceptors.request.use((e)=>{
                    const t = i.context.token;
                    return t && (e.headers.Authorization = `Bearer ${t}`), e.baseURL = i.context.transport.httpBaseURL, e;
                }), t.request = t.axiosInstance.request;
            },
            6989: function(e, t, n) {
                var o = this && this.__awaiter || function(e, t, n, o) {
                    return new (n || (n = Promise))(function(r, i) {
                        function s(e) {
                            try {
                                c(o.next(e));
                            } catch (t) {
                                i(t);
                            }
                        }
                        function a(e) {
                            try {
                                c(o.throw(e));
                            } catch (t) {
                                i(t);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((o = o.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getCollabServerVersion = t.getYLogs = t.addInitialYLogs = t.getDocIdByInvitation = t.createInvitation = t.deleteAnnotations = t.changeAnnotations = t.addAnnotations = t.getAnnotations = t.deleteDocMembers = t.getDocOnlineMembers = t.queryDocMembers = t.getDocMembers = t.editDocMembers = t.join = t.addDocMembers = t.editDocument = t.deleteDocument = t.getDocument = t.getAllDocuments = t.createDocument = void 0;
                const r = n(5221), i = n(2093), s = n(9170);
                t.createDocument = function(e) {
                    return o(this, void 0, void 0, function*() {
                        let t = -1;
                        t = (e.isDocPublic ? s.DOC_ACCESS_PERMISSION.allowAnyone : s.DOC_ACCESS_PERMISSION.allowMembers) + s.DOC_ACTION_PERMISSION.allowComment;
                        return (yield (0, r.request)({
                            url: "/api/doc/create",
                            method: "post",
                            data: {
                                file_url: e.fileUrl,
                                is_public: e.isDocPublic,
                                name: e.docName,
                                permission: t
                            }
                        })).data;
                    });
                }, t.getAllDocuments = function() {
                    return o(this, void 0, void 0, function*() {
                        return (yield (0, r.request)({
                            url: "/api/doc/list",
                            method: "get"
                        })).data.map((e)=>(0, i.formatDocResult)(e));
                    });
                }, t.getDocument = function(e) {
                    return o(this, void 0, void 0, function*() {
                        const t = yield (0, r.request)({
                            url: `/api/doc/${e}`,
                            method: "get"
                        }), n = t.data;
                        return 0 !== t.ret ? Promise.reject(t) : (0, i.formatDocResult)(n);
                    });
                }, t.deleteDocument = function(e, t) {
                    return o(this, void 0, void 0, function*() {
                        let n = `/api/doc/${e}/delete`;
                        const o = yield (0, r.request)({
                            url: n,
                            method: "post",
                            params: {
                                session_id: t
                            }
                        });
                        if (0 !== o.ret) return Promise.reject(o);
                        const s = o.data;
                        return (0, i.formatDocResult)(s);
                    });
                }, t.editDocument = function(e, t) {
                    return o(this, void 0, void 0, function*() {
                        const n = yield (0, r.request)({
                            url: `/api/doc/${e}/edit`,
                            method: "post",
                            data: {
                                is_public: t.isDocPublic,
                                permission: t.permission
                            }
                        });
                        return (0, i.formatDocResult)(n.data);
                    });
                }, t.addDocMembers = function(e, t, n) {
                    return o(this, void 0, void 0, function*() {
                        let o = `/api/doc/${e}/add/members`, i = {};
                        i = 0 != n.length && Object.keys(n[0]).includes("email") ? {
                            emails: n,
                            members: []
                        } : {
                            emails: [],
                            members: n
                        };
                        const s = yield (0, r.request)({
                            url: o,
                            method: "post",
                            data: i,
                            params: {
                                session_id: t
                            }
                        });
                        return 0 !== s.ret ? Promise.reject(s) : s.data;
                    });
                }, t.join = function(e, t) {
                    return o(this, void 0, void 0, function*() {
                        let n = `/api/doc/${e}/join`;
                        const o = yield (0, r.request)({
                            url: n,
                            method: "post",
                            params: {
                                session_id: t
                            }
                        });
                        return 0 !== o.ret ? Promise.reject(o) : o.data;
                    });
                }, t.editDocMembers = function(e, t, { members: n, emails: i }) {
                    return o(this, void 0, void 0, function*() {
                        let o = `/api/doc/${e}/edit/members`, s = {
                            emails: i,
                            members: n
                        };
                        const a = yield (0, r.request)({
                            url: o,
                            method: "post",
                            data: s,
                            params: {
                                session_id: t
                            }
                        });
                        return 0 !== a.ret ? Promise.reject(a) : a.data;
                    });
                }, t.getDocMembers = function(e) {
                    return o(this, void 0, void 0, function*() {
                        const t = yield (0, r.request)({
                            url: `/api/doc/${e}/members`,
                            method: "get"
                        });
                        return null == t.data ? [] : t.data.map((e)=>(0, i.formatUserResult)(e));
                    });
                }, t.queryDocMembers = function(e, t) {
                    return o(this, void 0, void 0, function*() {
                        const n = yield (0, r.request)({
                            url: `/api/doc/${e}/query/members`,
                            method: "post",
                            data: {
                                members: t
                            }
                        });
                        return null == n.data ? [] : n.data.map((e)=>(0, i.formatUserResult)(e));
                    });
                }, t.getDocOnlineMembers = function(e) {
                    return o(this, void 0, void 0, function*() {
                        const t = yield (0, r.request)({
                            url: `/api/doc/${e}/members/online`,
                            method: "get"
                        });
                        return null == t.data ? [] : t.data.map((e)=>(0, i.formatUserResult)(e));
                    });
                }, t.deleteDocMembers = function(e, t, n) {
                    return o(this, void 0, void 0, function*() {
                        let o = {
                            members: n
                        };
                        const i = yield (0, r.request)({
                            url: `/api/doc/${e}/delete/members`,
                            method: "post",
                            data: o,
                            params: {
                                session_id: t
                            }
                        });
                        return 0 !== i.ret ? Promise.reject(i) : i.data;
                    });
                }, t.getAnnotations = function(e, t, n = "in") {
                    return o(this, void 0, void 0, function*() {
                        let o = `/api/doc/${e}/annotations`;
                        const s = yield (0, r.request)({
                            url: o,
                            method: "get",
                            params: {
                                annotation_ids: t,
                                strategy: n
                            }
                        });
                        return 0 !== s.ret ? Promise.reject(s) : s.data.map((e)=>(0, i.formatAnnotationResult)(e));
                    });
                }, t.addAnnotations = function(e, t, n, s = !1) {
                    return o(this, void 0, void 0, function*() {
                        let o = `/api/doc/${e}/add/annotations`, a = {
                            annots: n.map((e)=>(0, i.formatAnnotationBean)(e)),
                            is_init: s
                        };
                        const c = yield (0, r.request)({
                            url: o,
                            method: "post",
                            data: a,
                            params: {
                                session_id: t
                            }
                        });
                        return 0 !== c.ret ? Promise.reject(c) : c.data;
                    });
                }, t.changeAnnotations = function(e, t, n) {
                    return o(this, void 0, void 0, function*() {
                        let o = `/api/doc/${e}/change/annotations`, s = {
                            annots: n.map((e)=>(0, i.formatAnnotationBean)(e))
                        };
                        const a = yield (0, r.request)({
                            url: o,
                            method: "post",
                            data: s,
                            params: {
                                session_id: t
                            }
                        });
                        return 0 !== a.ret ? Promise.reject(a) : a.data;
                    });
                }, t.deleteAnnotations = function(e, t, n) {
                    return o(this, void 0, void 0, function*() {
                        let o = `/api/doc/${e}/delete/annotations`, i = {
                            annots: n.map(({ annotationId: e, pageNumber: t })=>({
                                    annotation_id: e,
                                    page_number: t
                                }))
                        };
                        const s = yield (0, r.request)({
                            url: o,
                            method: "post",
                            data: i,
                            params: {
                                session_id: t
                            }
                        });
                        return 0 !== s.ret ? Promise.reject(s) : s.data;
                    });
                }, t.createInvitation = function(e, t) {
                    return o(this, void 0, void 0, function*() {
                        let n = `/api/doc/${e}/create/invitation`;
                        const o = yield (0, r.request)({
                            url: n,
                            method: "post",
                            data: {
                                expiresInMilliSeconds: t
                            }
                        });
                        return 0 !== o.ret ? Promise.reject(o) : o.data;
                    });
                }, t.getDocIdByInvitation = function(e) {
                    return o(this, void 0, void 0, function*() {
                        let t = `/api/doc/invitation/${e}`;
                        return (yield (0, r.request)({
                            url: t,
                            method: "get"
                        })).data;
                    });
                }, t.addInitialYLogs = function(e, t) {
                    return o(this, void 0, void 0, function*() {
                        let n = `/api/doc/${e}/ylogs`;
                        const o = yield (0, r.request)({
                            url: n,
                            method: "post",
                            data: {
                                ylog: t
                            }
                        });
                        return 0 !== o.ret ? Promise.reject(o) : o.data;
                    });
                }, t.getYLogs = function(e) {
                    return o(this, void 0, void 0, function*() {
                        let t = `/api/doc/${e}/ylogs`;
                        const n = yield (0, r.request)({
                            url: t,
                            method: "get"
                        });
                        return 0 !== n.ret ? Promise.reject(n) : n.data;
                    });
                }, t.getCollabServerVersion = function() {
                    return o(this, void 0, void 0, function*() {
                        const e = yield (0, r.request)({
                            url: "/api/version",
                            method: "get"
                        });
                        return 0 !== e.ret ? Promise.reject(e) : e.data.version;
                    });
                };
            },
            2093: (e, t)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.formatUserResult = t.formatDocResult = t.formatAnnotationBean = t.formatAnnotationResult = void 0, t.formatAnnotationResult = function(e) {
                    const { id: t, author_id: n, annotation_id: o, document_id: r, page_number: i, xfdf: s, in_reply_to: a } = e;
                    return {
                        id: t,
                        authorId: n,
                        annotationId: o,
                        documentId: r,
                        pageNumber: i,
                        xfdf: s,
                        inReplyTo: a
                    };
                }, t.formatAnnotationBean = function(e) {
                    const { id: t, authorId: n, annotationId: o, documentId: r, pageNumber: i, xfdf: s, inReplyTo: a } = e;
                    return {
                        id: t,
                        author_id: n,
                        annotation_id: o,
                        document_id: r,
                        page_number: i,
                        xfdf: s,
                        in_reply_to: a
                    };
                }, t.formatDocResult = function(e) {
                    const { id: t, name: n, file_url: o, created_at: r, author_id: i, updated_at: s, is_public: a, permission: c, access: d, status: l } = e;
                    return {
                        id: t,
                        docName: n,
                        fileUrl: o,
                        isDocPublic: a,
                        authorId: i,
                        docPermission: c,
                        createdAt: r,
                        updatedAt: s,
                        access: d,
                        status: l
                    };
                }, t.formatUserResult = function(e) {
                    const { id: t, user_name: n, email: o, status: r, type: i, isAllowComment: s, last_read: a, isInScreenSync: c } = e;
                    return {
                        id: t,
                        userName: n,
                        email: o,
                        status: r,
                        isAllowComment: s,
                        type: i,
                        lastRead: a,
                        isInScreenSync: c
                    };
                };
            },
            5741: function(e, t, n) {
                var o = this && this.__awaiter || function(e, t, n, o) {
                    return new (n || (n = Promise))(function(r, i) {
                        function s(e) {
                            try {
                                c(o.next(e));
                            } catch (t) {
                                i(t);
                            }
                        }
                        function a(e) {
                            try {
                                c(o.throw(e));
                            } catch (t) {
                                i(t);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((o = o.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getScreenSyncMembers = t.syncScreenData = t.leaveScreenSync = t.joinScreenSync = t.getScreenSyncList = t.getScreenSyncByMemberId = t.getScreenSync = t.createScreenSync = void 0;
                const r = n(5221), i = n(2093);
                t.createScreenSync = function(e, t, n) {
                    return o(this, void 0, void 0, function*() {
                        return (yield (0, r.request)({
                            url: "/api/screen-sync",
                            method: "post",
                            params: {
                                session_id: t,
                                doc_id: e
                            },
                            data: {
                                members: n
                            }
                        })).data;
                    });
                }, t.getScreenSync = function(e) {
                    return o(this, void 0, void 0, function*() {
                        const t = yield (0, r.request)({
                            url: `/api/screen-sync/${e}`,
                            method: "get"
                        });
                        return 0 !== t.ret ? Promise.reject(t) : t.data;
                    });
                }, t.getScreenSyncByMemberId = function(e, t, n) {
                    return o(this, void 0, void 0, function*() {
                        const o = yield (0, r.request)({
                            url: "/api/screen-sync",
                            method: "get",
                            params: {
                                session_id: e,
                                doc_id: t,
                                memberId: n
                            }
                        });
                        return 0 !== o.ret ? Promise.reject(o) : o.data;
                    });
                }, t.getScreenSyncList = function(e, t) {
                    return o(this, void 0, void 0, function*() {
                        return (yield (0, r.request)({
                            url: "/api/screen-sync/list",
                            method: "get",
                            params: {
                                session_id: t,
                                doc_id: e
                            }
                        })).data;
                    });
                }, t.joinScreenSync = function(e) {
                    return o(this, void 0, void 0, function*() {
                        const t = yield (0, r.request)({
                            url: `/api/screen-sync/${e}/join`,
                            method: "post"
                        });
                        return 0 !== t.ret ? Promise.reject(t) : t.data;
                    });
                }, t.leaveScreenSync = function(e) {
                    return o(this, void 0, void 0, function*() {
                        const t = yield (0, r.request)({
                            url: `/api/screen-sync/${e}/leave`,
                            method: "post"
                        });
                        return 0 !== t.ret ? Promise.reject(t) : t.data;
                    });
                }, t.syncScreenData = function(e, t) {
                    return o(this, void 0, void 0, function*() {
                        return (yield (0, r.request)({
                            url: `/api/screen-sync/${e}/sync`,
                            method: "post",
                            data: t
                        })).data;
                    });
                }, t.getScreenSyncMembers = function(e, t) {
                    return o(this, void 0, void 0, function*() {
                        return (yield (0, r.request)({
                            url: `/api/screen-sync/${e}/members`,
                            method: "get",
                            params: {
                                role: t
                            }
                        })).data.map((e)=>(0, i.formatUserResult)(e));
                    });
                };
            },
            5608: (e, t)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.NetworkConnectionEvent = t.DocumentAction = t.MessageType = void 0, function(e) {
                    e.HEART = "heart", e.SUBSCRIBE_DOC = "subscribe-doc", e.UNSUBSCRIBE_DOC = "unsubscribe-doc";
                }(t.MessageType || (t.MessageType = {})), function(e) {
                    e.MEMBER_ONLINE = "member-online", e.MEMBER_OFFLINE = "member-offline", e.ADD_MEMBERS = "add-members", e.DELETE_MEMBERS = "delete-members", e.ADD_ANNOTS = "add-annots", e.CHANGE_ANNOTS = "change-annots", e.DELETE_ANNOTS = "delete-annots", e.DELETE_SHARE = "delete-share", e.EDIT_MEMBERS = "edit-members", e.MOUSE_POINTER_SYNC = "mouse-pointer-sync", e.SYNC_YLOG = "sync-ylog", e.SYNC_YLOG_STEP_1 = "sync-ylog-s1", e.SYNC_YLOG_STEP_2 = "sync-ylog-s2";
                }(t.DocumentAction || (t.DocumentAction = {})), function(e) {
                    e.NetworkConnectionUp = "network-connection-up", e.NetworkConnectionDown = "network-connection-down";
                }(t.NetworkConnectionEvent || (t.NetworkConnectionEvent = {}));
            },
            8037: (e, t)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.CollabStatus = void 0, function(e) {
                    e.CREATED = "CREATED", e.BEGIN = "BEGIN", e.ENDED = "ENDED";
                }(t.CollabStatus || (t.CollabStatus = {}));
            },
            9648: (e, t)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ScreenSyncEvent = t.PointerStyle = t.ScreenSyncRole = void 0, function(e) {
                    e.LEADER = "leader", e.FOLLOWER = "follower";
                }(t.ScreenSyncRole || (t.ScreenSyncRole = {})), function(e) {
                    e.HAND = "hand", e.CROSSHAIR = "crosshair", e.ARROW = "arrow", e.LASTER_POINTER = "laser-pointer";
                }(t.PointerStyle || (t.PointerStyle = {})), function(e) {
                    e.CREATED = "screen-sync-created", e.STOPPED = "screen-sync-stopped", e.MEMBER_JOINED = "screen-sync-member-joined", e.MEMBER_LEAVE = "screen-sync-member-leave", e.SCREENSYNC_DATA = "screen-sync-data";
                }(t.ScreenSyncEvent || (t.ScreenSyncEvent = {}));
            },
            1095: (e, t)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.debounce = t.DebounceTaskExecutor = void 0;
                const n = ()=>{};
                class o {
                    constructor(e = 100, t = !1){
                        this.delay = e, this.leading = t, this.handle = n, this.flag = 0, this.pending = !1;
                    }
                    exec(e) {
                        if (this.flag++, this.handle = e, this.pending) return;
                        this.leading && (e(), this.flag = 0, this.handle = n);
                        const t = ()=>{
                            this.pending = !0, setTimeout(()=>{
                                if (this.flag > 1) this.flag = 0, t();
                                else {
                                    const e = this.handle;
                                    this.handle = n, e(), this.pending = !1;
                                }
                            }, this.delay);
                        };
                        t();
                    }
                    cancel() {
                        this.handle = n;
                    }
                }
                t.DebounceTaskExecutor = o, t.debounce = function(e, t = 100, n = !1) {
                    const r = new o(t, n);
                    return function(...t) {
                        const n = e.bind(this, ...t);
                        r.exec(n);
                    };
                };
            },
            4255: (e, t, n)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getTransportConfigFromBaseURL = t.getScreenSyncInitialInfo = t.isObjectValueEqual = t.throwByCollabStatus = t.throwParamRequiredError = t.validateEmail = void 0;
                const o = n(8037);
                t.validateEmail = function(e) {
                    return /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(e);
                }, t.throwParamRequiredError = function(e) {
                    throw new Error(`The ${e} parameter is required`);
                }, t.throwByCollabStatus = function(e) {
                    switch(e){
                        case o.CollabStatus.BEGIN:
                            throw new Error("The collaboration has begun");
                        case o.CollabStatus.ENDED:
                            throw new Error("The collaboration  has ended");
                        case o.CollabStatus.CREATED:
                            throw new Error("The collaboration has been created but not begun");
                    }
                }, t.isObjectValueEqual = function(e, t) {
                    var n = Object.getOwnPropertyNames(e), o = Object.getOwnPropertyNames(t);
                    if (n.length != o.length) return !1;
                    for(var r = 0; r < n.length; r++){
                        var i = n[r];
                        if (e[i] !== t[i]) return !1;
                    }
                    return !0;
                }, t.getScreenSyncInitialInfo = function() {
                    return {
                        defaultScreenSyncData: {
                            zoom: "fitWidth",
                            layoutMode: "continuous-page-view-mode",
                            isFullScreenMode: !1,
                            scrollPosition: {
                                x: 0,
                                y: 0
                            },
                            scale: 1
                        }
                    };
                }, t.getTransportConfigFromBaseURL = function(e) {
                    const { host: t, protocol: n, pathname: o } = new URL(e);
                    let r = `ws://${t}${o}/ws`, i = o;
                    return o.endsWith("/") || (i = i = o + "/"), r = "http:" === n ? `ws://${t}${i}ws` : `wss://${t}${i}ws`, {
                        httpBaseURL: e,
                        websocketURL: r
                    };
                };
            },
            7418: (e, t)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.throttle = void 0, t.throttle = function(e, t = 200, n = {}) {
                    let o, r, i, s, a = 0;
                    const c = ()=>{
                        a = !1 === n.leading ? 0 : Date.now(), o = null, s = e.apply(r, i), o || (r = i = null);
                    };
                    function d() {
                        const d = Date.now();
                        a || !1 !== n.leading || (a = d);
                        const l = t - (d - a);
                        return r = this, i = arguments, l <= 0 || l > t ? (o && (clearTimeout(o), o = null), a = d, s = e.apply(r, i), o || (r = i = null)) : o || !1 === n.trailing || (o = setTimeout(c, l)), s;
                    }
                    return d.cancel = function() {
                        clearTimeout(o), a = 0, o = r = i = null;
                    }, d.setThreshold = function(e) {
                        t = e;
                    }, d;
                };
            },
            5231: function(e, t, n) {
                var o = this && this.__awaiter || function(e, t, n, o) {
                    return new (n || (n = Promise))(function(r, i) {
                        function s(e) {
                            try {
                                c(o.next(e));
                            } catch (t) {
                                i(t);
                            }
                        }
                        function a(e) {
                            try {
                                c(o.throw(e));
                            } catch (t) {
                                i(t);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((o = o.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.MousePointerService = void 0;
                const r = n(5608), i = n(8907), s = n(6526), a = n(7418);
                const c = window.PDFViewCtrl;
                t.MousePointerService = class {
                    constructor(e, t){
                        var n;
                        this.context = t, this.color = "#222222", this.mousePointerStates = {}, this.disableSync = !0, this.onMemberOffline = (e)=>o(this, void 0, void 0, function*() {
                                const t = e.user_id;
                                if (this.mousePointerStates[t]) {
                                    const e = this.mousePointerStates[t].mouseElement;
                                    null === e || void 0 === e || e.remove(), delete this.mousePointerStates[t];
                                }
                            }), this.refresh = ()=>o(this, void 0, void 0, function*() {
                                for (const e of Object.keys(this.mousePointerStates)){
                                    const t = this.mousePointerStates[e];
                                    if (!t) continue;
                                    const { mouseElement: n, mouseData: o } = t, r = this.pdfViewer.getPDFPageRender(0);
                                    if (!r) return;
                                    const i = yield r.transformPoint({
                                        point: {
                                            x: o.x,
                                            y: o.y
                                        },
                                        srcType: c.constants.PagePointType.pdf,
                                        destType: c.constants.PagePointType.scroll
                                    });
                                    n ? Object.assign(n.style, {
                                        left: i.x + "px",
                                        top: i.y + "px"
                                    }) : t.mouseElement = this.addNode(o);
                                }
                            }), this.pdfViewer = e, this.color = function(e) {
                            let t = Math.floor(123 * e).toString(16);
                            for(; t.length < 6;)t = "0" + t;
                            return "#" + t;
                        }(null === (n = t.currentUser) || void 0 === n ? void 0 : n.id), this.context = t, this.onMouseMove = (0, a.throttle)(this.onMouseMove.bind(this));
                    }
                    setSyncRate(e) {
                        this.onMouseMove.setThreshold(e);
                    }
                    onMouseMove(e) {
                        return o(this, void 0, void 0, function*() {
                            const t = this.pdfViewer.getPDFPageRender(0);
                            if (!t) return;
                            const n = yield t.transformPoint({
                                point: {
                                    x: e.clientX,
                                    y: e.clientY
                                },
                                srcType: c.constants.PagePointType.viewport,
                                destType: c.constants.PagePointType.pdf
                            });
                            this.sync(n);
                        });
                    }
                    start(e, t) {
                        this.ws = e, this.docId = t, this.disableSync = !1;
                        const n = this.pdfViewer.getScrollWrap().scrollHost;
                        n.addEventListener("mousemove", this.onMouseMove), n.addEventListener("click", this.onMouseMove);
                        const o = this.pdfViewer.addEventListener(i.Event.zoomToSuccess, this.refresh), r = setInterval(()=>{
                            this.refresh();
                        }, 500);
                        this.pdfViewer.eventEmitter.once(i.Event.willCloseDocument, ()=>{
                            (0, s.stopCollaboration)(this.context.currentDocId), n.removeEventListener("mousemove", this.onMouseMove), n.removeEventListener("click", this.onMouseMove), o(), clearInterval(r), this.clean(), this.disableSync = !0;
                        });
                    }
                    stop() {
                        this.disableSync = !0;
                    }
                    sync(e) {
                        var t;
                        const n = {
                            event: "events",
                            data: {
                                type: r.DocumentAction.MOUSE_POINTER_SYNC,
                                data: {
                                    docId: this.docId,
                                    state: Object.assign(Object.assign({}, e), {
                                        username: null === (t = this.context.currentUser) || void 0 === t ? void 0 : t.username,
                                        color: this.color
                                    })
                                }
                            }
                        };
                        this.ws.send(JSON.stringify(n));
                    }
                    renderInitialMousePointers(e) {
                        return o(this, void 0, void 0, function*() {
                            this.disableSync = !1, this.clean();
                            for (const t of Object.keys(e))this.mousePointerStates[t] = {
                                mouseElement: null,
                                mouseData: e[t]
                            };
                        });
                    }
                    render({ userId: e, sessionId: t, state: n }) {
                        return o(this, void 0, void 0, function*() {
                            if (this.disableSync) return;
                            const t = this.pdfViewer.getPDFPageRender(0);
                            if (!t) return;
                            const o = yield t.transformPoint({
                                point: {
                                    x: n.x,
                                    y: n.y
                                },
                                srcType: c.constants.PagePointType.pdf,
                                destType: c.constants.PagePointType.scroll
                            }), r = this.mousePointerStates[e], i = null === r || void 0 === r ? void 0 : r.mouseElement;
                            i ? (r.mouseData = {
                                x: n.x,
                                y: n.y,
                                username: n.username,
                                color: n.color
                            }, Object.assign(i.style, {
                                left: o.x + "px",
                                top: o.y + "px"
                            })) : this.mousePointerStates[e] = {
                                mouseElement: this.addNode(n),
                                mouseData: {
                                    x: n.x,
                                    y: n.y,
                                    username: n.username,
                                    color: n.color
                                }
                            };
                        });
                    }
                    clean() {
                        for (const e of Object.keys(this.mousePointerStates)){
                            const t = this.mousePointerStates[e];
                            if (!t) continue;
                            const { mouseElement: n } = t;
                            null === n || void 0 === n || n.remove(), delete this.mousePointerStates[e];
                        }
                    }
                    addNode(e) {
                        const { username: t, color: n } = e, o = document.createElement("div");
                        Object.assign(o.style, {
                            position: "absolute",
                            left: e.x + "px",
                            top: e.y + "px",
                            zIndex: "999",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }), o.innerHTML = `\n      <svg width="10" height="13" viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg">\n        <path d="M5.8 8L7.48 11.56C7.56 11.76 7.48 12 7.28 12.08L5.84 12.76C5.64 12.84 5.4 12.76 5.32 12.56L3.6 8.92L1.52 11C1.44 11.08 1.36 11.12 1.24 11.12C0.999996 11.12 0.839996 10.96 0.839996 10.72V0.599999C0.839996 0.519999 0.879996 0.399999 0.959996 0.319999C1.12 0.159999 1.36 0.159999 1.52 0.279999L8.96 7.04C9.04 7.12 9.08 7.2 9.08 7.32C9.08 7.56 8.92 7.72 8.72 7.76L5.8 8Z" fill="${n}"/>\n      </svg>\n      <div style="font-size: 12px;color: #fff;background: ${n};padding: 0 2px; border-radius: 2px;">${t}</div>\n    `;
                        return this.pdfViewer.getScrollWrap().scrollHost.appendChild(o), o;
                    }
                };
            },
            923: function(e, t, n) {
                var o = this && this.__createBinding || (Object.create ? function(e, t, n, o) {
                    void 0 === o && (o = n);
                    var r = Object.getOwnPropertyDescriptor(t, n);
                    r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                        enumerable: !0,
                        get: function() {
                            return t[n];
                        }
                    }), Object.defineProperty(e, o, r);
                } : function(e, t, n, o) {
                    void 0 === o && (o = n), e[o] = t[n];
                }), r = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), i = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var n in e)"default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
                    return r(t, e), t;
                }, s = this && this.__awaiter || function(e, t, n, o) {
                    return new (n || (n = Promise))(function(r, i) {
                        function s(e) {
                            try {
                                c(o.next(e));
                            } catch (t) {
                                i(t);
                            }
                        }
                        function a(e) {
                            try {
                                c(o.throw(e));
                            } catch (t) {
                                i(t);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((o = o.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.SdkAnnotEventService = void 0;
                const a = n(8907), c = n(1095), d = i(n(9703)), l = n(5608), u = n(5285), h = n(6989), f = n(5692), p = i(n(7918)), v = n(9594);
                t.SdkAnnotEventService = class {
                    constructor(e, t){
                        this.addInitialAnnotations = (e)=>s(this, void 0, void 0, function*() {
                                for (let r of e)r.getName() || (yield r.setUniqueID());
                                const t = new d.Doc();
                                yield this.encodeAnnotationAdd(e, t);
                                const n = d.encodeStateAsUpdate(t), o = this.context.currentDocId;
                                return yield (0, h.addInitialYLogs)(o, n), !0;
                            }), this.addAnnotation = (e)=>s(this, void 0, void 0, function*() {
                                yield this.encodeAsYDocTypes(e, a.Event.annotationAdded);
                            }), this.addAnnotationReply = (e)=>s(this, void 0, void 0, function*() {
                                const t = [
                                    e
                                ];
                                yield this.encodeAsYDocTypes(t, a.Event.annotationAdded);
                            }), this.updateAnnotation = (e, t, n)=>s(this, void 0, void 0, function*() {
                                "add-replies" !== n && "review-state-updated" !== n && "marked-state-updated" !== n && (yield this.encodeAsYDocTypes(e, a.Event.annotationUpdated));
                            }), this.deleteAnnotation = (e)=>s(this, void 0, void 0, function*() {
                                yield this.encodeAsYDocTypes(e, a.Event.annotationRemoved);
                            }), this.annotReviewStateAdd = (e)=>s(this, void 0, void 0, function*() {
                                const t = [
                                    e
                                ];
                                yield this.encodeAsYDocTypes(t, a.Event.annotationAdded);
                            }), this.willCloseDocument = ()=>{
                            this.tempRemoveAnnotsUserId = {};
                        }, this.pdfViewer = e, this.annotList = [], this.context = t, this.changeViewModeEvent = this.changeViewModeEvent.bind(this), this.zoomEvent = (0, c.debounce)(this.zoomEvent.bind(this), 150), this.tempRemoveAnnotsUserId = {};
                    }
                    addAnnotationListener() {
                        this.removeAddAnnotListener = this.pdfViewer.addEventListener(a.Event.annotationAdded, this.addAnnotation), this.removeAddAnnotReplyListener = this.pdfViewer.addEventListener(a.Event.annotationReplyAdd, this.addAnnotationReply), this.removeUpdateAnnotListener = this.pdfViewer.addEventListener(a.Event.annotationUpdated, this.updateAnnotation), this.removeDeleteAnnotListener = this.pdfViewer.addEventListener(a.Event.annotationRemoved, this.deleteAnnotation), this.removeAnnotReviewStateAdd = this.pdfViewer.addEventListener(a.Event.annotationReviewStateAnnotAdd, this.annotReviewStateAdd), this.removeWillCloseDocumentListener = this.pdfViewer.addEventListener(a.Event.willCloseDocument, this.willCloseDocument), this.removeZoomEvent = this.pdfViewer.addEventListener(a.Event.zoomToSuccess, this.zoomEvent), this.removechangeViewModeEvent = this.pdfViewer.addEventListener(a.Event.changeViewModeSuccess, this.changeViewModeEvent), this.removeUndoRedoStoreChangeEvent = this.pdfViewer.addEventListener(a.Event.undoRedoStoreChange, (e)=>{
                            this.undoRedoManager = e.undoRedoManager;
                        }), this.pdfViewer.setContinuousAddPencilState && this.pdfViewer.setContinuousAddPencilState(!0);
                    }
                    syncUpdate(e, t = l.DocumentAction.SYNC_YLOG, n) {
                        const o = this.context.wsInstance, r = n || this.context.currentDocId;
                        v.LOGGER.debug(`sending msg ${t} to server, size: ${null === e || void 0 === e ? void 0 : e.length}`, {
                            serverId: u.context.serverId
                        });
                        const i = {
                            type: t,
                            data: {
                                docId: r,
                                ylog: e
                            }
                        };
                        o.send(p.encode(i));
                    }
                    removeAnnotationListener() {
                        this.removeAddAnnotListener(), this.removeAddAnnotReplyListener(), this.removeUpdateAnnotListener(), this.removeDeleteAnnotListener(), this.removeAnnotReviewStateAdd(), this.removeWillCloseDocumentListener(), this.removeZoomEvent(), this.removechangeViewModeEvent(), this.removeUndoRedoStoreChangeEvent(), this.pdfViewer.setContinuousAddPencilState && this.pdfViewer.setContinuousAddPencilState(!1);
                    }
                    zoomEvent(e) {
                        return s(this, void 0, void 0, function*() {
                            yield this.context.webSdkBinding.sdkScreenSyncService.setZoomBySDK(e);
                        });
                    }
                    changeViewModeEvent(e) {
                        return s(this, void 0, void 0, function*() {
                            yield this.context.webSdkBinding.sdkScreenSyncService.setViewModeBySDK(e);
                        });
                    }
                    getPageIdByPageIndex(e) {}
                    encodeAnnotationAdd(e, t, n) {
                        return s(this, void 0, void 0, function*() {
                            const o = this.context.currentUser.id, r = this.pdfViewer.getCurrentPDFDoc(), i = this.pdfViewer.getAnnotAuthorityManager(), s = yield r.exportAnnotsToJSON(e), a = t.getMap("pageAnnotMaps");
                            t.transact(()=>{
                                s.map((t, r)=>{
                                    const i = t.page.toString();
                                    let s = a.get(i);
                                    s || (s = new d.Map(), a.set(i, s));
                                    let c = s.get(t.name + `__${i}`);
                                    if (!c) {
                                        if (c = new d.Map(), s.set(t.name + `__${i}`, c), "local" === n) {
                                            let t = e[r].getId(), n = this.tempRemoveAnnotsUserId[t];
                                            c.set("userId", n || o), delete this.tempRemoveAnnotsUserId[t];
                                        } else c.set("userId", o);
                                    }
                                    Object.entries(t).forEach(function([e, t]) {
                                        c.set(e, t);
                                    });
                                }), e.forEach(function(e) {
                                    i.update(e);
                                });
                            }, n);
                        });
                    }
                    encodeAnnotationUpdate(e, t, n) {
                        return s(this, void 0, void 0, function*() {
                            this.context.currentUser.id;
                            const o = this.pdfViewer.getAnnotAuthorityManager(), r = this.pdfViewer.getCurrentPDFDoc(), i = yield r.exportAnnotsToJSON(e), s = t.getMap("pageAnnotMaps");
                            t.transact(function() {
                                i.forEach((e)=>{
                                    const t = e.page.toString();
                                    let n = s.get(t);
                                    n || (n = new d.Map(), s.set(t, n));
                                    let o = n.get(e.name + `__${t}`);
                                    if (!o) return;
                                    let r = o.toJSON();
                                    Object.entries(e).forEach(function([t, n]) {
                                        "userId" !== t && ("fileattachment" === e.type && "raw" === t || r[t] !== n && o.set(t, n));
                                    }), Object.keys(r).forEach(function(t) {
                                        "userId" !== t && void 0 === e[t] && o.delete(t);
                                    });
                                }), e.forEach(function(e) {
                                    o.update(e);
                                });
                            }, n);
                        });
                    }
                    encodeAsYDocTypes(e, t, n = "local") {
                        return s(this, void 0, void 0, function*() {
                            const o = this.ydoc;
                            if (0 === e.length) return [];
                            const r = e;
                            t !== a.Event.annotationRemoved ? t !== a.Event.annotationAdded ? yield this.encodeAnnotationUpdate(r, this.ydoc, n) : yield this.encodeAnnotationAdd(r, this.ydoc, n) : o.transact(()=>r.map((e)=>{
                                    const t = o.getMap("pageAnnotMaps"), r = e.getPage().getIndex().toString();
                                    let i = t.get(r);
                                    if (i) {
                                        let t = e.getUniqueID() + `__${r}`;
                                        if ("local" === n) {
                                            let n = i.get(t);
                                            if (n) {
                                                let t = n.toJSON();
                                                this.tempRemoveAnnotsUserId[e.getId()] = t.userId;
                                            }
                                        }
                                        i.delete(t);
                                    }
                                }), n);
                        });
                    }
                    initYDoc() {
                        v.LOGGER.debug("starting to init ydoc"), this.destroyYDoc();
                        let e = new d.Doc();
                        this.ydoc = e;
                    }
                    initProviders(e) {
                        return s(this, void 0, void 0, function*() {
                            const t = this.ydoc;
                            try {
                                yield this.initIndexedDBProvider("collab$$" + e, this.ydoc);
                            } catch (n) {
                                v.LOGGER.error("Failed to enable offline mode due to browser setup.");
                            }
                            this.initWebSocketProvider(t);
                        });
                    }
                    initWebSocketProvider(e) {
                        e.on("update", (e, t)=>{
                            "local" === t && this.syncUpdate(e);
                        });
                    }
                    initIndexedDBProvider(e, t) {
                        const n = new f.IndexeddbPersistence(e, t);
                        return this.idbPersistencePromise = new Promise((e, t)=>{
                            n.on("synced", function(t) {
                                v.LOGGER.debug("synced ydoc state with indexedDB persistence", t.name), e(t);
                            }), n.on("error", function(e) {
                                t(e);
                            });
                        }), this.idbPersistencePromise;
                    }
                    destroyYDoc() {
                        var e;
                        null === (e = this.ydoc) || void 0 === e || e.destroy(), delete this.ydoc;
                    }
                };
            },
            1630: function(e, t, n) {
                var o = this && this.__createBinding || (Object.create ? function(e, t, n, o) {
                    void 0 === o && (o = n);
                    var r = Object.getOwnPropertyDescriptor(t, n);
                    r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                        enumerable: !0,
                        get: function() {
                            return t[n];
                        }
                    }), Object.defineProperty(e, o, r);
                } : function(e, t, n, o) {
                    void 0 === o && (o = n), e[o] = t[n];
                }), r = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), i = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var n in e)"default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
                    return r(t, e), t;
                }, s = this && this.__awaiter || function(e, t, n, o) {
                    return new (n || (n = Promise))(function(r, i) {
                        function s(e) {
                            try {
                                c(o.next(e));
                            } catch (t) {
                                i(t);
                            }
                        }
                        function a(e) {
                            try {
                                c(o.throw(e));
                            } catch (t) {
                                i(t);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((o = o.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.SdkCollabService = void 0;
                const a = n(5608), c = i(n(9703)), d = n(5285), l = n(9594);
                function u(e, t, n) {
                    return s(this, void 0, void 0, function*() {
                        if (e.inreplyto) {
                            let o = yield n.getCurrentPDFDoc();
                            const r = yield o.getPageByIndex(e.page), i = (yield r.getAnnotsByIdArray([
                                e.inreplyto
                            ]))[0].exportToJSON();
                            t.push(i), i.inreplyto && (yield u(i, t, n));
                        }
                    });
                }
                function h(e, t) {
                    return s(this, void 0, void 0, function*() {
                        return e;
                    });
                }
                function f(e, t) {
                    return s(this, void 0, void 0, function*() {
                        if (!e || !e.length) return;
                        let n = e[0].page;
                        const o = yield t.getCurrentPDFDoc();
                        let r = yield o.getPageByIndex(Number(n));
                        if (!r) return;
                        let i = yield r.getAnnotsByIdArray(e.map(function(e) {
                            return e.name;
                        }));
                        if (!i || !i.length) return;
                        let s = yield t.getAnnotAuthorityManager();
                        i.forEach(function(e) {
                            s.update(e);
                        });
                    });
                }
                t.SdkCollabService = class {
                    constructor(e, t, n, o){
                        this.sdkAnnotEventService = n, this.mousePointerService = o, this.onBroadcastCollabNotice = (e)=>{
                            const { type: t, data: n } = e;
                            if (this.isContinueProcessing(n)) switch(t){
                                case a.DocumentAction.SYNC_YLOG:
                                    this.applyYlog(n.ylog);
                                    break;
                                case a.DocumentAction.SYNC_YLOG_STEP_1:
                                    l.LOGGER.debug("received sync-ylog-s1 from server", {
                                        serverId: this.context.serverId
                                    }), this.handleSyncStep1(n.ylog);
                                    break;
                                case a.DocumentAction.SYNC_YLOG_STEP_2:
                                    l.LOGGER.debug(`received sync-ylog-s2 from server, size: ${n.ylog.length}`, {
                                        serverId: this.context.serverId
                                    }), this.handleSyncStep2(n.ylog);
                                    break;
                                case a.DocumentAction.MOUSE_POINTER_SYNC:
                                    this.mousePointerService.render({
                                        userId: n.user_id,
                                        sessionId: n.session_id,
                                        state: n.state
                                    });
                            }
                        }, this.deleteAnnots = (e)=>s(this, void 0, void 0, function*() {
                                const { annots: t, isDeleteLocal: n } = e;
                                l.LOGGER.debug("start to delete annotations: ", t);
                                let o = yield this.pdfViewer.getCurrentPDFDoc();
                                for (const e of t){
                                    let t = e.annotId, n = e.pageIndex;
                                    const r = this.pdfViewer.getAnnotRender(+e.pageIndex, t);
                                    r && r.component.isActive && r.unActive();
                                    const i = ()=>{
                                        this.pdfViewer.customs.pushUndoStack = void 0;
                                    };
                                    this.pdfViewer.customs.pushUndoStack = (e, t)=>{
                                        if ("REMOVEANNOT" == e) return !1;
                                    };
                                    const s = yield o.getPageByIndex(n);
                                    s && s.removeAnnotById(t).then((e)=>{
                                        i(), this.sdkAnnotEventService.undoRedoManager && this.sdkAnnotEventService.undoRedoManager.removeByName(t);
                                    });
                                }
                            }), this.pdfViewer = e, this.context = t, this.annotList = [], this.otherAnnotsList = [], this.annotArr = [], this.pendingList = [], this.totalAnnotsCount = this.annotList.length + this.otherAnnotsList.length, this.ydoc = n.ydoc;
                    }
                    getAnnotUserId(e, t) {
                        let n = this.sdkAnnotEventService.ydoc;
                        if (!n) return;
                        let o = n.get(t.toString());
                        if (!o) return;
                        let r = o._length(e);
                        return r ? r.toJSON().userId : void 0;
                    }
                    resetCollaborationData() {
                        this.annotList = [], this.otherAnnotsList = [];
                    }
                    setOwnerAnnotId(e) {
                        this.otherAnnotsList.push(e);
                    }
                    uploadInitialAnnots() {
                        return s(this, void 0, void 0, function*() {
                            const e = yield this.pdfViewer.getCurrentPDFDoc();
                            if (!e) throw new Error("A PDF document need to be opened by PDFViewer first before creating collaboration.");
                            const t = yield e.getAnnots(), n = [];
                            t.forEach((e)=>{
                                n.push(...e);
                            }), yield this.sdkAnnotEventService.addInitialAnnotations(n);
                        });
                    }
                    isContinueProcessing(e) {
                        return !this.context.currentUser || this.context.sessionId !== e.session_id || this.context.currentUser.id != e.user_id;
                    }
                    fetchInitialAnnots(e) {
                        return s(this, void 0, void 0, function*() {
                            this.sendSyncStep1(e);
                        });
                    }
                    sendSyncStep1(e) {
                        return s(this, void 0, void 0, function*() {
                            const t = this.sdkAnnotEventService.ydoc, n = c.encodeStateVector(t);
                            this.sdkAnnotEventService.syncUpdate(n, a.DocumentAction.SYNC_YLOG_STEP_1, e);
                        });
                    }
                    ydocToPDF(e) {
                        return s(this, void 0, void 0, function*() {
                            if (!e) return;
                            let t = e.getMap("pageAnnotMaps");
                            const n = this.pdfViewer, o = this.deleteAnnots;
                            t.observeDeep(function(e, t) {
                                return s(this, void 0, void 0, function*() {
                                    l.LOGGER.debug("observed yevents:", e, "from origin:", t.origin, "server" === t.origin ? {
                                        serverId: d.context.serverId
                                    } : ""), "local" !== t.origin && (yield function(e, t) {
                                        return s(this, void 0, void 0, function*() {
                                            const t = yield n.getCurrentPDFDoc();
                                            for (let r of e){
                                                let e = r.target, i = r.path, s = r.changes.keys;
                                                if (!i.length) {
                                                    let r = [], i = [], a = !1;
                                                    if (s.forEach(function({ action: t, oldValue: n }, o) {
                                                        if ("add" === t) {
                                                            const [t, n] = o.split("__");
                                                            if (void 0 !== n) {
                                                                if (!e.get(o).toJSON) return void l.LOGGER.debug("no toJSON found for target by key", e, o);
                                                                l.LOGGER.debug(e.get(o).toJSON()), r.push(e.get(o).toJSON());
                                                            } else {
                                                                if (!e.get(o).toJSON) return void l.LOGGER.debug("no toJSON found for target by key", e, o);
                                                                const t = e.get(o).toJSON();
                                                                r = r.concat(Object.values(t));
                                                            }
                                                        } else if ("delete" === t) {
                                                            const [e, t] = o.split("__");
                                                            void 0 !== t && i.push({
                                                                annotId: e,
                                                                pageIndex: Number(t)
                                                            });
                                                        } else "update" === t && (l.LOGGER.debug("path length is 0 and action is update, the target is", e), a = !0);
                                                    }), a && e.toJSON) {
                                                        const t = e.toJSON();
                                                        yield h(t), r.push(t);
                                                    }
                                                    l.LOGGER.debug("path length = 0, start to import annots", r), yield t.importAnnotsFromJSON(r), yield f(r, n), i.length && (yield o({
                                                        annots: i,
                                                        isDeleteLocal: !0
                                                    }));
                                                }
                                                if (1 === i.length) {
                                                    const r = [], a = [];
                                                    if (i[0].split("__")[1]) {
                                                        if (!e.toJSON) return void l.LOGGER.debug("path length is 1 and not toJSON found for target", e);
                                                        let o = e.toJSON();
                                                        yield h(o);
                                                        let r = [
                                                            o
                                                        ];
                                                        o.inreplyto && (yield u(o, r, n)), yield t.importAnnotsFromJSON(r), yield f(r, n);
                                                    } else s.forEach(function({ action: t, oldValue: n }, o) {
                                                        if ("add" === t || "update" === t) {
                                                            let t = e.get(o);
                                                            t.toJSON ? r.push(t.toJSON()) : l.LOGGER.debug(`${o} not found in `, e);
                                                        } else if ("delete" === t) {
                                                            const e = o.split("__")[0];
                                                            a.push({
                                                                annotId: e,
                                                                pageIndex: (s = i[0], Number(s))
                                                            });
                                                        }
                                                        var s;
                                                    }), r.length && (1 === r.length && (yield u(r[0], r, n)), l.LOGGER.debug("path length = 1, start to import annots", r), yield t.importAnnotsFromJSON(r), yield f(r, n)), a.length && (yield o({
                                                        annots: a,
                                                        isDeleteLocal: !0
                                                    }));
                                                }
                                                if (2 === i.length) {
                                                    if (!e.toJSON) return void l.LOGGER.debug("not toJSON found for target", e);
                                                    let o = e.toJSON();
                                                    yield h(o);
                                                    let r = [
                                                        o
                                                    ];
                                                    o.inreplyto && (yield u(o, r, n)), l.LOGGER.debug("path length = 2, start to import annots", r), yield t.importAnnotsFromJSON(r), yield f(r, n);
                                                    const i = n.getAnnotRender(o.page, o.name), s = null === i || void 0 === i ? void 0 : i.getComponent();
                                                    (null === s || void 0 === s ? void 0 : s.isActive) && "Note" === o.subject && (yield i.unActive(), yield i.active());
                                                }
                                            }
                                        });
                                    }(e));
                                });
                            });
                        });
                    }
                    handleSyncStep1(e) {
                        const t = this.sdkAnnotEventService.ydoc;
                        t && this.sdkAnnotEventService.idbPersistencePromise.then(()=>{
                            const n = c.encodeStateAsUpdate(t, e);
                            this.sdkAnnotEventService.syncUpdate(n, a.DocumentAction.SYNC_YLOG_STEP_2, this.context.currentDocId);
                        }).catch(()=>{
                            const n = c.encodeStateAsUpdate(t, e);
                            this.sdkAnnotEventService.syncUpdate(n, a.DocumentAction.SYNC_YLOG_STEP_2, this.context.currentDocId);
                        });
                    }
                    handleSyncStep2(e) {
                        this.applyYlog(e);
                    }
                    applyYlog(e) {
                        l.LOGGER.debug("start to apply ylog update, size: ", e.length);
                        const t = this.sdkAnnotEventService.ydoc;
                        this.pendingList.push(e), this.applyingTimeout || (this.applyingTimeout = setTimeout(()=>{
                            this.applyingTimeout && (clearTimeout(this.applyingTimeout), this.applyingTimeout = null), c.transact(t, ()=>{
                                this.pendingList.forEach(function(e) {
                                    c.applyUpdate(t, e, "server");
                                });
                            }, "server", !1), this.pendingList = [];
                        }, 300));
                    }
                    observeYDoc() {
                        l.LOGGER.debug("setup ydoc and PDF binding"), this.ydocToPDF(this.sdkAnnotEventService.ydoc);
                    }
                };
            },
            7306: function(e, t, n) {
                var o = this && this.__createBinding || (Object.create ? function(e, t, n, o) {
                    void 0 === o && (o = n);
                    var r = Object.getOwnPropertyDescriptor(t, n);
                    r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                        enumerable: !0,
                        get: function() {
                            return t[n];
                        }
                    }), Object.defineProperty(e, o, r);
                } : function(e, t, n, o) {
                    void 0 === o && (o = n), e[o] = t[n];
                }), r = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), i = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var n in e)"default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
                    return r(t, e), t;
                }, s = this && this.__awaiter || function(e, t, n, o) {
                    return new (n || (n = Promise))(function(r, i) {
                        function s(e) {
                            try {
                                c(o.next(e));
                            } catch (t) {
                                i(t);
                            }
                        }
                        function a(e) {
                            try {
                                c(o.throw(e));
                            } catch (t) {
                                i(t);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((o = o.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.SdkScreenSyncService = void 0;
                const a = n(7418), c = i(n(5741)), d = n(4255);
                t.SdkScreenSyncService = class {
                    constructor(e, t){
                        this.pdfViewer = e, this.context = t, this.syncScreenData = null, this.leaderId = void 0, this.updateScreenSyncData = (0, d.getScreenSyncInitialInfo)().defaultScreenSyncData, this.getScrollData = (0, a.throttle)(this.getScrollData.bind(this));
                    }
                    listenScreenSyncData() {
                        var e;
                        return s(this, void 0, void 0, function*() {
                            this.leaderId && this.leaderId === (null === (e = this.context.currentUser) || void 0 === e ? void 0 : e.id) && (yield c.syncScreenData(this.screenSyncId, this.updateScreenSyncData));
                        });
                    }
                    getPdfInfo() {
                        return s(this, void 0, void 0, function*() {
                            return yield this.pdfViewer.getPDFDocRender().getOffsetInfo();
                        });
                    }
                    getScrollData() {
                        return s(this, void 0, void 0, function*() {
                            let e = this.pdfViewer.getScrollWrap().getScrollY(), t = this.pdfViewer.getScrollWrap().getScrollX(), n = yield this.getPdfInfo();
                            this.updateScreenSyncData.scrollPosition.x = t, this.updateScreenSyncData.scrollPosition.y = e, this.updateScreenSyncData.pdfInfo = n, this.listenScreenSyncData();
                        });
                    }
                    setZoomBySDK(e) {
                        var t;
                        return s(this, void 0, void 0, function*() {
                            let n = yield this.getPdfInfo();
                            this.updateScreenSyncData.zoom = e, this.updateScreenSyncData.pdfInfo = n, this.leaderId && this.leaderId === (null === (t = this.context.currentUser) || void 0 === t ? void 0 : t.id) && this.listenScreenSyncData();
                        });
                    }
                    setViewModeBySDK(e) {
                        var t;
                        return s(this, void 0, void 0, function*() {
                            let n = yield this.getPdfInfo();
                            this.updateScreenSyncData.layoutMode = e.getName(), this.updateScreenSyncData.pdfInfo = n, this.leaderId && this.leaderId === (null === (t = this.context.currentUser) || void 0 === t ? void 0 : t.id) && this.listenScreenSyncData();
                        });
                    }
                    addscreenSyncListener(e, t) {
                        if (this.getScrollData(), this.leaderId) return;
                        this.pdfViewer.getScrollWrap().scrollHost;
                        this.screenSyncId = e, this.leaderId = t, this.pdfviewerWrap = this.pdfViewer.getScrollWrap().scrollHost, window.addEventListener("scroll", this.getScrollData, !0);
                    }
                    removeScreenSyncListener() {
                        window.removeEventListener("scroll", this.getScrollData, !0), this.leaderId = void 0;
                    }
                    leaveScreenSync() {
                        this.syncScreenData = null;
                    }
                    sync(e) {
                        return s(this, void 0, void 0, function*() {
                            const { screenSyncData: t, leader: n } = e;
                            let o = yield this.getPdfInfo();
                            if (null !== this.syncScreenData && (0, d.isObjectValueEqual)(this.syncScreenData.scrollPosition, t.scrollPosition) || this.handleScrollEvent(t, o.scale), null === this.syncScreenData || this.syncScreenData.zoom !== t.zoom) {
                                const { top: e, left: n, index: o } = t.pdfInfo;
                                this.pdfViewer.zoomTo(t.zoom, {
                                    x: n,
                                    y: e,
                                    pageIndex: o
                                });
                            }
                            null !== this.syncScreenData && this.syncScreenData.layoutMode === t.layoutMode || this.pdfViewer.getViewModeManager().switchTo(t.layoutMode), this.syncScreenData = t;
                        });
                    }
                    handleScrollEvent(e, t) {
                        let n = Number(e.scrollPosition.y), o = Number(e.scrollPosition.x), r = t / e.pdfInfo.scale, i = Number(n * r), s = Number(o * r);
                        this.pdfViewer.getScrollWrap().scrollTo(s, i);
                    }
                    setSyncRate(e) {
                        this.getScrollData.setThreshold(e);
                    }
                };
            },
            7857: (e, t, n)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.WebSdkBinding = void 0;
                const o = n(923), r = n(1630), i = n(7306), s = n(5231);
                t.WebSdkBinding = class {
                    constructor(e, t){
                        this.sdkAnnotEventService = new o.SdkAnnotEventService(e, t), this.sdkScreenSyncService = new i.SdkScreenSyncService(e, t), this.mousePointerService = new s.MousePointerService(e, t), this.sdkCollabService = new r.SdkCollabService(e, t, this.sdkAnnotEventService, this.mousePointerService);
                    }
                };
            },
            8907: (e, t)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Event = void 0;
                let n = Object.assign(Object.assign({}, {
                    jrLicenseSuccess: "jr-license-success",
                    srLicenseSuccess: "sr-license-success",
                    beforeOpenFile: "before-open-file",
                    openingFile: "opening-file",
                    beforeLoadPDFDoc: "before-load-pdf-document",
                    startConvert: "start-convert",
                    finishConvert: "finish-convert",
                    openFileSuccess: "open-file-success",
                    openFileFailed: "open-file-failed",
                    willCloseDocument: "will-close-document",
                    renderFileSuccess: "render-file-success",
                    renderFileFailed: "render-file-error",
                    beforeRenderPage: "before-render-page",
                    renderPageSuccess: "render-page-success",
                    beforeZoomTo: "before-zoom-to",
                    zoomToSuccess: "zoom-to-success",
                    zoomToFailed: "zoom-to-failed",
                    startChangeViewMode: "start-change-view-mode",
                    changeViewModeSuccess: "change-view-mode-success",
                    changeViewModeFailed: "change-view-mode-failed",
                    pagesLayoutRedrawBegin: "pages-layout-redraw-begin",
                    pageLayoutRedraw: "page-layout-redraw",
                    pagesLayoutRedrawEnd: "pages-layout-redraw-end",
                    copyTextSuccess: "copy-text-success",
                    copyTextFailed: "copy-text-failed",
                    tapPage: "tap-page",
                    tapAnnotation: "tap-annotation",
                    pressPage: "press-page",
                    pressAnnotation: "press-annotation",
                    pressText: "press-text",
                    rightClickPage: "right-click-page",
                    rightClickAnnotation: "right-click-annotation",
                    doubleTapPage: "double-tap-page",
                    doubleTapAnnotation: "double-tap-annotation",
                    activeAnnotationBefore: "active-annotation-before",
                    activeAnnotation: "active-annotation",
                    activeAnnotationAfter: "active-annotation-after",
                    panActiveAnnotation: "pan-active-annotation",
                    doubleTapActiveAnnotation: "double-tap-active-annotation",
                    contextMenuActiveAnnotation: "contextmenu-action-annotation",
                    unActiveAnnotation: "unactive-annotation",
                    updateActiveAnnotation: "update-action-annotation",
                    updateActionAnnotation: "update-action-annotation",
                    removeActiveAnnotationBefore: "remove-action-annotation-before",
                    removeActionAnnotationBefore: "remove-action-annotation-before",
                    removeActiveAnnotationSuccess: "remove-action-annotation-success",
                    removeActionAnnotationSuccess: "remove-action-annotation-success",
                    removeActiveAnnotationFailed: "remove-action-annotation-failed",
                    removeActionAnnotationFailed: "remove-action-annotation-failed",
                    switchStateHandler: "switch-state-handler",
                    deactiveStateHandler: "deactive-state-handler",
                    redactAnnotRendered: "redact-annot-rendered",
                    redactAnnotAllApplyed: "applyed-all-redaction",
                    redactAnnotApplyed: "applyed-redaction",
                    pageNumberChange: "page-number-change",
                    beforeDocumentRotation: "before-document-rotation",
                    afterDocumentRotation: "after-document-rotation",
                    snapModeChanged: "snap-mode-changed",
                    createPageAreaRenderer: "create-page-area-renderer",
                    destroyPageAreaRenderer: "destroy-page-area-renderer",
                    startUpdatePageAreaRenderer: "start-update-page-area-renderer",
                    createSnapshotArea: "create-snapshot-area",
                    updateSnapshotArea: "update-snapshot-area",
                    stabilizedSnapshotArea: "stabilized-snapshot-area",
                    switchPageAreaRenderer: "switch-page-area-renderer",
                    fitWidthResizeViewport: "fit-width-resize-viewport",
                    signatureFieldMouseLButtonDown: "signature-field-Lbutton-down",
                    signatureFieldMouseLButtonUp: "signature-field-LButton-up",
                    signatureFieldMouseEnter: "signature-field-mouse-enter",
                    signatureFieldMouseExit: "signature-field-mouse-exit",
                    visiblePagesRenderCompleted: "completed-render-visible-pages",
                    marqueeZoomIn: "marquee-zoom-in",
                    marqueeZoomOut: "marquee-zoom-out",
                    inkSignAdded: "inkSign-added",
                    inkSignDeleted: "inkSign-deleted",
                    pageMoved: "page-moved",
                    pageRemoved: "page-removed",
                    pageAdded: "page-added",
                    customDataAdd: "custom-data-add",
                    customDataImported: "custom-data-imported",
                    customDataRemoved: "custom-data-removed",
                    customDataUpdated: "custom-data-updated",
                    securityTypeChanged: "security-type-changed",
                    distanceAnnotCreationStart: "distance-creation-start",
                    updateDistanceAnnot: "update-distance-annot",
                    distanceAnnotCreationEnd: "distance-creation-end",
                    distanceAnnotCreationCancel: "distance-creation-cancel",
                    addEditImage: "add-edit-image",
                    InkImageSelected: "ink-image-selected",
                    checkTheSearch: "check-the-search",
                    activeElementChanged: "active-element-changed",
                    cancelCreatingDistance: "cancel-creating-measurement",
                    completeCreatingDistance: "complete-creating-measurement",
                    eraserSuccess: "eraser-success",
                    addAnnotSuccess: "add-annot-success",
                    cancelAddAnnot: "cancel-add-annot",
                    globalAnnotFlagChanged: "global-annot-flag-changed",
                    toolbarTabsClicked: "toolbar-tabs-clicked",
                    disableScroll: "disable-scroll",
                    enableScroll: "enable-scroll",
                    updateScrollableStatus: "update-scrollable-status",
                    selectText: "select-text",
                    changeEnableJS: "change-enable-js",
                    toggleEngineSr2JrSuccess: "toggle-engine-sr-to-jr-success",
                    iconInited: "iconInited",
                    iconAdded: "iconAdded",
                    iconRemoved: "iconRemoved",
                    annotationPermissionChanged: "annotation-premission-changed",
                    startScrollingPage: "pdfui-start-scrolling-page",
                    scrollingPage: "pdfui-scrolling-page",
                    endScrollingPage: "pdfui-end-scrolling-page",
                    designerAssistantStatusChanged: "form-designer-assistant-status-changed",
                    mouseEnter: "mouse-enter",
                    mouseLeave: "mouse-leave",
                    setFromFieldHighlight: "set_form_field_highlight",
                    AddFontMaps: "set_font_map",
                    thumbnailClicked: "thumbnail-clicked",
                    layerActionActived: "layer-action-actived",
                    redeModeShowSidebar: "rede-mode-show-sidebar",
                    gridToggle: "grid-toggle",
                    snapGridToggle: "snap-grid-toggle",
                    toggleCollaborationMode: "toggleCollaborationMode",
                    findReplaceDialogVisibleChange: "find-replace-dialog-visible-change",
                    showAllComments: "show-all-comments",
                    hideAllComments: "hide-all-comments",
                    focusInObject: "focus-in-object",
                    blurFromObject: "blur-from-object"
                }), {
                    annotationUpdated: "annotation-updated",
                    annotationIDUpdated: "annotation-id-updated",
                    annotationAppearanceUpdated: "annotation-appearance-updated",
                    annotationReplyAdd: "annotation-reply-add",
                    annotationReviewStateAnnotAdd: "annotation-review-state-annot-add",
                    annotationMarkedStateAnnotAdd: "annotation-marked-state-annot-add",
                    annotationStatesCleared: "annotation-states-cleared",
                    annotationRemoved: "annotation-removed",
                    annotationMovedPosition: "annotation-moved-position",
                    annotationAdded: "annotation-add",
                    annotationAdd: "annotation-add",
                    moveAnnotsToPages: "moveAnnotsToPages",
                    annotationImported: "annotation-imported",
                    annotationImportedEx: "annotation-imported-ex",
                    annotationLoaded: "annotation-loaded",
                    actionUpdated: "action-updated",
                    actionAdd: "action-add",
                    actionRemove: "action-remove",
                    layerVisibleChange: "layer-visible-change",
                    layerRemoved: "layer-removed",
                    layerMerged: "layer-merged",
                    bookmarkAdded: "bookmark-added",
                    structureBookmarkAdded: "structure-bookmark-added",
                    bookmarkUpdated: "bookmark-updated",
                    bookmarkRemoved: "bookmark-removed",
                    stateAnnotNameUpdated: "state-annot-name-updated",
                    pageInfoChange: "page-info-change",
                    pageRotationChange: "page-rotation-change",
                    imageAdded: "image-added",
                    watermarkAdded: "watermark-added",
                    graphicsUpdated: "graphics-updated",
                    permissionChanged: "permission-changed",
                    drmEncryptSuccess: "drm-encrypt-success",
                    drmEncryptFailed: "drm-encrypt-failed",
                    pageMoved: "page-moved",
                    pageRemoved: "page-removed",
                    pageAdded: "page-added",
                    insertPages: "import-pages",
                    importPages: "import-pages",
                    documentAttachmentAdd: "document-attachment-add",
                    documentAttachmentModify: "document-attachment-modify",
                    documentAttachmentRemove: "document-attachment-remove",
                    applyRedaction: "apply-redaction",
                    removeReviewState: "remove-review-state",
                    removeMarkedState: "remove-marked-state",
                    formValueChanged: "form-value-changed",
                    metaDataChanged: "meta-data-changed",
                    docModified: "doc-modified",
                    flattened: "flattened",
                    headerFooterUpdated: "headerFooterUpdated",
                    headerFooterAdded: "headerFooterAdded",
                    COChange: "COChange",
                    pagesReversed: "pages-reversed",
                    pagesMoved: "pages-moved",
                    pagesRemoved: "pages-removed",
                    pagesRotated: "pages-rotated",
                    obtainsPageFromEngine: "obtains-page-from-engine",
                    pagesBoxChange: "pages-box-changed",
                    pagesLabelChange: "pages-label-change",
                    pagesLabelNeedUpdate: "pages-label-need-change",
                    pagesReplace: "pages-replace",
                    recognitionForm: "recognition-form",
                    removeEmbeddedPageThumbnail: "remove-embedded-page-thumbnail",
                    articleThreadAdded: "article-thread-added",
                    articleThreadUpdated: "article-thread-updated",
                    articleThreadRemoved: "article-thread-removed",
                    articleBeadAdded: "article-bead-added",
                    articleBeadRemoved: "article-bead-removed",
                    articleBeadUpdated: "article-bead-updated",
                    articleEnterReadMode: "article-enter-read-mode",
                    articleOutReadMode: "article-out-read-mode",
                    undoRedoStoreChange: "undo-redo-store-change",
                    fullscreenchange: "fullscreenchange"
                });
                t.Event = n;
            },
            7918: function(e, t, n) {
                var o = this && this.__createBinding || (Object.create ? function(e, t, n, o) {
                    void 0 === o && (o = n);
                    var r = Object.getOwnPropertyDescriptor(t, n);
                    r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                        enumerable: !0,
                        get: function() {
                            return t[n];
                        }
                    }), Object.defineProperty(e, o, r);
                } : function(e, t, n, o) {
                    void 0 === o && (o = n), e[o] = t[n];
                }), r = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), i = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var n in e)"default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
                    return r(t, e), t;
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.encode = t.decode = t.encodeSubscribeDocMsg = void 0;
                const s = n(5608), a = i(n(4641)), c = i(n(1840));
                function d(e, t) {
                    const n = a.createEncoder();
                    return a.writeUint8(n, e), a.writeVarUint8Array(n, t), a.toUint8Array(n);
                }
                t.encodeSubscribeDocMsg = function(e) {
                    const t = {
                        event: "events",
                        data: {
                            type: s.MessageType.SUBSCRIBE_DOC,
                            data: {
                                docId: e
                            }
                        }
                    };
                    return JSON.stringify(t);
                }, t.decode = function(e) {
                    return e instanceof ArrayBuffer ? function(e) {
                        const t = c.createDecoder(e), n = c.readUint8(t), o = c.readVarUint8Array(t);
                        if (0 === n) return {
                            event: "sync",
                            type: "sync-ylog",
                            data: {
                                ylog: o
                            }
                        };
                        if (1 === n) return {
                            event: "sync",
                            type: "sync-ylog-s1",
                            data: {
                                type: "sync-ylog-s1",
                                ylog: o
                            }
                        };
                        if (2 === n) return {
                            event: "sync",
                            type: "sync-ylog-s2",
                            data: {
                                type: "sync-ylog-s2",
                                ylog: o
                            }
                        };
                        return null;
                    }(new Uint8Array(e)) : JSON.parse(e);
                }, t.encode = function(e) {
                    return e.type === s.DocumentAction.SYNC_YLOG ? d(0, e.data.ylog) : e.type === s.DocumentAction.SYNC_YLOG_STEP_1 ? d(1, e.data.ylog) : e.type === s.DocumentAction.SYNC_YLOG_STEP_2 ? d(2, e.data.ylog) : JSON.stringify(e);
                };
            },
            6526: function(e, t, n) {
                var o = this && this.__createBinding || (Object.create ? function(e, t, n, o) {
                    void 0 === o && (o = n);
                    var r = Object.getOwnPropertyDescriptor(t, n);
                    r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                        enumerable: !0,
                        get: function() {
                            return t[n];
                        }
                    }), Object.defineProperty(e, o, r);
                } : function(e, t, n, o) {
                    void 0 === o && (o = n), e[o] = t[n];
                }), r = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), i = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var n in e)"default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
                    return r(t, e), t;
                }, s = this && this.__awaiter || function(e, t, n, o) {
                    return new (n || (n = Promise))(function(r, i) {
                        function s(e) {
                            try {
                                c(o.next(e));
                            } catch (t) {
                                i(t);
                            }
                        }
                        function a(e) {
                            try {
                                c(o.throw(e));
                            } catch (t) {
                                i(t);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((o = o.apply(e, t || [])).next());
                    });
                }, a = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.stopCollaboration = t.startCollaboration = void 0;
                const c = n(5608), d = a(n(9397)), l = n(9648), u = n(5285), h = i(n(7918)), f = n(9594);
                let p, v, g = !1, y = !0;
                function m(e) {
                    e === c.NetworkConnectionEvent.NetworkConnectionDown && y && (y = !1, u.context.listener && u.context.listener({
                        type: e,
                        data: {}
                    })), e !== c.NetworkConnectionEvent.NetworkConnectionUp || y || (y = !0, u.context.listener && u.context.listener({
                        type: e,
                        data: {}
                    }));
                }
                function S(e, t) {
                    return new Promise((n, o)=>{
                        const r = new d.default(e, void 0, {
                            maxEnqueuedMessages: 0,
                            debug: !1
                        });
                        r.binaryType = "arraybuffer", r.onopen = ()=>{
                            f.LOGGER.debug(`websocket opened, ${e}`), n(r), function(e) {
                                const t = {
                                    event: "events",
                                    data: {
                                        type: "heart"
                                    }
                                };
                                v = setInterval(function() {
                                    e.send(JSON.stringify(t));
                                }, 3e4);
                            }(r), function(e) {
                                e.onmessage = (e)=>{
                                    var t, n, o, r;
                                    let i = h.decode(e.data);
                                    switch(i.type){
                                        case c.DocumentAction.DELETE_ANNOTS:
                                        case c.DocumentAction.ADD_ANNOTS:
                                        case c.DocumentAction.CHANGE_ANNOTS:
                                        case c.DocumentAction.MOUSE_POINTER_SYNC:
                                        case c.DocumentAction.SYNC_YLOG:
                                        case c.DocumentAction.SYNC_YLOG_STEP_1:
                                        case c.DocumentAction.SYNC_YLOG_STEP_2:
                                            null === (t = u.context.webSdkBinding) || void 0 === t || t.sdkCollabService.onBroadcastCollabNotice(i);
                                            break;
                                        case "doc-subscribed":
                                            null === (n = u.context.webSdkBinding) || void 0 === n || n.sdkCollabService.onBroadcastCollabNotice(i), null === (o = u.context.webSdkBinding) || void 0 === o || o.mousePointerService.renderInitialMousePointers(i.data.mousePointerStates), f.LOGGER.debug(`user: ${i.data.id} subscribed to collaboration: ${i.data.docId} on server: ${i.data.serverId}`), u.context.serverId = i.data.serverId;
                                            break;
                                        case "heart-reply":
                                        case "doc-event-reply":
                                            break;
                                        case c.DocumentAction.MEMBER_ONLINE:
                                        case c.DocumentAction.MEMBER_OFFLINE:
                                        case c.DocumentAction.DELETE_SHARE:
                                        case c.DocumentAction.EDIT_MEMBERS:
                                        case c.DocumentAction.DELETE_MEMBERS:
                                        case l.ScreenSyncEvent.CREATED:
                                        case l.ScreenSyncEvent.STOPPED:
                                        case l.ScreenSyncEvent.MEMBER_JOINED:
                                        case l.ScreenSyncEvent.MEMBER_LEAVE:
                                        case l.ScreenSyncEvent.SCREENSYNC_DATA:
                                            const e1 = i;
                                            e1.type === c.DocumentAction.MEMBER_OFFLINE && (null === (r = u.context.webSdkBinding) || void 0 === r || r.mousePointerService.onMemberOffline(e1.data)), u.context.listener && u.context.listener(e1);
                                    }
                                };
                            }(r), m(c.NetworkConnectionEvent.NetworkConnectionUp), f.LOGGER.debug(`try subscribe to collaboration: ${t} `), r.send(h.encodeSubscribeDocMsg(t)), t && (f.LOGGER.debug("sync collaboration ydoc states after ws connect"), setTimeout(()=>{
                                var e;
                                null === (e = u.context.webSdkBinding) || void 0 === e || e.sdkCollabService.sendSyncStep1(t);
                            }, 300));
                        }, r.onerror = (e)=>{
                            f.LOGGER.error("websocket error", e), m(c.NetworkConnectionEvent.NetworkConnectionDown), o(e);
                        };
                    });
                }
                window.addEventListener("offline", (e)=>{
                    f.LOGGER.info("client network offline"), m(c.NetworkConnectionEvent.NetworkConnectionDown), g = !0;
                }), window.addEventListener("online", (e)=>{
                    f.LOGGER.info("client network online"), g && (null === p || void 0 === p || p.reconnect()), g = !1;
                }), t.startCollaboration = function(e, t) {
                    var n;
                    return s(this, void 0, void 0, function*() {
                        const o = null === (n = t.currentUser) || void 0 === n ? void 0 : n.id, r = t.sessionId;
                        let i = `${t.transport.websocketURL}?uid=${o}&sn=foxit&sessionId=${r}`;
                        try {
                            return p = yield S(i, e), p;
                        } catch (s) {
                            return null;
                        }
                    });
                }, t.stopCollaboration = function(e) {
                    var t, n, o, r;
                    return s(this, void 0, void 0, function*() {
                        const i = {
                            event: "events",
                            data: {
                                type: c.MessageType.UNSUBSCRIBE_DOC,
                                data: {
                                    docId: e
                                }
                            }
                        };
                        p.send(JSON.stringify(i)), null === (t = u.context.webSdkBinding) || void 0 === t || t.sdkAnnotEventService.removeAnnotationListener(), null === (n = u.context.webSdkBinding) || void 0 === n || n.sdkAnnotEventService.destroyYDoc(), null === (o = u.context.webSdkBinding) || void 0 === o || o.mousePointerService.stop(), v && clearInterval(v), p.close(), null === (r = u.context.webSdkBinding) || void 0 === r || r.sdkCollabService.resetCollaborationData(), u.context.webSdkBinding.sdkScreenSyncService.removeScreenSyncListener();
                    });
                };
            },
            3300: (e)=>{
                e.exports = t;
            },
            7430: (t)=>{
                t.exports = e;
            },
            9397: (e)=>{
                e.exports = o;
            },
            9703: (e)=>{
                e.exports = n;
            },
            9722: (e, t)=>{
                const n = (e)=>e[e.length - 1], o = ()=>[], r = (e)=>e.slice(), i = (e, t)=>{
                    for(let n = 0; n < t.length; n++)e.push(t[n]);
                }, s = Array.from, a = (e, t)=>e.every(t), c = (e, t)=>e.some(t), d = (e, t)=>e.length === t.length && a(e, (e, n)=>e === t[n]), l = (e)=>e.reduce((e, t)=>e.concat(t), []), u = Array.isArray;
                var h = Object.freeze({
                    __proto__: null,
                    last: n,
                    create: o,
                    copy: r,
                    appendTo: i,
                    from: s,
                    every: a,
                    some: c,
                    equalFlat: d,
                    flatten: l,
                    isArray: u
                });
                t.appendTo = i, t.array = h, t.copy = r, t.create = o, t.equalFlat = d, t.every = a, t.flatten = l, t.from = s, t.isArray = u, t.last = n, t.some = c;
            },
            409: (e, t)=>{
                const n = 131072, o = 262144, r = 524288, i = 1048576, s = 2097152, a = 4194304, c = 8388608, d = 16777216, l = 33554432, u = 67108864, h = 134217728, f = 268435456, p = 536870912, v = 1073741824, g = -2147483648, y = 131071, m = 262143, S = 524287, b = 1048575, E = 2097151, _ = 4194303, w = 8388607, I = d - 1, A = l - 1, D = u - 1, O = h - 1, P = f - 1, C = p - 1, T = v - 1, R = 2147483647, B = 4294967295;
                var M = Object.freeze({
                    __proto__: null,
                    BIT1: 1,
                    BIT2: 2,
                    BIT3: 4,
                    BIT4: 8,
                    BIT5: 16,
                    BIT6: 32,
                    BIT7: 64,
                    BIT8: 128,
                    BIT9: 256,
                    BIT10: 512,
                    BIT11: 1024,
                    BIT12: 2048,
                    BIT13: 4096,
                    BIT14: 8192,
                    BIT15: 16384,
                    BIT16: 32768,
                    BIT17: 65536,
                    BIT18: n,
                    BIT19: o,
                    BIT20: r,
                    BIT21: i,
                    BIT22: s,
                    BIT23: a,
                    BIT24: c,
                    BIT25: d,
                    BIT26: l,
                    BIT27: u,
                    BIT28: h,
                    BIT29: f,
                    BIT30: p,
                    BIT31: v,
                    BIT32: g,
                    BITS0: 0,
                    BITS1: 1,
                    BITS2: 3,
                    BITS3: 7,
                    BITS4: 15,
                    BITS5: 31,
                    BITS6: 63,
                    BITS7: 127,
                    BITS8: 255,
                    BITS9: 511,
                    BITS10: 1023,
                    BITS11: 2047,
                    BITS12: 4095,
                    BITS13: 8191,
                    BITS14: 16383,
                    BITS15: 32767,
                    BITS16: 65535,
                    BITS17: y,
                    BITS18: m,
                    BITS19: S,
                    BITS20: b,
                    BITS21: E,
                    BITS22: _,
                    BITS23: w,
                    BITS24: I,
                    BITS25: A,
                    BITS26: D,
                    BITS27: O,
                    BITS28: P,
                    BITS29: C,
                    BITS30: T,
                    BITS31: R,
                    BITS32: B
                });
                t.BIT1 = 1, t.BIT10 = 512, t.BIT11 = 1024, t.BIT12 = 2048, t.BIT13 = 4096, t.BIT14 = 8192, t.BIT15 = 16384, t.BIT16 = 32768, t.BIT17 = 65536, t.BIT18 = n, t.BIT19 = o, t.BIT2 = 2, t.BIT20 = r, t.BIT21 = i, t.BIT22 = s, t.BIT23 = a, t.BIT24 = c, t.BIT25 = d, t.BIT26 = l, t.BIT27 = u, t.BIT28 = h, t.BIT29 = f, t.BIT3 = 4, t.BIT30 = p, t.BIT31 = v, t.BIT32 = g, t.BIT4 = 8, t.BIT5 = 16, t.BIT6 = 32, t.BIT7 = 64, t.BIT8 = 128, t.BIT9 = 256, t.BITS0 = 0, t.BITS1 = 1, t.BITS10 = 1023, t.BITS11 = 2047, t.BITS12 = 4095, t.BITS13 = 8191, t.BITS14 = 16383, t.BITS15 = 32767, t.BITS16 = 65535, t.BITS17 = y, t.BITS18 = m, t.BITS19 = S, t.BITS2 = 3, t.BITS20 = b, t.BITS21 = E, t.BITS22 = _, t.BITS23 = w, t.BITS24 = I, t.BITS25 = A, t.BITS26 = D, t.BITS27 = O, t.BITS28 = P, t.BITS29 = C, t.BITS3 = 7, t.BITS30 = T, t.BITS31 = R, t.BITS32 = B, t.BITS4 = 15, t.BITS5 = 31, t.BITS6 = 63, t.BITS7 = 127, t.BITS8 = 255, t.BITS9 = 511, t.binary = M;
            },
            6797: (e, t, n)=>{
                var o = n(8720), r = n(4178), i = n(409), s = n(7039), a = n(2346), c = n(2203);
                class d {
                    constructor(){
                        this.cpos = 0, this.cbuf = new Uint8Array(100), this.bufs = [];
                    }
                }
                const l = ()=>new d(), u = (e)=>{
                    let t = e.cpos;
                    for(let n = 0; n < e.bufs.length; n++)t += e.bufs[n].length;
                    return t;
                }, h = (e)=>{
                    const t = new Uint8Array(u(e));
                    let n = 0;
                    for(let o = 0; o < e.bufs.length; o++){
                        const r = e.bufs[o];
                        t.set(r, n), n += r.length;
                    }
                    return t.set(xe(e.cbuf.buffer, 0, e.cpos), n), t;
                }, f = (e, t)=>{
                    const n = e.cbuf.length;
                    n - e.cpos < t && (e.bufs.push(xe(e.cbuf.buffer, 0, e.cpos)), e.cbuf = new Uint8Array(2 * s.max(n, t)), e.cpos = 0);
                }, p = (e, t)=>{
                    const n = e.cbuf.length;
                    e.cpos === n && (e.bufs.push(e.cbuf), e.cbuf = new Uint8Array(2 * n), e.cpos = 0), e.cbuf[e.cpos++] = t;
                }, v = (e, t, n)=>{
                    let o = null;
                    for(let r = 0; r < e.bufs.length && null === o; r++){
                        const n = e.bufs[r];
                        t < n.length ? o = n : t -= n.length;
                    }
                    null === o && (o = e.cbuf), o[t] = n;
                }, g = p, y = v, m = (e, t)=>{
                    p(e, t & i.BITS8), p(e, t >>> 8 & i.BITS8);
                }, S = (e, t, n)=>{
                    v(e, t, n & i.BITS8), v(e, t + 1, n >>> 8 & i.BITS8);
                }, b = (e, t)=>{
                    for(let n = 0; n < 4; n++)p(e, t & i.BITS8), t >>>= 8;
                }, E = (e, t)=>{
                    for(let n = 3; n >= 0; n--)p(e, t >>> 8 * n & i.BITS8);
                }, _ = (e, t, n)=>{
                    for(let o = 0; o < 4; o++)v(e, t + o, n & i.BITS8), n >>>= 8;
                }, w = (e, t)=>{
                    for(; t > i.BITS7;)p(e, i.BIT8 | i.BITS7 & t), t = s.floor(t / 128);
                    p(e, i.BITS7 & t);
                }, I = (e, t)=>{
                    const n = s.isNegativeZero(t);
                    for(n && (t = -t), p(e, (t > i.BITS6 ? i.BIT8 : 0) | (n ? i.BIT7 : 0) | i.BITS6 & t), t = s.floor(t / 64); t > 0;)p(e, (t > i.BITS7 ? i.BIT8 : 0) | i.BITS7 & t), t = s.floor(t / 128);
                }, A = new Uint8Array(3e4), D = A.length / 3, O = (e, t)=>{
                    if (t.length < D) {
                        const n = o.utf8TextEncoder.encodeInto(t, A).written || 0;
                        w(e, n);
                        for(let t = 0; t < n; t++)p(e, A[t]);
                    } else B(e, o.encodeUtf8(t));
                }, P = (e, t)=>{
                    const n = unescape(encodeURIComponent(t)), o = n.length;
                    w(e, o);
                    for(let r = 0; r < o; r++)p(e, n.codePointAt(r));
                }, C = o.utf8TextEncoder && o.utf8TextEncoder.encodeInto ? O : P, T = (e, t)=>R(e, h(t)), R = (e, t)=>{
                    const n = e.cbuf.length, o = e.cpos, r = s.min(n - o, t.length), i = t.length - r;
                    e.cbuf.set(t.subarray(0, r), o), e.cpos += r, i > 0 && (e.bufs.push(e.cbuf), e.cbuf = new Uint8Array(s.max(2 * n, i)), e.cbuf.set(t.subarray(r)), e.cpos = i);
                }, B = (e, t)=>{
                    w(e, t.byteLength), R(e, t);
                }, M = (e, t)=>{
                    f(e, t);
                    const n = new DataView(e.cbuf.buffer, e.cpos, t);
                    return e.cpos += t, n;
                }, L = (e, t)=>M(e, 4).setFloat32(0, t, !1), N = (e, t)=>M(e, 8).setFloat64(0, t, !1), U = (e, t)=>M(e, 8).setBigInt64(0, t, !1), x = (e, t)=>M(e, 8).setBigUint64(0, t, !1), k = new DataView(new ArrayBuffer(4)), j = (e, t)=>{
                    switch(typeof t){
                        case "string":
                            p(e, 119), C(e, t);
                            break;
                        case "number":
                            a.isInteger(t) && s.abs(t) <= i.BITS31 ? (p(e, 125), I(e, t)) : (n = t, k.setFloat32(0, n), k.getFloat32(0) === n ? (p(e, 124), L(e, t)) : (p(e, 123), N(e, t)));
                            break;
                        case "bigint":
                            p(e, 122), U(e, t);
                            break;
                        case "object":
                            if (null === t) p(e, 126);
                            else if (t instanceof Array) {
                                p(e, 117), w(e, t.length);
                                for(let n = 0; n < t.length; n++)j(e, t[n]);
                            } else if (t instanceof Uint8Array) p(e, 116), B(e, t);
                            else {
                                p(e, 118);
                                const n = Object.keys(t);
                                w(e, n.length);
                                for(let o = 0; o < n.length; o++){
                                    const r = n[o];
                                    C(e, r), j(e, t[r]);
                                }
                            }
                            break;
                        case "boolean":
                            p(e, t ? 120 : 121);
                            break;
                        default:
                            p(e, 127);
                    }
                    var n;
                };
                class V extends d {
                    constructor(e){
                        super(), this.w = e, this.s = null, this.count = 0;
                    }
                    write(e) {
                        this.s === e ? this.count++ : (this.count > 0 && w(this, this.count - 1), this.count = 1, this.w(this, e), this.s = e);
                    }
                }
                class F extends d {
                    constructor(e){
                        super(), this.s = e;
                    }
                    write(e) {
                        I(this, e - this.s), this.s = e;
                    }
                }
                class G extends d {
                    constructor(e){
                        super(), this.s = e, this.count = 0;
                    }
                    write(e) {
                        this.s === e && this.count > 0 ? this.count++ : (this.count > 0 && w(this, this.count - 1), this.count = 1, I(this, e - this.s), this.s = e);
                    }
                }
                const q = (e)=>{
                    e.count > 0 && (I(e.encoder, 1 === e.count ? e.s : -e.s), e.count > 1 && w(e.encoder, e.count - 2));
                };
                class Y {
                    constructor(){
                        this.encoder = new d(), this.s = 0, this.count = 0;
                    }
                    write(e) {
                        this.s === e ? this.count++ : (q(this), this.count = 1, this.s = e);
                    }
                    toUint8Array() {
                        return q(this), h(this.encoder);
                    }
                }
                class $ {
                    constructor(){
                        this.encoder = new d(), this.s = 0, this.count = 0;
                    }
                    write(e) {
                        this.s + this.count === e ? this.count++ : (q(this), this.count = 1, this.s = e);
                    }
                    toUint8Array() {
                        return q(this), h(this.encoder);
                    }
                }
                const z = (e)=>{
                    if (e.count > 0) {
                        const t = 2 * e.diff + (1 === e.count ? 0 : 1);
                        I(e.encoder, t), e.count > 1 && w(e.encoder, e.count - 2);
                    }
                };
                class W {
                    constructor(){
                        this.encoder = new d(), this.s = 0, this.count = 0, this.diff = 0;
                    }
                    write(e) {
                        this.diff === e - this.s ? (this.s = e, this.count++) : (z(this), this.count = 1, this.diff = e - this.s, this.s = e);
                    }
                    toUint8Array() {
                        return z(this), h(this.encoder);
                    }
                }
                class J {
                    constructor(){
                        this.sarr = [], this.s = "", this.lensE = new Y();
                    }
                    write(e) {
                        this.s += e, this.s.length > 19 && (this.sarr.push(this.s), this.s = ""), this.lensE.write(e.length);
                    }
                    toUint8Array() {
                        const e = new d();
                        return this.sarr.push(this.s), this.s = "", C(e, this.sarr.join("")), R(e, this.lensE.toUint8Array()), h(e);
                    }
                }
                var K = Object.freeze({
                    __proto__: null,
                    Encoder: d,
                    createEncoder: l,
                    length: u,
                    toUint8Array: h,
                    verifyLen: f,
                    write: p,
                    set: v,
                    writeUint8: g,
                    setUint8: y,
                    writeUint16: m,
                    setUint16: S,
                    writeUint32: b,
                    writeUint32BigEndian: E,
                    setUint32: _,
                    writeVarUint: w,
                    writeVarInt: I,
                    _writeVarStringNative: O,
                    _writeVarStringPolyfill: P,
                    writeVarString: C,
                    writeBinaryEncoder: T,
                    writeUint8Array: R,
                    writeVarUint8Array: B,
                    writeOnDataView: M,
                    writeFloat32: L,
                    writeFloat64: N,
                    writeBigInt64: U,
                    writeBigUint64: x,
                    writeAny: j,
                    RleEncoder: V,
                    IntDiffEncoder: F,
                    RleIntDiffEncoder: G,
                    UintOptRleEncoder: Y,
                    IncUintOptRleEncoder: $,
                    IntDiffOptRleEncoder: W,
                    StringEncoder: J
                });
                const Z = c.create("Unexpected end of array"), H = c.create("Integer out of Range");
                class X {
                    constructor(e){
                        this.arr = e, this.pos = 0;
                    }
                }
                const Q = (e)=>new X(e), ee = (e)=>e.pos !== e.arr.length, te = (e, t = e.pos)=>{
                    const n = Q(e.arr);
                    return n.pos = t, n;
                }, ne = (e, t)=>{
                    const n = xe(e.arr.buffer, e.pos + e.arr.byteOffset, t);
                    return e.pos += t, n;
                }, oe = (e)=>ne(e, fe(e)), re = (e)=>ne(e, e.arr.length - e.pos), ie = (e)=>e.pos++, se = (e)=>e.arr[e.pos++], ae = (e)=>{
                    const t = e.arr[e.pos] + (e.arr[e.pos + 1] << 8);
                    return e.pos += 2, t;
                }, ce = (e)=>{
                    const t = e.arr[e.pos] + (e.arr[e.pos + 1] << 8) + (e.arr[e.pos + 2] << 16) + (e.arr[e.pos + 3] << 24) >>> 0;
                    return e.pos += 4, t;
                }, de = (e)=>{
                    const t = e.arr[e.pos + 3] + (e.arr[e.pos + 2] << 8) + (e.arr[e.pos + 1] << 16) + (e.arr[e.pos] << 24) >>> 0;
                    return e.pos += 4, t;
                }, le = (e)=>e.arr[e.pos], ue = (e)=>e.arr[e.pos] + (e.arr[e.pos + 1] << 8), he = (e)=>e.arr[e.pos] + (e.arr[e.pos + 1] << 8) + (e.arr[e.pos + 2] << 16) + (e.arr[e.pos + 3] << 24) >>> 0, fe = (e)=>{
                    let t = 0, n = 1;
                    const o = e.arr.length;
                    for(; e.pos < o;){
                        const o = e.arr[e.pos++];
                        if (t += (o & i.BITS7) * n, n *= 128, o < i.BIT8) return t;
                        if (t > a.MAX_SAFE_INTEGER) throw H;
                    }
                    throw Z;
                }, pe = (e)=>{
                    let t = e.arr[e.pos++], n = t & i.BITS6, o = 64;
                    const r = (t & i.BIT7) > 0 ? -1 : 1;
                    if (0 === (t & i.BIT8)) return r * n;
                    const s = e.arr.length;
                    for(; e.pos < s;){
                        if (t = e.arr[e.pos++], n += (t & i.BITS7) * o, o *= 128, t < i.BIT8) return r * n;
                        if (n > a.MAX_SAFE_INTEGER) throw H;
                    }
                    throw Z;
                }, ve = (e)=>{
                    const t = e.pos, n = fe(e);
                    return e.pos = t, n;
                }, ge = (e)=>{
                    const t = e.pos, n = pe(e);
                    return e.pos = t, n;
                }, ye = (e)=>{
                    let t = fe(e);
                    if (0 === t) return "";
                    {
                        let n = String.fromCodePoint(se(e));
                        if (--t < 100) for(; t--;)n += String.fromCodePoint(se(e));
                        else for(; t > 0;){
                            const o = t < 1e4 ? t : 1e4, r = e.arr.subarray(e.pos, e.pos + o);
                            e.pos += o, n += String.fromCodePoint.apply(null, r), t -= o;
                        }
                        return decodeURIComponent(escape(n));
                    }
                }, me = (e)=>o.utf8TextDecoder.decode(oe(e)), Se = o.utf8TextDecoder ? me : ye, be = (e)=>{
                    const t = e.pos, n = Se(e);
                    return e.pos = t, n;
                }, Ee = (e, t)=>{
                    const n = new DataView(e.arr.buffer, e.arr.byteOffset + e.pos, t);
                    return e.pos += t, n;
                }, _e = (e)=>Ee(e, 4).getFloat32(0, !1), we = (e)=>Ee(e, 8).getFloat64(0, !1), Ie = (e)=>Ee(e, 8).getBigInt64(0, !1), Ae = (e)=>Ee(e, 8).getBigUint64(0, !1), De = [
                    (e)=>{},
                    (e)=>null,
                    pe,
                    _e,
                    we,
                    Ie,
                    (e)=>!1,
                    (e)=>!0,
                    Se,
                    (e)=>{
                        const t = fe(e), n = {};
                        for(let o = 0; o < t; o++)n[Se(e)] = Oe(e);
                        return n;
                    },
                    (e)=>{
                        const t = fe(e), n = [];
                        for(let o = 0; o < t; o++)n.push(Oe(e));
                        return n;
                    },
                    oe
                ], Oe = (e)=>De[127 - se(e)](e);
                class Pe extends X {
                    constructor(e, t){
                        super(e), this.reader = t, this.s = null, this.count = 0;
                    }
                    read() {
                        return 0 === this.count && (this.s = this.reader(this), ee(this) ? this.count = fe(this) + 1 : this.count = -1), this.count--, this.s;
                    }
                }
                class Ce extends X {
                    constructor(e, t){
                        super(e), this.s = t;
                    }
                    read() {
                        return this.s += pe(this), this.s;
                    }
                }
                class Te extends X {
                    constructor(e, t){
                        super(e), this.s = t, this.count = 0;
                    }
                    read() {
                        return 0 === this.count && (this.s += pe(this), ee(this) ? this.count = fe(this) + 1 : this.count = -1), this.count--, this.s;
                    }
                }
                class Re extends X {
                    constructor(e){
                        super(e), this.s = 0, this.count = 0;
                    }
                    read() {
                        if (0 === this.count) {
                            this.s = pe(this);
                            const e = s.isNegativeZero(this.s);
                            this.count = 1, e && (this.s = -this.s, this.count = fe(this) + 2);
                        }
                        return this.count--, this.s;
                    }
                }
                class Be extends X {
                    constructor(e){
                        super(e), this.s = 0, this.count = 0;
                    }
                    read() {
                        if (0 === this.count) {
                            this.s = pe(this);
                            const e = s.isNegativeZero(this.s);
                            this.count = 1, e && (this.s = -this.s, this.count = fe(this) + 2);
                        }
                        return this.count--, this.s++;
                    }
                }
                class Me extends X {
                    constructor(e){
                        super(e), this.s = 0, this.count = 0, this.diff = 0;
                    }
                    read() {
                        if (0 === this.count) {
                            const e = pe(this), t = 1 & e;
                            this.diff = s.floor(e / 2), this.count = 1, t && (this.count = fe(this) + 2);
                        }
                        return this.s += this.diff, this.count--, this.s;
                    }
                }
                class Le {
                    constructor(e){
                        this.decoder = new Re(e), this.str = Se(this.decoder), this.spos = 0;
                    }
                    read() {
                        const e = this.spos + this.decoder.read(), t = this.str.slice(this.spos, e);
                        return this.spos = e, t;
                    }
                }
                var Ne = Object.freeze({
                    __proto__: null,
                    Decoder: X,
                    createDecoder: Q,
                    hasContent: ee,
                    clone: te,
                    readUint8Array: ne,
                    readVarUint8Array: oe,
                    readTailAsUint8Array: re,
                    skip8: ie,
                    readUint8: se,
                    readUint16: ae,
                    readUint32: ce,
                    readUint32BigEndian: de,
                    peekUint8: le,
                    peekUint16: ue,
                    peekUint32: he,
                    readVarUint: fe,
                    readVarInt: pe,
                    peekVarUint: ve,
                    peekVarInt: ge,
                    _readVarStringPolyfill: ye,
                    _readVarStringNative: me,
                    readVarString: Se,
                    peekVarString: be,
                    readFromDataView: Ee,
                    readFloat32: _e,
                    readFloat64: we,
                    readBigInt64: Ie,
                    readBigUint64: Ae,
                    readAny: Oe,
                    RleDecoder: Pe,
                    IntDiffDecoder: Ce,
                    RleIntDiffDecoder: Te,
                    UintOptRleDecoder: Re,
                    IncUintOptRleDecoder: Be,
                    IntDiffOptRleDecoder: Me,
                    StringDecoder: Le
                });
                const Ue = (e)=>new Uint8Array(e), xe = (e, t, n)=>new Uint8Array(e, t, n), ke = (e)=>new Uint8Array(e), je = r.isBrowser ? (e)=>{
                    let t = "";
                    for(let n = 0; n < e.byteLength; n++)t += o.fromCharCode(e[n]);
                    return btoa(t);
                } : (e)=>$d1ede43de03c5b3d$require$Buffer.from(e.buffer, e.byteOffset, e.byteLength).toString("base64"), Ve = r.isBrowser ? (e)=>{
                    const t = atob(e), n = Ue(t.length);
                    for(let o = 0; o < t.length; o++)n[o] = t.charCodeAt(o);
                    return n;
                } : (e)=>{
                    const t = $d1ede43de03c5b3d$require$Buffer.from(e, "base64");
                    return new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
                }, Fe = (e)=>{
                    const t = Ue(e.byteLength);
                    return t.set(e), t;
                }, Ge = (e)=>{
                    const t = l();
                    return j(t, e), h(t);
                }, qe = (e)=>Oe(Q(e));
                var Ye = Object.freeze({
                    __proto__: null,
                    createUint8ArrayFromLen: Ue,
                    createUint8ArrayViewFromArrayBuffer: xe,
                    createUint8ArrayFromArrayBuffer: ke,
                    toBase64: je,
                    fromBase64: Ve,
                    copyUint8Array: Fe,
                    encodeAny: Ge,
                    decodeAny: qe
                });
                t.Decoder = X, t.Encoder = d, t.IncUintOptRleDecoder = Be, t.IncUintOptRleEncoder = $, t.IntDiffDecoder = Ce, t.IntDiffEncoder = F, t.IntDiffOptRleDecoder = Me, t.IntDiffOptRleEncoder = W, t.RleDecoder = Pe, t.RleEncoder = V, t.RleIntDiffDecoder = Te, t.RleIntDiffEncoder = G, t.StringDecoder = Le, t.StringEncoder = J, t.UintOptRleDecoder = Re, t.UintOptRleEncoder = Y, t._readVarStringNative = me, t._readVarStringPolyfill = ye, t._writeVarStringNative = O, t._writeVarStringPolyfill = P, t.buffer = Ye, t.clone = te, t.copyUint8Array = Fe, t.createDecoder = Q, t.createEncoder = l, t.createUint8ArrayFromArrayBuffer = ke, t.createUint8ArrayFromLen = Ue, t.createUint8ArrayViewFromArrayBuffer = xe, t.decodeAny = qe, t.decoding = Ne, t.encodeAny = Ge, t.encoding = K, t.fromBase64 = Ve, t.hasContent = ee, t.length = u, t.peekUint16 = ue, t.peekUint32 = he, t.peekUint8 = le, t.peekVarInt = ge, t.peekVarString = be, t.peekVarUint = ve, t.readAny = Oe, t.readBigInt64 = Ie, t.readBigUint64 = Ae, t.readFloat32 = _e, t.readFloat64 = we, t.readFromDataView = Ee, t.readTailAsUint8Array = re, t.readUint16 = ae, t.readUint32 = ce, t.readUint32BigEndian = de, t.readUint8 = se, t.readUint8Array = ne, t.readVarInt = pe, t.readVarString = Se, t.readVarUint = fe, t.readVarUint8Array = oe, t.set = v, t.setUint16 = S, t.setUint32 = _, t.setUint8 = y, t.skip8 = ie, t.toBase64 = je, t.toUint8Array = h, t.verifyLen = f, t.write = p, t.writeAny = j, t.writeBigInt64 = U, t.writeBigUint64 = x, t.writeBinaryEncoder = T, t.writeFloat32 = L, t.writeFloat64 = N, t.writeOnDataView = M, t.writeUint16 = m, t.writeUint32 = b, t.writeUint32BigEndian = E, t.writeUint8 = g, t.writeUint8Array = R, t.writeVarInt = I, t.writeVarString = C, t.writeVarUint = w, t.writeVarUint8Array = B;
            },
            6477: (e, t)=>{
                const n = (e)=>void 0 === e ? null : e;
                var o = Object.freeze({
                    __proto__: null,
                    undefinedToNull: n
                });
                t.conditions = o, t.undefinedToNull = n;
            },
            1840: (e, t, n)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var o = n(6797);
                n(409), n(7039), n(2346), n(8720), n(2203), n(4178), n(5537), n(6477), n(2826), n(8346), n(9722), n(7027), t.Decoder = o.Decoder, t.IncUintOptRleDecoder = o.IncUintOptRleDecoder, t.IntDiffDecoder = o.IntDiffDecoder, t.IntDiffOptRleDecoder = o.IntDiffOptRleDecoder, t.RleDecoder = o.RleDecoder, t.RleIntDiffDecoder = o.RleIntDiffDecoder, t.StringDecoder = o.StringDecoder, t.UintOptRleDecoder = o.UintOptRleDecoder, t._readVarStringNative = o._readVarStringNative, t._readVarStringPolyfill = o._readVarStringPolyfill, t.clone = o.clone, t.createDecoder = o.createDecoder, t.hasContent = o.hasContent, t.peekUint16 = o.peekUint16, t.peekUint32 = o.peekUint32, t.peekUint8 = o.peekUint8, t.peekVarInt = o.peekVarInt, t.peekVarString = o.peekVarString, t.peekVarUint = o.peekVarUint, t.readAny = o.readAny, t.readBigInt64 = o.readBigInt64, t.readBigUint64 = o.readBigUint64, t.readFloat32 = o.readFloat32, t.readFloat64 = o.readFloat64, t.readFromDataView = o.readFromDataView, t.readTailAsUint8Array = o.readTailAsUint8Array, t.readUint16 = o.readUint16, t.readUint32 = o.readUint32, t.readUint32BigEndian = o.readUint32BigEndian, t.readUint8 = o.readUint8, t.readUint8Array = o.readUint8Array, t.readVarInt = o.readVarInt, t.readVarString = o.readVarString, t.readVarUint = o.readVarUint, t.readVarUint8Array = o.readVarUint8Array, t.skip8 = o.skip8;
            },
            4641: (e, t, n)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var o = n(6797);
                n(7039), n(2346), n(409), n(8720), n(4178), n(5537), n(6477), n(2826), n(8346), n(9722), n(7027), n(2203), t.Encoder = o.Encoder, t.IncUintOptRleEncoder = o.IncUintOptRleEncoder, t.IntDiffEncoder = o.IntDiffEncoder, t.IntDiffOptRleEncoder = o.IntDiffOptRleEncoder, t.RleEncoder = o.RleEncoder, t.RleIntDiffEncoder = o.RleIntDiffEncoder, t.StringEncoder = o.StringEncoder, t.UintOptRleEncoder = o.UintOptRleEncoder, t._writeVarStringNative = o._writeVarStringNative, t._writeVarStringPolyfill = o._writeVarStringPolyfill, t.createEncoder = o.createEncoder, t.length = o.length, t.set = o.set, t.setUint16 = o.setUint16, t.setUint32 = o.setUint32, t.setUint8 = o.setUint8, t.toUint8Array = o.toUint8Array, t.verifyLen = o.verifyLen, t.write = o.write, t.writeAny = o.writeAny, t.writeBigInt64 = o.writeBigInt64, t.writeBigUint64 = o.writeBigUint64, t.writeBinaryEncoder = o.writeBinaryEncoder, t.writeFloat32 = o.writeFloat32, t.writeFloat64 = o.writeFloat64, t.writeOnDataView = o.writeOnDataView, t.writeUint16 = o.writeUint16, t.writeUint32 = o.writeUint32, t.writeUint32BigEndian = o.writeUint32BigEndian, t.writeUint8 = o.writeUint8, t.writeUint8Array = o.writeUint8Array, t.writeVarInt = o.writeVarInt, t.writeVarString = o.writeVarString, t.writeVarUint = o.writeVarUint, t.writeVarUint8Array = o.writeVarUint8Array;
            },
            4178: (e, t, n)=>{
                var o = n(5537), r = n(8720), i = n(6477), s = n(2826), a = n(8346);
                const c = "undefined" !== typeof $ibaza && $ibaza.release && /node|io\.js/.test($ibaza.release.name), d = "undefined" !== typeof window && !c, l = "undefined" !== typeof navigator && /Mac/.test(navigator.platform);
                let u;
                const h = ()=>{
                    if (void 0 === u) {
                        if (c) {
                            u = o.create();
                            const e = $ibaza.argv;
                            let t = null;
                            for(let n = 0; n < e.length; n++){
                                const o = e[n];
                                "-" === o[0] ? (null !== t && u.set(t, ""), t = o) : null !== t && (u.set(t, o), t = null);
                            }
                            null !== t && u.set(t, "");
                        } else "object" === typeof location ? (u = o.create(), (location.search || "?").slice(1).split("&").forEach((e)=>{
                            if (0 !== e.length) {
                                const [t, n] = e.split("=");
                                u.set(`--${r.fromCamelCase(t, "-")}`, n), u.set(`-${r.fromCamelCase(t, "-")}`, n);
                            }
                        })) : u = o.create();
                    }
                    return u;
                }, f = (e)=>h().has(e), p = (e, t)=>h().get(e) || t, v = (e)=>c ? i.undefinedToNull($ibaza.env[e.toUpperCase()]) : i.undefinedToNull(s.varStorage.getItem(e)), g = (e)=>h().get("--" + e) || v(e), y = (e)=>f("--" + e) || null !== v(e), m = y("production"), S = c && a.isOneOf(undefined, [
                    "true",
                    "1",
                    "2"
                ]), b = !f("no-colors") && (!c || $ibaza.stdout.isTTY || S) && (!c || f("color") || S || null !== v("COLORTERM") || (v("TERM") || "").includes("color"));
                var E = Object.freeze({
                    __proto__: null,
                    isNode: c,
                    isBrowser: d,
                    isMac: l,
                    hasParam: f,
                    getParam: p,
                    getVariable: v,
                    getConf: g,
                    hasConf: y,
                    production: m,
                    supportsColor: b
                });
                t.environment = E, t.getConf = g, t.getParam = p, t.getVariable = v, t.hasConf = y, t.hasParam = f, t.isBrowser = d, t.isMac = l, t.isNode = c, t.production = m, t.supportsColor = b;
            },
            2203: (e, t)=>{
                const n = (e)=>new Error(e), o = ()=>{
                    throw n("Method unimplemented");
                }, r = ()=>{
                    throw n("Unexpected case");
                };
                var i = Object.freeze({
                    __proto__: null,
                    create: n,
                    methodUnimplemented: o,
                    unexpectedCase: r
                });
                t.create = n, t.error = i, t.methodUnimplemented = o, t.unexpectedCase = r;
            },
            8346: (e, t, n)=>{
                var o = n(9722), r = n(7027);
                const i = (e, t, n = 0)=>{
                    try {
                        for(; n < e.length; n++)e[n](...t);
                    } finally{
                        n < e.length && i(e, t, n + 1);
                    }
                }, s = ()=>{}, a = (e)=>e(), c = (e)=>e, d = (e, t)=>e === t, l = (e, t)=>e === t || null != e && null != t && e.constructor === t.constructor && (e instanceof Array && o.equalFlat(e, t) || "object" === typeof e && r.equalFlat(e, t)), u = (e, t)=>{
                    if (null == e || null == t) return d(e, t);
                    if (e.constructor !== t.constructor) return !1;
                    if (e === t) return !0;
                    switch(e.constructor){
                        case ArrayBuffer:
                            e = new Uint8Array(e), t = new Uint8Array(t);
                        case Uint8Array:
                            if (e.byteLength !== t.byteLength) return !1;
                            for(let n = 0; n < e.length; n++)if (e[n] !== t[n]) return !1;
                            break;
                        case Set:
                            if (e.size !== t.size) return !1;
                            for (const n of e)if (!t.has(n)) return !1;
                            break;
                        case Map:
                            if (e.size !== t.size) return !1;
                            for (const n of e.keys())if (!t.has(n) || !u(e.get(n), t.get(n))) return !1;
                            break;
                        case Object:
                            if (r.length(e) !== r.length(t)) return !1;
                            for(const n in e)if (!r.hasProperty(e, n) || !u(e[n], t[n])) return !1;
                            break;
                        case Array:
                            if (e.length !== t.length) return !1;
                            for(let n = 0; n < e.length; n++)if (!u(e[n], t[n])) return !1;
                            break;
                        default:
                            return !1;
                    }
                    return !0;
                }, h = (e, t)=>t.includes(e);
                var f = Object.freeze({
                    __proto__: null,
                    callAll: i,
                    nop: s,
                    apply: a,
                    id: c,
                    equalityStrict: d,
                    equalityFlat: l,
                    equalityDeep: u,
                    isOneOf: h
                });
                t._function = f, t.apply = a, t.callAll = i, t.equalityDeep = u, t.equalityFlat = l, t.equalityStrict = d, t.id = c, t.isOneOf = h, t.nop = s;
            },
            5537: (e, t)=>{
                const n = ()=>new Map(), o = (e)=>{
                    const t = n();
                    return e.forEach((e, n)=>{
                        t.set(n, e);
                    }), t;
                }, r = (e, t, n)=>{
                    let o = e.get(t);
                    return void 0 === o && e.set(t, o = n()), o;
                }, i = (e, t)=>{
                    const n = [];
                    for (const [o, r] of e)n.push(t(r, o));
                    return n;
                }, s = (e, t)=>{
                    for (const [n, o] of e)if (t(o, n)) return !0;
                    return !1;
                }, a = (e, t)=>{
                    for (const [n, o] of e)if (!t(o, n)) return !1;
                    return !0;
                };
                var c = Object.freeze({
                    __proto__: null,
                    create: n,
                    copy: o,
                    setIfUndefined: r,
                    map: i,
                    any: s,
                    all: a
                });
                t.all = a, t.any = s, t.copy = o, t.create = n, t.map = i, t.map$1 = c, t.setIfUndefined = r;
            },
            7039: (e, t)=>{
                const n = Math.floor, o = Math.ceil, r = Math.abs, i = Math.imul, s = Math.round, a = Math.log10, c = Math.log2, d = Math.log, l = Math.sqrt, u = (e, t)=>e + t, h = (e, t)=>e < t ? e : t, f = (e, t)=>e > t ? e : t, p = Number.isNaN, v = Math.pow, g = (e)=>Math.pow(10, e), y = Math.sign, m = (e)=>0 !== e ? e < 0 : 1 / e < 0;
                var S = Object.freeze({
                    __proto__: null,
                    floor: n,
                    ceil: o,
                    abs: r,
                    imul: i,
                    round: s,
                    log10: a,
                    log2: c,
                    log: d,
                    sqrt: l,
                    add: u,
                    min: h,
                    max: f,
                    isNaN: p,
                    pow: v,
                    exp10: g,
                    sign: y,
                    isNegativeZero: m
                });
                t.abs = r, t.add = u, t.ceil = o, t.exp10 = g, t.floor = n, t.imul = i, t.isNaN = p, t.isNegativeZero = m, t.log = d, t.log10 = a, t.log2 = c, t.math = S, t.max = f, t.min = h, t.pow = v, t.round = s, t.sign = y, t.sqrt = l;
            },
            2346: (e, t, n)=>{
                var o = n(7039), r = n(409);
                const i = Number.MAX_SAFE_INTEGER, s = Number.MIN_SAFE_INTEGER, a = -2147483648, c = r.BITS31, d = Number.isInteger || ((e)=>"number" === typeof e && isFinite(e) && o.floor(e) === e), l = Number.isNaN, u = Number.parseInt;
                var h = Object.freeze({
                    __proto__: null,
                    MAX_SAFE_INTEGER: i,
                    MIN_SAFE_INTEGER: s,
                    LOWEST_INT32: a,
                    HIGHEST_INT32: c,
                    isInteger: d,
                    isNaN: l,
                    parseInt: u
                });
                t.HIGHEST_INT32 = c, t.LOWEST_INT32 = a, t.MAX_SAFE_INTEGER = i, t.MIN_SAFE_INTEGER = s, t.isInteger = d, t.isNaN = l, t.number = h, t.parseInt = u;
            },
            7027: (e, t)=>{
                const n = ()=>Object.create(null), o = Object.assign, r = Object.keys, i = (e, t)=>{
                    for(const n in e)t(e[n], n);
                }, s = (e, t)=>{
                    const n = [];
                    for(const o in e)n.push(t(e[o], o));
                    return n;
                }, a = (e)=>r(e).length, c = (e, t)=>{
                    for(const n in e)if (t(e[n], n)) return !0;
                    return !1;
                }, d = (e, t)=>{
                    for(const n in e)if (!t(e[n], n)) return !1;
                    return !0;
                }, l = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), u = (e, t)=>e === t || a(e) === a(t) && d(e, (e, n)=>(void 0 !== e || l(t, n)) && t[n] === e);
                var h = Object.freeze({
                    __proto__: null,
                    create: n,
                    assign: o,
                    keys: r,
                    forEach: i,
                    map: s,
                    length: a,
                    some: c,
                    every: d,
                    hasProperty: l,
                    equalFlat: u
                });
                t.assign = o, t.create = n, t.equalFlat = u, t.every = d, t.forEach = i, t.hasProperty = l, t.keys = r, t.length = a, t.map = s, t.object = h, t.some = c;
            },
            2826: (e, t)=>{
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                let n = new class {
                    constructor(){
                        this.map = new Map();
                    }
                    setItem(e, t) {
                        this.map.set(e, t);
                    }
                    getItem(e) {
                        return this.map.get(e);
                    }
                }(), o = !0;
                try {
                    "undefined" !== typeof localStorage && (n = localStorage, o = !1);
                } catch (i) {}
                const r = n;
                t.onChange = (e)=>o || addEventListener("storage", e), t.varStorage = r;
            },
            8720: (e, t)=>{
                const n = String.fromCharCode, o = String.fromCodePoint, r = /^\s*/g, i = (e)=>e.replace(r, ""), s = /([A-Z])/g, a = (e, t)=>i(e.replace(s, (e)=>`${t}${((e)=>e.toLowerCase())(e)}`)), c = (e)=>unescape(encodeURIComponent(e)).length, d = (e)=>{
                    const t = unescape(encodeURIComponent(e)), n = t.length, o = new Uint8Array(n);
                    for(let r = 0; r < n; r++)o[r] = t.codePointAt(r);
                    return o;
                }, l = "undefined" !== typeof TextEncoder ? new TextEncoder() : null, u = (e)=>l.encode(e), h = l ? u : d, f = (e)=>{
                    let t = e.length, n = "", o = 0;
                    for(; t > 0;){
                        const r = t < 1e4 ? t : 1e4, i = e.subarray(o, o + r);
                        o += r, n += String.fromCodePoint.apply(null, i), t -= r;
                    }
                    return decodeURIComponent(escape(n));
                };
                t.utf8TextDecoder = "undefined" === typeof TextDecoder ? null : new TextDecoder("utf-8", {
                    fatal: !0,
                    ignoreBOM: !0
                }), t.utf8TextDecoder && 1 === t.utf8TextDecoder.decode(new Uint8Array()).length && (t.utf8TextDecoder = null);
                const p = (e)=>t.utf8TextDecoder.decode(e), v = t.utf8TextDecoder ? p : f, g = (e, t, n, o = "")=>e.slice(0, t) + o + e.slice(t + n);
                var y = Object.freeze({
                    __proto__: null,
                    fromCharCode: n,
                    fromCodePoint: o,
                    trimLeft: i,
                    fromCamelCase: a,
                    utf8ByteLength: c,
                    _encodeUtf8Polyfill: d,
                    utf8TextEncoder: l,
                    _encodeUtf8Native: u,
                    encodeUtf8: h,
                    _decodeUtf8Polyfill: f,
                    get utf8TextDecoder () {
                        return t.utf8TextDecoder;
                    },
                    _decodeUtf8Native: p,
                    decodeUtf8: v,
                    splice: g
                });
                t._decodeUtf8Native = p, t._decodeUtf8Polyfill = f, t._encodeUtf8Native = u, t._encodeUtf8Polyfill = d, t.decodeUtf8 = v, t.encodeUtf8 = h, t.fromCamelCase = a, t.fromCharCode = n, t.fromCodePoint = o, t.splice = g, t.string = y, t.trimLeft = i, t.utf8ByteLength = c, t.utf8TextEncoder = l;
            },
            297: (e, t, n)=>{
                n.r(t), n.d(t, {
                    add: ()=>p,
                    addAutoKey: ()=>v,
                    count: ()=>l,
                    createIDBKeyRangeBound: ()=>D,
                    createIDBKeyRangeLowerBound: ()=>P,
                    createIDBKeyRangeUpperBound: ()=>O,
                    createStores: ()=>c,
                    del: ()=>h,
                    deleteDB: ()=>a,
                    get: ()=>u,
                    getAll: ()=>g,
                    getAllKeys: ()=>y,
                    getAllKeysValues: ()=>E,
                    getFirstKey: ()=>b,
                    getLastKey: ()=>S,
                    getStore: ()=>A,
                    iterate: ()=>w,
                    iterateKeys: ()=>I,
                    openDB: ()=>s,
                    put: ()=>f,
                    queryFirst: ()=>m,
                    rtop: ()=>i,
                    transact: ()=>d
                });
                const o = (e)=>new Promise(e), r = (e)=>new Error(e), i = (e)=>o((t, n)=>{
                        e.onerror = (e)=>n(new Error(e.target.error)), e.onblocked = ()=>location.reload(), e.onsuccess = (e)=>t(e.target.result);
                    }), s = (e, t)=>o((n, o)=>{
                        const i = indexedDB.open(e);
                        i.onupgradeneeded = (e)=>t(e.target.result), i.onerror = (e)=>o(r(e.target.error)), i.onblocked = ()=>location.reload(), i.onsuccess = (e)=>{
                            const t = e.target.result;
                            t.onversionchange = ()=>{
                                t.close();
                            }, "undefined" !== typeof addEventListener && addEventListener("unload", ()=>t.close()), n(t);
                        };
                    }), a = (e)=>i(indexedDB.deleteDatabase(e)), c = (e, t)=>t.forEach((t)=>e.createObjectStore.apply(e, t)), d = (e, t, n = "readwrite")=>{
                    const o = e.transaction(t, n);
                    return t.map((e)=>A(o, e));
                }, l = (e, t)=>i(e.count(t)), u = (e, t)=>i(e.get(t)), h = (e, t)=>i(e.delete(t)), f = (e, t, n)=>i(e.put(t, n)), p = (e, t, n)=>i(e.add(t, n)), v = (e, t)=>i(e.add(t)), g = (e, t, n)=>i(e.getAll(t, n)), y = (e, t, n)=>i(e.getAllKeys(t, n)), m = (e, t, n)=>{
                    let o = null;
                    return I(e, t, (e)=>(o = e, !1), n).then(()=>o);
                }, S = (e, t = null)=>m(e, t, "prev"), b = (e, t = null)=>m(e, t, "next"), E = (e, t, n)=>{
                    var o;
                    return (o = [
                        y(e, t, n),
                        g(e, t, n)
                    ], Promise.all(o)).then(([e, t])=>e.map((e, n)=>({
                                k: e,
                                v: t[n]
                            })));
                }, _ = (e, t)=>o((n, o)=>{
                        e.onerror = o, e.onsuccess = async (e)=>{
                            const o = e.target.result;
                            if (null === o || !1 === await t(o)) return n();
                            o.continue();
                        };
                    }), w = (e, t, n, o = "next")=>_(e.openCursor(t, o), (e)=>n(e.value, e.key)), I = (e, t, n, o = "next")=>_(e.openKeyCursor(t, o), (e)=>n(e.key)), A = (e, t)=>e.objectStore(t), D = (e, t, n, o)=>IDBKeyRange.bound(e, t, n, o), O = (e, t)=>IDBKeyRange.upperBound(e, t), P = (e, t)=>IDBKeyRange.lowerBound(e, t);
            },
            5750: (e, t, n)=>{
                n.r(t), n.d(t, {
                    Observable: ()=>s
                });
                const o = ()=>new Map(), r = ()=>new Set(), i = Array.from;
                Array.isArray;
                class s {
                    constructor(){
                        this._observers = o();
                    }
                    on(e, t) {
                        ((e, t, n)=>{
                            let o = e.get(t);
                            return void 0 === o && e.set(t, o = n()), o;
                        })(this._observers, e, r).add(t);
                    }
                    once(e, t) {
                        const n = (...o)=>{
                            this.off(e, n), t(...o);
                        };
                        this.on(e, n);
                    }
                    off(e, t) {
                        const n = this._observers.get(e);
                        void 0 !== n && (n.delete(t), 0 === n.size && this._observers.delete(e));
                    }
                    emit(e, t) {
                        return i((this._observers.get(e) || o()).values()).forEach((e)=>e(...t));
                    }
                    destroy() {
                        this._observers = o();
                    }
                }
            }
        }, i = {};
        function s(e) {
            var t = i[e];
            if (void 0 !== t) return t.exports;
            var n = i[e] = {
                exports: {}
            };
            return r[e].call(n.exports, n, n.exports, s), n.exports;
        }
        return s.d = (e, t)=>{
            for(var n in t)s.o(t, n) && !s.o(e, n) && Object.defineProperty(e, n, {
                enumerable: !0,
                get: t[n]
            });
        }, s.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), s.r = (e)=>{
            "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, s(6814);
    })());

})();
//# sourceMappingURL=index.js.map
